
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("3u0c5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9eefc705df3b46df$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $eHWoK = parcelRequire("eHWoK");

var $lj8SI = parcelRequire("lj8SI");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $9eefc705df3b46df$var$Lozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>(0, $VSDnB.fg)('platform_dst_lozenge_fg') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eHWoK.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lj8SI.default), {
        ...props
    }));
// NOTE: Remove this and just directly `export { default } from '…';` when tidying `platform_dst_lozenge_fg`
$9eefc705df3b46df$var$Lozenge.displayName = 'Lozenge';
var $9eefc705df3b46df$export$2e2bcd8739ae039 = $9eefc705df3b46df$var$Lozenge;

});
parcelRegister("eHWoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $06cab042e4136439$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $06cab042e4136439$var$stylesOld = {
    container: "_2rkoglpi _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    'text.bold.default': "_syaz15cr",
    'text.bold.inprogress': "_syaz15cr",
    'text.bold.moved': "_syazal3n",
    'text.bold.new': "_syaz15cr",
    'text.bold.removed': "_syaz15cr",
    'text.bold.success': "_syaz15cr",
    'text.subtle.default': "_syazjjyb",
    'text.subtle.inprogress': "_syaz1lpn",
    'text.subtle.moved': "_syaz1tm6",
    'text.subtle.new': "_syaz1mvf",
    'text.subtle.removed': "_syaz1ick",
    'text.subtle.success': "_syaz17fi"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
const $06cab042e4136439$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
const $06cab042e4136439$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $06cab042e4136439$var$stylesNew = {
    container: "_2rko1l7b _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhk1w7a",
    'bg.subtle.inprogress': "_bfhk1w7a",
    'bg.subtle.moved': "_bfhk1w7a",
    'bg.subtle.new': "_bfhk1w7a",
    'bg.subtle.removed': "_bfhk1w7a",
    'bg.subtle.success': "_bfhk1w7a",
    'border.subtle.default': "_19it14mp",
    'border.subtle.inprogress': "_19it1cy7",
    'border.subtle.moved': "_19itzi1n",
    'border.subtle.new': "_19it1apr",
    'border.subtle.removed': "_19itoa5t",
    'border.subtle.success': "_19it1am1",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syaz1fxt",
    'text.bold': "_syazwwip"
};
const $06cab042e4136439$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $06cab042e4136439$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $5uXOq.useMemo)(()=>$06cab042e4136439$var$appearanceTypes.includes(appearance) ? appearance : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $VSDnB.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $06cab042e4136439$var$stylesNew.container,
            $06cab042e4136439$var$stylesNew[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && !(0, $VSDnB.fg)('visual-refresh_drop_5') && $06cab042e4136439$var$stylesNew[`border.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $VSDnB.fg)('visual-refresh_drop_5') && $06cab042e4136439$var$stylesNew[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $VSDnB.fg)('visual-refresh_drop_5') && $06cab042e4136439$var$stylesNew.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $bwpsq.default)([
                $06cab042e4136439$var$stylesNew.text,
                (0, $VSDnB.fg)('platform-lozenge-custom-letterspacing') && $06cab042e4136439$var$stylesNew.customLetterspacing,
                $06cab042e4136439$var$stylesNew[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        backgroundColor: $06cab042e4136439$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $06cab042e4136439$var$stylesOld.container,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $bwpsq.default)([
                $06cab042e4136439$var$stylesOldUnbounded.text,
                (0, $VSDnB.fg)('platform-lozenge-custom-letterspacing') && $06cab042e4136439$var$stylesOldUnbounded.customLetterspacing,
                $06cab042e4136439$var$stylesOld[`text.${appearanceStyle}.${appearanceType}`]
            ]),
            children: children
        })
    });
});
$06cab042e4136439$var$Lozenge.displayName = 'Lozenge';
var $06cab042e4136439$export$2e2bcd8739ae039 = $06cab042e4136439$var$Lozenge;

});

parcelRegister("lj8SI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d0fb02cd496bf13$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
function $2d0fb02cd496bf13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2d0fb02cd496bf13$var$baseStylesOld = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
const $2d0fb02cd496bf13$var$styles = {
    container: {
        name: "1s8rs5f",
        styles: "display:inline-flex;box-sizing:border-box;position:static;block-size:min-content;border-radius:3px;overflow:hidden;padding-inline:var(--ds-space-050, 4px)"
    },
    containerSubtle: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: {
                name: "1007ca",
                styles: "background-color:#DDDEE1"
            },
            inprogress: {
                name: "5nwhd8",
                styles: "background-color:#8FB8F6"
            },
            moved: {
                name: "1v45608",
                styles: "background-color:#F9C84E"
            },
            new: {
                name: "1ra4w2w",
                styles: "background-color:#D8A0F7"
            },
            removed: {
                name: "1y25gsq",
                styles: "background-color:#FD9891"
            },
            success: {
                name: "2bpbki",
                styles: "background-color:#B3DF72"
            }
        },
        subtle: {
            default: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            inprogress: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            moved: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            new: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            removed: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            success: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            }
        }
    },
    border: {
        subtle: {
            default: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #B7B9BE`
            }),
            inprogress: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #669DF1`
            }),
            moved: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #FCA700`
            }),
            new: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #C97CF4`
            }),
            removed: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #F87168`
            }),
            success: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #94C748`
            })
        }
    },
    outline: {
        subtle: {
            default: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #B7B9BE`
            }),
            inprogress: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #669DF1`
            }),
            moved: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #FCA700`
            }),
            new: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #C97CF4`
            }),
            removed: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #F87168`
            }),
            success: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #94C748`
            })
        }
    },
    text: {
        subtle: {
            name: "nws7uq",
            styles: "color:var(--ds-text, #172B4D)"
        },
        bold: {
            name: "14qj9ca",
            styles: "color:#292A2E"
        }
    }
};
const $2d0fb02cd496bf13$var$textStyles = {
    name: "zdgrwm",
    styles: "font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-size:11px;font-style:normal;font-weight:var(--ds-font-weight-bold, 700);line-height:16px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap"
};
const $2d0fb02cd496bf13$var$customLetterspacingStyles = {
    name: "gkoibw",
    styles: "letter-spacing:0.165px"
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $2d0fb02cd496bf13$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = appearance in $2d0fb02cd496bf13$var$styles.background[appearanceStyle] ? appearance : 'default';
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $VSDnB.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        css: [
            $2d0fb02cd496bf13$var$styles.container,
            $2d0fb02cd496bf13$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === 'subtle' && !(0, $VSDnB.fg)('visual-refresh_drop_5') && $2d0fb02cd496bf13$var$styles.border.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $VSDnB.fg)('visual-refresh_drop_5') && $2d0fb02cd496bf13$var$styles.outline.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $VSDnB.fg)('visual-refresh_drop_5') && $2d0fb02cd496bf13$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            $2d0fb02cd496bf13$var$textStyles,
            (0, $VSDnB.fg)('platform-lozenge-custom-letterspacing') && $2d0fb02cd496bf13$var$customLetterspacingStyles,
            $2d0fb02cd496bf13$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
    const appearanceTypeOld = appearance in $2d0fb02cd496bf13$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        as: "span",
        backgroundColor: $2d0fb02cd496bf13$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $2d0fb02cd496bf13$var$baseStylesOld,
        testId: testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            $2d0fb02cd496bf13$var$textStyles,
            (0, $VSDnB.fg)('platform-lozenge-custom-letterspacing') && $2d0fb02cd496bf13$var$customLetterspacingStyles,
            $2d0fb02cd496bf13$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
});
$2d0fb02cd496bf13$var$Lozenge.displayName = 'Lozenge';
var $2d0fb02cd496bf13$export$2e2bcd8739ae039 = $2d0fb02cd496bf13$var$Lozenge;
const $2d0fb02cd496bf13$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
const $2d0fb02cd496bf13$var$textColorsOld = {
    bold: {
        default: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        inprogress: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        moved: {
            name: "tgubtb",
            styles: "color:var(--ds-text-warning-inverse, #172B4D)"
        },
        new: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        removed: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        success: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        default: {
            name: "kmxsjg",
            styles: "color:var(--ds-text-subtle, #42526E)"
        },
        inprogress: {
            name: "3j31nl",
            styles: "color:var(--ds-text-information, #0052CC)"
        },
        moved: {
            name: "1g2i1rp",
            styles: "color:var(--ds-text-warning, #974F0C)"
        },
        new: {
            name: "3juofh",
            styles: "color:var(--ds-text-discovery, #403294)"
        },
        removed: {
            name: "18zo14t",
            styles: "color:var(--ds-text-danger, #DE350B)"
        },
        success: {
            name: "1ychrch",
            styles: "color:var(--ds-text-success, #006644)"
        }
    }
};

});
parcelRegister("dC5iT", function(module, exports) {

$parcel$export(module.exports, "Box", () => $edbf142c131c29f6$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $edbf142c131c29f6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aCkBt = parcelRequire("aCkBt");

var $55sHU = parcelRequire("55sHU");

var $8CUq3 = parcelRequire("8CUq3");
function $edbf142c131c29f6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $edbf142c131c29f6$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $edbf142c131c29f6$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $55sHU.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $55sHU.isSurfaceColorToken)(backgroundColor) && (0, $55sHU.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $55sHU.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $55sHU.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $55sHU.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $55sHU.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $55sHU.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $55sHU.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $55sHU.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aCkBt.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $edbf142c131c29f6$export$2e2bcd8739ae039 = $edbf142c131c29f6$export$e71c4d32a2263218;
const $edbf142c131c29f6$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("8CUq3", function(module, exports) {

$parcel$export(module.exports, "tokensMap", () => $060528c06daf5c10$export$9a199fbafee0014e);
$parcel$export(module.exports, "parseXcss", () => $060528c06daf5c10$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $060528c06daf5c10$export$f6c783d06584602c);
/* xcss.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $55sHU = parcelRequire("55sHU");

var $6cAn5 = parcelRequire("6cAn5");
const $060528c06daf5c10$export$9a199fbafee0014e = {
    backgroundColor: (0, $55sHU.backgroundColorMap),
    blockSize: (0, $55sHU.dimensionMap),
    borderBlockColor: (0, $55sHU.borderColorMap),
    borderBlockEndColor: (0, $55sHU.borderColorMap),
    borderBlockEndWidth: (0, $55sHU.borderWidthMap),
    borderBlockStartColor: (0, $55sHU.borderColorMap),
    borderBlockStartWidth: (0, $55sHU.borderWidthMap),
    borderBlockWidth: (0, $55sHU.borderWidthMap),
    borderBottomColor: (0, $55sHU.borderColorMap),
    borderBottomLeftRadius: (0, $55sHU.borderRadiusMap),
    borderBottomRightRadius: (0, $55sHU.borderRadiusMap),
    borderBottomWidth: (0, $55sHU.borderWidthMap),
    borderColor: (0, $55sHU.borderColorMap),
    borderEndEndRadius: (0, $55sHU.borderRadiusMap),
    borderEndStartRadius: (0, $55sHU.borderRadiusMap),
    borderInlineColor: (0, $55sHU.borderColorMap),
    borderInlineEndColor: (0, $55sHU.borderColorMap),
    borderInlineEndWidth: (0, $55sHU.borderWidthMap),
    borderInlineStartColor: (0, $55sHU.borderColorMap),
    borderInlineStartWidth: (0, $55sHU.borderWidthMap),
    borderInlineWidth: (0, $55sHU.borderWidthMap),
    borderLeftColor: (0, $55sHU.borderColorMap),
    borderLeftWidth: (0, $55sHU.borderWidthMap),
    borderRadius: (0, $55sHU.borderRadiusMap),
    borderRightColor: (0, $55sHU.borderColorMap),
    borderRightWidth: (0, $55sHU.borderWidthMap),
    borderStartEndRadius: (0, $55sHU.borderRadiusMap),
    borderStartStartRadius: (0, $55sHU.borderRadiusMap),
    borderTopColor: (0, $55sHU.borderColorMap),
    borderTopLeftRadius: (0, $55sHU.borderRadiusMap),
    borderTopRightRadius: (0, $55sHU.borderRadiusMap),
    borderTopWidth: (0, $55sHU.borderWidthMap),
    borderWidth: (0, $55sHU.borderWidthMap),
    bottom: (0, $55sHU.allSpaceMap),
    boxShadow: (0, $55sHU.shadowMap),
    color: (0, $55sHU.textColorMap),
    columnGap: (0, $55sHU.positiveSpaceMap),
    font: (0, $55sHU.fontMap),
    fontFamily: (0, $55sHU.fontFamilyMap),
    fontWeight: (0, $55sHU.fontWeightMap),
    gap: (0, $55sHU.positiveSpaceMap),
    height: (0, $55sHU.dimensionMap),
    inlineSize: (0, $55sHU.dimensionMap),
    inset: (0, $55sHU.allSpaceMap),
    insetBlock: (0, $55sHU.allSpaceMap),
    insetBlockEnd: (0, $55sHU.allSpaceMap),
    insetBlockStart: (0, $55sHU.allSpaceMap),
    insetInline: (0, $55sHU.allSpaceMap),
    insetInlineEnd: (0, $55sHU.allSpaceMap),
    insetInlineStart: (0, $55sHU.allSpaceMap),
    left: (0, $55sHU.allSpaceMap),
    margin: (0, $55sHU.allSpaceMap),
    marginBlock: (0, $55sHU.allSpaceMap),
    marginBlockEnd: (0, $55sHU.allSpaceMap),
    marginBlockStart: (0, $55sHU.allSpaceMap),
    marginBottom: (0, $55sHU.allSpaceMap),
    marginInline: (0, $55sHU.allSpaceMap),
    marginInlineEnd: (0, $55sHU.allSpaceMap),
    marginInlineStart: (0, $55sHU.allSpaceMap),
    marginLeft: (0, $55sHU.allSpaceMap),
    marginRight: (0, $55sHU.allSpaceMap),
    marginTop: (0, $55sHU.allSpaceMap),
    maxBlockSize: (0, $55sHU.dimensionMap),
    maxHeight: (0, $55sHU.dimensionMap),
    maxInlineSize: (0, $55sHU.dimensionMap),
    maxWidth: (0, $55sHU.dimensionMap),
    minBlockSize: (0, $55sHU.dimensionMap),
    minHeight: (0, $55sHU.dimensionMap),
    minInlineSize: (0, $55sHU.dimensionMap),
    minWidth: (0, $55sHU.dimensionMap),
    opacity: (0, $55sHU.opacityMap),
    outlineColor: (0, $55sHU.borderColorMap),
    outlineOffset: (0, $55sHU.allSpaceMap),
    outlineWidth: (0, $55sHU.borderWidthMap),
    padding: (0, $55sHU.positiveSpaceMap),
    paddingBlock: (0, $55sHU.positiveSpaceMap),
    paddingBlockEnd: (0, $55sHU.positiveSpaceMap),
    paddingBlockStart: (0, $55sHU.positiveSpaceMap),
    paddingBottom: (0, $55sHU.positiveSpaceMap),
    paddingInline: (0, $55sHU.positiveSpaceMap),
    paddingInlineEnd: (0, $55sHU.positiveSpaceMap),
    paddingInlineStart: (0, $55sHU.positiveSpaceMap),
    paddingLeft: (0, $55sHU.positiveSpaceMap),
    paddingRight: (0, $55sHU.positiveSpaceMap),
    paddingTop: (0, $55sHU.positiveSpaceMap),
    right: (0, $55sHU.allSpaceMap),
    rowGap: (0, $55sHU.positiveSpaceMap),
    top: (0, $55sHU.allSpaceMap),
    width: (0, $55sHU.dimensionMap),
    zIndex: (0, $55sHU.layerMap)
};
const $060528c06daf5c10$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $060528c06daf5c10$var$isSafeEnvToThrow = ()=>typeof $6cAn5 === 'object' && typeof $6cAn5.env === 'object' && false;
const $060528c06daf5c10$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $060528c06daf5c10$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $060528c06daf5c10$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($060528c06daf5c10$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $060528c06daf5c10$var$safeSelectors.test(key)) {
            styleObj[key] = $060528c06daf5c10$var$transformStyles(value);
            return;
        }
        if ($060528c06daf5c10$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($060528c06daf5c10$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $060528c06daf5c10$export$9a199fbafee0014e)) return;
        const tokenValue = $060528c06daf5c10$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $060528c06daf5c10$var$baseXcss = (style)=>{
    const transformedStyles = $060528c06daf5c10$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [$060528c06daf5c10$var$uniqueSymbol]: /*#__PURE__*/ (0, $f8Sb3.css)(transformedStyles)
    };
}; /**
    * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
    * to supported both Emotion and Compiled styles until we've fully migrated
    * to Compiled.
    *
    * @private
    * @deprecated
    */ 
const $060528c06daf5c10$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $060528c06daf5c10$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$060528c06daf5c10$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $060528c06daf5c10$export$f6c783d06584602c(style) {
    return $060528c06daf5c10$var$baseXcss(style);
}

});




parcelRegister("ckyDP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4ce7dd41e05f3ded01848e6f06d1f7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fa2395aa4b4a70e$var$_react = $8fa2395aa4b4a70e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8fa2395aa4b4a70e$var$_peopleGroup = $8fa2395aa4b4a70e$var$_interopRequireDefault((parcelRequire("fptva")));

var $8fa2395aa4b4a70e$var$_peopleGroup2 = $8fa2395aa4b4a70e$var$_interopRequireDefault((parcelRequire("kFO36")));
function $8fa2395aa4b4a70e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fa2395aa4b4a70e$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $8fa2395aa4b4a70e$var$_react.default.createElement($8fa2395aa4b4a70e$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $8fa2395aa4b4a70e$var$_peopleGroup2.default
    }, props));
$8fa2395aa4b4a70e$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $8fa2395aa4b4a70e$var$_default = module.exports.default = $8fa2395aa4b4a70e$var$PeopleGroupIcon;

});
parcelRegister("fptva", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3801338456dce10$var$_react = $b3801338456dce10$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b3801338456dce10$var$_baseNew = $b3801338456dce10$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b3801338456dce10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b3801338456dce10$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $b3801338456dce10$var$_react.default.createElement($b3801338456dce10$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$b3801338456dce10$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $b3801338456dce10$var$_default = module.exports.default = $b3801338456dce10$var$PeopleGroupIcon;

});

parcelRegister("kFO36", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0ce75b3f6725a8c$var$_react = $f0ce75b3f6725a8c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f0ce75b3f6725a8c$var$_peopleGroup = $f0ce75b3f6725a8c$var$_interopRequireDefault((parcelRequire("fptva")));
function $f0ce75b3f6725a8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f0ce75b3f6725a8c$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $f0ce75b3f6725a8c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props, {
        newIcon: $f0ce75b3f6725a8c$var$_peopleGroup.default
    }));
$f0ce75b3f6725a8c$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $f0ce75b3f6725a8c$var$_default = module.exports.default = $f0ce75b3f6725a8c$var$PeopleGroupIcon;

});


parcelRegister("29YN9", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", () => $232c206a39097f42$export$c4b5b1f965d8b3eb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $232c206a39097f42$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const $232c206a39097f42$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $232c206a39097f42$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("hxoiH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0bb205476692ad1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cSyk1 = parcelRequire("cSyk1");

var $8Zdb4 = parcelRequire("8Zdb4");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $b0bb205476692ad1$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $5uXOq.useState)((0, $cSyk1.default)());
    (0, $5uXOq.useEffect)(()=>{
        const observer = new (0, $8Zdb4.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $b0bb205476692ad1$export$2e2bcd8739ae039 = $b0bb205476692ad1$var$useThemeObserver;

});
parcelRegister("cSyk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $29d05f12610acfc6$export$2e2bcd8739ae039);

var $f8twK = parcelRequire("f8twK");

var $hdU6u = parcelRequire("hdU6u");

var $imVhc = parcelRequire("imVhc");
const $29d05f12610acfc6$var$isThemeColorMode = (colorMode)=>{
    return (0, $hdU6u.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $29d05f12610acfc6$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $f8twK.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $f8twK.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $imVhc.themeStringToObject)(theme),
        ...$29d05f12610acfc6$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $29d05f12610acfc6$export$2e2bcd8739ae039 = $29d05f12610acfc6$var$getGlobalTheme;

});
parcelRegister("hdU6u", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $25f91216499731dd$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $25f91216499731dd$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $25f91216499731dd$export$92ba366331403db2);
$parcel$export(module.exports, "themeStateDefaults", () => $25f91216499731dd$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $25f91216499731dd$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");
const $25f91216499731dd$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ const $25f91216499731dd$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $25f91216499731dd$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const $25f91216499731dd$var$themeOverrideIds = [];
const $25f91216499731dd$export$92ba366331403db2 = [
    ...$25f91216499731dd$export$7d43e72a58e3283f,
    ...$25f91216499731dd$var$themeOverrideIds
];
const $25f91216499731dd$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
const $25f91216499731dd$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: ()=>{
        if ((0, $VSDnB.fg)('platform-default-typography-modernized')) return 'typography-modernized';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var $25f91216499731dd$export$2e2bcd8739ae039 = $25f91216499731dd$var$themeConfig;

});

parcelRegister("imVhc", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", () => $67939390e238a0f3$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $67939390e238a0f3$export$62c37ab81302621a);

var $hdU6u = parcelRequire("hdU6u");
const $67939390e238a0f3$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
const $67939390e238a0f3$var$customThemeOptions = 'UNSAFE_themeOptions';
const $67939390e238a0f3$var$isThemeKind = (themeKind)=>{
    return $67939390e238a0f3$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $67939390e238a0f3$var$isThemeIds = (themeId)=>{
    return (0, $hdU6u.themeIds).find((id)=>id === themeId) !== undefined;
};
const $67939390e238a0f3$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $67939390e238a0f3$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $67939390e238a0f3$var$isColorMode(id)) themeObject[kind] = id;
        if ($67939390e238a0f3$var$isThemeKind(kind) && $67939390e238a0f3$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $67939390e238a0f3$var$customThemeOptions) try {
            themeObject[$67939390e238a0f3$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $67939390e238a0f3$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $67939390e238a0f3$var$isColorMode(id) || // custom theme state
        kind === $67939390e238a0f3$var$customThemeOptions && typeof id === 'object' || // other theme states
        $67939390e238a0f3$var$isThemeKind(kind) && typeof id === 'string' && $67939390e238a0f3$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});


parcelRegister("8Zdb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $332f5cb1aec7999c$export$2e2bcd8739ae039);

var $f8twK = parcelRequire("f8twK");

var $cSyk1 = parcelRequire("cSyk1");
class $332f5cb1aec7999c$export$2e2bcd8739ae039 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $332f5cb1aec7999c$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$332f5cb1aec7999c$export$2e2bcd8739ae039.observer) {
            $332f5cb1aec7999c$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $cSyk1.default)();
                $332f5cb1aec7999c$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $332f5cb1aec7999c$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $f8twK.THEME_DATA_ATTRIBUTE),
                    (0, $f8twK.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $332f5cb1aec7999c$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($332f5cb1aec7999c$export$2e2bcd8739ae039.callbacks.size === 0 && $332f5cb1aec7999c$export$2e2bcd8739ae039.observer) {
            $332f5cb1aec7999c$export$2e2bcd8739ae039.observer.disconnect();
            $332f5cb1aec7999c$export$2e2bcd8739ae039.observer = null;
        }
    }
}

});


parcelRegister("lEsIP", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", () => $90614d6f5902a55a$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $90614d6f5902a55a$export$793fba32aed8942a);
const $90614d6f5902a55a$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $90614d6f5902a55a$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};

});

parcelRegister("6PPEt", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $b6578d83d04b350e$export$362a25f017e2bc8a);
$parcel$export(module.exports, "getColorsFromAppearance", () => $b6578d83d04b350e$export$bbacc3980e0f3029);
$parcel$export(module.exports, "getColorsForLoom", () => $b6578d83d04b350e$export$7818df200941dbbf);

const $b6578d83d04b350e$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $829f609a65d26a98$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $829f609a65d26a98$export$215b7063051591f1);
            iconColor = (0, $829f609a65d26a98$export$215b7063051591f1);
            textColor = `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`;
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $829f609a65d26a98$export$b3de0ae08da2ce64);
            break;
        case 'neutral':
            iconGradientStart = (0, $829f609a65d26a98$export$7090862dc3038a9f);
            iconGradientStop = (0, $829f609a65d26a98$export$d6447c357493214f);
            iconColor = (0, $829f609a65d26a98$export$d6447c357493214f);
            textColor = (0, $829f609a65d26a98$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $829f609a65d26a98$export$eece5f492e429f08);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $b6578d83d04b350e$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $829f609a65d26a98$export$29a4f05edc054374);
            textColor = (0, $829f609a65d26a98$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $829f609a65d26a98$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $b6578d83d04b350e$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = $b6578d83d04b350e$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    let textColor = $b6578d83d04b350e$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("iVs6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e738af8b5a2657f$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $4e738af8b5a2657f$var$CSS_VAR_COLOR = '--logo-color';
const $4e738af8b5a2657f$var$CSS_VAR_FILL = '--logo-fill';
const $4e738af8b5a2657f$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xsmall: "_4t3i7vkz",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $4e738af8b5a2657f$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            [$4e738af8b5a2657f$var$CSS_VAR_COLOR]: iconColor,
            [$4e738af8b5a2657f$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $bwpsq.default)([
            $4e738af8b5a2657f$var$styles.root,
            shouldApplyStopColor && $4e738af8b5a2657f$var$styles.stop,
            size && $4e738af8b5a2657f$var$styles[size]
        ])
    });
};
var $4e738af8b5a2657f$export$2e2bcd8739ae039 = $4e738af8b5a2657f$var$Wrapper;

});


parcelRegister("hPSf5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfc14681ddf388d2$var$_react = $cfc14681ddf388d2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cfc14681ddf388d2$var$_dashboard = $cfc14681ddf388d2$var$_interopRequireDefault((parcelRequire("gsyzJ")));
function $cfc14681ddf388d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cfc14681ddf388d2$var$ActivityIcon = (props)=>/*#__PURE__*/ $cfc14681ddf388d2$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M19.004 17C19 17 19 7.006 19 7.006 19 7 4.996 7 4.996 7 5 7 5 16.994 5 16.994 5 17 19.004 17 19.004 17M3 7.006A2 2 0 0 1 4.995 5h14.01A2 2 0 0 1 21 7.006v9.988A2 2 0 0 1 19.005 19H4.995A2 2 0 0 1 3 16.994z"/><path d="M4 6h16v5H4zm5 2c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C9.455 7 9 7.448 9 8M5 8c0 .556.448 1 1 1 .556 0 1-.448 1-1 0-.556-.448-1-1-1-.556 0-1 .448-1 1"/></g></svg>`
    }, props, {
        newIcon: $cfc14681ddf388d2$var$_dashboard.default
    }));
$cfc14681ddf388d2$var$ActivityIcon.displayName = 'ActivityIcon';
var $cfc14681ddf388d2$var$_default = module.exports.default = $cfc14681ddf388d2$var$ActivityIcon;

});
parcelRegister("gsyzJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4502f1006918f00802afd208dfed8019>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfba14cfc1d5c2b2$var$_react = $bfba14cfc1d5c2b2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bfba14cfc1d5c2b2$var$_baseNew = $bfba14cfc1d5c2b2$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bfba14cfc1d5c2b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bfba14cfc1d5c2b2$var$DashboardIcon = (props)=>/*#__PURE__*/ $bfba14cfc1d5c2b2$var$_react.default.createElement($bfba14cfc1d5c2b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$bfba14cfc1d5c2b2$var$DashboardIcon.displayName = 'DashboardIcon';
var $bfba14cfc1d5c2b2$var$_default = module.exports.default = $bfba14cfc1d5c2b2$var$DashboardIcon;

});


parcelRegister("apKqz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $795040bc4792cf5e$var$_react = $795040bc4792cf5e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $795040bc4792cf5e$var$_app = $795040bc4792cf5e$var$_interopRequireDefault((parcelRequire("hRf4g")));
function $795040bc4792cf5e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $795040bc4792cf5e$var$AddonIcon = (props)=>/*#__PURE__*/ $795040bc4792cf5e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m5.376 6.455 5.248-3.104c.792-.469 1.963-.467 2.752 0l5.248 3.104C19.416 6.923 20 7.962 20 8.895v6.21c0 .936-.587 1.973-1.376 2.44l-5.248 3.104c-.792.469-1.963.467-2.752 0l-5.248-3.104C4.584 17.077 4 16.038 4 15.105v-6.21c0-.936.587-1.973 1.376-2.44m6.99-1.314c-.165-.098-.566-.098-.733 0L6.385 8.245c-.166.098-.367.454-.367.65v6.21c0 .195.2.551.367.65l5.248 3.104c.166.098.567.098.734 0l5.248-3.104c.166-.098.367-.454.367-.65v-6.21c0-.195-.2-.551-.367-.65z"/><path d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></g></svg>`
    }, props, {
        newIcon: $795040bc4792cf5e$var$_app.default
    }));
$795040bc4792cf5e$var$AddonIcon.displayName = 'AddonIcon';
var $795040bc4792cf5e$var$_default = module.exports.default = $795040bc4792cf5e$var$AddonIcon;

});
parcelRegister("hRf4g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c18dea19497efa81c490b216a2f8ff9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d003130f2c1019f5$var$_react = $d003130f2c1019f5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d003130f2c1019f5$var$_baseNew = $d003130f2c1019f5$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d003130f2c1019f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d003130f2c1019f5$var$AppIcon = (props)=>/*#__PURE__*/ $d003130f2c1019f5$var$_react.default.createElement($d003130f2c1019f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.257 1.779a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zM8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$d003130f2c1019f5$var$AppIcon.displayName = 'AppIcon';
var $d003130f2c1019f5$var$_default = module.exports.default = $d003130f2c1019f5$var$AppIcon;

});


parcelRegister("4PKNr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $385039a59389c30c$var$_react = $385039a59389c30c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $385039a59389c30c$var$_appSwitcher = $385039a59389c30c$var$_interopRequireDefault((parcelRequire("3fDjf")));
function $385039a59389c30c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $385039a59389c30c$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $385039a59389c30c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01z"/></svg>`
    }, props, {
        newIcon: $385039a59389c30c$var$_appSwitcher.default
    }));
$385039a59389c30c$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $385039a59389c30c$var$_default = module.exports.default = $385039a59389c30c$var$AppSwitcherIcon;

});
parcelRegister("3fDjf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a710c2ad5ea3773aa39998727af6369>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25e143d7635b2d95$var$_react = $25e143d7635b2d95$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25e143d7635b2d95$var$_baseNew = $25e143d7635b2d95$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25e143d7635b2d95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25e143d7635b2d95$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $25e143d7635b2d95$var$_react.default.createElement($25e143d7635b2d95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm6 .5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$25e143d7635b2d95$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $25e143d7635b2d95$var$_default = module.exports.default = $25e143d7635b2d95$var$AppSwitcherIcon;

});


parcelRegister("adDD5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7709dbddc6671c4c$var$_react = $7709dbddc6671c4c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7709dbddc6671c4c$var$_backlog = $7709dbddc6671c4c$var$_interopRequireDefault((parcelRequire("bRTCF")));
function $7709dbddc6671c4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7709dbddc6671c4c$var$BacklogIcon = (props)=>/*#__PURE__*/ $7709dbddc6671c4c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $7709dbddc6671c4c$var$_backlog.default
    }));
$7709dbddc6671c4c$var$BacklogIcon.displayName = 'BacklogIcon';
var $7709dbddc6671c4c$var$_default = module.exports.default = $7709dbddc6671c4c$var$BacklogIcon;

});
parcelRegister("bRTCF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a3fca7537c506d3$var$_react = $8a3fca7537c506d3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8a3fca7537c506d3$var$_baseNew = $8a3fca7537c506d3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8a3fca7537c506d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a3fca7537c506d3$var$BacklogIcon = (props)=>/*#__PURE__*/ $8a3fca7537c506d3$var$_react.default.createElement($8a3fca7537c506d3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$8a3fca7537c506d3$var$BacklogIcon.displayName = 'BacklogIcon';
var $8a3fca7537c506d3$var$_default = module.exports.default = $8a3fca7537c506d3$var$BacklogIcon;

});


parcelRegister("5DSin", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41bab6388b256edf$var$_react = $41bab6388b256edf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $41bab6388b256edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $41bab6388b256edf$var$BillingIcon = (props)=>/*#__PURE__*/ $41bab6388b256edf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="5" height="2" x="8" y="9" rx="1"/><rect width="5" height="2" x="8" y="12" rx="1"/><rect width="5" height="2" x="8" y="15" rx="1"/><rect width="2" height="2" x="14" y="12" rx="1"/><rect width="2" height="2" x="14" y="15" rx="1"/><rect width="2" height="2" x="14" y="9" rx="1"/></g></svg>`
    }, props));
$41bab6388b256edf$var$BillingIcon.displayName = 'BillingIcon';
var $41bab6388b256edf$var$_default = module.exports.default = $41bab6388b256edf$var$BillingIcon;

});

parcelRegister("v8Zna", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05d9de5ec3a4369b$var$_react = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $05d9de5ec3a4369b$var$_board = $05d9de5ec3a4369b$var$_interopRequireDefault((parcelRequire("8EsNC")));
function $05d9de5ec3a4369b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $05d9de5ec3a4369b$var$BoardIcon = (props)=>/*#__PURE__*/ $05d9de5ec3a4369b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $05d9de5ec3a4369b$var$_board.default
    }));
$05d9de5ec3a4369b$var$BoardIcon.displayName = 'BoardIcon';
var $05d9de5ec3a4369b$var$_default = module.exports.default = $05d9de5ec3a4369b$var$BoardIcon;

});
parcelRegister("8EsNC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64c8661ab6d81803$var$_react = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $64c8661ab6d81803$var$_baseNew = $64c8661ab6d81803$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $64c8661ab6d81803$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64c8661ab6d81803$var$BoardIcon = (props)=>/*#__PURE__*/ $64c8661ab6d81803$var$_react.default.createElement($64c8661ab6d81803$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$64c8661ab6d81803$var$BoardIcon.displayName = 'BoardIcon';
var $64c8661ab6d81803$var$_default = module.exports.default = $64c8661ab6d81803$var$BoardIcon;

});


parcelRegister("90gd1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68e0afe9fd548c5c$var$_react = $68e0afe9fd548c5c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $68e0afe9fd548c5c$var$_listBulleted = $68e0afe9fd548c5c$var$_interopRequireDefault((parcelRequire("bEjt9")));
function $68e0afe9fd548c5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68e0afe9fd548c5c$var$BulletListIcon = (props)=>/*#__PURE__*/ $68e0afe9fd548c5c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $68e0afe9fd548c5c$var$_listBulleted.default
    }));
$68e0afe9fd548c5c$var$BulletListIcon.displayName = 'BulletListIcon';
var $68e0afe9fd548c5c$var$_default = module.exports.default = $68e0afe9fd548c5c$var$BulletListIcon;

});
parcelRegister("bEjt9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87b28849bcb64a34$var$_react = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87b28849bcb64a34$var$_baseNew = $87b28849bcb64a34$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87b28849bcb64a34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87b28849bcb64a34$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $87b28849bcb64a34$var$_react.default.createElement($87b28849bcb64a34$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$87b28849bcb64a34$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $87b28849bcb64a34$var$_default = module.exports.default = $87b28849bcb64a34$var$ListBulletedIcon;

});


parcelRegister("6Ingq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e38e5e3b0c66004$var$_react = $4e38e5e3b0c66004$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4e38e5e3b0c66004$var$_chevronDown = $4e38e5e3b0c66004$var$_interopRequireDefault((parcelRequire("iy9RA")));
function $4e38e5e3b0c66004$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4e38e5e3b0c66004$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $4e38e5e3b0c66004$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $4e38e5e3b0c66004$var$_chevronDown.default
    }));
$4e38e5e3b0c66004$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $4e38e5e3b0c66004$var$_default = module.exports.default = $4e38e5e3b0c66004$var$ChevronDownIcon;

});

parcelRegister("ebd3R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a52c39769ffb7919$var$_react = $a52c39769ffb7919$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a52c39769ffb7919$var$_chevronRight = $a52c39769ffb7919$var$_interopRequireDefault((parcelRequire("bpC55")));
function $a52c39769ffb7919$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a52c39769ffb7919$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $a52c39769ffb7919$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $a52c39769ffb7919$var$_chevronRight.default
    }));
$a52c39769ffb7919$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $a52c39769ffb7919$var$_default = module.exports.default = $a52c39769ffb7919$var$ChevronRightIcon;

});
parcelRegister("bpC55", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d99c40083bd8ba17abae11f3e4c84cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84ef9197bc7f6085$var$_react = $84ef9197bc7f6085$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $84ef9197bc7f6085$var$_baseNew = $84ef9197bc7f6085$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $84ef9197bc7f6085$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84ef9197bc7f6085$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $84ef9197bc7f6085$var$_react.default.createElement($84ef9197bc7f6085$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$84ef9197bc7f6085$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $84ef9197bc7f6085$var$_default = module.exports.default = $84ef9197bc7f6085$var$ChevronRightIcon;

});


parcelRegister("kbAiU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb20feef8ba5b644$var$_react = $eb20feef8ba5b644$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb20feef8ba5b644$var$_creditCard = $eb20feef8ba5b644$var$_interopRequireDefault((parcelRequire("yJt0Y")));
function $eb20feef8ba5b644$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb20feef8ba5b644$var$CreditcardFilledIcon = (props)=>/*#__PURE__*/ $eb20feef8ba5b644$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 10.99h18V17c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2zM6.01 16h2v-2h-2zM21 8.99V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v1.99"/></svg>`
    }, props, {
        newIcon: $eb20feef8ba5b644$var$_creditCard.default
    }));
$eb20feef8ba5b644$var$CreditcardFilledIcon.displayName = 'CreditcardFilledIcon';
var $eb20feef8ba5b644$var$_default = module.exports.default = $eb20feef8ba5b644$var$CreditcardFilledIcon;

});
parcelRegister("yJt0Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4932f6dfff92518aeab5d46f90dd8b8a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $068671e2aa0a9124$var$_react = $068671e2aa0a9124$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $068671e2aa0a9124$var$_baseNew = $068671e2aa0a9124$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $068671e2aa0a9124$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $068671e2aa0a9124$var$CreditCardIcon = (props)=>/*#__PURE__*/ $068671e2aa0a9124$var$_react.default.createElement($068671e2aa0a9124$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$068671e2aa0a9124$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $068671e2aa0a9124$var$_default = module.exports.default = $068671e2aa0a9124$var$CreditCardIcon;

});


parcelRegister("d5Zn3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $988b58f36f60a149$var$_react = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $988b58f36f60a149$var$_crossCircle = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("hI6SY")));
function $988b58f36f60a149$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $988b58f36f60a149$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $988b58f36f60a149$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $988b58f36f60a149$var$_crossCircle.default
    }));
$988b58f36f60a149$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $988b58f36f60a149$var$_default = module.exports.default = $988b58f36f60a149$var$CrossCircleIcon;

});
parcelRegister("hI6SY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70e4741cbfa8f6087ac64902b38a7366>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ce4be313f95bc8ed$var$_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;

});


parcelRegister("hSLU7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04ca3956c274a75$var$_react = $d04ca3956c274a75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d04ca3956c274a75$var$_dashboard = $d04ca3956c274a75$var$_interopRequireDefault((parcelRequire("gsyzJ")));
function $d04ca3956c274a75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d04ca3956c274a75$var$DashboardIcon = (props)=>/*#__PURE__*/ $d04ca3956c274a75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>`
    }, props, {
        newIcon: $d04ca3956c274a75$var$_dashboard.default
    }));
$d04ca3956c274a75$var$DashboardIcon.displayName = 'DashboardIcon';
var $d04ca3956c274a75$var$_default = module.exports.default = $d04ca3956c274a75$var$DashboardIcon;

});

parcelRegister("9lMrf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ceba61d72cb155b$var$_react = $6ceba61d72cb155b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6ceba61d72cb155b$var$_add = $6ceba61d72cb155b$var$_interopRequireDefault((parcelRequire("dZbEw")));
function $6ceba61d72cb155b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6ceba61d72cb155b$var$EditorAddIcon = (props)=>/*#__PURE__*/ $6ceba61d72cb155b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $6ceba61d72cb155b$var$_add.default
    }));
$6ceba61d72cb155b$var$EditorAddIcon.displayName = 'EditorAddIcon';
var $6ceba61d72cb155b$var$_default = module.exports.default = $6ceba61d72cb155b$var$EditorAddIcon;

});
parcelRegister("dZbEw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2ea02ce9c6e0054$var$_react = $a2ea02ce9c6e0054$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a2ea02ce9c6e0054$var$_baseNew = $a2ea02ce9c6e0054$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a2ea02ce9c6e0054$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2ea02ce9c6e0054$var$AddIcon = (props)=>/*#__PURE__*/ $a2ea02ce9c6e0054$var$_react.default.createElement($a2ea02ce9c6e0054$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$a2ea02ce9c6e0054$var$AddIcon.displayName = 'AddIcon';
var $a2ea02ce9c6e0054$var$_default = module.exports.default = $a2ea02ce9c6e0054$var$AddIcon;

});


parcelRegister("kkuz9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eccd62a69c1a1c51$var$_react = $eccd62a69c1a1c51$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eccd62a69c1a1c51$var$_information = $eccd62a69c1a1c51$var$_interopRequireDefault((parcelRequire("2Yv61")));
function $eccd62a69c1a1c51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eccd62a69c1a1c51$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $eccd62a69c1a1c51$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $eccd62a69c1a1c51$var$_information.default
    }));
$eccd62a69c1a1c51$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $eccd62a69c1a1c51$var$_default = module.exports.default = $eccd62a69c1a1c51$var$EditorPanelIcon;

});

parcelRegister("23aI7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17e42b7e07778bdb$var$_react = $17e42b7e07778bdb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $17e42b7e07778bdb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $17e42b7e07778bdb$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $17e42b7e07778bdb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
    }, props));
$17e42b7e07778bdb$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
var $17e42b7e07778bdb$var$_default = module.exports.default = $17e42b7e07778bdb$var$EmojiAtlassianIcon;

});

parcelRegister("bTqXB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a89be8174ef75ee$var$_react = $8a89be8174ef75ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8a89be8174ef75ee$var$_filter = $8a89be8174ef75ee$var$_interopRequireDefault((parcelRequire("jX361")));
function $8a89be8174ef75ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a89be8174ef75ee$var$FilterIcon = (props)=>/*#__PURE__*/ $8a89be8174ef75ee$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $8a89be8174ef75ee$var$_filter.default
    }));
$8a89be8174ef75ee$var$FilterIcon.displayName = 'FilterIcon';
var $8a89be8174ef75ee$var$_default = module.exports.default = $8a89be8174ef75ee$var$FilterIcon;

});
parcelRegister("jX361", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e89b7505e55a28f8d68b8d102eb88514>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e865edd1a40a2be5$var$_react = $e865edd1a40a2be5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e865edd1a40a2be5$var$_baseNew = $e865edd1a40a2be5$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e865edd1a40a2be5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e865edd1a40a2be5$var$FilterIcon = (props)=>/*#__PURE__*/ $e865edd1a40a2be5$var$_react.default.createElement($e865edd1a40a2be5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-2 5.25H3v-1.5h10zM11 14H5v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$e865edd1a40a2be5$var$FilterIcon.displayName = 'FilterIcon';
var $e865edd1a40a2be5$var$_default = module.exports.default = $e865edd1a40a2be5$var$FilterIcon;

});


parcelRegister("bP37O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89b6e1b4c0102ce3$var$_react = $89b6e1b4c0102ce3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $89b6e1b4c0102ce3$var$_folderClosed = $89b6e1b4c0102ce3$var$_interopRequireDefault((parcelRequire("9xuGL")));
function $89b6e1b4c0102ce3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89b6e1b4c0102ce3$var$FolderIcon = (props)=>/*#__PURE__*/ $89b6e1b4c0102ce3$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props, {
        newIcon: $89b6e1b4c0102ce3$var$_folderClosed.default
    }));
$89b6e1b4c0102ce3$var$FolderIcon.displayName = 'FolderIcon';
var $89b6e1b4c0102ce3$var$_default = module.exports.default = $89b6e1b4c0102ce3$var$FolderIcon;

});
parcelRegister("9xuGL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0bcbb1797ade28bc1c80b60f118d24e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f1f0046e553e72e$var$_react = $6f1f0046e553e72e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6f1f0046e553e72e$var$_baseNew = $6f1f0046e553e72e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6f1f0046e553e72e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f1f0046e553e72e$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $6f1f0046e553e72e$var$_react.default.createElement($6f1f0046e553e72e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$6f1f0046e553e72e$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $6f1f0046e553e72e$var$_default = module.exports.default = $6f1f0046e553e72e$var$FolderClosedIcon;

});


parcelRegister("8sgpE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $627dab81872ead3d$var$_react = $627dab81872ead3d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $627dab81872ead3d$var$_issues = $627dab81872ead3d$var$_interopRequireDefault((parcelRequire("gmyWi")));
function $627dab81872ead3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $627dab81872ead3d$var$IssuesIcon = (props)=>/*#__PURE__*/ $627dab81872ead3d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $627dab81872ead3d$var$_issues.default
    }));
$627dab81872ead3d$var$IssuesIcon.displayName = 'IssuesIcon';
var $627dab81872ead3d$var$_default = module.exports.default = $627dab81872ead3d$var$IssuesIcon;

});
parcelRegister("gmyWi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::756d4fa5fd77b2680e9e19bf5f6c468d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be99cd9cde9dc967$var$_react = $be99cd9cde9dc967$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $be99cd9cde9dc967$var$_baseNew = $be99cd9cde9dc967$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $be99cd9cde9dc967$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Issues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be99cd9cde9dc967$var$IssuesIcon = (props)=>/*#__PURE__*/ $be99cd9cde9dc967$var$_react.default.createElement($be99cd9cde9dc967$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.302.641 1.146.968-3.167 3.75a.75.75 0 0 1-1.146 0L3.552 7.484l1.146-.968 1.01 1.197z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M16 7v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75V7z" clip-rule="evenodd"/>`
    }, props));
$be99cd9cde9dc967$var$IssuesIcon.displayName = 'IssuesIcon';
var $be99cd9cde9dc967$var$_default = module.exports.default = $be99cd9cde9dc967$var$IssuesIcon;

});


parcelRegister("iUyym", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $038d8d75c24b10fb$var$_react = $038d8d75c24b10fb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $038d8d75c24b10fb$var$_lightbulb = $038d8d75c24b10fb$var$_interopRequireDefault((parcelRequire("e78BF")));
function $038d8d75c24b10fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $038d8d75c24b10fb$var$LightbulbFilledIcon = (props)=>/*#__PURE__*/ $038d8d75c24b10fb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.998 4A5.997 5.997 0 0 0 6 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611s.45.907 1 .907h4c.55 0 1-.408 1-.907s.32-1.224.71-1.611c0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0 0 11.998 4m2.965 15c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1z"/></svg>`
    }, props, {
        newIcon: $038d8d75c24b10fb$var$_lightbulb.default
    }));
$038d8d75c24b10fb$var$LightbulbFilledIcon.displayName = 'LightbulbFilledIcon';
var $038d8d75c24b10fb$var$_default = module.exports.default = $038d8d75c24b10fb$var$LightbulbFilledIcon;

});
parcelRegister("e78BF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff1a0601d1dfa1b068f5f916af0a8fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a46865398d7c7cda$var$_react = $a46865398d7c7cda$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a46865398d7c7cda$var$_baseNew = $a46865398d7c7cda$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a46865398d7c7cda$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a46865398d7c7cda$var$LightbulbIcon = (props)=>/*#__PURE__*/ $a46865398d7c7cda$var$_react.default.createElement($a46865398d7c7cda$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a4.5 4.5 0 0 0-2.516 8.232c.545.368 1.002.994 1.016 1.768h3c.014-.774.471-1.4 1.016-1.768A4.5 4.5 0 0 0 8 1.5M9.5 13h-3v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM2 6a6 6 0 1 1 9.355 4.975c-.247.167-.355.385-.355.56V14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-2.465c0-.175-.108-.393-.355-.56A6 6 0 0 1 2 6" clip-rule="evenodd"/>`
    }, props));
$a46865398d7c7cda$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $a46865398d7c7cda$var$_default = module.exports.default = $a46865398d7c7cda$var$LightbulbIcon;

});


parcelRegister("3oUqw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $279f6226088164aa$var$_react = $279f6226088164aa$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $279f6226088164aa$var$_showMoreHorizontal = $279f6226088164aa$var$_interopRequireDefault((parcelRequire("8U6zd")));
function $279f6226088164aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $279f6226088164aa$var$MoreIcon = (props)=>/*#__PURE__*/ $279f6226088164aa$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $279f6226088164aa$var$_showMoreHorizontal.default
    }));
$279f6226088164aa$var$MoreIcon.displayName = 'MoreIcon';
var $279f6226088164aa$var$_default = module.exports.default = $279f6226088164aa$var$MoreIcon;

});
parcelRegister("8U6zd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb6bef909769872b46b1e0328cacf596>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67b8a5c31f137a02$var$_react = $67b8a5c31f137a02$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $67b8a5c31f137a02$var$_baseNew = $67b8a5c31f137a02$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $67b8a5c31f137a02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67b8a5c31f137a02$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $67b8a5c31f137a02$var$_react.default.createElement($67b8a5c31f137a02$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$67b8a5c31f137a02$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $67b8a5c31f137a02$var$_default = module.exports.default = $67b8a5c31f137a02$var$ShowMoreHorizontalIcon;

});


parcelRegister("825vU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d92c98d74042315$var$_react = $5d92c98d74042315$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5d92c98d74042315$var$_notification = $5d92c98d74042315$var$_interopRequireDefault((parcelRequire("jDorM")));
function $5d92c98d74042315$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5d92c98d74042315$var$NotificationIcon = (props)=>/*#__PURE__*/ $5d92c98d74042315$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.49 17.67a2 2 0 0 0 2.83 0l-2.83-2.83a2 2 0 0 0 0 2.83m4.89-12.19-.72.73c-.78.78-2.21 1.81-3.21 2.31l-3.02 1.51c-.49.25-.58.77-.19 1.17l8.56 8.56c.4.4.92.31 1.17-.19l1.51-3.02c.49-.99 1.53-2.42 2.31-3.21l.73-.73a5.05 5.05 0 0 0 .64-6.36 1.01 1.01 0 1 0-1.35-1.49q-.04.04-.07.08A5.04 5.04 0 0 0 14.95 4a5.04 5.04 0 0 0-3.57 1.48"/></svg>`
    }, props, {
        newIcon: $5d92c98d74042315$var$_notification.default
    }));
$5d92c98d74042315$var$NotificationIcon.displayName = 'NotificationIcon';
var $5d92c98d74042315$var$_default = module.exports.default = $5d92c98d74042315$var$NotificationIcon;

});
parcelRegister("jDorM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1e0c080c29498771abac7d6e0a3c394>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4b49f7de9b103d8$var$_react = $e4b49f7de9b103d8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e4b49f7de9b103d8$var$_baseNew = $e4b49f7de9b103d8$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e4b49f7de9b103d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4b49f7de9b103d8$var$NotificationIcon = (props)=>/*#__PURE__*/ $e4b49f7de9b103d8$var$_react.default.createElement($e4b49f7de9b103d8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 5a5 5 0 0 1 10 0v3.535l1.788 2.861a1.375 1.375 0 0 1-1.166 2.104h-2.459a3.251 3.251 0 0 1-6.326 0h-2.46a1.375 1.375 0 0 1-1.165-2.104L3 8.535zm3.418 8.5a1.75 1.75 0 0 0 3.164 0zM8 1.5A3.5 3.5 0 0 0 4.5 5v3.636c0 .215-.06.426-.175.608L2.603 12h10.794l-1.723-2.756a1.15 1.15 0 0 1-.174-.608V5A3.5 3.5 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$e4b49f7de9b103d8$var$NotificationIcon.displayName = 'NotificationIcon';
var $e4b49f7de9b103d8$var$_default = module.exports.default = $e4b49f7de9b103d8$var$NotificationIcon;

});


parcelRegister("6Njc0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f2634e9f5bc5da4$var$_react = $4f2634e9f5bc5da4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4f2634e9f5bc5da4$var$_notification = $4f2634e9f5bc5da4$var$_interopRequireDefault((parcelRequire("jDorM")));
function $4f2634e9f5bc5da4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f2634e9f5bc5da4$var$NotificationDirectIcon = (props)=>/*#__PURE__*/ $4f2634e9f5bc5da4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.59 17.83a2 2 0 0 0 2.83 0L6.59 15a2 2 0 0 0 0 2.83m4.79-12.35A5.04 5.04 0 0 1 14.95 4c.97 0 1.95.28 2.79.84q.03-.04.07-.07a1.01 1.01 0 1 1 1.35 1.49 5.05 5.05 0 0 1-.64 6.36l-.72.73c-.78.78-1.81 2.21-2.31 3.21l-1.51 3.02c-.25.5-.77.58-1.17.19l-8.56-8.55c-.4-.4-.31-.92.19-1.17l3.02-1.51c.99-.49 2.42-1.53 3.21-2.31zm2.74 9.63c.52-.97 1.57-2.4 2.35-3.18l.73-.73a3.05 3.05 0 0 0 .39-3.83c-.19-.29-.72-.77-.86-.86A3.04 3.04 0 0 0 15.05 6c-.8 0-1.57.31-2.16.89l-.95.95c-.78.79-2.22 1.82-3.2 2.31L7 11.02l6.07 6.07z"/></svg>`
    }, props, {
        newIcon: $4f2634e9f5bc5da4$var$_notification.default
    }));
$4f2634e9f5bc5da4$var$NotificationDirectIcon.displayName = 'NotificationDirectIcon';
var $4f2634e9f5bc5da4$var$_default = module.exports.default = $4f2634e9f5bc5da4$var$NotificationDirectIcon;

});

parcelRegister("1FouZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $136c9fbd1122fba5$var$_react = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $136c9fbd1122fba5$var$_arrowUpRight = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("3sGLB")));
function $136c9fbd1122fba5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $136c9fbd1122fba5$var$OpenIcon = (props)=>/*#__PURE__*/ $136c9fbd1122fba5$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $136c9fbd1122fba5$var$_arrowUpRight.default
    }));
$136c9fbd1122fba5$var$OpenIcon.displayName = 'OpenIcon';
var $136c9fbd1122fba5$var$_default = module.exports.default = $136c9fbd1122fba5$var$OpenIcon;

});
parcelRegister("3sGLB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2855293259c2814d$var$_react = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2855293259c2814d$var$_baseNew = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2855293259c2814d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2855293259c2814d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $2855293259c2814d$var$_react.default.createElement($2855293259c2814d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$2855293259c2814d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $2855293259c2814d$var$_default = module.exports.default = $2855293259c2814d$var$ArrowUpRightIcon;

});


parcelRegister("eWXbg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae246388ea520792$var$_react = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $ae246388ea520792$var$_page = $ae246388ea520792$var$_interopRequireDefault((parcelRequire("kdfZa")));
function $ae246388ea520792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae246388ea520792$var$PageIcon = (props)=>/*#__PURE__*/ $ae246388ea520792$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $ae246388ea520792$var$_page.default
    }));
$ae246388ea520792$var$PageIcon.displayName = 'PageIcon';
var $ae246388ea520792$var$_default = module.exports.default = $ae246388ea520792$var$PageIcon;

});
parcelRegister("kdfZa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb716bf3c984513d$var$_react = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb716bf3c984513d$var$_baseNew = $eb716bf3c984513d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb716bf3c984513d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb716bf3c984513d$var$PageIcon = (props)=>/*#__PURE__*/ $eb716bf3c984513d$var$_react.default.createElement($eb716bf3c984513d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$eb716bf3c984513d$var$PageIcon.displayName = 'PageIcon';
var $eb716bf3c984513d$var$_default = module.exports.default = $eb716bf3c984513d$var$PageIcon;

});


parcelRegister("h8cgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
function $c78cb3eb85357720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c78cb3eb85357720$var$PeopleIcon = (props)=>/*#__PURE__*/ $c78cb3eb85357720$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $c78cb3eb85357720$var$_peopleGroup.default
    }));
$c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;

});

parcelRegister("j85Tc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ded35532616fdba1$var$_react = $ded35532616fdba1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $ded35532616fdba1$var$_person = $ded35532616fdba1$var$_interopRequireDefault((parcelRequire("1bKdn")));
function $ded35532616fdba1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ded35532616fdba1$var$PersonIcon = (props)=>/*#__PURE__*/ $ded35532616fdba1$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $ded35532616fdba1$var$_person.default
    }));
$ded35532616fdba1$var$PersonIcon.displayName = 'PersonIcon';
var $ded35532616fdba1$var$_default = module.exports.default = $ded35532616fdba1$var$PersonIcon;

});
parcelRegister("1bKdn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ddaaacfb131e12e$var$_react = $0ddaaacfb131e12e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0ddaaacfb131e12e$var$_baseNew = $0ddaaacfb131e12e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0ddaaacfb131e12e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ddaaacfb131e12e$var$PersonIcon = (props)=>/*#__PURE__*/ $0ddaaacfb131e12e$var$_react.default.createElement($0ddaaacfb131e12e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$0ddaaacfb131e12e$var$PersonIcon.displayName = 'PersonIcon';
var $0ddaaacfb131e12e$var$_default = module.exports.default = $0ddaaacfb131e12e$var$PersonIcon;

});


parcelRegister("3B33y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29e732b528688c5f$var$_react = $29e732b528688c5f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $29e732b528688c5f$var$_personAvatar = $29e732b528688c5f$var$_interopRequireDefault((parcelRequire("bdVbi")));
function $29e732b528688c5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $29e732b528688c5f$var$PersonCircleIcon = (props)=>/*#__PURE__*/ $29e732b528688c5f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M14.5 13.009h-5c-1.38 0-2.5 1.12-2.5 2.503v3.978a8.95 8.95 0 0 0 5 1.519 8.95 8.95 0 0 0 5-1.519v-3.978a2.5 2.5 0 0 0-2.5-2.503"/><circle cx="12" cy="9" r="3"/><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></g></svg>`
    }, props, {
        newIcon: $29e732b528688c5f$var$_personAvatar.default
    }));
$29e732b528688c5f$var$PersonCircleIcon.displayName = 'PersonCircleIcon';
var $29e732b528688c5f$var$_default = module.exports.default = $29e732b528688c5f$var$PersonCircleIcon;

});
parcelRegister("bdVbi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82bd439e3b283de9$var$_react = $82bd439e3b283de9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $82bd439e3b283de9$var$_baseNew = $82bd439e3b283de9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $82bd439e3b283de9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82bd439e3b283de9$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $82bd439e3b283de9$var$_react.default.createElement($82bd439e3b283de9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$82bd439e3b283de9$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $82bd439e3b283de9$var$_default = module.exports.default = $82bd439e3b283de9$var$PersonAvatarIcon;

});


parcelRegister("8EYBJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64e11291068cd489$var$_react = $64e11291068cd489$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $64e11291068cd489$var$_premium = $64e11291068cd489$var$_interopRequireDefault((parcelRequire("41hx5")));
function $64e11291068cd489$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64e11291068cd489$var$PremiumIcon = (props)=>/*#__PURE__*/ $64e11291068cd489$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
    }, props, {
        newIcon: $64e11291068cd489$var$_premium.default
    }));
$64e11291068cd489$var$PremiumIcon.displayName = 'PremiumIcon';
var $64e11291068cd489$var$_default = module.exports.default = $64e11291068cd489$var$PremiumIcon;

});
parcelRegister("41hx5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::821d8a868bec01d1b9c95a45239911fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ed4db10c38a4841$var$_react = $2ed4db10c38a4841$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ed4db10c38a4841$var$_baseNew = $2ed4db10c38a4841$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2ed4db10c38a4841$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ed4db10c38a4841$var$PremiumIcon = (props)=>/*#__PURE__*/ $2ed4db10c38a4841$var$_react.default.createElement($2ed4db10c38a4841$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$2ed4db10c38a4841$var$PremiumIcon.displayName = 'PremiumIcon';
var $2ed4db10c38a4841$var$_default = module.exports.default = $2ed4db10c38a4841$var$PremiumIcon;

});


parcelRegister("eJS47", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abaf34f2ab9c61b9$var$_react = $abaf34f2ab9c61b9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $abaf34f2ab9c61b9$var$_questionCircle = $abaf34f2ab9c61b9$var$_interopRequireDefault((parcelRequire("8nk07")));
function $abaf34f2ab9c61b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $abaf34f2ab9c61b9$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $abaf34f2ab9c61b9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $abaf34f2ab9c61b9$var$_questionCircle.default
    }));
$abaf34f2ab9c61b9$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $abaf34f2ab9c61b9$var$_default = module.exports.default = $abaf34f2ab9c61b9$var$QuestionCircleIcon;

});
parcelRegister("8nk07", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $618ffc7dfbf067c7$var$_react = $618ffc7dfbf067c7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $618ffc7dfbf067c7$var$_baseNew = $618ffc7dfbf067c7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $618ffc7dfbf067c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $618ffc7dfbf067c7$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $618ffc7dfbf067c7$var$_react.default.createElement($618ffc7dfbf067c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$618ffc7dfbf067c7$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $618ffc7dfbf067c7$var$_default = module.exports.default = $618ffc7dfbf067c7$var$QuestionCircleIcon;

});


parcelRegister("i3vuN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d250f039686fbf24$var$_react = $d250f039686fbf24$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d250f039686fbf24$var$_roadmap = $d250f039686fbf24$var$_interopRequireDefault((parcelRequire("ifnb0")));
function $d250f039686fbf24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d250f039686fbf24$var$RoadmapIcon = (props)=>/*#__PURE__*/ $d250f039686fbf24$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $d250f039686fbf24$var$_roadmap.default
    }));
$d250f039686fbf24$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $d250f039686fbf24$var$_default = module.exports.default = $d250f039686fbf24$var$RoadmapIcon;

});
parcelRegister("ifnb0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d48b9b12f073239d$var$_react = $d48b9b12f073239d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d48b9b12f073239d$var$_baseNew = $d48b9b12f073239d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d48b9b12f073239d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d48b9b12f073239d$var$RoadmapIcon = (props)=>/*#__PURE__*/ $d48b9b12f073239d$var$_react.default.createElement($d48b9b12f073239d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$d48b9b12f073239d$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $d48b9b12f073239d$var$_default = module.exports.default = $d48b9b12f073239d$var$RoadmapIcon;

});


parcelRegister("3Jz4b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b80c68588d37bf1$var$_react = $2b80c68588d37bf1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2b80c68588d37bf1$var$_screen = $2b80c68588d37bf1$var$_interopRequireDefault((parcelRequire("9fIhE")));
function $2b80c68588d37bf1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2b80c68588d37bf1$var$ScreenIcon = (props)=>/*#__PURE__*/ $2b80c68588d37bf1$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M3 6.009C3 4.899 3.893 4 4.995 4h14.01C20.107 4 21 4.902 21 6.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 13.991zM5 14h14V6H5z"/><path d="M10 17h4v3h-4zm-1 3.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5v.5H9z"/></g></svg>`
    }, props, {
        newIcon: $2b80c68588d37bf1$var$_screen.default
    }));
$2b80c68588d37bf1$var$ScreenIcon.displayName = 'ScreenIcon';
var $2b80c68588d37bf1$var$_default = module.exports.default = $2b80c68588d37bf1$var$ScreenIcon;

});
parcelRegister("9fIhE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6bc7dd9da70c6d51$var$_react = $6bc7dd9da70c6d51$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6bc7dd9da70c6d51$var$_baseNew = $6bc7dd9da70c6d51$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6bc7dd9da70c6d51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6bc7dd9da70c6d51$var$ScreenIcon = (props)=>/*#__PURE__*/ $6bc7dd9da70c6d51$var$_react.default.createElement($6bc7dd9da70c6d51$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$6bc7dd9da70c6d51$var$ScreenIcon.displayName = 'ScreenIcon';
var $6bc7dd9da70c6d51$var$_default = module.exports.default = $6bc7dd9da70c6d51$var$ScreenIcon;

});


parcelRegister("tvuR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $058b2421e8b6ab38$var$_react = $058b2421e8b6ab38$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $058b2421e8b6ab38$var$_search = $058b2421e8b6ab38$var$_interopRequireDefault((parcelRequire("hyOJh")));
function $058b2421e8b6ab38$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $058b2421e8b6ab38$var$SearchIcon = (props)=>/*#__PURE__*/ $058b2421e8b6ab38$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $058b2421e8b6ab38$var$_search.default
    }));
$058b2421e8b6ab38$var$SearchIcon.displayName = 'SearchIcon';
var $058b2421e8b6ab38$var$_default = module.exports.default = $058b2421e8b6ab38$var$SearchIcon;

});
parcelRegister("hyOJh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17c2ea3862f75cebada30b1178c22cdb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc8cf66814b59134$var$_react = $cc8cf66814b59134$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cc8cf66814b59134$var$_baseNew = $cc8cf66814b59134$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $cc8cf66814b59134$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc8cf66814b59134$var$SearchIcon = (props)=>/*#__PURE__*/ $cc8cf66814b59134$var$_react.default.createElement($cc8cf66814b59134$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$cc8cf66814b59134$var$SearchIcon.displayName = 'SearchIcon';
var $cc8cf66814b59134$var$_default = module.exports.default = $cc8cf66814b59134$var$SearchIcon;

});


parcelRegister("lzUP9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb58f1f2f3adb0d0$var$_react = $fb58f1f2f3adb0d0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $fb58f1f2f3adb0d0$var$_settings = $fb58f1f2f3adb0d0$var$_interopRequireDefault((parcelRequire("epOG5")));
function $fb58f1f2f3adb0d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb58f1f2f3adb0d0$var$SettingsIcon = (props)=>/*#__PURE__*/ $fb58f1f2f3adb0d0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $fb58f1f2f3adb0d0$var$_settings.default
    }));
$fb58f1f2f3adb0d0$var$SettingsIcon.displayName = 'SettingsIcon';
var $fb58f1f2f3adb0d0$var$_default = module.exports.default = $fb58f1f2f3adb0d0$var$SettingsIcon;

});
parcelRegister("epOG5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::654979ffcf55141d2c08f198a843721e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7eab60df9d4cfd1$var$_react = $a7eab60df9d4cfd1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a7eab60df9d4cfd1$var$_baseNew = $a7eab60df9d4cfd1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a7eab60df9d4cfd1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7eab60df9d4cfd1$var$SettingsIcon = (props)=>/*#__PURE__*/ $a7eab60df9d4cfd1$var$_react.default.createElement($a7eab60df9d4cfd1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$a7eab60df9d4cfd1$var$SettingsIcon.displayName = 'SettingsIcon';
var $a7eab60df9d4cfd1$var$_default = module.exports.default = $a7eab60df9d4cfd1$var$SettingsIcon;

});


parcelRegister("jUUuf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7ff1067bfd2c51e$var$_react = $e7ff1067bfd2c51e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e7ff1067bfd2c51e$var$_release = $e7ff1067bfd2c51e$var$_interopRequireDefault((parcelRequire("2Ljwn")));
function $e7ff1067bfd2c51e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e7ff1067bfd2c51e$var$ShipIcon = (props)=>/*#__PURE__*/ $e7ff1067bfd2c51e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $e7ff1067bfd2c51e$var$_release.default
    }));
$e7ff1067bfd2c51e$var$ShipIcon.displayName = 'ShipIcon';
var $e7ff1067bfd2c51e$var$_default = module.exports.default = $e7ff1067bfd2c51e$var$ShipIcon;

});
parcelRegister("2Ljwn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1a26e96d639121c034f7ae4d8530108>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $202f1d0bd9c274bb$var$_react = $202f1d0bd9c274bb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $202f1d0bd9c274bb$var$_baseNew = $202f1d0bd9c274bb$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $202f1d0bd9c274bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $202f1d0bd9c274bb$var$ReleaseIcon = (props)=>/*#__PURE__*/ $202f1d0bd9c274bb$var$_react.default.createElement($202f1d0bd9c274bb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$202f1d0bd9c274bb$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $202f1d0bd9c274bb$var$_default = module.exports.default = $202f1d0bd9c274bb$var$ReleaseIcon;

});


parcelRegister("17Ngn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d1ca88a8f82a5bd$var$_react = $0d1ca88a8f82a5bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0d1ca88a8f82a5bd$var$_linkExternal = $0d1ca88a8f82a5bd$var$_interopRequireDefault((parcelRequire("ggICg")));
function $0d1ca88a8f82a5bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0d1ca88a8f82a5bd$var$ShortcutIcon = (props)=>/*#__PURE__*/ $0d1ca88a8f82a5bd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props, {
        newIcon: $0d1ca88a8f82a5bd$var$_linkExternal.default
    }));
$0d1ca88a8f82a5bd$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $0d1ca88a8f82a5bd$var$_default = module.exports.default = $0d1ca88a8f82a5bd$var$ShortcutIcon;

});
parcelRegister("ggICg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3602017c9c0db571ac57dae4d1f426bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd80bfcc708167b5$var$_react = $bd80bfcc708167b5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bd80bfcc708167b5$var$_baseNew = $bd80bfcc708167b5$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $bd80bfcc708167b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd80bfcc708167b5$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $bd80bfcc708167b5$var$_react.default.createElement($bd80bfcc708167b5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$bd80bfcc708167b5$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $bd80bfcc708167b5$var$_default = module.exports.default = $bd80bfcc708167b5$var$LinkExternalIcon;

});


parcelRegister("71IBF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51db3a542c2bbfd0$var$_react = $51db3a542c2bbfd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $51db3a542c2bbfd0$var$_logIn = $51db3a542c2bbfd0$var$_interopRequireDefault((parcelRequire("pkYLA")));
function $51db3a542c2bbfd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $51db3a542c2bbfd0$var$SignInIcon = (props)=>/*#__PURE__*/ $51db3a542c2bbfd0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M15.503 3H12v2h7v14h-7v2h7.006c1.1 0 1.994-.893 1.994-1.995V4.995A1.993 1.993 0 0 0 19.006 3z"/><path d="M3.977 11A.99.99 0 0 0 3 12.001c0 .551.437.999.977.999h11.047a.99.99 0 0 0 .976-.999.99.99 0 0 0-.976-1.001z"/><path d="M12.303 8.305a1.053 1.053 0 0 0 0 1.478L14.5 12l-2.197 2.217a1.05 1.05 0 0 0 0 1.476c.404.409 1.06.409 1.465 0l2.93-2.955a1.055 1.055 0 0 0 0-1.477l-2.93-2.956a1.034 1.034 0 0 0-1.465 0"/></g></svg>`
    }, props, {
        newIcon: $51db3a542c2bbfd0$var$_logIn.default
    }));
$51db3a542c2bbfd0$var$SignInIcon.displayName = 'SignInIcon';
var $51db3a542c2bbfd0$var$_default = module.exports.default = $51db3a542c2bbfd0$var$SignInIcon;

});
parcelRegister("pkYLA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd6da84e11aa1d5b6e9ca710faf282a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04c29bed890774ab$var$_react = $04c29bed890774ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $04c29bed890774ab$var$_baseNew = $04c29bed890774ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $04c29bed890774ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04c29bed890774ab$var$LogInIcon = (props)=>/*#__PURE__*/ $04c29bed890774ab$var$_react.default.createElement($04c29bed890774ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$04c29bed890774ab$var$LogInIcon.displayName = 'LogInIcon';
var $04c29bed890774ab$var$_default = module.exports.default = $04c29bed890774ab$var$LogInIcon;

});


parcelRegister("5oTeF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eea0a48351333dc$var$_react = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3eea0a48351333dc$var$_starUnstarred = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("dAf5R")));
function $3eea0a48351333dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3eea0a48351333dc$var$StarIcon = (props)=>/*#__PURE__*/ $3eea0a48351333dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $3eea0a48351333dc$var$_starUnstarred.default
    }));
$3eea0a48351333dc$var$StarIcon.displayName = 'StarIcon';
var $3eea0a48351333dc$var$_default = module.exports.default = $3eea0a48351333dc$var$StarIcon;

});
parcelRegister("dAf5R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79fdc87e6bc8c8ac301f370494c87ace>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e3a586d66f39291$var$_react = $9e3a586d66f39291$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9e3a586d66f39291$var$_baseNew = $9e3a586d66f39291$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9e3a586d66f39291$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e3a586d66f39291$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $9e3a586d66f39291$var$_react.default.createElement($9e3a586d66f39291$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$9e3a586d66f39291$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $9e3a586d66f39291$var$_default = module.exports.default = $9e3a586d66f39291$var$StarUnstarredIcon;

});


parcelRegister("bH1hf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8834b3797a7b4177$var$_react = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8834b3797a7b4177$var$_starStarred = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("dm1qi")));
function $8834b3797a7b4177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8834b3797a7b4177$var$StarFilledIcon = (props)=>/*#__PURE__*/ $8834b3797a7b4177$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $8834b3797a7b4177$var$_starStarred.default
    }));
$8834b3797a7b4177$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $8834b3797a7b4177$var$_default = module.exports.default = $8834b3797a7b4177$var$StarFilledIcon;

});
parcelRegister("dm1qi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b8e6f0febff8b04$var$_react = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9b8e6f0febff8b04$var$_baseNew = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9b8e6f0febff8b04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b8e6f0febff8b04$var$StarStarredIcon = (props)=>/*#__PURE__*/ $9b8e6f0febff8b04$var$_react.default.createElement($9b8e6f0febff8b04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$9b8e6f0febff8b04$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $9b8e6f0febff8b04$var$_default = module.exports.default = $9b8e6f0febff8b04$var$StarStarredIcon;

});


parcelRegister("iZZ4y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd4d4c38eee85cd6$var$_react = $dd4d4c38eee85cd6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $dd4d4c38eee85cd6$var$_personAvatar = $dd4d4c38eee85cd6$var$_interopRequireDefault((parcelRequire("bdVbi")));
function $dd4d4c38eee85cd6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dd4d4c38eee85cd6$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $dd4d4c38eee85cd6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
    }, props, {
        newIcon: $dd4d4c38eee85cd6$var$_personAvatar.default
    }));
$dd4d4c38eee85cd6$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
var $dd4d4c38eee85cd6$var$_default = module.exports.default = $dd4d4c38eee85cd6$var$UserAvatarCircleIcon;

});

parcelRegister("jgVsb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $917e50e7374c5801$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $gjZMs = parcelRequire("gjZMs");

var $kdO7l = parcelRequire("kdO7l");
const $917e50e7374c5801$var$headerStyles = null;
const $917e50e7374c5801$var$flexStyles = (0, $8CUq3.xcss)({
    flexDirection: 'row-reverse',
    width: '100%'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $917e50e7374c5801$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $kdO7l.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1ezb _85i5pxbi _1q511ejb"
        ]),
        children: shouldShowCloseButton ? // The reason we are putting the close button first in the DOM and then
        // reordering them is to ensure that users of assistive technology get
        // all the context of a modal when initial focus is placed on the close
        // button, since it's the first interactive element.
        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $917e50e7374c5801$var$flexStyles,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kgoHi.default), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gjZMs.CloseButton), {
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kgoHi.default), {
                    justifyContent: "start",
                    alignItems: "center",
                    children: children
                })
            ]
        }) : children
    });
};
var $917e50e7374c5801$export$2e2bcd8739ae039 = $917e50e7374c5801$var$ModalHeader;

});
parcelRegister("kgoHi", function(module, exports) {

$parcel$export(module.exports, "default", () => $30ed2d7f7860488b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $55sHU = parcelRequire("55sHU");

var $8CUq3 = parcelRequire("8CUq3");
function $30ed2d7f7860488b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $30ed2d7f7860488b$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $30ed2d7f7860488b$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $30ed2d7f7860488b$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $30ed2d7f7860488b$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $30ed2d7f7860488b$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $30ed2d7f7860488b$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $30ed2d7f7860488b$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $55sHU.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $55sHU.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $55sHU.spaceStylesMap).rowGap[rowGap],
            alignItems && $30ed2d7f7860488b$var$alignItemsMap[alignItems],
            direction && $30ed2d7f7860488b$var$flexDirectionMap[direction],
            justifyContent && $30ed2d7f7860488b$var$justifyContentMap[justifyContent],
            wrap && $30ed2d7f7860488b$var$flexWrapMap[wrap],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$30ed2d7f7860488b$var$Flex.displayName = 'Flex';
var $30ed2d7f7860488b$export$2e2bcd8739ae039 = $30ed2d7f7860488b$var$Flex;

});

parcelRegister("gjZMs", function(module, exports) {

$parcel$export(module.exports, "CloseButton", () => $dba41d8b7626d36b$export$de65de8213222d10);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $84THj = parcelRequire("84THj");
const $dba41d8b7626d36b$export$de65de8213222d10 = ({ label: label, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($84THj))),
        label: label || 'Close Modal',
        onClick: onClick
    });

});
parcelRegister("42CjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0bfcbabdc5b5773$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5JjdN = parcelRequire("5JjdN");

var $3bDjY = parcelRequire("3bDjY");

var $jldZL = parcelRequire("jldZL");

var $2PDYT = parcelRequire("2PDYT");

var $4vsgW = parcelRequire("4vsgW");

var $ijDdv = parcelRequire("ijDdv");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $f0bfcbabdc5b5773$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PDYT.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4vsgW.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ijDdv.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PDYT.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $5JjdN.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4vsgW.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ijDdv.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$f0bfcbabdc5b5773$var$IconButton.displayName = 'IconButton';
var $f0bfcbabdc5b5773$export$2e2bcd8739ae039 = $f0bfcbabdc5b5773$var$IconButton;

});
parcelRegister("5JjdN", function(module, exports) {

$parcel$export(module.exports, "default", () => $633359c4b482af8b$export$2e2bcd8739ae039);
function $633359c4b482af8b$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("3bDjY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a32ae7efc436f22$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $cVP8B = parcelRequire("cVP8B");

var $eGmKJ = parcelRequire("eGmKJ");

var $71YXv = parcelRequire("71YXv");

var $98OXW = parcelRequire("98OXW");

var $9Mkr0 = parcelRequire("9Mkr0");

var $35XSW = parcelRequire("35XSW");
var $4uxPN = parcelRequire("4uxPN");

var $VSDnB = parcelRequire("VSDnB");

var $4oNEb = parcelRequire("4oNEb");

var $k8nZq = parcelRequire("k8nZq");

var $k5uoT = parcelRequire("k5uoT");

var $7r5w3 = parcelRequire("7r5w3");

var $hujyS = parcelRequire("hujyS");

var $i7NyT = parcelRequire("i7NyT");

var $2GU2Y = parcelRequire("2GU2Y");

var $BCDGx = parcelRequire("BCDGx");
const $6a32ae7efc436f22$var$tooltipZIndex = (0, $k5uoT.layers).tooltip();
const $6a32ae7efc436f22$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
// Inverts motion direction
const $6a32ae7efc436f22$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $6a32ae7efc436f22$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $6a32ae7efc436f22$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $2GU2Y.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $eGmKJ.default), onHide: onHide = (0, $eGmKJ.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $cVP8B.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$6a32ae7efc436f22$var$analyticsAttributes
    });
    const onHideHandler = (0, $cVP8B.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$6a32ae7efc436f22$var$analyticsAttributes
    });
    const apiRef = (0, $5uXOq.useRef)(null);
    const [state, setState] = (0, $5uXOq.useState)('hide');
    const targetRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $5uXOq.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $98OXW.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $98OXW.default)(onShowHandler);
    const onHideHandlerStable = (0, $98OXW.default)(onHideHandler);
    const delayStable = (0, $98OXW.default)(delay);
    const canAppearStable = (0, $98OXW.default)(canAppear);
    const hasCalledShowHandler = (0, $5uXOq.useRef)(false);
    const start = (0, $5uXOq.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $5uXOq.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $5uXOq.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5uXOq.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $7r5w3.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $5uXOq.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $hujyS.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    const hideTooltipOnEsc = (0, $5uXOq.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $71YXv.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (state === 'hide') return 0, $eGmKJ.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $cBeZP.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $5uXOq.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $BCDGx.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $5uXOq.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $BCDGx.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $5uXOq.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (targetRef.current && !targetRef.current.matches(':focus-visible') && (0, $VSDnB.fg)('platform-tooltip-focus-visible')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $5uXOq.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const handleOpenLayerObserverCloseSignal = (0, $5uXOq.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && ((0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers') ? shouldRenderTooltipChildren : true),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $i7NyT.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $5uXOq.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    children({
                        ...tooltipTriggerProps,
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    }),
                    hiddenContent
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)(CastTargetContainer, {
                ...tooltipTriggerProps,
                ref: setImplicitRefFromChildren,
                /**
     * TODO: Why is role="presentation" added?
     * - Is it only to "remove" the `Container` from screen readers?
     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
     */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            }),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                zIndex: $6a32ae7efc436f22$var$tooltipZIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        const direction = position === 'mouse' ? undefined : $6a32ae7efc436f22$var$invertedDirection[$6a32ae7efc436f22$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4uxPN.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
$6a32ae7efc436f22$var$Tooltip.displayName = 'Tooltip';
var $6a32ae7efc436f22$export$2e2bcd8739ae039 = $6a32ae7efc436f22$var$Tooltip;

});
parcelRegister("71YXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3279c389e4b2ed8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

function $c3279c389e4b2ed8$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $5uXOq.useRef)(false);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $5e71d9a7b5ef77ee$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $5uXOq.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $5e71d9a7b5ef77ee$export$390330c10ff2b9a1 = 'ArrowUp';
const $5e71d9a7b5ef77ee$export$a80636c6f41931fe = 'ArrowDown';
const $5e71d9a7b5ef77ee$export$4af703091671bc = 'Home';
const $5e71d9a7b5ef77ee$export$e2bc30913faa5db7 = 'End';
const $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b = 'Tab';
const $5e71d9a7b5ef77ee$export$8152f929a25a0ff4 = 'Enter';
const $5e71d9a7b5ef77ee$export$e51a3576c045c8d5 = 'Space';
const $5e71d9a7b5ef77ee$export$2bb790b9008907b4 = 'Escape';


parcelRegister("98OXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $16857c6631d3f677$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $16857c6631d3f677$export$2e2bcd8739ae039(value) {
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("9Mkr0", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $cae134e314e7af2c$export$469bb693f11edc7f);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $kEhTY = parcelRequire("kEhTY");

var $7e96v = parcelRequire("7e96v");
function $cae134e314e7af2c$export$469bb693f11edc7f({ isOpen: isOpen, onClose: onClose }) {
    const context = (0, $5uXOq.useContext)((0, $kEhTY.OpenLayerObserverContext));
    const namespace = (0, $7e96v.useOpenLayerObserverNamespace)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers')) return;
        /**
		 * Increments the layer count when the component mounts or becomes visible.
		 *
		 * Returns a cleanup function to decrement the layer count when the component unmounts or becomes hidden.
		 */ if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function cleanup() {
            context.decrement();
        };
    }, [
        context,
        isOpen,
        namespace
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (!(0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers')) return;
        if (context === null) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("kEhTY", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", () => $b69a64f72818831f$export$5fbf4d7fae6cdc00);

var $5uXOq = parcelRequire("5uXOq");
const $b69a64f72818831f$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});

parcelRegister("7e96v", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $00141b72bf12446b$export$1d57e79091cc3046);

var $5uXOq = parcelRequire("5uXOq");

var $6uI1O = parcelRequire("6uI1O");
function $00141b72bf12446b$export$1d57e79091cc3046() {
    const namespace = (0, $5uXOq.useContext)((0, $6uI1O.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("6uI1O", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $8ef0ae0e95e482da$export$644a49f3b8c50fcd);

var $5uXOq = parcelRequire("5uXOq");
const $8ef0ae0e95e482da$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});



parcelRegister("7r5w3", function(module, exports) {

$parcel$export(module.exports, "register", () => $30d13d24dfc1dd2d$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $cBeZP = parcelRequire("cBeZP");
const $30d13d24dfc1dd2d$var$registrations = new Set();
let $30d13d24dfc1dd2d$var$cleanupEndEventListeners = null;
function $30d13d24dfc1dd2d$var$onDragStart() {
    if ($30d13d24dfc1dd2d$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $30d13d24dfc1dd2d$var$cleanupEndEventListeners = (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragend',
            listener: $30d13d24dfc1dd2d$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $30d13d24dfc1dd2d$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $30d13d24dfc1dd2d$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($30d13d24dfc1dd2d$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $30d13d24dfc1dd2d$var$onDragEnd() {
    $30d13d24dfc1dd2d$var$cleanupEndEventListeners?.();
    $30d13d24dfc1dd2d$var$cleanupEndEventListeners = null;
    const clone = Array.from($30d13d24dfc1dd2d$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $30d13d24dfc1dd2d$var$bindStartEvents() {
    return (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $30d13d24dfc1dd2d$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $30d13d24dfc1dd2d$var$onDragStart
        }
    ]);
}
let $30d13d24dfc1dd2d$var$cleanupStartEventListeners = null;
function $30d13d24dfc1dd2d$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$30d13d24dfc1dd2d$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $30d13d24dfc1dd2d$var$cleanupStartEventListeners = $30d13d24dfc1dd2d$var$bindStartEvents();
    $30d13d24dfc1dd2d$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $30d13d24dfc1dd2d$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $30d13d24dfc1dd2d$var$registrations.delete(registration);
        if ($30d13d24dfc1dd2d$var$registrations.size === 0) {
            $30d13d24dfc1dd2d$var$cleanupStartEventListeners?.();
            $30d13d24dfc1dd2d$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("hujyS", function(module, exports) {

$parcel$export(module.exports, "show", () => $20cb1f7c3bdaaaba$export$57bf213be019eeb0);

var $fDxFB = parcelRequire("fDxFB");
let $20cb1f7c3bdaaaba$var$active = null;
function $20cb1f7c3bdaaaba$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($20cb1f7c3bdaaaba$var$active && $20cb1f7c3bdaaaba$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $fDxFB.clearScheduled)();
            $20cb1f7c3bdaaaba$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $fDxFB.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $fDxFB.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $fDxFB.scheduleTimeout)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($20cb1f7c3bdaaaba$var$active && $20cb1f7c3bdaaaba$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($20cb1f7c3bdaaaba$var$active) {
            (0, $fDxFB.clearScheduled)();
            $20cb1f7c3bdaaaba$var$active.entry.hide({
                isImmediate: true
            });
            $20cb1f7c3bdaaaba$var$active.entry.done();
            $20cb1f7c3bdaaaba$var$active = null;
        }
        // this tooltip is now the active tooltip
        $20cb1f7c3bdaaaba$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $fDxFB.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("fDxFB", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", () => $a0c696065026d985$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $a0c696065026d985$export$5f4d6617421d489b);
let $a0c696065026d985$var$delayId = null;
function $a0c696065026d985$export$eaf678f6f93f5250() {
    if ($a0c696065026d985$var$delayId != null) {
        window.clearTimeout($a0c696065026d985$var$delayId);
        $a0c696065026d985$var$delayId = null;
    }
}
function $a0c696065026d985$export$5f4d6617421d489b(fn, delay) {
    $a0c696065026d985$export$eaf678f6f93f5250();
    $a0c696065026d985$var$delayId = window.setTimeout(()=>{
        $a0c696065026d985$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("i7NyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6abe69a0276ee72$export$2e2bcd8739ae039);

var $9KnKW = parcelRequire("9KnKW");
function $a6abe69a0276ee72$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $9KnKW.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("9KnKW", function(module, exports) {

$parcel$export(module.exports, "useId", () => $62a5d20aa68cb64e$export$f680877a34711e37);
$parcel$export(module.exports, "IdProvider", () => $62a5d20aa68cb64e$export$6be90bcb437e928f);
$parcel$export(module.exports, "useIdSeed", () => $62a5d20aa68cb64e$export$6ee17796e3d70de2);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $22Gxp = parcelRequire("22Gxp");

var $VSDnB = parcelRequire("VSDnB");
// @ts-ignore - useId is not accessible in React 16
const $62a5d20aa68cb64e$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useId ?? undefined;
function $62a5d20aa68cb64e$export$f680877a34711e37() {
    if ($62a5d20aa68cb64e$var$react18UseId && (0, $VSDnB.fg)('platform-dst-react-18-use-id')) return $62a5d20aa68cb64e$var$react18UseId();
    return `uid${(0, $22Gxp.useUID)()}`;
}
const $62a5d20aa68cb64e$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${$62a5d20aa68cb64e$export$f680877a34711e37()}${postfix}`;
    (0, $5uXOq.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
function $62a5d20aa68cb64e$export$6ee17796e3d70de2() {
    if ($62a5d20aa68cb64e$var$react18UseId && (0, $VSDnB.fg)('platform-dst-react-18-use-id')) {
        const uid = $62a5d20aa68cb64e$var$react18UseId();
        return (id)=>`${uid}-${id.toString()}`;
    }
    return (0, $22Gxp.useUIDSeed)();
}

});


parcelRegister("2GU2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5329ae62da69c819$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $btzsC = parcelRequire("btzsC");
const $5329ae62da69c819$var$baseStyles = null;
const $5329ae62da69c819$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $5329ae62da69c819$var$TooltipContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $btzsC.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        children: children
    });
});
$5329ae62da69c819$var$TooltipContainer.displayName = 'TooltipContainer';
var $5329ae62da69c819$export$2e2bcd8739ae039 = $5329ae62da69c819$var$TooltipContainer;

});
parcelRegister("btzsC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ffa256b65532dda$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $k5uoT = parcelRequire("k5uoT");
const $5ffa256b65532dda$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
const $5ffa256b65532dda$var$primitiveStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zindex: `var(${$5ffa256b65532dda$var$VAR_PRIMITIVE_ZINDEX})`,
    cursor: `default`
});
/**
 * The lower level component for rendering a tooltip.
 */ const $5ffa256b65532dda$var$TooltipPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    const styleWithZIndex = {
        ...style,
        [$5ffa256b65532dda$var$VAR_PRIMITIVE_ZINDEX]: (0, $k5uoT.layers).tooltip()
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styleWithZIndex,
        "data-testid": testId ? `${testId}--wrapper` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "tooltip",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // Because the tooltip should not be focusable, there is no reason to have key events.
        /* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
        /* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
        css: $5ffa256b65532dda$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$5ffa256b65532dda$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $5ffa256b65532dda$export$2e2bcd8739ae039 = $5ffa256b65532dda$var$TooltipPrimitive;

});


parcelRegister("BCDGx", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", () => $525a92fc84f54d7e$export$642213d516a9b928);
function $525a92fc84f54d7e$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("2PDYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4992a0728282b0$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $5JjdN = parcelRequire("5JjdN");

var $SliG5 = parcelRequire("SliG5");

var $9KnKW = parcelRequire("9KnKW");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");

var $jldZL = parcelRequire("jldZL");

var $icwyz = parcelRequire("icwyz");

var $cUzav = parcelRequire("cUzav");

var $77410 = parcelRequire("77410");
const $6a4992a0728282b0$var$LOADING_LABEL = ', Loading';
const $6a4992a0728282b0$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1caa _syaz1lh4 _aetrglyw _irr31caa _30l31lh4 _1di61caa _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhk1w7a _y4ti12x7 _bozg12x7"
};
const $6a4992a0728282b0$var$defaultStyles = {
    root: "_bfhkiw92 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $6a4992a0728282b0$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $6a4992a0728282b0$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
const $6a4992a0728282b0$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
const $6a4992a0728282b0$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $6a4992a0728282b0$var$subtleStyles = {
    root: "_bfhk1w7a _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
const $6a4992a0728282b0$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $6a4992a0728282b0$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    const localRef = (0, $5uXOq.useRef)(null);
    const splitButtonContext = (0, $icwyz.useSplitButtonContext)();
    const loadingLabelId = (0, $9KnKW.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton && (0, $VSDnB.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $SliG5.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $5JjdN.default)([
            localRef,
            ref
        ]),
        xcss: (0, $3JT92.cx)($6a4992a0728282b0$var$styles.base, appearance === 'default' && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $6a4992a0728282b0$var$defaultStyles.rootRefreshed : $6a4992a0728282b0$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $6a4992a0728282b0$var$defaultStyles.interactiveRefreshed : $6a4992a0728282b0$var$defaultStyles.interactive), appearance === 'primary' && $6a4992a0728282b0$var$primaryStyles.root, appearance === 'primary' && isInteractive && $6a4992a0728282b0$var$primaryStyles.interactive, appearance === 'warning' && $6a4992a0728282b0$var$warningStyles.root, appearance === 'warning' && isInteractive && $6a4992a0728282b0$var$warningStyles.interactive, appearance === 'danger' && $6a4992a0728282b0$var$dangerStyles.root, appearance === 'danger' && isInteractive && $6a4992a0728282b0$var$dangerStyles.interactive, appearance === 'discovery' && $6a4992a0728282b0$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $6a4992a0728282b0$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $6a4992a0728282b0$var$subtleStyles.rootRefreshed : $6a4992a0728282b0$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $6a4992a0728282b0$var$subtleStyles.interactiveRefreshed : $6a4992a0728282b0$var$subtleStyles.interactive), $6a4992a0728282b0$var$styles.linkDecorationUnset, isSelected && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $6a4992a0728282b0$var$selectedStyles.rootRefreshed : $6a4992a0728282b0$var$selectedStyles.root), isSelected && isSplitButton && $6a4992a0728282b0$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $6a4992a0728282b0$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $6a4992a0728282b0$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $6a4992a0728282b0$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $6a4992a0728282b0$var$selectedStyles.discovery, isDisabled && $6a4992a0728282b0$var$styles.disabled, isCircle && !isSplitButton && $6a4992a0728282b0$var$styles.circle, spacing === 'compact' && $6a4992a0728282b0$var$styles.spacingCompact, hasIconBefore && $6a4992a0728282b0$var$styles.buttonIconBefore, shouldFitContainer && $6a4992a0728282b0$var$styles.fullWidth, hasIconAfter && $6a4992a0728282b0$var$styles.buttonIconAfter, isIconButton && $6a4992a0728282b0$var$styles.iconButton, isIconButton && spacing === 'compact' && $6a4992a0728282b0$var$styles.iconButtonCompact, isLoading && $6a4992a0728282b0$var$styles.loading, isSplitButton && $6a4992a0728282b0$var$styles.splitButton, isNavigationSplitButton && $6a4992a0728282b0$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$6a4992a0728282b0$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $cUzav.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $icwyz.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        $6a4992a0728282b0$var$styles.loadingOverlay
                    ]),
                    children: (0, $77410.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                    id: loadingLabelId,
                    children: $6a4992a0728282b0$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $6a4992a0728282b0$export$2e2bcd8739ae039 = $6a4992a0728282b0$var$ButtonBase;

});
parcelRegister("icwyz", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", () => $c9c095971b0e7001$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $c9c095971b0e7001$export$47e2c6fdb142d947);

var $5uXOq = parcelRequire("5uXOq");
const $c9c095971b0e7001$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c9c095971b0e7001$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $5uXOq.useContext)($c9c095971b0e7001$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("cUzav", function(module, exports) {

$parcel$export(module.exports, "default", () => $084bad2e87cd222d$export$2e2bcd8739ae039);
function $084bad2e87cd222d$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $084bad2e87cd222d$var$tabKeyCode = 9;
function $084bad2e87cd222d$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $084bad2e87cd222d$var$tabKeyCode) return;
    $084bad2e87cd222d$var$abort(event);
}
function $084bad2e87cd222d$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $084bad2e87cd222d$var$abort,
        onMouseUpCapture: $084bad2e87cd222d$var$abort,
        onKeyDownCapture: $084bad2e87cd222d$var$onKey,
        onKeyUpCapture: $084bad2e87cd222d$var$onKey,
        onTouchStartCapture: $084bad2e87cd222d$var$abort,
        onTouchEndCapture: $084bad2e87cd222d$var$abort,
        onPointerDownCapture: $084bad2e87cd222d$var$abort,
        onPointerUpCapture: $084bad2e87cd222d$var$abort,
        onClickCapture: $084bad2e87cd222d$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $084bad2e87cd222d$var$abort
    } : events;
}

});

parcelRegister("77410", function(module, exports) {

$parcel$export(module.exports, "default", () => $8751b8327b6d3f9f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");
function $8751b8327b6d3f9f$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $8751b8327b6d3f9f$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $8751b8327b6d3f9f$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
        size: $8751b8327b6d3f9f$var$getIconSpacing(spacing),
        appearance: $8751b8327b6d3f9f$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("4vsgW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff38d2b65d8a0d1f$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $ff38d2b65d8a0d1f$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $ff38d2b65d8a0d1f$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $ff38d2b65d8a0d1f$var$styles.common,
            type === 'text' && $ff38d2b65d8a0d1f$var$styles.text,
            type === 'icon' && $ff38d2b65d8a0d1f$var$styles.icon,
            isLoading && $ff38d2b65d8a0d1f$var$styles.fade,
            position === 'before' && $ff38d2b65d8a0d1f$var$styles.beforeIcon,
            position === 'after' && $ff38d2b65d8a0d1f$var$styles.afterIcon
        ]),
        children: children
    });
};
var $ff38d2b65d8a0d1f$export$2e2bcd8739ae039 = $ff38d2b65d8a0d1f$var$Content;

});

parcelRegister("ijDdv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1772ea5cb5ed674$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $c1772ea5cb5ed674$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $c1772ea5cb5ed674$var$IconRenderer = ({ icon: Icon })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: $c1772ea5cb5ed674$var$isIconRenderProp(Icon) ? Icon({
            label: '',
            color: 'currentColor'
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: "",
            color: 'currentColor'
        })
    });
};
var $c1772ea5cb5ed674$export$2e2bcd8739ae039 = $c1772ea5cb5ed674$var$IconRenderer;

});



parcelRegister("kdO7l", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $ba226b18ae1f0093$export$33ffd74ebf07f060);

var $5uXOq = parcelRequire("5uXOq");

var $fYbIt = parcelRequire("fYbIt");
const $ba226b18ae1f0093$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $5uXOq.useContext)((0, $fYbIt.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});
parcelRegister("fYbIt", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $086829fa8fafdd69$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $086829fa8fafdd69$export$dece24112a937f92);

var $5uXOq = parcelRequire("5uXOq");
const $086829fa8fafdd69$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $086829fa8fafdd69$export$dece24112a937f92 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});



parcelRegister("gofOI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c302b95a5bf85006$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $bU3PY = parcelRequire("bU3PY");

var $kdO7l = parcelRequire("kdO7l");
const $c302b95a5bf85006$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E56910)"
};
const $c302b95a5bf85006$var$iconStyles = null;
const $c302b95a5bf85006$var$titleStyles = null;
const $c302b95a5bf85006$var$textStyles = null;
const $c302b95a5bf85006$var$truncatedTextStyles = null;
const $c302b95a5bf85006$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))) : (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: appearance,
            color: $c302b95a5bf85006$var$iconColor[appearance],
            spacing: "spacious"
        })
    });
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $c302b95a5bf85006$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $kdO7l.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("h1", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _11c8lodh _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, $2OMIu.jsx)($c302b95a5bf85006$var$TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: titleId,
                "data-testid": testId && `${testId}-text`,
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
                    !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
var $c302b95a5bf85006$export$2e2bcd8739ae039 = $c302b95a5bf85006$var$ModalTitle;

});

parcelRegister("7QSqG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2169e0f4dcf60dbd$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $2alJM = parcelRequire("2alJM");

var $VSDnB = parcelRequire("VSDnB");

var $kdO7l = parcelRequire("kdO7l");

var $ke3x4 = parcelRequire("ke3x4");

var $9sx7u = parcelRequire("9sx7u");
const $2169e0f4dcf60dbd$var$bodyStyles = null;
const $2169e0f4dcf60dbd$var$fontStyles = null;
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ const $2169e0f4dcf60dbd$var$bodyScrollStyles = null;
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ const $2169e0f4dcf60dbd$var$viewportScrollStyles = null;
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $2169e0f4dcf60dbd$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $kdO7l.useModal)();
    const shouldScrollInViewport = (0, $9sx7u.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            "_18zr1ejb",
            (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2alJM.TouchScrollable), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ke3x4.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                "data-testid": testId,
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug",
                    "_1rjc1bk5 _18zr1ejb",
                    (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
                ]),
                children: children
            })
        })
    });
};
var $2169e0f4dcf60dbd$export$2e2bcd8739ae039 = $2169e0f4dcf60dbd$var$ModalBody;

});
parcelRegister("ke3x4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3670e1796fbbd4c6$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $5JjdN = parcelRequire("5JjdN");

var $eGmKJ = parcelRequire("eGmKJ");

var $i65Nq = parcelRequire("i65Nq");

var $jhVLw = parcelRequire("jhVLw");
const $3670e1796fbbd4c6$var$keylineColor = "var(--ds-border, #091E4224)";
const $3670e1796fbbd4c6$var$baseStyles = null;
const $3670e1796fbbd4c6$var$keylineHeight = 2;
const $3670e1796fbbd4c6$var$topKeylineStyles = null;
const $3670e1796fbbd4c6$var$bottomKeylineStyles = null;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $3670e1796fbbd4c6$var$ScrollContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $5uXOq.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $5uXOq.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $5uXOq.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5uXOq.useEffect)(()=>{
        const schedule = (0, $7nRxN.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $i65Nq.default)((0, $7nRxN.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $3670e1796fbbd4c6$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $3670e1796fbbd4c6$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $5uXOq.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $cBeZP.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $eGmKJ.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhVLw.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // tabindex is allowed here so that keyboard users can scroll content
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            tabIndex: showContentFocus ? 0 : undefined,
            role: showContentFocus ? 'region' : undefined,
            "aria-label": showContentFocus ? 'Scrollable content' : undefined,
            "data-testid": testId && `${testId}--scrollable`,
            ref: (0, $5JjdN.default)([
                ref,
                scrollableRef
            ]),
            className: (0, $bwpsq.default)([
                "_16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _2lx21kw7 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
                showTopKeyline && "_mqm2v2xi",
                showBottomKeyline && "_179rv2xi"
            ]),
            children: children
        })
    });
});
$3670e1796fbbd4c6$var$ScrollContainer.displayName = 'ScrollContainer';
var $3670e1796fbbd4c6$export$2e2bcd8739ae039 = $3670e1796fbbd4c6$var$ScrollContainer;

});
parcelRegister("i65Nq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8170a624321a7900$export$2e2bcd8739ae039);

var $f8qry = parcelRequire("f8qry");
function $8170a624321a7900$export$2e2bcd8739ae039(callback) {
    const ref = (0, $f8qry.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("f8qry", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f294347e0efb6c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $6f294347e0efb6c9$var$uniqueReferencedValue = {};
function $6f294347e0efb6c9$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $5uXOq.useRef)($6f294347e0efb6c9$var$uniqueReferencedValue);
    if (ref.current === $6f294347e0efb6c9$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});



parcelRegister("9sx7u", function(module, exports) {

$parcel$export(module.exports, "default", () => $6267dd4dabfabb6f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fYbIt = parcelRequire("fYbIt");
function $6267dd4dabfabb6f$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $5uXOq.useContext)((0, $fYbIt.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("juxqI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4eb21c8acfa6cbdd$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kdO7l = parcelRequire("kdO7l");
const $4eb21c8acfa6cbdd$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $4eb21c8acfa6cbdd$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $kdO7l.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1ezb _85i51ejb _1q51pxbi"
        ]),
        children: children
    });
};
var $4eb21c8acfa6cbdd$export$2e2bcd8739ae039 = $4eb21c8acfa6cbdd$var$ModalFooter;

});

parcelRegister("eQfWH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::182e7300aed0f8931ea6d6a6afcdcbad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ace24a83748025fe$var$_react = $ace24a83748025fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ace24a83748025fe$var$_page = $ace24a83748025fe$var$_interopRequireDefault((parcelRequire("kdfZa")));

var $ace24a83748025fe$var$_page2 = $ace24a83748025fe$var$_interopRequireDefault((parcelRequire("eWXbg")));
function $ace24a83748025fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "PageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ace24a83748025fe$var$PageIcon = (props)=>/*#__PURE__*/ $ace24a83748025fe$var$_react.default.createElement($ace24a83748025fe$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $ace24a83748025fe$var$_page2.default
    }, props));
$ace24a83748025fe$var$PageIcon.Name = 'PageIconMigration';
var $ace24a83748025fe$var$_default = module.exports.default = $ace24a83748025fe$var$PageIcon;

});

parcelRegister("i8Qvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e1183b83a373acd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $9e1183b83a373acd$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
var $9e1183b83a373acd$export$2e2bcd8739ae039 = $9e1183b83a373acd$var$ModalTransition;

});

parcelRegister("e4yMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c4e7f5fe5d003ac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");
var $MHKc7 = parcelRequire("MHKc7");
const $8c4e7f5fe5d003ac$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu18uv _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b18uv _4fpr8stv _5goinqa1 _f8pj14q2 _9oik18uv _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm18uv _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu18uv _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b18uv _4fprglyw _5goinqa1 _f8pj1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu18uv _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b18uv _4fpr8stv _5goinqa1 _f8pj15cr _9oik18uv _1bnxglyw _jf4cnqa1 _30l315cr _1nrm18uv _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n4jp4b _kqswh2mm _152ttb3r"
};
const $8c4e7f5fe5d003ac$var$iconStyles = null;
const $8c4e7f5fe5d003ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5McnS.default), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $3JT92.cx)(appearance === 'default' && $8c4e7f5fe5d003ac$var$styles.defaultAppearance, appearance === 'subtle' && $8c4e7f5fe5d003ac$var$styles.subtleAppearance, appearance === 'inverse' && $8c4e7f5fe5d003ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $8c4e7f5fe5d003ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                as: "span",
                xcss: $8c4e7f5fe5d003ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $bwpsq.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: (0, $bwpsq.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $8c4e7f5fe5d003ac$var$Link = /*#__PURE__*/ (0, $5uXOq.forwardRef)($8c4e7f5fe5d003ac$var$LinkWithoutRef);
var $8c4e7f5fe5d003ac$export$2e2bcd8739ae039 = $8c4e7f5fe5d003ac$var$Link;

});
parcelRegister("5McnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b40cffea142bae23$export$2e2bcd8739ae039);
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $3joPi = parcelRequire("3joPi");

var $6QvkM = parcelRequire("6QvkM");

var $7a0yc = parcelRequire("7a0yc");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $6wxJn = parcelRequire("6wxJn");

var $jldZL = parcelRequire("jldZL");

var $a1dy0 = parcelRequire("a1dy0");
const $b40cffea142bae23$var$styles = {
    root: "_4bfu18uv _1hms8stv _ajmmnqa1 _vchhusvi"
};
const $b40cffea142bae23$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $b40cffea142bae23$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $b40cffea142bae23$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $eGmKJ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $9KnKW.useId)();
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $7a0yc.default)();
    const isExternal = typeof href === 'string' && $b40cffea142bae23$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $b40cffea142bae23$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $3joPi.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $a1dy0.default // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $DEWI6.cx)($b40cffea142bae23$var$styles.root, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $b40cffea142bae23$var$Anchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)($b40cffea142bae23$var$AnchorNoRef);
var $b40cffea142bae23$export$2e2bcd8739ae039 = $b40cffea142bae23$var$Anchor;

});
parcelRegister("7a0yc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f05306b0a621838$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $grjRA = parcelRequire("grjRA");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $1f05306b0a621838$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $5uXOq.useContext)((0, $grjRA.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
};
var $1f05306b0a621838$export$2e2bcd8739ae039 = $1f05306b0a621838$var$useRouterLink;

});
parcelRegister("grjRA", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", () => $e2ad785297db7cde$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $e2ad785297db7cde$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $e2ad785297db7cde$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5uXOq.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $e2ad785297db7cde$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e2ad785297db7cde$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $e2ad785297db7cde$export$2e2bcd8739ae039 = $e2ad785297db7cde$var$RouterLinkProvider;

});




parcelRegister("lkmWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $846af68bcfd2a415$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

const $846af68bcfd2a415$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $846af68bcfd2a415$var$inlineStyles = {
    root: "_1ul9idpf"
};
const $846af68bcfd2a415$var$textStyles = {
    root: "_11c82smr _1reo15vq _18m915vq _syaz12s4 _k48p1wq8 _1bto1l2s _o5721q9c _593818uv _7hxb18uv _9m7f18uv _rfqo18uv _qfs118uv _yha28stv _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43ds1r31 _p03c1r31 _oavv1r31 _oxk41r31 _1cay1r31"
};
const $846af68bcfd2a415$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $846af68bcfd2a415$var$tokenBackgroundColors = {
    warning: `var(--ds-background-warning-bold, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
    error: `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
    announcement: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
};
const $846af68bcfd2a415$var$tokenTextColors = {
    warning: `var(--ds-text-warning-inverse, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
    error: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    announcement: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
};
const $846af68bcfd2a415$var$containerStyles = {
    root: "_4t3i1wto _4cvr1h6o _1e0c1txw"
};
const $846af68bcfd2a415$var$iconWrapperStyles = {
    root: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s _1o9zidpf"
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $846af68bcfd2a415$var$Banner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $846af68bcfd2a415$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $846af68bcfd2a415$var$containerStyles.root,
        backgroundColor: $846af68bcfd2a415$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $846af68bcfd2a415$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "span",
                    xcss: $846af68bcfd2a415$var$iconWrapperStyles.root,
                    style: {
                        fill: $846af68bcfd2a415$var$tokenBackgroundColors[appearanceType],
                        color: $846af68bcfd2a415$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    style: {
                        [$846af68bcfd2a415$var$CSS_VAR_TEXT_COLOR]: $846af68bcfd2a415$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $bwpsq.default)([
                        $846af68bcfd2a415$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $846af68bcfd2a415$export$2e2bcd8739ae039 = $846af68bcfd2a415$var$Banner;

});

parcelRegister("ctg8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31fb25f1b05491f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9MHPe = parcelRequire("9MHPe");
var $fxUuP = parcelRequire("fxUuP");

var $VSDnB = parcelRequire("VSDnB");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");

var $68kvT = parcelRequire("68kvT");

var $94LdA = parcelRequire("94LdA");
const $a31fb25f1b05491f$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $a31fb25f1b05491f$var$checkIsChildOfPortal(node.parentElement);
};
// Close manager for layering
const $a31fb25f1b05491f$var$CloseManager = ({ handleEscapeClose: handleEscapeClose, handleClick: handleClick })=>{
    (0, $fxUuP.useCloseOnEscapePress)({
        onClose: handleEscapeClose
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $fxUuP.useLayering)();
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: (e)=>{
                if (isLayerDisabled()) return;
                handleClick(e);
            },
            options: {
                capture: true
            }
        });
    }, [
        handleClick,
        isLayerDisabled
    ]);
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {});
};
const $a31fb25f1b05491f$var$InlineDialog = /*#__PURE__*/ (0, $5uXOq.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $eGmKJ.default), onContentClick: onContentClick = (0, $eGmKJ.default), onContentFocus: onContentFocus = (0, $eGmKJ.default), onClose: providedOnClose = (0, $eGmKJ.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children, fallbackPlacements: fallbackPlacements }) {
    const containerRef = (0, $5uXOq.useRef)(null);
    const triggerRef = (0, $5uXOq.useRef)(null);
    const onClose = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $5uXOq.useRef)(onClose);
    (0, $5uXOq.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $5uXOq.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isOpen) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($a31fb25f1b05491f$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isOpen
    ]);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        if (containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        containerRef,
        triggerRef
    ]);
    /**
   * Auto-flip is enabled by default in `@atlaskit/popper` and
   * the `InlineDialog` API does not allow disabling it.
   *
   * We only need to override it if there are `fallbackPlacements` specified.
   */ const modifiers = (0, $5uXOq.useMemo)(()=>fallbackPlacements ? [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ] : [], [
        fallbackPlacements
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
        placement: placement,
        strategy: strategy,
        modifiers: modifiers,
        children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $94LdA.Container), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                testId: testId,
                children: typeof content === 'function' ? content() : content
            })
    }) : null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $68kvT.default), {
                        innerRef: (node)=>{
                            triggerRef.current = node;
                            if (typeof ref === 'function') ref(node);
                            else ref.current = node;
                        },
                        hasNodeResolver: !(0, $VSDnB.fg)('platform_design_system_team_portal_logic_r18_fix'),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                            children: children
                        })
                    })
            }),
            isOpen ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9MHPe.Layering), {
                isDisabled: false,
                children: [
                    popper,
                    /*#__PURE__*/ (0, $2OMIu.jsx)($a31fb25f1b05491f$var$CloseManager, {
                        handleEscapeClose: handleCloseRequest,
                        handleClick: handleClick
                    })
                ]
            }) : popper
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a31fb25f1b05491f$export$2e2bcd8739ae039 = $a31fb25f1b05491f$var$InlineDialog;

});
parcelRegister("9MHPe", function(module, exports) {

$parcel$export(module.exports, "LevelContext", () => $13009cd54ca6fd25$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $13009cd54ca6fd25$export$48b383b280e20440);
$parcel$export(module.exports, "Layering", () => $13009cd54ca6fd25$export$7c885f891c940977);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $13009cd54ca6fd25$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5uXOq.createContext)(0);
const $13009cd54ca6fd25$export$48b383b280e20440 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $eGmKJ.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ const $13009cd54ca6fd25$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
    const { setTopLevel: setTopLevel, topLevelRef: topLevelRef, layerList: layerList } = (0, $5uXOq.useContext)($13009cd54ca6fd25$export$48b383b280e20440);
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const id = (0, $5uXOq.useRef)((0, $VSDnB.fg)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $VSDnB.fg)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $VSDnB.fg)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(()=>{
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $VSDnB.fg)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        const safeLayerList = layerList?.current;
        const safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return ()=>{
            const index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($13009cd54ca6fd25$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel,
        children: children
    });
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ const $13009cd54ca6fd25$var$LayeringProvider = ({ children: children })=>{
    const topLevelRef = (0, $5uXOq.useRef)(0);
    const layerList = (0, $5uXOq.useRef)([]);
    const value = (0, $5uXOq.useMemo)(()=>({
            topLevelRef: topLevelRef,
            setTopLevel: (level)=>{
                topLevelRef.current = level;
            },
            ...(0, $VSDnB.fg)('layering-top-level-use-array') ? {
                layerList: layerList
            } : {}
        }), [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($13009cd54ca6fd25$export$48b383b280e20440.Provider, {
        value: value,
        children: children
    });
};
const $13009cd54ca6fd25$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $5uXOq.useContext)($13009cd54ca6fd25$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)($13009cd54ca6fd25$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $2OMIu.jsx)($13009cd54ca6fd25$var$LayeringProvider, {
        children: content
    });
};

});

parcelRegister("fxUuP", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $ad9fa941cb83a846$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "useLayering", () => $ad9fa941cb83a846$export$c8b4d54e03dee6ed);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $VSDnB = parcelRequire("VSDnB");

var $9MHPe = parcelRequire("9MHPe");
const $ad9fa941cb83a846$var$ESCAPE = 'Escape';
function $ad9fa941cb83a846$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $5uXOq.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $ad9fa941cb83a846$export$c8b4d54e03dee6ed();
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $ad9fa941cb83a846$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $5uXOq.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $ad9fa941cb83a846$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $5uXOq.useContext)((0, $9MHPe.LevelContext));
    const { topLevelRef: topLevelRef, layerList: layerList } = (0, $5uXOq.useContext)((0, $9MHPe.TopLevelContext));
    const isLayerDisabled = (0, $5uXOq.useCallback)(()=>{
        if ((0, $VSDnB.fg)('layering-top-level-use-array')) return (layerList?.current?.length ?? 0) !== currentLevel;
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled,
        ...(0, $VSDnB.fg)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {}
    };
}

});

parcelRegister("68kvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f26cc8148e40cea2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dI393 = parcelRequire("dI393");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $f26cc8148e40cea2$var$NodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: (node)=>{
            innerRef(node?.firstElementChild);
        },
        children: children
    });
};
var $f26cc8148e40cea2$export$2e2bcd8739ae039 = $f26cc8148e40cea2$var$NodeResolverWrapper;

});

parcelRegister("94LdA", function(module, exports) {

$parcel$export(module.exports, "Container", () => $ecacbacca9d72f42$export$42a852a2b6b56249);
/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $ecacbacca9d72f42$var$CSS_THEME_BACKGROUND = '--theme-background';
const $ecacbacca9d72f42$var$CSS_THEME_COLOR = '--theme-color';
const $ecacbacca9d72f42$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $ecacbacca9d72f42$var$containerStyles = null;
const $ecacbacca9d72f42$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$ecacbacca9d72f42$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            [$ecacbacca9d72f42$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
            [$ecacbacca9d72f42$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
            ...style
        },
        className: (0, $bwpsq.default)([
            "_11q7gluh _2rko1sit _vchh18uv _p12flti4 _c71llti4 _1pbyowjs _16qs1r44 _syazjslb _85i5pxbi _1q51pxbi _y4ti1ejb _bozg1ejb _nt751r31 _49pcglyw _1hvw1o36"
        ]),
        children: typeof children === 'function' ? children() : children
    });
});

});


parcelRegister("1R1Ge", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffd0023e007d9cb$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ao4Ml = parcelRequire("ao4Ml");

var $2alJM = parcelRequire("2alJM");

var $6QvkM = parcelRequire("6QvkM");

var $j55bS = parcelRequire("j55bS");

var $eGmKJ = parcelRequire("eGmKJ");

var $9MHPe = parcelRequire("9MHPe");

var $4uxPN = parcelRequire("4uxPN");

var $k8nZq = parcelRequire("k8nZq");

var $k5uoT = parcelRequire("k5uoT");

var $is0E3 = parcelRequire("is0E3");

var $7tnMN = parcelRequire("7tnMN");

var $9XIqZ = parcelRequire("9XIqZ");
const $7ffd0023e007d9cb$var$fillScreenStyles = null;
const $7ffd0023e007d9cb$var$allowlistElements = (element, callback)=>{
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
     // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
}; /**
    * __Modal wrapper__
    *
    * A modal wrapper displays content that requires user interaction, in a layer above the page.
    * This component is primary container for other modal components.
    *
    * - [Examples](https://atlassian.design/components/modal-dialog/examples)
    * - [Code](https://atlassian.design/components/modal-dialog/code)
    * - [Usage](https://atlassian.design/components/modal-dialog/usage)
    */ 
const $7ffd0023e007d9cb$var$ModalWrapper = (props)=>{
    const { autoFocus: autoFocus = true, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $eGmKJ.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId } = props;
    const calculatedStackIndex = (0, $7tnMN.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    const onCloseHandler = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $eGmKJ.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onBlanketClicked = (0, $5uXOq.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    const allowListCallback = (0, $5uXOq.useCallback)((element)=>$7ffd0023e007d9cb$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    (0, $9XIqZ.default)();
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j55bS.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $is0E3.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            children: children
        })
    });
    let returnFocus = true;
    let onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MHPe.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
            zIndex: (0, $k5uoT.layers).modal(),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4uxPN.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...fadeInProps,
                        className: (0, $bwpsq.default)([
                            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2alJM.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
};
var $7ffd0023e007d9cb$export$2e2bcd8739ae039 = $7ffd0023e007d9cb$var$ModalWrapper;

});
parcelRegister("j55bS", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dca3d7b20962bd7$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");
const $3dca3d7b20962bd7$var$packageName = "platform-pkg";
const $3dca3d7b20962bd7$var$packageVersion = "0.0.0-use.local";
const $3dca3d7b20962bd7$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $3dca3d7b20962bd7$var$packageName,
    packageVersion: $3dca3d7b20962bd7$var$packageVersion
};
const $3dca3d7b20962bd7$var$baseStyles = null;
const $3dca3d7b20962bd7$var$shouldAllowClickThroughStyles = null;
const $3dca3d7b20962bd7$var$invisibleStyles = null; /**
                               * __Blanket__
                               *
                               * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
                               *
                               * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
                               */ 
const $3dca3d7b20962bd7$var$Blanket = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $eGmKJ.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $5uXOq.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$3dca3d7b20962bd7$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $5uXOq.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $5uXOq.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhku5cu _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk18uv"
        ]),
        children: children
    });
}));
$3dca3d7b20962bd7$var$Blanket.displayName = 'Blanket';
var $3dca3d7b20962bd7$export$2e2bcd8739ae039 = $3dca3d7b20962bd7$var$Blanket;

});

parcelRegister("is0E3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e86ab6183d35f3a4$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5JjdN = parcelRequire("5JjdN");

var $SliG5 = parcelRequire("SliG5");

var $9KnKW = parcelRequire("9KnKW");

var $fxUuP = parcelRequire("fxUuP");

var $4uxPN = parcelRequire("4uxPN");

var $4hDdm = parcelRequire("4hDdm");

var $fYbIt = parcelRequire("fYbIt");

var $8DdLp = parcelRequire("8DdLp");

var $klFzX = parcelRequire("klFzX");

var $gErrX = parcelRequire("gErrX");

var $9vYhy = parcelRequire("9vYhy");

var $ator5 = parcelRequire("ator5");

var $1vCNB = parcelRequire("1vCNB");
const $e86ab6183d35f3a4$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $e86ab6183d35f3a4$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syaz1fxt _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1p6i _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y _epkx1sit _we1i1kw7 _zg7p1cd0 _yakv1kw7 _4lht1kw7 _1xlt6m9r"
};
const $e86ab6183d35f3a4$var$viewportScrollStyles = null;
const $e86ab6183d35f3a4$var$bodyScrollStyles = null;
const $e86ab6183d35f3a4$var$ModalDialog = (props)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId } = props;
    const id = (0, $9KnKW.useId)();
    const titleId = `modal-dialog-title-${id}`;
    (0, $5uXOq.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $4hDdm.combine)((0, $klFzX.disableDraggingToCrossOriginIFramesForElement)(), (0, $9vYhy.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $gErrX.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $SliG5.default)(typeof autoFocus === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $8DdLp.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $5uXOq.useMemo)(()=>({
            testId: testId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose
        }), [
        testId,
        titleId,
        onClose,
        hasProvidedOnClose
    ]);
    (0, $fxUuP.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $fxUuP.useLayering)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1vCNB.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fYbIt.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fYbIt.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4uxPN.default), {
                    entranceDirection: "bottom",
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $5JjdN.default)([
                                bottomFadeInProps.ref,
                                motionRef
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $ator5.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $ator5.dialogHeight)(height)
                            },
                            className: (0, $bwpsq.default)([
                                $e86ab6183d35f3a4$var$dialogStyles.root,
                                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": testId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $e86ab6183d35f3a4$export$2e2bcd8739ae039 = $e86ab6183d35f3a4$var$ModalDialog;

});
parcelRegister("8DdLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4317034ec2e3d5b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $c4317034ec2e3d5b$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $5uXOq.useRef)(null);
    const onMotionFinish = (0, $5uXOq.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("klFzX", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $5e7c041a1fb152f5$export$ec28e97c7d8b1b35);

var $cBeZP = parcelRequire("cBeZP");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");

var $gBukj = parcelRequire("gBukj");
function $5e7c041a1fb152f5$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $7gWdR.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $4hDdm.combine)(unbindEvents, unbindMonitor);
}
function $5e7c041a1fb152f5$var$watchForInteractionStart({ start: start }) {
    return (0, $cBeZP.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $5e7c041a1fb152f5$var$api = (0, $gBukj.makeFixForAdapter)({
    watchForInteractionStart: $5e7c041a1fb152f5$var$watchForInteractionStart,
    watchForInteractionEnd: $5e7c041a1fb152f5$var$watchForInteractionEnd
});
function $5e7c041a1fb152f5$export$ec28e97c7d8b1b35() {
    return $5e7c041a1fb152f5$var$api.registerUsage();
}

});
parcelRegister("gBukj", function(module, exports) {

$parcel$export(module.exports, "makeFixForAdapter", () => $35c5518f4a7d5d30$export$a74bff2507e6126b);

var $4hDdm = parcelRequire("4hDdm");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $35c5518f4a7d5d30$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $35c5518f4a7d5d30$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $35c5518f4a7d5d30$var$isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !$35c5518f4a7d5d30$var$hasSameOrigin(window.location.href, iframe.src);
}
const $35c5518f4a7d5d30$var$registry = new Map();
function $35c5518f4a7d5d30$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($35c5518f4a7d5d30$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $35c5518f4a7d5d30$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $35c5518f4a7d5d30$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $35c5518f4a7d5d30$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $35c5518f4a7d5d30$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $4hDdm.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $35c5518f4a7d5d30$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $35c5518f4a7d5d30$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("gErrX", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $e219e1274c4fc374$export$27d79116d3a4e7d5);

var $61IPU = parcelRequire("61IPU");

var $gBukj = parcelRequire("gBukj");
function $e219e1274c4fc374$var$watchForInteractionStart({ start: start }) {
    return (0, $61IPU.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $e219e1274c4fc374$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $61IPU.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $e219e1274c4fc374$var$api = (0, $gBukj.makeFixForAdapter)({
    watchForInteractionStart: $e219e1274c4fc374$var$watchForInteractionStart,
    watchForInteractionEnd: $e219e1274c4fc374$var$watchForInteractionEnd
});
function $e219e1274c4fc374$export$27d79116d3a4e7d5() {
    return $e219e1274c4fc374$var$api.registerUsage();
}

});

parcelRegister("9vYhy", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $aa69f8f5bffdc1a7$export$9c0606fcefb5d1e2);

var $cBeZP = parcelRequire("cBeZP");

var $4hDdm = parcelRequire("4hDdm");

var $dOXu7 = parcelRequire("dOXu7");

var $gBukj = parcelRequire("gBukj");
function $aa69f8f5bffdc1a7$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $dOXu7.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $4hDdm.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $aa69f8f5bffdc1a7$var$watchForInteractionStart({ start: start }) {
    return (0, $cBeZP.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $aa69f8f5bffdc1a7$var$api = (0, $gBukj.makeFixForAdapter)({
    watchForInteractionStart: $aa69f8f5bffdc1a7$var$watchForInteractionStart,
    watchForInteractionEnd: $aa69f8f5bffdc1a7$var$watchForInteractionEnd
});
function $aa69f8f5bffdc1a7$export$9c0606fcefb5d1e2() {
    return $aa69f8f5bffdc1a7$var$api.registerUsage();
}

});

parcelRegister("ator5", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", () => $72ba27e5976b9c16$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogHeight", () => $72ba27e5976b9c16$export$ceba93bf0bdd16f2);
const $72ba27e5976b9c16$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
const $72ba27e5976b9c16$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = $72ba27e5976b9c16$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${$72ba27e5976b9c16$export$7e3df82ee760448c.widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};
const $72ba27e5976b9c16$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("1vCNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f543e674b5c19d9$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $lObw7 = parcelRequire("lObw7");
const $8f543e674b5c19d9$var$gutter = 60;
const $8f543e674b5c19d9$var$maxWidthDimensions = `calc(100vw - ${$8f543e674b5c19d9$var$gutter * 2}px)`;
const $8f543e674b5c19d9$var$maxHeightDimensions = `calc(100vh - ${$8f543e674b5c19d9$var$gutter * 2 - 1}px)`;
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $8f543e674b5c19d9$var$positionerStyles = null;
const $8f543e674b5c19d9$var$viewportScrollStyles = null;
const $8f543e674b5c19d9$var$bodyScrollStyles = null;
const $8f543e674b5c19d9$var$stackTransitionStyles = null;
const $8f543e674b5c19d9$var$stackTransformStyles = null;
const $8f543e674b5c19d9$var$stackIdleStyles = null;
const $8f543e674b5c19d9$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $lObw7.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $eba99f58997c09b3$export$c07234257a03d5e9)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            "_k8m01e03 _1bumglyw _sedtglyw",
            stackIndex > 0 ? "_t9ec1b95" : "_t9ecglyw",
            shouldScrollInViewport ? "_4t3i1wug _kqswh2mm _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _eoawglyw" : "_we1i18uh _e8uozwhf _y1k5stnw _5ee41wqb _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw"
        ]),
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8f543e674b5c19d9$export$2e2bcd8739ae039 = $8f543e674b5c19d9$var$Positioner;

});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eba99f58997c09b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';



parcelRegister("7tnMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e81b0e5cdef75b43$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i65Nq = parcelRequire("i65Nq");

var $lp9re = parcelRequire("lp9re");

var $kdxL3 = parcelRequire("kdxL3");

var $35XSW = parcelRequire("35XSW");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $e81b0e5cdef75b43$var$modalStackRegister = [];
function $e81b0e5cdef75b43$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $35XSW.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $kdxL3.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $lp9re.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $i65Nq.default)(()=>{
        const newStackIndex = $e81b0e5cdef75b43$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        const currentStackIndex = $e81b0e5cdef75b43$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $e81b0e5cdef75b43$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $e81b0e5cdef75b43$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $e81b0e5cdef75b43$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $e81b0e5cdef75b43$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $e81b0e5cdef75b43$var$modalStackRegister.splice(currentStackIndex, 1);
                $e81b0e5cdef75b43$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("lp9re", function(module, exports) {

$parcel$export(module.exports, "default", () => $06a256e02abd1f05$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $06a256e02abd1f05$export$2e2bcd8739ae039(value) {
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("kdxL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f67363697749cb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $92f67363697749cb$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $5uXOq.useState)(initialState);
    const valueRef = (0, $5uXOq.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("9XIqZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a91aea5a2a8a28$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $59a91aea5a2a8a28$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $59a91aea5a2a8a28$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setScrollTopOffset($59a91aea5a2a8a28$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $5uXOq.useCallback)(()=>{
        if ($59a91aea5a2a8a28$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("1I7E8", function(module, exports) {

$parcel$export(module.exports, "default", () => $30a8e47dcc753634$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("ed37w")).Popup);

var $ed37w = parcelRequire("ed37w");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$30a8e47dcc753634$export$2e2bcd8739ae039 = (0, $ed37w.Popup);

});
parcelRegister("ed37w", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $8d10e877eee410d3$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9KnKW = parcelRequire("9KnKW");

var $9MHPe = parcelRequire("9MHPe");

var $9Mkr0 = parcelRequire("9Mkr0");

var $VSDnB = parcelRequire("VSDnB");

var $gkD4s = parcelRequire("gkD4s");
var $1V7PR = parcelRequire("1V7PR");

var $k8nZq = parcelRequire("k8nZq");

var $MHKc7 = parcelRequire("MHKc7");

var $jIMB4 = parcelRequire("jIMB4");

var $hdHM8 = parcelRequire("hdHM8");

var $jLapR = parcelRequire("jLapR");

var $9Qtvo = parcelRequire("9Qtvo");
const $8d10e877eee410d3$var$defaultLayer = 400;
const $8d10e877eee410d3$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $8d10e877eee410d3$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5uXOq.memo)(({ xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $8d10e877eee410d3$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport })=>{
    const [triggerRef, setTriggerRef] = (0, $5uXOq.useState)(null);
    const getMergedTriggerRef = (0, $jLapR.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $9Qtvo.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $9KnKW.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $hdHM8.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $5uXOq.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    const renderPopperWrapper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MHPe.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jIMB4.default), {
            xcss: xcss,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $VSDnB.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $VSDnB.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            }))
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $8d10e877eee410d3$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
});

});
parcelRegister("jIMB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9858401ca27a71a5$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fxUuP = parcelRequire("fxUuP");

var $VSDnB = parcelRequire("VSDnB");

var $4oNEb = parcelRequire("4oNEb");

var $kwAGY = parcelRequire("kwAGY");

var $cLdxp = parcelRequire("cLdxp");

var $f9bw2 = parcelRequire("f9bw2");
const $9858401ca27a71a5$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $9858401ca27a71a5$var$fullWidthStyles = null;
const $9858401ca27a71a5$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
const $9858401ca27a71a5$var$scrollableStyles = null;
const $9858401ca27a71a5$var$blanketStyles = null;
const $9858401ca27a71a5$var$modalStyles = null;
const $9858401ca27a71a5$var$focusRingStyles = {
    root: "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
const $9858401ca27a71a5$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $bwpsq.default)([
            $9858401ca27a71a5$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: ref,
        children: children
    });
});
function $9858401ca27a71a5$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
popupComponent: PopupContainer = $9858401ca27a71a5$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default' }) {
    const [popupRef, setPopupRef] = (0, $5uXOq.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $5uXOq.useState)(null); // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $f9bw2.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $cLdxp.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $fxUuP.useLayering)();
    const mergedModifiers = (0, $5uXOq.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update })=>{
            const popupContainer = /*#__PURE__*/ (0, $2OMIu.jsx)(PopupContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $bwpsq.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    (0, $VSDnB.fg)('platform-design-system-apply-popup-wrapper-focus') && $9858401ca27a71a5$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kwAGY.RepositionOnUpdate), {
                    update: update,
                    children: content({
                        update: update,
                        isOpen: isOpen,
                        onClose: onClose,
                        setInitialFocusRef: setInitialFocusRef
                    })
                })
            });
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_1r04idpf _kqsw1n9t _bfhk10xm"
                        ])
                    })
                ]
            });
        }
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9858401ca27a71a5$export$2e2bcd8739ae039 = $9858401ca27a71a5$var$PopperWrapper;

});
parcelRegister("kwAGY", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", () => $7c4d306c23f4e590$export$51eddd7655ca235a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $7c4d306c23f4e590$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children
    });
};

});

parcelRegister("cLdxp", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", () => $83624aa7913be40b$export$92dae2778ae88f9d);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eGmKJ = parcelRequire("eGmKJ");

var $fxUuP = parcelRequire("fxUuP");

var $VSDnB = parcelRequire("VSDnB");

var $3DdHF = parcelRequire("3DdHF");

var $baX5J = parcelRequire("baX5J");
const $83624aa7913be40b$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $fxUuP.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $baX5J.useAnimationFrame)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $eGmKJ.default;
        const inIframe = window && window.self !== window.top && (0, $VSDnB.fg)('fix-dropdown-close-outside-iframe');
        const closePopup = (event)=>{
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level');
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $VSDnB.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    const layeredElement = target.closest?.(`[data-ds--level]`);
                    if (layeredElement) {
                        const closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $3DdHF.isInteractiveElement)(document.activeElement) && (0, $VSDnB.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onKeyDown = (event)=>{
            if ((0, $VSDnB.fg)('platform_dst_popup-disable-focuslock')) {
                const { key: key, shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                const { key: key } = event;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $cBeZP.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        let unbind = (0, $eGmKJ.default);
        if ((0, $VSDnB.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $cBeZP.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $cBeZP.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $eGmKJ.default);
        unbindBlur = (0, $cBeZP.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $VSDnB.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            parentUnbind?.();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("3DdHF", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $7d7e1fccd0afde1a$export$3dee5e4542c672d9);
const $7d7e1fccd0afde1a$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $7d7e1fccd0afde1a$export$3dee5e4542c672d9 = (element)=>{
    if ($7d7e1fccd0afde1a$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("baX5J", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", () => $599fc9184c33a338$export$641fa9c94086b46e);

var $5uXOq = parcelRequire("5uXOq");
const $599fc9184c33a338$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $5uXOq.useRef)([]);
    const requestFrame = (0, $5uXOq.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $5uXOq.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $5uXOq.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("f9bw2", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", () => $5cfd1123aa183e54$export$10c5169755ce7bd7);

var $5uXOq = parcelRequire("5uXOq");

var $fGOj2 = parcelRequire("fGOj2");

var $eGmKJ = parcelRequire("eGmKJ");

var $fxUuP = parcelRequire("fxUuP");

var $VSDnB = parcelRequire("VSDnB");

var $baX5J = parcelRequire("baX5J");
const $5cfd1123aa183e54$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $baX5J.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $fxUuP.useLayering)();
    (0, $5uXOq.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $eGmKJ.default;
        if (shouldDisableFocusTrap && (0, $VSDnB.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $eGmKJ.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($fGOj2)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("hdHM8", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", () => $9a30ae17eff5ab49$export$4065aef1d79a5730);

var $5uXOq = parcelRequire("5uXOq");

var $4ErVz = parcelRequire("4ErVz");
function $9a30ae17eff5ab49$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const mq = (0, $4ErVz.UNSAFE_useMediaQuery)('below.sm', (e)=>{
        setIsSmallViewport(!!e.matches);
    });
    const [isSmallViewport, setIsSmallViewport] = (0, $5uXOq.useState)(!!mq?.matches);
    const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("4ErVz", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $168a6b3daa1a05a2$export$49e55ae2c03d6045);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $52mbL = parcelRequire("52mbL");
const $168a6b3daa1a05a2$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $52mbL.media).below.xl.replace('@media ', '').trim())
};
const $168a6b3daa1a05a2$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $168a6b3daa1a05a2$var$queries[queryString];
    (0, $5uXOq.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cBeZP.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("52mbL", function(module, exports) {

$parcel$export(module.exports, "media", () => $b6cd58c4b4f8f8d3$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $b6cd58c4b4f8f8d3$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("jLapR", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $511b0ab22a44ec88$export$7cc5c058dd769dff);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");
const $511b0ab22a44ec88$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $5uXOq.useState)(()=>(0, $8QpSo.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("9Qtvo", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $22af45ce662ac8e0$export$5d3a2de79e07b376);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");
const $22af45ce662ac8e0$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $5uXOq.useState)(()=>(0, $8QpSo.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("7gs1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbff6f33edc9e742$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $SWIxc = parcelRequire("SWIxc");

var $imZsD = parcelRequire("imZsD");
/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $bbff6f33edc9e742$var$Spotlight = ({ actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth = 400, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label, pulse: pulse = true, scrollPositionBlock: scrollPositionBlock, shouldWatchTarget: shouldWatchTarget = false, target: target, targetBgColor: targetBgColor, targetNode: targetNode, targetOnClick: targetOnClick, targetRadius: targetRadius, targetReplacement: targetReplacement, testId: testId = 'spotlight', titleId: titleId, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $imZsD.SpotlightConsumer), {
        children: ({ opened: opened, closed: closed, targets: targets })=>{
            // use the targetNode prop or try get the target from context targets using name
            const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
            return actualTargetNode ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $SWIxc.default), {
                ...rest,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                children: children,
                dialogPlacement: dialogPlacement,
                dialogWidth: dialogWidth,
                footer: footer,
                header: header,
                heading: heading,
                headingAfterElement: headingAfterElement,
                image: image,
                label: label,
                onClosed: closed,
                onOpened: opened,
                pulse: pulse,
                scrollPositionBlock: scrollPositionBlock,
                shouldWatchTarget: shouldWatchTarget,
                target: target,
                targetBgColor: targetBgColor,
                targetNode: actualTargetNode,
                targetOnClick: targetOnClick,
                targetRadius: targetRadius,
                targetReplacement: targetReplacement,
                testId: testId,
                titleId: titleId
            }) : null;
        }
    });
var $bbff6f33edc9e742$export$2e2bcd8739ae039 = $bbff6f33edc9e742$var$Spotlight;

});
parcelRegister("SWIxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $150cbc32a362a4e3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lv4Ny = parcelRequire("lv4Ny");

var $2alJM = parcelRequire("2alJM");

var $k9tnV = parcelRequire("k9tnV");

var $9MHPe = parcelRequire("9MHPe");

var $VSDnB = parcelRequire("VSDnB");

var $k8nZq = parcelRequire("k8nZq");

var $18JP0 = parcelRequire("18JP0");

var $YYGxJ = parcelRequire("YYGxJ");

var $7SX8k = parcelRequire("7SX8k");

var $ekHpI = parcelRequire("ekHpI");

var $e4PSc = parcelRequire("e4PSc");

var $1QiBP = parcelRequire("1QiBP");
/**
 * __Spotlight inner__
 *
 * Renders the spotlight target clone and dialog.
 *
 * @internal
 */ class $150cbc32a362a4e3$var$SpotlightInner extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            dialogWidth: 400,
            pulse: true
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.targetNode !== this.props.targetNode) (0, $k9tnV.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
    }
    componentDidMount() {
        (0, $k9tnV.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
        this.props.onOpened();
    }
    componentWillUnmount() {
        this.props.onClosed();
    }
    render() {
        const { pulse: pulse, shouldWatchTarget: shouldWatchTarget, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
        const { replacementElement: replacementElement } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1QiBP.SpotlightTransitionConsumer), {
            children: ({ isOpen: isOpen, onExited: onExited })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $k8nZq.default), {
                    zIndex: 701,
                    children: [
                        TargetReplacement ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ekHpI.default), {
                            hasNodeResolver: !(0, $VSDnB.fg)('platform_design_system_team_onboarding_noderesolve'),
                            innerRef: (elem)=>this.setState({
                                    replacementElement: elem
                                }),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $18JP0.ElementBox), {
                                element: targetNode,
                                resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                                children: (box)=>/*#__PURE__*/ (0, $2OMIu.jsx)(TargetReplacement, {
                                        "data-testid": `${testId}--target`,
                                        ...this.getTargetNodeStyle(box)
                                    })
                            })
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $18JP0.ElementBox), {
                            element: targetNode,
                            resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                            children: (box)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7SX8k.default), {
                                    shouldWatch: shouldWatchTarget,
                                    testId: `${testId}--target`,
                                    pulse: pulse,
                                    target: target,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                    style: this.getTargetNodeStyle(box),
                                    targetBgColor: targetBgColor,
                                    targetNode: targetNode,
                                    targetOnClick: targetOnClick,
                                    targetRadius: targetRadius
                                })
                        }),
                        TargetReplacement && !replacementElement ? null : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $YYGxJ.Fade), {
                            hasEntered: isOpen,
                            onExited: onExited,
                            children: (animationStyles)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MHPe.Layering), {
                                    isDisabled: false,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4PSc.default), {
                                        testId: `${testId}--dialog`,
                                        actions: this.props.actions,
                                        actionsBeforeElement: this.props.actionsBeforeElement,
                                        children: this.props.children,
                                        dialogPlacement: this.props.dialogPlacement,
                                        dialogWidth: this.props.dialogWidth,
                                        footer: this.props.footer,
                                        header: this.props.header,
                                        heading: this.props.heading,
                                        titleId: this.props.titleId,
                                        label: this.props.label,
                                        headingAfterElement: this.props.headingAfterElement,
                                        image: this.props.image,
                                        targetNode: replacementElement || targetNode,
                                        animationStyles: animationStyles
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), {})
                    ]
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // This is only used when targetReplacement is specified.
            // In this case, we have to render the targetReplacement component,
            // get a dom reference from that component, then render again passing
            // that reference into SpotlightDialog (Popper).
            replacementElement: null
        }, this.getTargetNodeStyle = (box)=>{
            if (!(0, $lv4Ny.canUseDOM)) return {};
            const { height: height, left: left, top: top, width: width, ...rest } = box;
            return {
                // Handling this just in case there are invalid elements being sent in to
                // the `box` arg
                ...rest,
                height: height,
                left: left,
                top: top,
                width: width,
                position: 'fixed',
                // when width is 0, set visibility hidden to avoid the target flashing issue
                ...width === 0 && (0, $VSDnB.fg)('scroll-lock-replacement') && {
                    visibility: 'hidden'
                }
            };
        };
    }
}
var $150cbc32a362a4e3$export$2e2bcd8739ae039 = $150cbc32a362a4e3$var$SpotlightInner;

});
parcelRegister("18JP0", function(module, exports) {

$parcel$export(module.exports, "ElementBox", () => $a258af1780b88209$export$1b6719bd7aff3c00);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $VSDnB = parcelRequire("VSDnB");
// The minimum interval between position updates in milliseconds
const $a258af1780b88209$var$POSITION_UPDATE_INTERVAL = 200;
const $a258af1780b88209$var$getElementRect = (element)=>{
    const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
    return {
        height: height,
        left: left,
        top: top,
        width: width
    };
};
const $a258af1780b88209$var$useResizeAwareElementBox = (element, updateMethod)=>{
    const [box, setBox] = (0, $5uXOq.useState)({
        width: 0,
        height: 0,
        left: 0,
        top: 0
    });
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (updateMethod === 'resizeListener') {
            if ((0, $VSDnB.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                setBox($a258af1780b88209$var$getElementRect(element));
            }, 0);
            else setBox($a258af1780b88209$var$getElementRect(element));
        }
    }, [
        element,
        updateMethod
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const onResize = ()=>{
            requestAnimationFrame(()=>{
                setBox($a258af1780b88209$var$getElementRect(element));
            });
        };
        if (updateMethod === 'resizeListener') return (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: onResize
        });
    }, [
        element,
        updateMethod
    ]);
    return box;
};
const $a258af1780b88209$var$usePollingElementBox = (element, updateMethod)=>{
    // These are intentionally tracked as number primitives rather than as a shared `box` object.
    // Since the requestAnimationFrame code below updates this often, we want to avoid re-renders
    // when the values are the same.  React uses `Object.is` to figure out if the state changed after a setState.
    // If we represent this as a shared `box` object, this will re-render even if the two objects have identical contents.
    const [width, setWidth] = (0, $5uXOq.useState)(0);
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const [left, setLeft] = (0, $5uXOq.useState)(0);
    const [top, setTop] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (updateMethod === 'polling') {
            if ((0, $VSDnB.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                const newBox = $a258af1780b88209$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }, 0);
            else {
                const newBox = $a258af1780b88209$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }
        }
    }, [
        element,
        updateMethod
    ]);
    // Souce: https://css-tricks.com/using-requestanimationframe-with-react-hooks/
    // Use useRef for mutable variables that we want to persist
    // without triggering a re-render on their change
    const requestRef = (0, $5uXOq.useRef)();
    const previousUpdateTimeRef = (0, $5uXOq.useRef)();
    const animate = (0, $5uXOq.useCallback)((time)=>{
        if (previousUpdateTimeRef.current !== undefined) {
            const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
            if (timeSinceLastUpdate > $a258af1780b88209$var$POSITION_UPDATE_INTERVAL) {
                const newBox = $a258af1780b88209$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
                previousUpdateTimeRef.current = time;
            }
        } else // Initialize previousUpdateTimeRef
        previousUpdateTimeRef.current = time;
        requestRef.current = requestAnimationFrame(animate);
    }, [
        element
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
        return ()=>{
            if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
        };
    // This useEffect should only run on mount and when `element` or `updateMethod` changes.
    }, [
        animate,
        element,
        updateMethod
    ]);
    const box = (0, $5uXOq.useMemo)(()=>({
            width: width,
            height: height,
            left: left,
            top: top
        }), [
        width,
        height,
        left,
        top
    ]);
    return box;
};
/**
 * Will listen to the document resizing to see if an element has moved positions.
 * Not using ResizeObserver because of IE11 support.
 * @param element HTMLElement to watch when resizing.
 */ const $a258af1780b88209$var$useElementBox = (element, resizeUpdateMethod)=>{
    const updateMethod = resizeUpdateMethod || 'resizeListener';
    const boxViaResizeListener = $a258af1780b88209$var$useResizeAwareElementBox(element, updateMethod);
    const boxViaPolling = $a258af1780b88209$var$usePollingElementBox(element, updateMethod);
    return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
};
const $a258af1780b88209$export$1b6719bd7aff3c00 = (props)=>{
    const box = $a258af1780b88209$var$useElementBox(props.element, props.resizeUpdateMethod);
    return props.children(box);
};

});

parcelRegister("YYGxJ", function(module, exports) {

$parcel$export(module.exports, "Fade", () => $d18d88acb014b28d$export$c983850c6c9d8b0e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ahdj0 = parcelRequire("ahdj0");

var $VSDnB = parcelRequire("VSDnB");
const $d18d88acb014b28d$var$duration = {
    enter: 0,
    exit: 100
};
const $d18d88acb014b28d$export$c983850c6c9d8b0e = ({ hasEntered: hasEntered, children: children, onExited: onExited })=>{
    const nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahdj0.default), {
        in: hasEntered,
        timeout: $d18d88acb014b28d$var$duration,
        onExited: onExited,
        unmountOnExit: true,
        appear: true,
        ...(0, $VSDnB.fg)('platform_design_system_team_transition_group_r18') && {
            nodeRef: nodeRef
        },
        children: (status)=>{
            const anim = {
                entered: {
                    opacity: 1
                },
                exiting: {
                    opacity: 0
                }
            };
            return children({
                transition: `opacity ${$d18d88acb014b28d$var$duration.exit}ms`,
                opacity: 0,
                ...status in anim ? anim[status] : {}
            });
        }
    });
};

});

parcelRegister("7SX8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f418dd4dd618d4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");

var $1azd9 = parcelRequire("1azd9");
const $b6f418dd4dd618d4$var$computedStyleAttributesToClone = [
    'fontSize',
    'fontWeight',
    'lineHeight',
    'padding',
    'color',
    'textOverflow'
];
function $b6f418dd4dd618d4$var$cloneAndOverrideStyles(node) {
    const shouldCloneChildren = true;
    const clonedNode = node.cloneNode(shouldCloneChildren);
    const computedStyles = getComputedStyle(node);
    $b6f418dd4dd618d4$var$computedStyleAttributesToClone.forEach((attribute)=>{
        clonedNode.style[attribute] = computedStyles[attribute];
    });
    clonedNode.style.margin = '0';
    clonedNode.style.position = 'static';
    // The target may have other transforms applied. Avoid unintended side effects
    // by zeroing out "translate" rather than applying a value of "none".
    clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
    return clonedNode;
}
/**
 * __Clone__
 *
 * Used for cloning spotlight targets. The clone is positioned on top of the spotlight target with
 * a pulsing animation.
 *
 * @internal
 */ const $b6f418dd4dd618d4$var$Clone = (props)=>{
    const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
    const contentVersion = (0, $1azd9.useElementObserver)(targetNode, {
        disableWatch: !shouldWatch
    });
    const contentHTML = (0, $5uXOq.useMemo)(()=>$b6f418dd4dd618d4$var$cloneAndOverrideStyles(targetNode).outerHTML, // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to update when the content changes
    [
        contentVersion,
        targetNode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $k6T4f.TargetInner), {
        "data-testid": testId,
        pulse: pulse,
        bgColor: targetBgColor,
        radius: targetRadius,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: contentHTML
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    height: '100%',
                    pointerEvents: 'none'
                }
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k6T4f.TargetOverlay), {
                onClick: targetOnClick ? (event)=>targetOnClick({
                        event: event,
                        target: target
                    }) : undefined
            })
        ]
    });
};
var $b6f418dd4dd618d4$export$2e2bcd8739ae039 = $b6f418dd4dd618d4$var$Clone;

});
parcelRegister("k6T4f", function(module, exports) {

$parcel$export(module.exports, "TargetInner", () => $74265a1b3b566a15$export$b1542cc928b93af);
$parcel$export(module.exports, "TargetOverlay", () => $74265a1b3b566a15$export$a28a07e0025d709d);
$parcel$export(module.exports, "Pulse", () => $74265a1b3b566a15$export$927d63e2511364c0);
/* target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $74265a1b3b566a15$var$reduceMotionAsPerUserPreference = null;
// NOTE:
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const $74265a1b3b566a15$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #8270DB)"}`;
const $74265a1b3b566a15$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $74265a1b3b566a15$var$pulseKeyframes = null;
const $74265a1b3b566a15$var$animationStyles = null;
const $74265a1b3b566a15$var$Base = ({ bgColor: bgColor, children: children, className: className, radius: radius, testId: testId, style: style, // The rest of these props are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style is not allowed at the moment
            ...style,
            backgroundColor: bgColor,
            borderRadius: radius ? `${radius}px` : undefined
        },
        ...props,
        children: children
    });
const $74265a1b3b566a15$export$b1542cc928b93af = ({ bgColor: bgColor, children: children, className: className, pulse: pulse, radius: radius, testId: testId, // Thes rest of these are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($74265a1b3b566a15$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            pulse && "",
            pulse && "_5sagi11n _tip812c5 _j7hq1ukm _1pglmcjr _16qs1wx8",
            "_1bumglyw _sedtglyw",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });
const $74265a1b3b566a15$var$targetOverlayStyles = null;
const $74265a1b3b566a15$export$a28a07e0025d709d = ({ onClick: onClick, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        onClick: onClick,
        ...props,
        style: {
            cursor: onClick ? 'pointer' : 'auto'
        },
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _kqswstnw _152tze3t _1e02ze3t"
        ])
    });
const $74265a1b3b566a15$export$927d63e2511364c0 = ({ bgColor: bgColor, children: children, className: className, radius: radius, pulse: pulse = true, testId: testId, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($74265a1b3b566a15$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            pulse && "",
            pulse && "_5sagi11n _tip812c5 _j7hq1ukm _1pglmcjr _16qs1wx8",
            "_1bumglyw _sedtglyw",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });

});

parcelRegister("1azd9", function(module, exports) {

$parcel$export(module.exports, "useElementObserver", () => $0e054e21ef522f23$export$729bafd4e621fba0);

var $5uXOq = parcelRequire("5uXOq");
function $0e054e21ef522f23$export$729bafd4e621fba0(element, opts = {}) {
    const { onChange: onChange, disableWatch: disableWatch = false } = opts;
    // This state is used to force a re-render when the target changes
    const [targetContentVersion, setTargetContentVersion] = (0, $5uXOq.useState)(0);
    const mutationObserver = (0, $5uXOq.useRef)(undefined);
    const cancelIdleCallback1 = (0, $5uXOq.useRef)(undefined);
    const disposer = (0, $5uXOq.useCallback)(()=>{
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = undefined;
        mutationObserver.current?.disconnect();
        mutationObserver.current = undefined;
    }, []);
    const onMutation = (0, $5uXOq.useCallback)(()=>{
        // MutationObserver can make multiple calls to the callback in quick succession so debounce when idle
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = $0e054e21ef522f23$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                const version = v + 1;
                onChange?.(version);
                return version;
            }));
    }, [
        onChange
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Clean up any existing observer in the case that the target node has changed
        disposer();
        if (!disableWatch && element) {
            mutationObserver.current = new MutationObserver(onMutation);
            mutationObserver.current.observe(element, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        return disposer;
    }, [
        disableWatch,
        disposer,
        element,
        onMutation
    ]);
    return targetContentVersion;
}
/**
 * When the browser is idle call the callback.
 *
 * This function will use `requestIdleCallback` if available, otherwise it will fallback to `setTimeout`.
 *
 * @param callback The function to call when the browser is idle.
 * @param [opts] Options for the idle callback.
 * @param [opts.timeout=100] The maximum time to wait for the browser to be idle.
 *
 * @returns A function that can be called to cancel the idle callback.
 *
 * @internal
 */ function $0e054e21ef522f23$var$callWhenIdle(callback, opts = {}) {
    const { timeout: timeout = 100 } = opts;
    if (typeof window.requestIdleCallback === 'function') {
        const idleHandle = window.requestIdleCallback(callback, {
            timeout: timeout
        });
        return ()=>cancelIdleCallback(idleHandle);
    }
    // Fallback to setTimeout if requestIdleCallback is not available
    const timeoutHandle = setTimeout(callback, timeout);
    return ()=>clearTimeout(timeoutHandle);
}

});


parcelRegister("ekHpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $37a1a812aa8f24aa$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dI393 = parcelRequire("dI393");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $37a1a812aa8f24aa$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    const divRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasNodeResolver
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: divRef,
        children: children
    });
};
var $37a1a812aa8f24aa$export$2e2bcd8739ae039 = $37a1a812aa8f24aa$var$NodeResolverSpotlightInner;

});

parcelRegister("e4PSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $789e05520a01dfea$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");

var $4oNEb = parcelRequire("4oNEb");

var $MHKc7 = parcelRequire("MHKc7");

var $jdzOc = parcelRequire("jdzOc");

var $5ujeO = parcelRequire("5ujeO");

var $4XGH5 = parcelRequire("4XGH5");
/**
 * __Spotlight dialog__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $789e05520a01dfea$var$SpotlightDialogComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.focusLockTimeoutId = window.setTimeout(()=>{
            // we delay the enabling of the focus lock to avoid the scroll position
            // jumping around in some situations
            this.setState({
                focusLockDisabled: false
            });
        }, 200);
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusLockTimeoutId);
    }
    render() {
        const { actions: actions, actionsBeforeElement: actionsBeforeElement, animationStyles: animationStyles, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label = 'Introducing new feature', titleId: titleId, targetNode: targetNode, testId: testId } = this.props;
        const { focusLockDisabled: focusLockDisabled } = this.state;
        const dialogLabel = !heading && !titleId ? label : undefined;
        const dialogLabelledBy = titleId || (heading ? 'spotlight-dialog-label' : undefined);
        const translatedPlacement = dialogPlacement ? ({
            'top left': 'top-start',
            'top center': 'top',
            'top right': 'top-end',
            'right top': 'right-start',
            'right middle': 'right',
            'right bottom': 'right-end',
            'bottom left': 'bottom-start',
            'bottom center': 'bottom',
            'bottom right': 'bottom-end',
            'left top': 'left-start',
            'left middle': 'left',
            'left bottom': 'left-end'
        })[dialogPlacement] : undefined;
        // If there's no room on either side of the popper, it will extend off-screen.
        //  This looks buggy when scroll-lock and focus is placed on the dialog, so we
        //  customise popper so it overflows the spotlight instead with altAxis=true.
        const modifiers = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document',
                    altAxis: true,
                    tether: false
                }
            }
        ];
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
            modifiers: modifiers,
            referenceElement: targetNode,
            placement: translatedPlacement,
            children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4XGH5.default), {
                    value: dialogWidth,
                    onChange: update,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ao4Ml.default), {
                        disabled: focusLockDisabled,
                        returnFocus: false,
                        autoFocus: true,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: {
                                ...style,
                                ...animationStyles
                            },
                            ref: ref,
                            "aria-modal": true,
                            role: "dialog",
                            "aria-label": dialogLabel,
                            "aria-labelledby": dialogLabelledBy,
                            testId: `${testId}-container`,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ujeO.default), {
                                testId: testId,
                                width: dialogWidth,
                                actions: actions,
                                actionsBeforeElement: actionsBeforeElement,
                                image: image && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdzOc.DialogImage), {
                                    alt: heading,
                                    src: image
                                }),
                                components: {
                                    Header: header,
                                    Footer: footer
                                },
                                heading: heading,
                                headingId: "spotlight-dialog-label",
                                headingAfterElement: headingAfterElement,
                                // This should be heading level 1 since this is technically a modal, including a focus lock on the modal window.
                                // But because it is not a _true_ modal, we are setting it to `2` until that is fixed.
                                headingLevel: 2,
                                children: children
                            })
                        })
                    })
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            focusLockDisabled: true
        };
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$789e05520a01dfea$export$2e2bcd8739ae039 = $789e05520a01dfea$var$SpotlightDialogComponent;

});
parcelRegister("jdzOc", function(module, exports) {

$parcel$export(module.exports, "DialogImage", () => $701e8b2a5a3a9de9$export$855e1a47874d6b81);
$parcel$export(module.exports, "DialogActionItemContainer", () => $701e8b2a5a3a9de9$export$ed9b6b50bbed5f27);
$parcel$export(module.exports, "DialogActionItem", () => $701e8b2a5a3a9de9$export$6ae54e00f59e1f33);
/* dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $MHKc7 = parcelRequire("MHKc7");
const $701e8b2a5a3a9de9$var$imageStyles = null;
const $701e8b2a5a3a9de9$var$actionItemContainerStyles = {
    root: "_1e0c1txw _2lx21sbv _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr"
};
const $701e8b2a5a3a9de9$var$actionItemStyles = {
    root: "_6rthze3t _1pfhze3t _12l21b66 _ahbq1b66"
};
const $701e8b2a5a3a9de9$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        ...props,
        className: (0, $bwpsq.default)([
            "_p12f1osq _4t3i1wug"
        ])
    });
const $701e8b2a5a3a9de9$export$ed9b6b50bbed5f27 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $701e8b2a5a3a9de9$var$actionItemContainerStyles.root,
        children: children
    });
const $701e8b2a5a3a9de9$export$6ae54e00f59e1f33 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $701e8b2a5a3a9de9$var$actionItemStyles.root,
        children: children
    });

});

parcelRegister("5ujeO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c733b7879a85e4b1$export$2e2bcd8739ae039);
/* spotlight-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9yOBd = parcelRequire("9yOBd");
var $dkK4L = parcelRequire("dkK4L");

var $3JT92 = parcelRequire("3JT92");

var $l1N8i = parcelRequire("l1N8i");

var $fxUuP = parcelRequire("fxUuP");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jdzOc = parcelRequire("jdzOc");

var $lPfex = parcelRequire("lPfex");
const $c733b7879a85e4b1$var$bodyStyles = null;
const $c733b7879a85e4b1$var$imageStyles = null;
const $c733b7879a85e4b1$var$defaultHeaderStyles = null;
const $c733b7879a85e4b1$var$DefaultHeader = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1q9y _1bah1yb4 _85i5u2gc"
        ]),
        children: children
    });
const $c733b7879a85e4b1$var$defaultFooterStyles = null;
const $c733b7879a85e4b1$var$DefaultFooter = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": "spotlight--dialog-footer",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1q51u2gc"
        ]),
        children: children
    });
const $c733b7879a85e4b1$var$containerStyles = {
    root: "_2rkoglpi _1reo1wug _18m91wug _4t3i1ns9 _syaz15cr _1ul91lit _p12f1ogm"
};
const $c733b7879a85e4b1$var$containerShadowStyles = {
    root: "_16qszucj"
};
/**
 * __Spotlight card__
 *
 * A spotlight card is for onboarding messages that need a more flexible layout, or don't require a dialog.
 *
 * - [Examples](https://atlassian.design/components/onboarding/spotlight-card/examples)
 * - [Code](https://atlassian.design/components/onboarding/spotlight-card/code)
 * - [Usage](https://atlassian.design/components/onboarding/spotlight-card/usage)
 */ const $c733b7879a85e4b1$var$SpotlightCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
    const { Header: Header = $c733b7879a85e4b1$var$DefaultHeader, Footer: Footer = $c733b7879a85e4b1$var$DefaultFooter } = components;
    const { currentLevel: currentLevel } = (0, $fxUuP.useLayering)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dkK4L.default).Provider, {
        value: (0, $lPfex.spotlightButtonTheme),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
            backgroundColor: "color.background.discovery.bold",
            xcss: (0, $3JT92.cx)($c733b7879a85e4b1$var$containerStyles.root, !isFlat && $c733b7879a85e4b1$var$containerShadowStyles.root),
            style: {
                width: width
            },
            ref: ref || innerRef,
            testId: testId,
            "data-ds--level": currentLevel,
            // temporarily use this data attribute to prevent clicking outside won't close spotlight correctly issue
            "data-ds--close--type": "single",
            children: [
                typeof image === 'string' ? /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                    src: image,
                    alt: "",
                    className: (0, $bwpsq.default)([
                        "_1e0c1ule"
                    ])
                }) : image,
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _2lx21bp4 _85i5pxbi _1q51pxbi _y4tiv47k _bozgv47k"
                    ]),
                    children: [
                        heading || headingAfterElement ? /*#__PURE__*/ (0, $2OMIu.jsxs)(Header, {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                                    id: headingId,
                                    size: "medium",
                                    as: `h${headingLevel}`,
                                    color: "color.text.inverse",
                                    children: heading
                                }),
                                headingAfterElement
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                            children: children
                        }),
                        actions.length > 0 || actionsBeforeElement ? /*#__PURE__*/ (0, $2OMIu.jsxs)(Footer, {
                            children: [
                                actionsBeforeElement || /*#__PURE__*/ (0, $2OMIu.jsx)("span", {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdzOc.DialogActionItemContainer), {
                                    children: actions.map(({ text: text, key: key, ...rest }, idx)=>{
                                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdzOc.DialogActionItem), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9yOBd.default), {
                                                ...rest,
                                                children: text
                                            })
                                        }, key || (typeof text === 'string' ? text : `${idx}`));
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
});
$c733b7879a85e4b1$var$SpotlightCard.displayName = 'SpotlightCard';
var $c733b7879a85e4b1$export$2e2bcd8739ae039 = $c733b7879a85e4b1$var$SpotlightCard;

});
parcelRegister("lPfex", function(module, exports) {

$parcel$export(module.exports, "spotlightButtonTheme", () => $8aced0e496744c93$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $8aced0e496744c93$export$d131eb21ba4cbd16);
const $8aced0e496744c93$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #091E4208)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CCE0FF)",
                dark: "var(--ds-background-selected-hovered, #CCE0FF)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CCE0FF)",
                dark: "var(--ds-background-selected-hovered, #CCE0FF)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #091E424F)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #5E4DB2)",
            selected: "var(--ds-text-selected, #0C66E4)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $8aced0e496744c93$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #6E5DC6)",
            hover: "var(--ds-background-discovery-bold-hovered, #5E4DB2)",
            active: "var(--ds-background-discovery-bold-pressed, #352C63)",
            disabled: {
                light: "var(--ds-background-disabled, #091E4208)",
                dark: "var(--ds-background-disabled, #091E4208)"
            },
            selected: "var(--ds-background-selected-hovered, #CCE0FF)",
            focus: "var(--ds-background-discovery-bold-hovered, #5E4DB2)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: "var(--ds-text-selected, #0C66E4)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $8aced0e496744c93$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $8aced0e496744c93$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$8aced0e496744c93$var$extract($8aced0e496744c93$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $8aced0e496744c93$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$8aced0e496744c93$var$extract($8aced0e496744c93$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});


parcelRegister("4XGH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a3c5fc6b92d479$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $10a3c5fc6b92d479$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.props.onChange();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("1QiBP", function(module, exports) {

$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $a6b34dff0b441b13$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $a6b34dff0b441b13$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $a6b34dff0b441b13$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOpen: true,
    onExited: (0, $eGmKJ.default)
});
// checks if children exist and are truthy
const $a6b34dff0b441b13$var$hasChildren = (children)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) > 0 && ((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ class $a6b34dff0b441b13$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $a6b34dff0b441b13$var$hasChildren(previousChildren) && !$a6b34dff0b441b13$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)($a6b34dff0b441b13$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $a6b34dff0b441b13$var$hasChildren(this.props.children)
            },
            children: this.state.currentChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            currentChildren: undefined
        }, this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
const $a6b34dff0b441b13$export$7d63b19b854c2fe8 = $a6b34dff0b441b13$var$SpotlightTransitionContext.Consumer;
var $a6b34dff0b441b13$export$2e2bcd8739ae039 = $a6b34dff0b441b13$var$SpotlightTransition;

});


parcelRegister("imZsD", function(module, exports) {

$parcel$export(module.exports, "TargetConsumer", () => $9612e9b514677162$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightContext", () => $9612e9b514677162$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightConsumer", () => $9612e9b514677162$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $9612e9b514677162$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");

var $k8nZq = parcelRequire("k8nZq");

var $6b6Qn = parcelRequire("6b6Qn");

var $YYGxJ = parcelRequire("YYGxJ");

var $6cAn5 = parcelRequire("6cAn5");
const { Consumer: $9612e9b514677162$export$f643dd64c1952cc8, Provider: $9612e9b514677162$var$TargetProvider } = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $9612e9b514677162$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $5uXOq.createContext)({
    opened: (0, $eGmKJ.default),
    closed: (0, $eGmKJ.default),
    targets: {}
});
const { Consumer: $9612e9b514677162$export$3503199acd121708, Provider: $9612e9b514677162$var$SpotlightStateProvider } = $9612e9b514677162$export$7b5aa0f5b37a336d;
const $9612e9b514677162$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: children
    });
class $9612e9b514677162$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            blanketIsTinted: true
        };
    }
    componentDidMount() {
        typeof $6cAn5;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($9612e9b514677162$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($9612e9b514677162$var$TargetProvider, {
                value: this.getTargetRef,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)($9612e9b514677162$var$Container, {
                    component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $YYGxJ.Fade), {
                            hasEntered: this.state.spotlightCount > 0,
                            children: (animationStyles)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                                    zIndex: 700,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6b6Qn.default), {
                                        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: animationStyles,
                                        isTinted: blanketIsTinted,
                                        onBlanketClicked: onBlanketClicked
                                    })
                                })
                        }),
                        children
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            spotlightCount: 0,
            targets: {}
        }, /*
	 * When enabling React Streaming in Confluence, a
	 * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
	 * error happens.
	 * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
	 */ this.getTargetRef = (0, $VSDnB.fg)('platform_fix_component_state_update_for_suspense') ? (name)=>(element)=>{
                (0, $5uXOq.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            } : (name)=>(element)=>{
                this.setState((state)=>({
                        targets: {
                            ...state.targets,
                            [name]: element || undefined
                        }
                    }));
            }, this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        }, this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        }, this.getStateProviderValue = (0, $8QpSo.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}

});
parcelRegister("6b6Qn", function(module, exports) {

$parcel$export(module.exports, "default", () => $518ed4e5e45982af$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ // IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $518ed4e5e45982af$var$blanketStyles = null;
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $518ed4e5e45982af$var$Blanket = ({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #091E427D)" : 'transparent'
        },
        onClick: onBlanketClicked,
        className: (0, $bwpsq.default)([
            "_1r04idpf _v56414ka _kqsw1n9t _1pby1fw0"
        ])
    });
};
var $518ed4e5e45982af$export$2e2bcd8739ae039 = $518ed4e5e45982af$var$Blanket;

});



parcelRegister("luBm6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d9db030912e81b8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");

var $kgoHi = parcelRequire("kgoHi");
const $2d9db030912e81b8$var$flexGrowMap = {
    hug: (0, $8CUq3.xcss)({
        flexGrow: 0
    }),
    fill: (0, $8CUq3.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $2d9db030912e81b8$var$Stack = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $2d9db030912e81b8$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kgoHi.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$2d9db030912e81b8$var$Stack.displayName = 'Stack';
var $2d9db030912e81b8$export$2e2bcd8739ae039 = $2d9db030912e81b8$var$Stack;

});

parcelRegister("cgL5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $921aac447e0344be$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3joPi = parcelRequire("3joPi");

var $d1fMa = parcelRequire("d1fMa");

var $aCkBt = parcelRequire("aCkBt");

var $55sHU = parcelRequire("55sHU");
function $921aac447e0344be$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $921aac447e0344be$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $921aac447e0344be$var$resetStyles = {
    name: "eb2bs7",
    styles: "margin:0;overflow-wrap:anywhere"
};
const $921aac447e0344be$var$strongStyles = {
    name: "zh3azs",
    styles: "font-weight:var(--ds-font-weight-bold, 700)"
};
const $921aac447e0344be$var$emStyles = {
    name: "1jwcxx3",
    styles: "font-style:italic"
};
const $921aac447e0344be$var$textAlignMap = {
    center: {
        name: "1azakc",
        styles: "text-align:center"
    },
    end: {
        name: "va2k03",
        styles: "text-align:end"
    },
    start: {
        name: "9kuh93",
        styles: "text-align:start"
    }
};
const $921aac447e0344be$var$truncationStyles = {
    name: "478gwf",
    styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical"
};
const $921aac447e0344be$var$wordBreakMap = {
    breakAll: {
        name: "1m5hyg0",
        styles: "word-break:break-all"
    }
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $921aac447e0344be$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $aCkBt.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $55sHU.inverseColorMap).hasOwnProperty(surface)) return (0, $55sHU.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $921aac447e0344be$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $3joPi.default)($921aac447e0344be$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $d1fMa.useHasTextAncestor)();
    const color = $921aac447e0344be$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        ref: ref,
        css: [
            $921aac447e0344be$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $55sHU.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $55sHU.textColorStylesMap)[color],
            maxLines && $921aac447e0344be$var$truncationStyles,
            maxLines === 1 && $921aac447e0344be$var$wordBreakMap.breakAll,
            align && $921aac447e0344be$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $55sHU.textWeightStylesMap)[weight],
            Component === 'em' && $921aac447e0344be$var$emStyles,
            Component === 'strong' && $921aac447e0344be$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $d1fMa.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $921aac447e0344be$export$2e2bcd8739ae039 = $921aac447e0344be$var$Text;

});

parcelRegister("eCeGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $31e0e6ab408159ad$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2PDYT = parcelRequire("2PDYT");

var $4vsgW = parcelRequire("4vsgW");

var $ijDdv = parcelRequire("ijDdv");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $31e0e6ab408159ad$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PDYT.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4vsgW.default), {
                    type: "icon",
                    position: "before",
                    isLoading: isLoading,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ijDdv.default), {
                        icon: iconBefore
                    })
                }),
                children && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4vsgW.default), {
                    isLoading: isLoading,
                    children: children
                }),
                iconAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4vsgW.default), {
                    type: "icon",
                    position: "after",
                    isLoading: isLoading,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ijDdv.default), {
                        icon: iconAfter
                    })
                })
            ]
        })
    });
}));
$31e0e6ab408159ad$var$Button.displayName = 'Button';
var $31e0e6ab408159ad$export$2e2bcd8739ae039 = $31e0e6ab408159ad$var$Button;

});

parcelRegister("dV6Te", function(module, exports) {

$parcel$export(module.exports, "default", () => $c98cdffddc81709c$export$2e2bcd8739ae039);
/* svg.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c98cdffddc81709c$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $c98cdffddc81709c$var$svgStyles = null;
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ const $c98cdffddc81709c$var$SVG = /*#__PURE__*/ (0, $5uXOq.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw _vc881r31",
            $c98cdffddc81709c$var$sizeStyles[size]
        ]),
        children: children
    });
});
var $c98cdffddc81709c$export$2e2bcd8739ae039 = $c98cdffddc81709c$var$SVG;

});

parcelRegister("dp5jO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e020f1fc2312446fd3f70c7fae886980>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c21bc4d0ace2e1e$var$_react = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c21bc4d0ace2e1e$var$_checkCircle = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("34OIV")));

var $9c21bc4d0ace2e1e$var$_checkCircle2 = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("btivG")));
function $9c21bc4d0ace2e1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckCircleIcon.
 * This component is CheckCircleIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c21bc4d0ace2e1e$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $9c21bc4d0ace2e1e$var$_react.default.createElement($9c21bc4d0ace2e1e$var$_checkCircle.default, Object.assign({
        LEGACY_fallbackIcon: $9c21bc4d0ace2e1e$var$_checkCircle2.default
    }, props));
$9c21bc4d0ace2e1e$var$CheckCircleIcon.Name = 'CheckCircleIconMigration';
var $9c21bc4d0ace2e1e$var$_default = module.exports.default = $9c21bc4d0ace2e1e$var$CheckCircleIcon;

});
parcelRegister("34OIV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::114f507630eda1e5cfc84d510c7f0a43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d917767cf5e6f4$var$_react = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $23d917767cf5e6f4$var$_baseNew = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $23d917767cf5e6f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d917767cf5e6f4$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $23d917767cf5e6f4$var$_react.default.createElement($23d917767cf5e6f4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m4.326 3.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$23d917767cf5e6f4$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $23d917767cf5e6f4$var$_default = module.exports.default = $23d917767cf5e6f4$var$CheckCircleIcon;

});


parcelRegister("jnhNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $90dd6416d3b8b9cd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $ujWmd = parcelRequire("ujWmd");


var $eGmKJ = parcelRequire("eGmKJ");

var $fsuMn = parcelRequire("fsuMn");

var $9UCCQ = parcelRequire("9UCCQ");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $9Prrp = parcelRequire("9Prrp");

var $8APWV = parcelRequire("8APWV");

var $ibUQm = parcelRequire("ibUQm");

var $6tB70 = parcelRequire("6tB70");

var $3PuF6 = parcelRequire("3PuF6");

var $lFwF6 = parcelRequire("lFwF6");

var $4VtSA = parcelRequire("4VtSA");
const $90dd6416d3b8b9cd$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $90dd6416d3b8b9cd$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $5uXOq.createElement)(Component, {
                    ...props,
                    key: (0, $4VtSA.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $5uXOq.createElement)(Component, {
                    ...props,
                    key: (0, $4VtSA.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $90dd6416d3b8b9cd$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $ujWmd.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $5uXOq.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $fsuMn.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $5uXOq.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $eGmKJ.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $eGmKJ.default;
        (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$90dd6416d3b8b9cd$var$getOverrides(overrides).MoreIndicator.render((0, $3PuF6.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ibUQm.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6tB70.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
                            children: data.slice(max).map((avatar, index)=>$90dd6416d3b8b9cd$var$getOverrides(overrides).AvatarGroupItem.render((0, $9Prrp.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $90dd6416d3b8b9cd$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $lFwF6.default) : (0, $8APWV.default);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $90dd6416d3b8b9cd$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $4VtSA.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total)
        ]
    });
};
var $90dd6416d3b8b9cd$export$2e2bcd8739ae039 = $90dd6416d3b8b9cd$var$AvatarGroup;

});
parcelRegister("ujWmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e439760307c6b7fd$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2NMNM = parcelRequire("2NMNM");

var $9KnKW = parcelRequire("9KnKW");

var $cEPfF = parcelRequire("cEPfF");

var $620nX = parcelRequire("620nX");

var $9PZiu = parcelRequire("9PZiu");

var $lrlju = parcelRequire("lrlju");

var $cEhko = parcelRequire("cEhko");

var $kyyq3 = parcelRequire("kyyq3");
const $e439760307c6b7fd$var$packageName = "platform-pkg";
const $e439760307c6b7fd$var$packageVersion = "0.0.0-use.local";
const $e439760307c6b7fd$var$containerStyles = null; // eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $e439760307c6b7fd$var$Avatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', isDecorative: isDecorative = false, imgLoading: imgLoading }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const context = (0, $620nX.useAvatarContext)();
    const size = sizeProp || context?.size || 'medium';
    const customPresenceNode = /*#__PURE__*/ (0, $5uXOq.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $5uXOq.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $5uXOq.useRef)(analyticsContext);
    const labelId = (0, $9KnKW.useId)();
    (0, $5uXOq.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $e439760307c6b7fd$var$packageName,
                packageVersion: $e439760307c6b7fd$var$packageVersion
            }
        }); /**
         * To avoid wrapping this component in AnalyticsContext we manually
         * push the parent context's meta data into the context.
         */ 
        const context = {
            componentName: 'avatar',
            packageName: $e439760307c6b7fd$var$packageName,
            packageVersion: $e439760307c6b7fd$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context); /**
                                           * Replicating the logic in the `withAnalyticsEvents` HOC.
                                           */ 
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status; // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $620nX.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $620nX.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $kyyq3.getCustomElement)(isDisabled, href, onClick),
                        appearance: appearance,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        avatarImage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9PZiu.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            size: size,
                            testId: testId,
                            imgLoading: imgLoading
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEPfF.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrlju.PresenceWrapper), {
                    appearance: appearance,
                    size: size,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEhko.StatusWrapper), {
                    appearance: appearance,
                    size: size,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$e439760307c6b7fd$var$Avatar.displayName = 'Avatar';
var $e439760307c6b7fd$export$2e2bcd8739ae039 = $e439760307c6b7fd$var$Avatar;

});
parcelRegister("cEPfF", function(module, exports) {

$parcel$export(module.exports, "AvatarContent", () => $c356dfee75bebba7$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $620nX = parcelRequire("620nX");
const $c356dfee75bebba7$var$boxShadowCssVar = '--avatar-box-shadow';
const $c356dfee75bebba7$var$bgColorCssVar = '--avatar-bg-color';
const $c356dfee75bebba7$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128m1bk5 _4dave4h9",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $c356dfee75bebba7$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $c356dfee75bebba7$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $c356dfee75bebba7$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
const $c356dfee75bebba7$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>{
    (0, $620nX.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, avatarImage: avatarImage, borderColor: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    borderColor = (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex } = (0, $620nX.useAvatarContent)();
    const isInteractive = Boolean(onClick || href || isDisabled);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Container, {
        style: {
            [$c356dfee75bebba7$var$bgColorCssVar]: borderColor,
            [$c356dfee75bebba7$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $bwpsq.default)([
            $c356dfee75bebba7$var$unboundStyles.root,
            $c356dfee75bebba7$var$styles.root,
            $c356dfee75bebba7$var$borderRadiusMap[size],
            appearance === 'circle' && $c356dfee75bebba7$var$styles.circle,
            $c356dfee75bebba7$var$widthHeightMap[size],
            stackIndex !== undefined && $c356dfee75bebba7$var$styles.positionRelative,
            isInteractive && !isDisabled && $c356dfee75bebba7$var$unboundStyles.interactive,
            isDisabled && $c356dfee75bebba7$var$styles.disabled
        ]),
        children: children || avatarImage
    });
});

});
parcelRegister("620nX", function(module, exports) {

$parcel$export(module.exports, "AvatarContext", () => $77861849a3cd2fa6$export$a20dad690e1279e2);
$parcel$export(module.exports, "useAvatarContext", () => $77861849a3cd2fa6$export$b50b87a1c4086b23);
$parcel$export(module.exports, "AvatarContentContext", () => $77861849a3cd2fa6$export$b983474ddd0b6d28);
$parcel$export(module.exports, "useAvatarContent", () => $77861849a3cd2fa6$export$79d078b69b7e4842);
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $77861849a3cd2fa6$export$6b4cbd90d24955ad);
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $77861849a3cd2fa6$export$7db5c57474082dd9);

var $5uXOq = parcelRequire("5uXOq");
const $77861849a3cd2fa6$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $77861849a3cd2fa6$export$b50b87a1c4086b23 = ()=>(0, $5uXOq.useContext)($77861849a3cd2fa6$export$a20dad690e1279e2);
const $77861849a3cd2fa6$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $77861849a3cd2fa6$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $5uXOq.createContext)($77861849a3cd2fa6$var$defaultAvatarContentProps);
const $77861849a3cd2fa6$export$79d078b69b7e4842 = ()=>(0, $5uXOq.useContext)($77861849a3cd2fa6$export$b983474ddd0b6d28);
const $77861849a3cd2fa6$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $77861849a3cd2fa6$export$7db5c57474082dd9 = ()=>{
    const context = (0, $5uXOq.useContext)($77861849a3cd2fa6$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});


parcelRegister("9PZiu", function(module, exports) {

$parcel$export(module.exports, "default", () => $94d3810ada805c0a$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $e16Mp = parcelRequire("e16Mp");

var $esjuM = parcelRequire("esjuM");

var $VSDnB = parcelRequire("VSDnB");
const $94d3810ada805c0a$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq",
    iconBg: "_bfhkr4aa",
    iconBGVisualRefresh: "_bfhk1v33",
    circle: "_2rko1q5u"
};
const $94d3810ada805c0a$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rko1l7b",
    large: "_2rko1l7b",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
const $94d3810ada805c0a$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $94d3810ada805c0a$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $94d3810ada805c0a$var$styles.icon,
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $94d3810ada805c0a$var$styles.iconBGVisualRefresh : $94d3810ada805c0a$var$styles.iconBg,
            $94d3810ada805c0a$var$nestedSvgStylesMap[size]
        ]),
        children: appearance === 'circle' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e16Mp))), {
            label: alt,
            color: (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)",
            testId: testId && `${testId}--person`,
            spacing: "spacious",
            LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($esjuM))), {
            label: alt,
            color: (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)",
            testId: testId && `${testId}--ship`,
            spacing: "spacious",
            LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $bwpsq.default)([
            $94d3810ada805c0a$var$styles.image,
            $94d3810ada805c0a$var$borderRadiusMap[size],
            appearance === 'circle' && $94d3810ada805c0a$var$styles.circle
        ])
    });
};
var $94d3810ada805c0a$export$2e2bcd8739ae039 = $94d3810ada805c0a$var$AvatarImage;

});
parcelRegister("e16Mp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::325d0bc066f2b42d61e7c5ff0e093014>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3466b06ce7a773e$var$_react = $a3466b06ce7a773e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a3466b06ce7a773e$var$_person = $a3466b06ce7a773e$var$_interopRequireDefault((parcelRequire("1bKdn")));

var $a3466b06ce7a773e$var$_person2 = $a3466b06ce7a773e$var$_interopRequireDefault((parcelRequire("j85Tc")));
function $a3466b06ce7a773e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3466b06ce7a773e$var$PersonIcon = (props)=>/*#__PURE__*/ $a3466b06ce7a773e$var$_react.default.createElement($a3466b06ce7a773e$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $a3466b06ce7a773e$var$_person2.default
    }, props));
$a3466b06ce7a773e$var$PersonIcon.Name = 'PersonIconMigration';
var $a3466b06ce7a773e$var$_default = module.exports.default = $a3466b06ce7a773e$var$PersonIcon;

});

parcelRegister("esjuM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df09611fb9f343ce3ed015b37269b5a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a862cd9a944ef962$var$_react = $a862cd9a944ef962$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a862cd9a944ef962$var$_release = $a862cd9a944ef962$var$_interopRequireDefault((parcelRequire("2Ljwn")));

var $a862cd9a944ef962$var$_ship = $a862cd9a944ef962$var$_interopRequireDefault((parcelRequire("jUUuf")));
function $a862cd9a944ef962$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a862cd9a944ef962$var$ReleaseIcon = (props)=>/*#__PURE__*/ $a862cd9a944ef962$var$_react.default.createElement($a862cd9a944ef962$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $a862cd9a944ef962$var$_ship.default
    }, props));
$a862cd9a944ef962$var$ReleaseIcon.Name = 'ReleaseIconMigration';
var $a862cd9a944ef962$var$_default = module.exports.default = $a862cd9a944ef962$var$ReleaseIcon;

});


parcelRegister("lrlju", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", () => $d98bbac7bd20e695$export$972c5e90200fa0ef);
/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $brvtT = parcelRequire("brvtT");
const $d98bbac7bd20e695$var$BusyIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $d98bbac7bd20e695$var$FocusIndicator = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
    children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
        fill: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $d98bbac7bd20e695$var$OfflineIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $d98bbac7bd20e695$var$OnlineIndicator = /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
    fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
    cx: "4",
    cy: "4",
    r: "4"
});
function $d98bbac7bd20e695$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $d98bbac7bd20e695$var$BusyIndicator;
        case 'focus':
            return $d98bbac7bd20e695$var$FocusIndicator;
        case 'offline':
            return $d98bbac7bd20e695$var$OfflineIndicator;
        case 'online':
            return $d98bbac7bd20e695$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $d98bbac7bd20e695$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $brvtT.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $d98bbac7bd20e695$var$getPresence(presence)
        }) : children
    });
var $d98bbac7bd20e695$export$2e2bcd8739ae039 = $d98bbac7bd20e695$var$AvatarPresence;
const $d98bbac7bd20e695$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $d98bbac7bd20e695$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $d98bbac7bd20e695$var$iconOffsetMap = {
    square: "_94n5myb0 _1xi2myb0",
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $d98bbac7bd20e695$export$972c5e90200fa0ef = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $bwpsq.default)([
            $d98bbac7bd20e695$var$styles.root,
            $d98bbac7bd20e695$var$iconSizeMap[size],
            $d98bbac7bd20e695$var$iconOffsetMap[size],
            appearance === 'square' && $d98bbac7bd20e695$var$iconOffsetMap['square']
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($d98bbac7bd20e695$var$AvatarPresence, {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};

});
parcelRegister("brvtT", function(module, exports) {

$parcel$export(module.exports, "default", () => $093799a7163ada22$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $093799a7163ada22$var$styles = {
    root: "_2rko1q5u _1reo15vq _18m915vq _189e1bk5 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $093799a7163ada22$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $093799a7163ada22$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $bwpsq.default)([
            $093799a7163ada22$var$styles.root,
            $093799a7163ada22$var$unboundStyles.root
        ]),
        children: children
    });
var $093799a7163ada22$export$2e2bcd8739ae039 = $093799a7163ada22$var$IconWrapper;

});


parcelRegister("cEhko", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", () => $29c1eab79794ef03$export$8045894f255f9726);
/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $brvtT = parcelRequire("brvtT");
const $29c1eab79794ef03$var$styles = {
    root: "_kqswstnw"
};
const $29c1eab79794ef03$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $29c1eab79794ef03$var$iconOffsetMap = {
    square: "_1xi2idpf _154iidpf",
    small: "_1xi2idpf _154iidpf",
    medium: "_1xi2idpf _154iidpf",
    large: "_1xi2t94y _154it94y",
    xlarge: "_1xi21v6z _154i1v6z"
};
const $29c1eab79794ef03$var$ApprovedIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $29c1eab79794ef03$var$DeclinedIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $29c1eab79794ef03$var$LockedIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
function $29c1eab79794ef03$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $29c1eab79794ef03$var$ApprovedIndicator;
        case 'declined':
            return $29c1eab79794ef03$var$DeclinedIndicator;
        case 'locked':
            return $29c1eab79794ef03$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $29c1eab79794ef03$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $brvtT.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $29c1eab79794ef03$var$getStatus(status)
        }) : children
    });
var $29c1eab79794ef03$export$2e2bcd8739ae039 = $29c1eab79794ef03$var$AvatarStatus;
const $29c1eab79794ef03$export$8045894f255f9726 = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $bwpsq.default)([
            $29c1eab79794ef03$var$styles.root,
            $29c1eab79794ef03$var$iconSizeMap[size],
            $29c1eab79794ef03$var$iconOffsetMap[size],
            appearance === 'square' && $29c1eab79794ef03$var$iconOffsetMap['square']
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($29c1eab79794ef03$var$AvatarStatus, {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};

});

parcelRegister("kyyq3", function(module, exports) {

$parcel$export(module.exports, "getCustomElement", () => $336c0ca94b4731ff$export$83ee468102cdf04c);
const $336c0ca94b4731ff$export$83ee468102cdf04c = (isDisabled, href, onClick)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};

});


parcelRegister("fsuMn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb649bf26e54ce35$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $cb649bf26e54ce35$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $5uXOq.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $5uXOq.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("9UCCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce4b68b55e2d295e$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4mNf3 = parcelRequire("4mNf3");
const $ce4b68b55e2d295e$var$itemHeadingTopMargin = 20;
const $ce4b68b55e2d295e$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $ce4b68b55e2d295e$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $ce4b68b55e2d295e$var$skeletonHeadingHeight = 8;
const $ce4b68b55e2d295e$var$skeletonHeadingMarginOffset = 3;
const $ce4b68b55e2d295e$var$skeletonHeadingTopMargin = $ce4b68b55e2d295e$var$itemHeadingTopMargin + ($ce4b68b55e2d295e$var$itemHeadingContentHeight - $ce4b68b55e2d295e$var$skeletonHeadingHeight) - $ce4b68b55e2d295e$var$skeletonHeadingMarginOffset;
const $ce4b68b55e2d295e$var$sectionPaddingTopBottom = 6;
const $ce4b68b55e2d295e$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2ytrf",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $ce4b68b55e2d295e$var$Section = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        },
        children: (0, $5uXOq.Children).map((0, $5uXOq.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                children: child
            }, index))
    }) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4mNf3.default), {
                testId: testId && `${testId}--heading`,
                "aria-hidden": true,
                // @ts-expect-error
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                className: (0, $bwpsq.default)([
                    isSideNavSection && $ce4b68b55e2d295e$var$styles.sideNavSectionHeading
                ]),
                children: title
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: content
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $ce4b68b55e2d295e$var$styles.root,
            isScrollable ? $ce4b68b55e2d295e$var$styles.scrollable : $ce4b68b55e2d295e$var$styles.unscrollable,
            hasSeparator ? $ce4b68b55e2d295e$var$styles.thinSeparator : $ce4b68b55e2d295e$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref,
        children: childrenMarkup
    });
});
var $ce4b68b55e2d295e$export$2e2bcd8739ae039 = $ce4b68b55e2d295e$var$Section;

});
parcelRegister("4mNf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad2c1a6550a739b$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $cad2c1a6550a739b$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $cad2c1a6550a739b$var$HeadingItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_11c81vhk _1rjcze3t _18zrpxbi _syaz1n3s",
            UNSAFE_className
        ]),
        ...rest,
        children: children
    });
});
var $cad2c1a6550a739b$export$2e2bcd8739ae039 = $cad2c1a6550a739b$var$HeadingItem;

});


parcelRegister("9Prrp", function(module, exports) {

$parcel$export(module.exports, "default", () => $70f7ee1b8d27f0de$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $5JjdN = parcelRequire("5JjdN");

var $kJpBP = parcelRequire("kJpBP");
var $1aogK = parcelRequire("1aogK");
var $3Z96c = parcelRequire("3Z96c");

var $kiqun = parcelRequire("kiqun");
const $70f7ee1b8d27f0de$var$AvatarGroupItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $kiqun.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
        ref: (0, $5JjdN.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        ref: (0, $5JjdN.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aogK.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70f7ee1b8d27f0de$export$2e2bcd8739ae039 = $70f7ee1b8d27f0de$var$AvatarGroupItem;

});
parcelRegister("kJpBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $935f4004e63fbbc2$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");

var $VSDnB = parcelRequire("VSDnB");

var $bDaWv = parcelRequire("bDaWv");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $935f4004e63fbbc2$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bDaWv.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)("button", {
                "data-testid": testId,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: (0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
                onMouseDown: onMouseDownHandler,
                type: "button",
                children: children
            })
    });
}));
var $935f4004e63fbbc2$export$2e2bcd8739ae039 = $935f4004e63fbbc2$var$ButtonItem;

});
parcelRegister("bDaWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $24aefab920b5a8fa$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $c0aEF = parcelRequire("c0aEF");

var $j7LBE = parcelRequire("j7LBE");
const $24aefab920b5a8fa$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...props
    });
const $24aefab920b5a8fa$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt75194a _mizu194a _1bg411pw _1ah311pw _49pcnqa1 _ra3xnqa1 _1hvw1bk5 _128m1bk5 _9oik18uv _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElementOld: "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c82smr",
    wordBreak: "_1nmz1hna",
    description: "_11c8dcr7 _syaz1wmz",
    disabledDescription: "_syaz2oi6",
    unselected: "_bfhk1w7a _syaz1r31 _10531r31 _irr31dko _30l31r31 _1di61dko _9h8h1r31",
    disabled: "_80om13gf _bfhk1w7a _syaz2oi6 _irr31w7a _30l32oi6 _1di61w7a _9h8h2oi6",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rus13lq _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx315o9 _1mp41y44 _1cs8stnw _1rus13lq _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk1q4k _syazhu5v _1053hu5v _irr32seo _30l316ov _1di6guph _9h8hhu5v",
    selectedOld: "_30l3hu5v"
};
const $24aefab920b5a8fa$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
const $24aefab920b5a8fa$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $24aefab920b5a8fa$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $5uXOq.useContext)((0, $j7LBE.SpacingContext));
    const selectionStyle = (0, $5uXOq.useContext)((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $bwpsq.default)([
                (0, $bwpsq.default)([
                    $24aefab920b5a8fa$var$styles.root,
                    $24aefab920b5a8fa$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $24aefab920b5a8fa$var$styles.unselected,
                    !isDisabled && isSelected && $24aefab920b5a8fa$var$styles.selected,
                    !(0, $VSDnB.fg)('platform_fix_a11y_selected_and_hovered_state_color') && !isDisabled && isSelected && $24aefab920b5a8fa$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $24aefab920b5a8fa$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $24aefab920b5a8fa$var$styles.selectedNotch,
                    isDisabled && $24aefab920b5a8fa$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $24aefab920b5a8fa$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`,
                children: [
                    iconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        "data-item-elem-before": true,
                        "data-testid": testId && `${testId}--icon-before`,
                        className: (0, $bwpsq.default)([
                            (0, $VSDnB.fg)('platform_ads_component_no_icon_spacing_support') && $24aefab920b5a8fa$var$styles.beforeAfterElement,
                            !(0, $VSDnB.fg)('platform_ads_component_no_icon_spacing_support') && $24aefab920b5a8fa$var$styles.beforeAfterElementOld
                        ]),
                        children: iconBefore
                    }),
                    title && /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        className: (0, $bwpsq.default)([
                            $24aefab920b5a8fa$var$styles.content
                        ]),
                        children: [
                            $24aefab920b5a8fa$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                                children: title,
                                className: (0, $bwpsq.default)([
                                    $24aefab920b5a8fa$var$styles.title,
                                    shouldTitleWrap ? $24aefab920b5a8fa$var$styles.wordBreak : $24aefab920b5a8fa$var$styles.truncate
                                ]),
                                'data-item-title': true
                            }),
                            description && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                                "data-item-description": true,
                                className: (0, $bwpsq.default)([
                                    $24aefab920b5a8fa$var$styles.description,
                                    isDisabled && $24aefab920b5a8fa$var$styles.disabledDescription,
                                    shouldDescriptionWrap && $24aefab920b5a8fa$var$styles.wordBreak,
                                    !shouldDescriptionWrap && $24aefab920b5a8fa$var$styles.truncate
                                ]),
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        "data-item-elem-after": true,
                        "data-testid": testId && `${testId}--icon-after`,
                        className: (0, $bwpsq.default)([
                            (0, $VSDnB.fg)('platform_ads_component_no_icon_spacing_support') && $24aefab920b5a8fa$var$styles.beforeAfterElement,
                            !(0, $VSDnB.fg)('platform_ads_component_no_icon_spacing_support') && $24aefab920b5a8fa$var$styles.beforeAfterElementOld
                        ]),
                        children: iconAfter
                    })
                ]
            })
        });
    })();
};
var $24aefab920b5a8fa$export$2e2bcd8739ae039 = $24aefab920b5a8fa$var$MenuItemPrimitive;

});
parcelRegister("j7LBE", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", () => $05612b3235137344$export$443076ec7ebce042);
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $05612b3235137344$export$9ca534b70725964d);

var $5uXOq = parcelRequire("5uXOq");
const $05612b3235137344$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5uXOq.createContext)('cozy');
const $05612b3235137344$export$9ca534b70725964d = /*#__PURE__*/ (0, $5uXOq.createContext)('border');

});



parcelRegister("1aogK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c4cb74e8151525f$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");

var $VSDnB = parcelRequire("VSDnB");

var $bDaWv = parcelRequire("bDaWv");
const $0c4cb74e8151525f$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $0c4cb74e8151525f$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bDaWv.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                "data-testid": testId,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $0c4cb74e8151525f$var$preventEvent
                },
                onMouseDown: isDisabled ? $0c4cb74e8151525f$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $0c4cb74e8151525f$var$preventEvent : (0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled,
                children: children
            })
    });
}));
var $0c4cb74e8151525f$export$2e2bcd8739ae039 = $0c4cb74e8151525f$var$CustomItem;

});

parcelRegister("3Z96c", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cddba17323f139b$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7a0yc = parcelRequire("7a0yc");

var $6wxJn = parcelRequire("6wxJn");

var $VSDnB = parcelRequire("VSDnB");

var $bDaWv = parcelRequire("bDaWv");
const $0cddba17323f139b$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $0cddba17323f139b$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $0cddba17323f139b$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $0cddba17323f139b$var$LinkItem = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $7a0yc.default)();
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $0cddba17323f139b$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $0cddba17323f139b$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bDaWv.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // @ts-expect-error
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $0cddba17323f139b$var$preventEvent
                },
                onMouseDown: isDisabled ? $0cddba17323f139b$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $0cddba17323f139b$var$preventEvent : (0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled,
                ref: ref,
                children: children
            })
    });
}));
var $0cddba17323f139b$export$2e2bcd8739ae039 = $0cddba17323f139b$var$LinkItem;

});

parcelRegister("kiqun", function(module, exports) {

$parcel$export(module.exports, "default", () => $7253832d56a8089b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ibUQm = parcelRequire("ibUQm");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $7253832d56a8089b$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $5uXOq.useContext)((0, $ibUQm.FocusManagerContext));
    const itemRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $7253832d56a8089b$export$2e2bcd8739ae039 = $7253832d56a8089b$var$useRegisterItemWithFocusManager;

});
parcelRegister("ibUQm", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $55ca5414cf1fda71$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $55ca5414cf1fda71$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eGmKJ = parcelRequire("eGmKJ");

var $kmker = parcelRequire("kmker");
const $55ca5414cf1fda71$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    menuItemRefs: [],
    registerRef: (0, $eGmKJ.default)
});
/**
 * Focus manager logic
 */ const $55ca5414cf1fda71$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $5uXOq.useRef)([]);
    const registerRef = (0, $5uXOq.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $5uXOq.useEffect)(()=>{
        (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: (0, $kmker.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: (0, $kmker.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($55ca5414cf1fda71$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $55ca5414cf1fda71$export$2e2bcd8739ae039 = $55ca5414cf1fda71$var$FocusManager;

});
parcelRegister("kmker", function(module, exports) {

$parcel$export(module.exports, "default", () => $3817c9dabf013561$export$2e2bcd8739ae039);

const $3817c9dabf013561$var$actionMap = {
    [(0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)]: 'next',
    [(0, $5e71d9a7b5ef77ee$export$390330c10ff2b9a1)]: 'prev',
    [(0, $5e71d9a7b5ef77ee$export$4af703091671bc)]: 'first',
    [(0, $5e71d9a7b5ef77ee$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $3817c9dabf013561$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $3817c9dabf013561$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $3817c9dabf013561$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $3817c9dabf013561$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $3817c9dabf013561$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $3817c9dabf013561$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $3817c9dabf013561$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $3817c9dabf013561$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("8APWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb6c6550ac6ffd68$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $fb6c6550ac6ffd68$var$gutter = "var(--ds-space-negative-050, -4px)";
const $fb6c6550ac6ffd68$var$listStyles = null;
const $fb6c6550ac6ffd68$var$listItemStyles = null;
const $fb6c6550ac6ffd68$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $5uXOq.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                className: (0, $bwpsq.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fb6c6550ac6ffd68$export$2e2bcd8739ae039 = $fb6c6550ac6ffd68$var$Grid;

});

parcelRegister("6tB70", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f8303bf50b0794$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");

var $ibUQm = parcelRequire("ibUQm");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $76f8303bf50b0794$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $5uXOq.useContext)((0, $ibUQm.FocusManagerContext));
    (0, $5uXOq.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZUJu.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $76f8303bf50b0794$export$2e2bcd8739ae039 = $76f8303bf50b0794$var$PopupAvatarGroup;

});
parcelRegister("eZUJu", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b901a90a69a2f9$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7LBE = parcelRequire("j7LBE");
const $19b901a90a69a2f9$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $19b901a90a69a2f9$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7LBE.SpacingContext).Provider, {
        value: spacing,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                "aria-busy": isLoading,
                style: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                },
                "data-testid": testId,
                role: role,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $bwpsq.default)([
                    "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
                    UNSAFE_className
                ]),
                ...rest
            })
        })
    });
var $19b901a90a69a2f9$export$2e2bcd8739ae039 = $19b901a90a69a2f9$var$MenuGroup;

});


parcelRegister("3PuF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $107bc22aecddc7e7$export$2e2bcd8739ae039);
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $107bc22aecddc7e7$var$boxShadowCssVar = '--avatar-box-shadow';
const $107bc22aecddc7e7$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh18uv _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhkm7j4 _syaz1fxt _16qs1nhn _t9ec1aqe _1ejjglyw _mizu194a _ra3xnqa1 _1ah3yh40 _128myh40 _irr315ej _30l31fxt _1di6ip91 _9h8h1fxt _1q8w1np6 _jlxit94y",
    circle: "_2rko1q5u",
    active: "_bfhkfg4m _16qsqz53 _syazaqb7 _t9ec1np6 _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    disabled: "_80om13gf _1peqs237 _1hfkvuon"
};
const $107bc22aecddc7e7$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $107bc22aecddc7e7$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
const $107bc22aecddc7e7$var$fontMap = {
    small: "_11c81o8v",
    medium: "_11c81o8v",
    large: "_11c8dcr7",
    xlarge: "_11c81ixg",
    xxlarge: "_11c81ixg"
};
const $107bc22aecddc7e7$var$MAX_DISPLAY_COUNT = 99;
const $107bc22aecddc7e7$var$MoreIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'circle', borderColor: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
borderColor = (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-border-inverse, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        style: {
            [$107bc22aecddc7e7$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $bwpsq.default)([
            $107bc22aecddc7e7$var$styles.root,
            $107bc22aecddc7e7$var$borderRadiusMap[size],
            appearance === 'circle' && $107bc22aecddc7e7$var$styles.circle,
            $107bc22aecddc7e7$var$widthHeightMap[size],
            $107bc22aecddc7e7$var$fontMap[size],
            isActive && $107bc22aecddc7e7$var$styles.active
        ]),
        children: [
            "+",
            count > $107bc22aecddc7e7$var$MAX_DISPLAY_COUNT ? $107bc22aecddc7e7$var$MAX_DISPLAY_COUNT : count
        ]
    });
});
$107bc22aecddc7e7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$107bc22aecddc7e7$export$2e2bcd8739ae039 = $107bc22aecddc7e7$var$MoreIndicator;

});

parcelRegister("lFwF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bab9e2cbf400fcb$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7bab9e2cbf400fcb$var$listStyles = null;
const $7bab9e2cbf400fcb$var$listItemStyles = null;
const $7bab9e2cbf400fcb$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $5uXOq.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                className: (0, $bwpsq.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7bab9e2cbf400fcb$export$2e2bcd8739ae039 = $7bab9e2cbf400fcb$var$Stack;

});

parcelRegister("4VtSA", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $71c6d3b80b1d879f$export$b067756944994c79);
const $71c6d3b80b1d879f$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("vIiRg", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", () => $32eb610dda6e4a8d$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $32eb610dda6e4a8d$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $32eb610dda6e4a8d$export$e2bd4c1faded7921);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $32eb610dda6e4a8d$export$9a270941bcff7e77 = {
    xsmall: (0, $k5uoT.gridSize)() * 2,
    small: (0, $k5uoT.gridSize)() * 3,
    medium: (0, $k5uoT.gridSize)() * 4,
    large: (0, $k5uoT.gridSize)() * 5,
    xlarge: (0, $k5uoT.gridSize)() * 12,
    xxlarge: (0, $k5uoT.gridSize)() * 16
};
const $32eb610dda6e4a8d$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $32eb610dda6e4a8d$export$e2bd4c1faded7921 = 2;
const $32eb610dda6e4a8d$export$89a980dfdf90df51 = 0.9;
const $32eb610dda6e4a8d$export$3c061e31594ebabe = '--avatar-background-color';
const $32eb610dda6e4a8d$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $32eb610dda6e4a8d$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});

parcelRegister("bgrar", function(module, exports) {

$parcel$export(module.exports, "default", () => $caed9dac4f56dc1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $55sHU = parcelRequire("55sHU");

var $8CUq3 = parcelRequire("8CUq3");
function $caed9dac4f56dc1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $caed9dac4f56dc1e$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $caed9dac4f56dc1e$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $caed9dac4f56dc1e$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $caed9dac4f56dc1e$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $caed9dac4f56dc1e$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $caed9dac4f56dc1e$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $caed9dac4f56dc1e$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $caed9dac4f56dc1e$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$caed9dac4f56dc1e$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$caed9dac4f56dc1e$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$caed9dac4f56dc1e$var$gridTemplateRowsVar})`
});
const $caed9dac4f56dc1e$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $caed9dac4f56dc1e$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $5uXOq.useMemo)(()=>({
            [$caed9dac4f56dc1e$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$caed9dac4f56dc1e$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$caed9dac4f56dc1e$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $caed9dac4f56dc1e$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $55sHU.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $55sHU.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $55sHU.spaceStylesMap).rowGap[rowGap],
            alignItems && $caed9dac4f56dc1e$var$alignItemsMap[alignItems],
            alignContent && $caed9dac4f56dc1e$var$alignContentMap[alignContent],
            justifyContent && $caed9dac4f56dc1e$var$justifyContentMap[justifyContent],
            autoFlow && $caed9dac4f56dc1e$var$gridAutoFlowMap[autoFlow],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$caed9dac4f56dc1e$var$Grid.displayName = 'Grid';
var $caed9dac4f56dc1e$export$2e2bcd8739ae039 = $caed9dac4f56dc1e$var$Grid;

});

parcelRegister("f5TWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $980f2c1bc8a6941a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");

var $kgoHi = parcelRequire("kgoHi");
const $980f2c1bc8a6941a$var$flexGrowMap = {
    hug: (0, $8CUq3.xcss)({
        flexGrow: 0
    }),
    fill: (0, $8CUq3.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $980f2c1bc8a6941a$var$separatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $980f2c1bc8a6941a$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $980f2c1bc8a6941a$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $980f2c1bc8a6941a$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $f8Sb3.jsx)($980f2c1bc8a6941a$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $980f2c1bc8a6941a$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kgoHi.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$980f2c1bc8a6941a$var$Inline.displayName = 'Inline';
var $980f2c1bc8a6941a$export$2e2bcd8739ae039 = $980f2c1bc8a6941a$var$Inline;

});

parcelRegister("5qRwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e92bcc4cb7160f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4NS88 = parcelRequire("4NS88");

var $hxoiH = parcelRequire("hxoiH");
const $b3e92bcc4cb7160f$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $b3e92bcc4cb7160f$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $5uXOq.useRef)(null);
    const providedColorMode = (0, $4NS88.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $hxoiH.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $5uXOq.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $bwpsq.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("4NS88", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $c865b9b4a27ce99e$export$ce91654eb9fea460);
$parcel$export(module.exports, "default", () => $c865b9b4a27ce99e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $VSDnB = parcelRequire("VSDnB");

var $cSyk1 = parcelRequire("cSyk1");
var $9NXG8 = parcelRequire("9NXG8");
var $8Zdb4 = parcelRequire("8Zdb4");
const $c865b9b4a27ce99e$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: (0, $VSDnB.fg)('platform-default-typography-modernized') ? 'typography-modernized' : undefined
    });
const $c865b9b4a27ce99e$var$ColorModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c865b9b4a27ce99e$var$SetColorModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c865b9b4a27ce99e$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $c865b9b4a27ce99e$var$SetThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $c865b9b4a27ce99e$export$ce91654eb9fea460() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ColorModeContext);
    return value;
}
function $c865b9b4a27ce99e$export$20f3076712c8dfa() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ColorModeContext);
    if (!value) throw new Error('useColorMode must be used within AppProvider.');
    return value;
}
function $c865b9b4a27ce99e$export$e2afe7397c3d11c7() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $c865b9b4a27ce99e$export$93d4e7f90805808f() {
    const theme = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $5uXOq.useState)(theme || (0, $cSyk1.default)());
    (0, $5uXOq.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $8Zdb4.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return resolvedTheme;
}
function $c865b9b4a27ce99e$export$501aa0dcd5527a48() {
    const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $c865b9b4a27ce99e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $c865b9b4a27ce99e$var$prefersDarkModeMql = $c865b9b4a27ce99e$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $c865b9b4a27ce99e$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $c865b9b4a27ce99e$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $c865b9b4a27ce99e$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $5uXOq.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $5uXOq.useState)($c865b9b4a27ce99e$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $5uXOq.useState)(()=>({
            ...$c865b9b4a27ce99e$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $5uXOq.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($c865b9b4a27ce99e$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $5uXOq.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $9NXG8.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!$c865b9b4a27ce99e$var$prefersDarkModeMql) return;
        const unbindListener = (0, $cBeZP.bind)($c865b9b4a27ce99e$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($c865b9b4a27ce99e$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: children
                })
            })
        })
    });
}
var $c865b9b4a27ce99e$export$2e2bcd8739ae039 = $c865b9b4a27ce99e$var$ThemeProvider;

});
parcelRegister("9NXG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0abfa3a3a9e806a4$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $hdU6u = parcelRequire("hdU6u");

var $31Wet = parcelRequire("31Wet");

var $9GmyU = parcelRequire("9GmyU");

var $dqUdo = parcelRequire("dqUdo");

var $9mHmN = parcelRequire("9mHmN");

var $caSeK = parcelRequire("caSeK");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $0abfa3a3a9e806a4$var$setGlobalTheme = async ({ colorMode: colorMode = (0, $hdU6u.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $hdU6u.themeStateDefaults)['contrastMode'], dark: dark = (0, $hdU6u.themeStateDefaults)['dark'], light: light = (0, $hdU6u.themeStateDefaults)['light'], shape: shape = (0, $hdU6u.themeStateDefaults)['shape'], spacing: spacing = (0, $hdU6u.themeStateDefaults)['spacing'], typography: typography = (0, $hdU6u.themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $hdU6u.themeStateDefaults)['UNSAFE_themeOptions'] } = {}, themeLoader)=>{
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $VSDnB.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $9mHmN.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $caSeK.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $31Wet.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $hdU6u.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $dqUdo.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("2FWvr"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $9mHmN.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $9GmyU.default)(themeState);
    return autoUnbind;
};
var $0abfa3a3a9e806a4$export$2e2bcd8739ae039 = $0abfa3a3a9e806a4$var$setGlobalTheme;

});
parcelRegister("31Wet", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $5b69e7b6787ca4fb$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $5b69e7b6787ca4fb$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $5b69e7b6787ca4fb$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $5b69e7b6787ca4fb$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $5b69e7b6787ca4fb$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $5b69e7b6787ca4fb$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $5b69e7b6787ca4fb$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $5b69e7b6787ca4fb$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $5b69e7b6787ca4fb$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $5b69e7b6787ca4fb$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $5b69e7b6787ca4fb$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $5b69e7b6787ca4fb$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $5b69e7b6787ca4fb$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $5b69e7b6787ca4fb$export$b36dbdb4f463f05c(hex) {
    if (!$5b69e7b6787ca4fb$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $5b69e7b6787ca4fb$export$1212645cf40ebf71(hex)
    ];
}
function $5b69e7b6787ca4fb$export$5a544e13ad4e1fa5(hex) {
    if (!$5b69e7b6787ca4fb$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $5b69e7b6787ca4fb$export$47ea145a83f50dc0(hex) {
    if (!$5b69e7b6787ca4fb$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $5b69e7b6787ca4fb$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $5b69e7b6787ca4fb$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $5b69e7b6787ca4fb$export$d061e26956a60b0a(foreground, background) {
    if (!$5b69e7b6787ca4fb$var$isValidHex(foreground) || !$5b69e7b6787ca4fb$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $5b69e7b6787ca4fb$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $5b69e7b6787ca4fb$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $5b69e7b6787ca4fb$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $5b69e7b6787ca4fb$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $5b69e7b6787ca4fb$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $5b69e7b6787ca4fb$var$rgbToLab(rgbA);
    let labB = $5b69e7b6787ca4fb$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $5b69e7b6787ca4fb$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("9GmyU", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a1bca1aa5a408d$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $9mVKx = parcelRequire("9mVKx");

var $gV7Ao = parcelRequire("gV7Ao");

var $eZkgC = parcelRequire("eZkgC");
function $28a1bca1aa5a408d$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $gV7Ao.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $gV7Ao.default).bind();
    } else (0, $gV7Ao.default).unbind();
    if ((0, $VSDnB.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $eZkgC.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $eZkgC.default).bind();
        } else (0, $eZkgC.default).unbind();
    }
    const themeAttributes = (0, $9mVKx.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $gV7Ao.default).unbind();
        if ((0, $VSDnB.fg)('platform_increased-contrast-themes')) (0, $eZkgC.default).unbind();
    };
}

});
parcelRegister("9mVKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f1d4f215b977897$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $f8twK = parcelRequire("f8twK");

var $hdU6u = parcelRequire("hdU6u");

var $imVhc = parcelRequire("imVhc");

var $31Wet = parcelRequire("31Wet");

var $bDESO = parcelRequire("bDESO");
const $8f1d4f215b977897$var$defaultColorMode = 'light';
const $8f1d4f215b977897$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $8f1d4f215b977897$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $hdU6u.themeStateDefaults)['colorMode'], dark: dark = (0, $hdU6u.themeStateDefaults)['dark'], light: light = (0, $hdU6u.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $hdU6u.themeStateDefaults)['contrastMode'], shape: shape = (0, $hdU6u.themeStateDefaults)['shape'], spacing: spacing = (0, $hdU6u.themeStateDefaults)['spacing'], typography: typography = (0, $hdU6u.themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $hdU6u.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $imVhc.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $f8twK.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $f8twK.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $8f1d4f215b977897$var$defaultColorMode : colorMode
    };
    if ((0, $VSDnB.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $f8twK.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $8f1d4f215b977897$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $31Wet.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $bDESO.hash)(optionString);
        result[0, $f8twK.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $8f1d4f215b977897$export$2e2bcd8739ae039 = $8f1d4f215b977897$var$getThemeHtmlAttrs;

});
parcelRegister("bDESO", function(module, exports) {

$parcel$export(module.exports, "hash", () => $43d583a5e7299761$export$d6af199866bfb566);
const $43d583a5e7299761$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("gV7Ao", function(module, exports) {

$parcel$export(module.exports, "default", () => $276fb674d0bfcc1f$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");

var $f8twK = parcelRequire("f8twK");

var $caSeK = parcelRequire("caSeK");
const $276fb674d0bfcc1f$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $276fb674d0bfcc1f$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $f8twK.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $276fb674d0bfcc1f$var$darkModeMql = $276fb674d0bfcc1f$var$isMatchMediaAvailable && window.matchMedia((0, $caSeK.darkModeMediaQuery));
class $276fb674d0bfcc1f$var$ColorModeObserver {
    getColorMode() {
        if (!$276fb674d0bfcc1f$var$darkModeMql) return 'light';
        return $276fb674d0bfcc1f$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($276fb674d0bfcc1f$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $cBeZP.bind)($276fb674d0bfcc1f$var$darkModeMql, {
            type: 'change',
            listener: $276fb674d0bfcc1f$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $276fb674d0bfcc1f$var$SingletonColorModeObserver = new $276fb674d0bfcc1f$var$ColorModeObserver();
var $276fb674d0bfcc1f$export$2e2bcd8739ae039 = $276fb674d0bfcc1f$var$SingletonColorModeObserver;

});
parcelRegister("caSeK", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", () => $86176f76153a16e1$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "loadThemeCss", () => $86176f76153a16e1$export$8a48286ed7df6720);
$parcel$export(module.exports, "darkModeMediaQuery", () => $86176f76153a16e1$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $86176f76153a16e1$export$8662df6937d86fcb);

var $VSDnB = parcelRequire("VSDnB");

var $hKzN0 = parcelRequire("hKzN0");

var $f8twK = parcelRequire("f8twK");
const $86176f76153a16e1$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $f8twK.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $f8twK.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await $86176f76153a16e1$export$8a48286ed7df6720(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $86176f76153a16e1$export$8a48286ed7df6720 = async (themeId)=>{
    if ((themeId === 'light' || themeId === 'dark') && (0, $VSDnB.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
    const { default: themeCss } = await (0, $hKzN0.default)[themeId]();
    return themeCss;
};
const $86176f76153a16e1$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $86176f76153a16e1$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("hKzN0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f78a79dcac3478c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::8352f41e09dfe9d45ead708661744456>>
 * @codegenCommand yarn build tokens
 */ 














const $8f78a79dcac3478c$var$themeImportsMap = {
    'light': ()=>(parcelRequire("7gYUp")),
    'light-future': ()=>(parcelRequire("aJuQ0")),
    'light-increased-contrast': ()=>(parcelRequire("kMqZp")),
    'dark': ()=>(parcelRequire("9s2m0")),
    'dark-future': ()=>(parcelRequire("emRYK")),
    'dark-increased-contrast': ()=>(parcelRequire("edxrW")),
    'legacy-light': ()=>(parcelRequire("dd9xK")),
    'legacy-dark': ()=>(parcelRequire("d9vQU")),
    'spacing': ()=>(parcelRequire("eMuVG")),
    'typography-adg3': ()=>(parcelRequire("1EPgz")),
    'shape': ()=>(parcelRequire("kvE79")),
    'typography-modernized': ()=>(parcelRequire("cn7Hw")),
    'typography-refreshed': ()=>(parcelRequire("43lOe")),
    'light-brand-refresh': ()=>(parcelRequire("2RFWW")),
    'dark-brand-refresh': ()=>(parcelRequire("6tNRE"))
};
var $8f78a79dcac3478c$export$2e2bcd8739ae039 = $8f78a79dcac3478c$var$themeImportsMap;

});
parcelRegister("7gYUp", function(module, exports) {

let $54b94644cff7c554$var$load = (parcelRequire("28QjX"))(4);
module.exports = $54b94644cff7c554$var$load("8CAvw").then(()=>parcelRequire('iscuj'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


let $18f4e9fbd43d4c3b$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});



parcelRegister("aJuQ0", function(module, exports) {

let $7d06071e010c591c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d06071e010c591c$var$load("il6NV").then(()=>parcelRequire('4dVBj'));

});

parcelRegister("kMqZp", function(module, exports) {

let $f20d39e9ffe8059d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f20d39e9ffe8059d$var$load("9C021").then(()=>parcelRequire('ljoQC'));

});

parcelRegister("9s2m0", function(module, exports) {

let $6e188e0893c6fa8f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e188e0893c6fa8f$var$load("lWoNp").then(()=>parcelRequire('kJWHz'));

});

parcelRegister("emRYK", function(module, exports) {

let $a75cfdd5f76b7f10$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a75cfdd5f76b7f10$var$load("3gm3l").then(()=>parcelRequire('foDOQ'));

});

parcelRegister("edxrW", function(module, exports) {

let $a59c39fb9cf9a3e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a59c39fb9cf9a3e2$var$load("b4xnt").then(()=>parcelRequire('6XJvL'));

});

parcelRegister("dd9xK", function(module, exports) {

let $99e3e456db702681$var$load = (parcelRequire("28QjX"))(4);
module.exports = $99e3e456db702681$var$load("8guJp").then(()=>parcelRequire('49EkV'));

});

parcelRegister("d9vQU", function(module, exports) {

let $9934d2d489a79ff6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9934d2d489a79ff6$var$load("4Y77P").then(()=>parcelRequire('5hDHe'));

});

parcelRegister("eMuVG", function(module, exports) {

let $ac2d8a4d49207dbc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac2d8a4d49207dbc$var$load("jXDzW").then(()=>parcelRequire('hA9wZ'));

});

parcelRegister("1EPgz", function(module, exports) {

let $13514b47446684e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $13514b47446684e8$var$load("dPbB5").then(()=>parcelRequire('78NH5'));

});

parcelRegister("kvE79", function(module, exports) {

let $eee5d1c652648960$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eee5d1c652648960$var$load("elnga").then(()=>parcelRequire('7eY2Z'));

});

parcelRegister("cn7Hw", function(module, exports) {

let $901d9b4988260754$var$load = (parcelRequire("28QjX"))(4);
module.exports = $901d9b4988260754$var$load("3gspE").then(()=>parcelRequire('i2ikM'));

});

parcelRegister("43lOe", function(module, exports) {

let $2f385c0fd2f2de92$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f385c0fd2f2de92$var$load("9Zz24").then(()=>parcelRequire('2DMsg'));

});

parcelRegister("2RFWW", function(module, exports) {

let $21611252ad264b05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $21611252ad264b05$var$load("cVhz9").then(()=>parcelRequire('9m5Rp'));

});

parcelRegister("6tNRE", function(module, exports) {

let $4b7c2188685fd54c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b7c2188685fd54c$var$load("5liw2").then(()=>parcelRequire('7gle3'));

});




parcelRegister("eZkgC", function(module, exports) {

$parcel$export(module.exports, "default", () => $025f9528f4e449a3$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");

var $f8twK = parcelRequire("f8twK");

var $caSeK = parcelRequire("caSeK");
const $025f9528f4e449a3$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $025f9528f4e449a3$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $f8twK.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $025f9528f4e449a3$var$contrastModeMql = $025f9528f4e449a3$var$isMatchMediaAvailable && window.matchMedia((0, $caSeK.moreContrastMediaQuery));
class $025f9528f4e449a3$var$ContrastModeObserver {
    getContrastMode() {
        if (!$025f9528f4e449a3$var$contrastModeMql) return 'no-preference';
        return $025f9528f4e449a3$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($025f9528f4e449a3$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $cBeZP.bind)($025f9528f4e449a3$var$contrastModeMql, {
            type: 'change',
            listener: $025f9528f4e449a3$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $025f9528f4e449a3$var$SingletonContrastModeObserver = new $025f9528f4e449a3$var$ContrastModeObserver();
var $025f9528f4e449a3$export$2e2bcd8739ae039 = $025f9528f4e449a3$var$SingletonContrastModeObserver;

});


parcelRegister("dqUdo", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $97dbd21cb4f6cca4$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $97dbd21cb4f6cca4$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $97dbd21cb4f6cca4$export$e673f367da2ff23e);

var $hAKJr = parcelRequire("hAKJr");

var $f8twK = parcelRequire("f8twK");

var $bDESO = parcelRequire("bDESO");
function $97dbd21cb4f6cca4$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $bDESO.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $f8twK.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $f8twK.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $97dbd21cb4f6cca4$export$e7ae172320e03461(sizeThreshold) {
    const styleTags = [
        ...Array.from(document.head.querySelectorAll(`style[${(0, $f8twK.CUSTOM_THEME_ATTRIBUTE)}][${(0, $f8twK.THEME_DATA_ATTRIBUTE)}]`))
    ];
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
}
function $97dbd21cb4f6cca4$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce((acc, [key, value])=>{
        const cssVar = (0, $hAKJr.default)[key];
        return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
    }, '');
}

});
parcelRegister("hAKJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1064fb07223d4e99$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02412877f3dbfda4dbaee7a917f24b6c>>
 * @codegenCommand yarn build tokens
 */ const $1064fb07223d4e99$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body'
};
var $1064fb07223d4e99$export$2e2bcd8739ae039 = $1064fb07223d4e99$var$tokens;

});


parcelRegister("9mHmN", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", () => $37f8be660dd1191e$export$dd6aeb7c823fc03d);
$parcel$export(module.exports, "getThemeOverridePreferences", () => $37f8be660dd1191e$export$5d76d7014f4a5d08);

var $VSDnB = parcelRequire("VSDnB");

var $iDyon = parcelRequire("iDyon");
const $37f8be660dd1191e$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $VSDnB.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $iDyon.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $VSDnB.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $iDyon.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};
const $37f8be660dd1191e$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("iDyon", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1388cb358683ad9$export$2e2bcd8739ae039);

var $hdU6u = parcelRequire("hdU6u");
function $b1388cb358683ad9$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $hdU6u.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});


parcelRegister("2FWvr", function(module, exports) {

let $1f2ccb39e637afed$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f2ccb39e637afed$var$load("3qRpd").then(()=>parcelRequire('msaV2'));

});




parcelRegister("bjGSs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56f9c413d8fbf4deb11215ad83bf4b70>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83d2ba975692c1a3$var$_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83d2ba975692c1a3$var$CrossIcon = (props)=>/*#__PURE__*/ $83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.06 6 3.47-3.47-1.06-1.06L6 4.94 2.53 1.47 1.47 2.53 4.94 6 1.47 9.47l1.06 1.06L6 7.06l3.47 3.47 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;

});

parcelRegister("bJeNF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b775822095ff11ff1cfe3f316db8614>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $889f60aca54b55ef$var$_react = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $889f60aca54b55ef$var$_showMoreHorizontal = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("8U6zd")));

var $889f60aca54b55ef$var$_more = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("3oUqw")));
function $889f60aca54b55ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $889f60aca54b55ef$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $889f60aca54b55ef$var$_react.default.createElement($889f60aca54b55ef$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $889f60aca54b55ef$var$_more.default
    }, props));
$889f60aca54b55ef$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $889f60aca54b55ef$var$_default = module.exports.default = $889f60aca54b55ef$var$ShowMoreHorizontalIcon;

});

parcelRegister("1GGwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9768e745d0380796$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $5JjdN = parcelRequire("5JjdN");

var $SliG5 = parcelRequire("SliG5");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");

var $4vsgW = parcelRequire("4vsgW");

var $ijDdv = parcelRequire("ijDdv");
const $9768e745d0380796$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r81 _1hmsagmp _ajmmvv82 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    fullWidth: "_1bsb1osq"
};
const $9768e745d0380796$var$defaultStyles = {
    root: "_bfhkiw92 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $9768e745d0380796$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $9768e745d0380796$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
const $9768e745d0380796$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
const $9768e745d0380796$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $9768e745d0380796$var$subtleStyles = {
    root: "_bfhk1w7a _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
const $9768e745d0380796$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l31pke _1di619ru _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $9768e745d0380796$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $5uXOq.useRef)(null);
    (0, $SliG5.default)(localRef, autoFocus);
    const combinedRef = (0, $5JjdN.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5McnS.default), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $3JT92.cx)($9768e745d0380796$var$styles.base, appearance === 'default' && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $9768e745d0380796$var$defaultStyles.rootRefreshed : $9768e745d0380796$var$defaultStyles.root), appearance === 'primary' && $9768e745d0380796$var$primaryStyles.root, appearance === 'warning' && $9768e745d0380796$var$warningStyles.root, appearance === 'danger' && $9768e745d0380796$var$dangerStyles.root, appearance === 'discovery' && $9768e745d0380796$var$discoveryStyles.root, appearance === 'subtle' && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $9768e745d0380796$var$subtleStyles.rootRefreshed : $9768e745d0380796$var$subtleStyles.root), $9768e745d0380796$var$styles.linkDecorationUnset, isSelected && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $9768e745d0380796$var$selectedStyles.rootRefreshed : $9768e745d0380796$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $9768e745d0380796$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $9768e745d0380796$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $9768e745d0380796$var$selectedStyles.discovery, isDisabled && $9768e745d0380796$var$styles.disabled, spacing === 'compact' && $9768e745d0380796$var$styles.spacingCompact, hasIconBefore && $9768e745d0380796$var$styles.buttonIconBefore, hasIconAfter && $9768e745d0380796$var$styles.buttonIconAfter, shouldFitContainer && $9768e745d0380796$var$styles.fullWidth),
        children: [
            iconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4vsgW.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ijDdv.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4vsgW.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4vsgW.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ijDdv.default), {
                    icon: iconAfter
                })
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $9768e745d0380796$var$LinkButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)($9768e745d0380796$var$LinkButtonBase);
$9768e745d0380796$var$LinkButton.displayName = 'LinkButton';
var $9768e745d0380796$export$2e2bcd8739ae039 = $9768e745d0380796$var$LinkButton;

});

parcelRegister("BLPHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c58d48a2d2ab0e8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eCeGD = parcelRequire("eCeGD");


var $5JjdN = parcelRequire("5JjdN");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fsuMn = parcelRequire("fsuMn");

var $c8Oei = parcelRequire("c8Oei");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k5uoT = parcelRequire("k5uoT");

var $aFqyR = parcelRequire("aFqyR");

var $5CZpS = parcelRequire("5CZpS");

var $iY6id = parcelRequire("iY6id");

var $l7Q0F = parcelRequire("l7Q0F");

var $gsxsp = parcelRequire("gsxsp");
const $5c58d48a2d2ab0e8$var$gridSize = (0, $k5uoT.gridSize)();
const $5c58d48a2d2ab0e8$var$MAX_HEIGHT = `calc(100vh - ${$5c58d48a2d2ab0e8$var$gridSize * 2}px)`;
const $5c58d48a2d2ab0e8$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $5c58d48a2d2ab0e8$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$5c58d48a2d2ab0e8$var$opposites[crossAxis]}`,
            `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}-${crossAxis}`,
            `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}`,
            `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}-${$5c58d48a2d2ab0e8$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}`,
        `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}-start`,
        `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $5c58d48a2d2ab0e8$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $5c58d48a2d2ab0e8$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $eGmKJ.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $k5uoT.layers).modal(), label: label, interactionName: interactionName, strategy: strategy })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $33etG.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $5uXOq.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const id = (0, $gsxsp.default)();
    const itemRef = (0, $l7Q0F.default)();
    const fallbackPlacements = (0, $5uXOq.useMemo)(()=>$5c58d48a2d2ab0e8$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $5uXOq.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $5uXOq.useCallback)((event, currentLevel)=>{
        const isTabOrEscapeKey = $5c58d48a2d2ab0e8$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $gsxsp.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($5c58d48a2d2ab0e8$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body && // except if clicking on the body
            (0, $VSDnB.fg)('platform_design_system_team_dropdown_return_focus');
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $fsuMn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $5uXOq.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $eGmKJ.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $eGmKJ.default;
        return (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $gsxsp.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $5e71d9a7b5ef77ee$export$e51a3576c045c8d5) || e.key === (0, $5e71d9a7b5ef77ee$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iY6id.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $5JjdN.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                    ...bindFocus,
                    ref: (0, $5JjdN.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
                        interactionName: interactionName
                    },
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $aFqyR.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5CZpS.default), {
                        spacing: spacing,
                        maxHeight: $5c58d48a2d2ab0e8$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        children: children
                    })
                })
        })
    });
};
var $5c58d48a2d2ab0e8$export$2e2bcd8739ae039 = $5c58d48a2d2ab0e8$var$DropdownMenu;

});
parcelRegister("33etG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d76037f5e9b3123$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $9d76037f5e9b3123$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $5uXOq.useState)(getDefaultPropValue);
    const isControlledRef = (0, $5uXOq.useRef)(isControlled);
    (0, $5uXOq.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $5uXOq.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("c8Oei", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a08e2cd9fd0eae78f18da4572f37370>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d6d31f6a6431b53$var$_react = $8d6d31f6a6431b53$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8d6d31f6a6431b53$var$_chevronDown = $8d6d31f6a6431b53$var$_interopRequireDefault((parcelRequire("hORKG")));

var $8d6d31f6a6431b53$var$_chevronDown2 = $8d6d31f6a6431b53$var$_interopRequireDefault((parcelRequire("6Ingq")));
function $8d6d31f6a6431b53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d6d31f6a6431b53$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $8d6d31f6a6431b53$var$_react.default.createElement($8d6d31f6a6431b53$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $8d6d31f6a6431b53$var$_chevronDown2.default
    }, props));
$8d6d31f6a6431b53$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $8d6d31f6a6431b53$var$_default = module.exports.default = $8d6d31f6a6431b53$var$ChevronDownIcon;

});

parcelRegister("aFqyR", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $974fa4bbe12da3a6$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $974fa4bbe12da3a6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eGmKJ = parcelRequire("eGmKJ");

var $fxUuP = parcelRequire("fxUuP");

var $c7zut = parcelRequire("c7zut");
const $974fa4bbe12da3a6$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    menuItemRefs: [],
    registerRef: (0, $eGmKJ.default)
});
/**
 * Focus manager logic.
 */ const $974fa4bbe12da3a6$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $5uXOq.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $5uXOq.useState)(0);
    const registerMode = (0, $5uXOq.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $5uXOq.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled } = (0, $fxUuP.useLayering)();
    // Intentionally rebinding on each render
    (0, $5uXOq.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $5uXOq.useEffect)(()=>(0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: (0, $c7zut.default)(menuItemRefs, isLayerDisabled, onClose)
        }), [
        isLayerDisabled,
        onClose
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($974fa4bbe12da3a6$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $974fa4bbe12da3a6$export$2e2bcd8739ae039 = $974fa4bbe12da3a6$var$FocusManager;

});
parcelRegister("c7zut", function(module, exports) {

$parcel$export(module.exports, "default", () => $8063bd9a2f17da3b$export$2e2bcd8739ae039);


var $VSDnB = parcelRequire("VSDnB");

var $gsxsp = parcelRequire("gsxsp");
const $8063bd9a2f17da3b$var$actionMap = {
    [(0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)]: 'next',
    [(0, $5e71d9a7b5ef77ee$export$390330c10ff2b9a1)]: 'prev',
    [(0, $5e71d9a7b5ef77ee$export$4af703091671bc)]: 'first',
    [(0, $5e71d9a7b5ef77ee$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8063bd9a2f17da3b$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    if ((0, $VSDnB.fg)('dropdown-menu-disabled-navigation-fix')) for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    else while(currentFocusedIdx + 1 < refs.length){
        const { current: element } = refs[++currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8063bd9a2f17da3b$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    if ((0, $VSDnB.fg)('dropdown-menu-disabled-navigation-fix')) for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    else while(currentFocusedIdx > 0){
        const { current: element } = refs[--currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
function $8063bd9a2f17da3b$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $VSDnB.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $gsxsp.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $8063bd9a2f17da3b$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if ((0, $VSDnB.fg)('dropdown-menu-disabled-navigation-fix')) {
                    const nextFocusableElement = $8063bd9a2f17da3b$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                    break;
                }
                // Remove on FG cleanup dropdown-menu-disabled-navigation-fix
                if (currentFocusedIdx < currentRefs.length - 1) {
                    const nextFocusableElement = $8063bd9a2f17da3b$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $8063bd9a2f17da3b$var$getNextFocusableElement(currentRefs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if ((0, $VSDnB.fg)('dropdown-menu-disabled-navigation-fix')) {
                    const prevFocusableElement = $8063bd9a2f17da3b$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                    break;
                }
                // Remove on FG cleanup dropdown-menu-disabled-navigation-fix
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $8063bd9a2f17da3b$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $8063bd9a2f17da3b$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $8063bd9a2f17da3b$var$getNextFocusableElement(currentRefs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $8063bd9a2f17da3b$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("gsxsp", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $53348102ac8cc8b7$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $53348102ac8cc8b7$export$2e2bcd8739ae039);

var $9KnKW = parcelRequire("9KnKW");
const $53348102ac8cc8b7$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $53348102ac8cc8b7$export$2e2bcd8739ae039() {
    const id = (0, $9KnKW.useId)();
    return `${$53348102ac8cc8b7$export$8a682ae47622dbb9}${id}`;
}

});



parcelRegister("5CZpS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6165a25e5ac52753$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eZUJu = parcelRequire("eZUJu");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $1yOpY = parcelRequire("1yOpY");

var $enuC5 = parcelRequire("enuC5");

var $aFqyR = parcelRequire("aFqyR");
const $6165a25e5ac52753$var$spinnerContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $6165a25e5ac52753$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $6165a25e5ac52753$var$spinnerContainerStyles,
        role: "menuitem"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $6165a25e5ac52753$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $5uXOq.useContext)((0, $aFqyR.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $1yOpY.default)(menuItem) || (0, $enuC5.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $5uXOq.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZUJu.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $f8Sb3.jsx)($6165a25e5ac52753$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $6165a25e5ac52753$export$2e2bcd8739ae039 = $6165a25e5ac52753$var$MenuWrapper;

});
parcelRegister("1yOpY", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f2429108c8dfd0$export$2e2bcd8739ae039);
function $11f2429108c8dfd0$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("enuC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf55b1b2e2bb5e7$export$2e2bcd8739ae039);
function $1bf55b1b2e2bb5e7$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("iY6id", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $bab2af36b28b0b77$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $bab2af36b28b0b77$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $bab2af36b28b0b77$export$756f795847463ebd = /*#__PURE__*/ (0, $5uXOq.createContext)({
    setItemState: (0, $eGmKJ.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $eGmKJ.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $bab2af36b28b0b77$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $5uXOq.useRef)({});
    const context = (0, $5uXOq.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($bab2af36b28b0b77$export$756f795847463ebd.Provider, {
        value: context,
        children: children
    });
};
var $bab2af36b28b0b77$export$2e2bcd8739ae039 = $bab2af36b28b0b77$var$SelectionStore;

});

parcelRegister("l7Q0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $70536c1d6eed3410$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $aFqyR = parcelRequire("aFqyR");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $70536c1d6eed3410$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $5uXOq.useContext)((0, $aFqyR.FocusManagerContext));
    const itemRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (hasPopup && (0, $VSDnB.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $70536c1d6eed3410$export$2e2bcd8739ae039 = $70536c1d6eed3410$var$useRegisterItemWithFocusManager;

});


parcelRegister("6B7KL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ff85f737833a5bc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5JjdN = parcelRequire("5JjdN");

var $kJpBP = parcelRequire("kJpBP");

var $1aogK = parcelRequire("1aogK");

var $3Z96c = parcelRequire("3Z96c");

var $VSDnB = parcelRequire("VSDnB");

var $l7Q0F = parcelRequire("l7Q0F");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $9ff85f737833a5bc$var$DropdownMenuItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $l7Q0F.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aogK.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5JjdN.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5JjdN.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5JjdN.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest,
        children: children
    });
});
var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;

});

parcelRegister("aRoVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1f89f82839ba50$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9KnKW = parcelRequire("9KnKW");

var $9UCCQ = parcelRequire("9UCCQ");

var $k20lf = parcelRequire("k20lf");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $6c1f89f82839ba50$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $9KnKW.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k20lf.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;

});
parcelRegister("k20lf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0173d5b95091e18$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $f0173d5b95091e18$var$headingStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    font: 'font.heading.xxsmall',
    paddingBlock: 'space.0',
    paddingInline: 'space.200'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $f0173d5b95091e18$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $f0173d5b95091e18$var$headingStyles,
        children: title
    });
var $f0173d5b95091e18$export$2e2bcd8739ae039 = $f0173d5b95091e18$var$GroupTitle;

});


parcelRegister("hyKRO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4c1734fa923dab0dd658a9a18dcfad0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc89f770b0677de5$var$_react = $cc89f770b0677de5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cc89f770b0677de5$var$_baseNew = $cc89f770b0677de5$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $cc89f770b0677de5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc89f770b0677de5$var$ClockIcon = (props)=>/*#__PURE__*/ $cc89f770b0677de5$var$_react.default.createElement($cc89f770b0677de5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8.75-.36V3.25h-1.5v5.11l2.781 2.226.938-1.172z" clip-rule="evenodd"/>`
    }, props));
$cc89f770b0677de5$var$ClockIcon.displayName = 'ClockIcon';
var $cc89f770b0677de5$var$_default = module.exports.default = $cc89f770b0677de5$var$ClockIcon;

});

parcelRegister("2pMF0", function(module, exports) {

$parcel$export(module.exports, "AtlassianIcon", () => $f254a283aa81cf60$export$8a485e2e7ed91e8f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $f254a283aa81cf60$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $f254a283aa81cf60$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $lEsIP.defaultLogoParams).size, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $f254a283aa81cf60$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("1DVhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4b6b583e25d0959$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d4b6b583e25d0959$var$shimmerKeyframes = null;
const $d4b6b583e25d0959$var$skeletonStyles = null;
const $d4b6b583e25d0959$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $d4b6b583e25d0959$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $bwpsq.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq1y0p"
        ])
    });
};
var $d4b6b583e25d0959$export$2e2bcd8739ae039 = $d4b6b583e25d0959$var$Skeleton;

});

parcelRegister("1Cvrw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::52af1617dddfd09530e8f62747e987f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12e1baef6b49aa95$var$_react = $12e1baef6b49aa95$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $12e1baef6b49aa95$var$_baseNew = $12e1baef6b49aa95$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $12e1baef6b49aa95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starring or favoriting objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12e1baef6b49aa95$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $12e1baef6b49aa95$var$_react.default.createElement($12e1baef6b49aa95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 0a.75.75 0 0 1 .7.48l1.288 3.35 3.32.256a.75.75 0 0 1 .422 1.324L9.182 7.533l.945 3.523a.75.75 0 0 1-1.148.813L6 9.825l-2.979 2.042a.75.75 0 0 1-1.148-.812l.945-3.523L.27 5.41a.75.75 0 0 1 .422-1.324l3.32-.256L5.3.48A.75.75 0 0 1 6 0m0 2.84-.928 2.413-2.423.186 1.866 1.556-.667 2.488L6 8.007l2.152 1.476-.667-2.488L9.35 5.439l-2.423-.186z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$12e1baef6b49aa95$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $12e1baef6b49aa95$var$_default = module.exports.default = $12e1baef6b49aa95$var$StarUnstarredIcon;

});

parcelRegister("iwwXK", function(module, exports) {

$parcel$export(module.exports, "default", () => $97b85b059b286d19$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $cYuZM = parcelRequire("cYuZM");

var $eGmKJ = parcelRequire("eGmKJ");


var $k5uoT = parcelRequire("k5uoT");

var $baKwq = parcelRequire("baKwq");
function $97b85b059b286d19$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $97b85b059b286d19$var$gridSize = (0, $k5uoT.gridSize)();
const $97b85b059b286d19$var$borderRadius = (0, $k5uoT.borderRadius)();
const $97b85b059b286d19$var$itemElemSpacing = $97b85b059b286d19$var$gridSize * 1.5;
const $97b85b059b286d19$var$itemExpectedElemSize = $97b85b059b286d19$var$gridSize * 3;
const $97b85b059b286d19$var$itemMinHeight = $97b85b059b286d19$var$gridSize * 5;
const $97b85b059b286d19$var$skeletonItemElemSize = $97b85b059b286d19$var$gridSize * 2.5;
const $97b85b059b286d19$var$itemElemSkeletonOffset = ($97b85b059b286d19$var$itemExpectedElemSize - $97b85b059b286d19$var$skeletonItemElemSize) / 2;
const $97b85b059b286d19$var$skeletonTextBorderRadius = 100;
const $97b85b059b286d19$var$skeletonContentHeight = 9;
const $97b85b059b286d19$var$skeletonColor = `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`;
const $97b85b059b286d19$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: $97b85b059b286d19$var$itemMinHeight,
    padding: `0 ${"var(--ds-space-250, 20px)"}`,
    alignItems: 'center',
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        height: $97b85b059b286d19$var$skeletonContentHeight,
        backgroundColor: $97b85b059b286d19$var$skeletonColor,
        borderRadius: $97b85b059b286d19$var$skeletonTextBorderRadius,
        content: '""',
        // This is a little bespoke but we need to push everything down 1px
        // because the skeleton content should align to the bottom of the text.
        // Confirm VR test failures before accepting a change.
        marginBlockStart: 1
    }
});
const $97b85b059b286d19$var$defaultWidthStyles = {
    name: "sljcv5",
    styles: ":nth-of-type(1n)::after{flex-basis:70%;}:nth-of-type(2n)::after{flex-basis:50%;}:nth-of-type(3n)::after{flex-basis:60%;}:nth-of-type(4n)::after{flex-basis:90%;}:nth-of-type(5n)::after{flex-basis:35%;}:nth-of-type(6n)::after{flex-basis:77%;}"
};
const $97b85b059b286d19$var$customWidthStyles = {
    name: "nsk3fe",
    styles: "::after{flex-basis:var(--width);}"
};
const $97b85b059b286d19$var$beforeElementStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: $97b85b059b286d19$var$skeletonItemElemSize,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $97b85b059b286d19$var$skeletonItemElemSize,
        flexShrink: 0,
        backgroundColor: $97b85b059b286d19$var$skeletonColor,
        content: '""',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginInlineEnd: $97b85b059b286d19$var$itemElemSpacing + $97b85b059b286d19$var$itemElemSkeletonOffset,
        marginInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $97b85b059b286d19$var$avatarStyles = {
    name: "lz1zvf",
    styles: "::before{border-radius:100%;}"
};
const $97b85b059b286d19$var$iconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        $97b85b059b286d19$var$borderRadius
    }
});
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $97b85b059b286d19$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $eGmKJ.default) })=>{
    (0, $cYuZM.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $eGmKJ.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $f8Sb3.css)(cssFn());
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $baKwq.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            style: {
                '--width': width
            },
            css: [
                $97b85b059b286d19$var$skeletonStyles,
                (hasAvatar || hasIcon) && $97b85b059b286d19$var$beforeElementStyles,
                hasAvatar && $97b85b059b286d19$var$avatarStyles,
                hasIcon && $97b85b059b286d19$var$iconStyles,
                width ? $97b85b059b286d19$var$customWidthStyles : $97b85b059b286d19$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-testid": testId
        }));
};
var $97b85b059b286d19$export$2e2bcd8739ae039 = $97b85b059b286d19$var$SkeletonItem;

});
parcelRegister("baKwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $04660292477cff34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

/**
 * These keyframes are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $04660292477cff34$var$shimmerKeyframes = (0, $f8Sb3.keyframes)({
    from: {
        backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
    },
    to: {
        backgroundColor: `var(--ds-skeleton-subtle, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
    }
});
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $04660292477cff34$var$shimmerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before, ::after': {
        animationDirection: 'alternate',
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        animationName: `${$04660292477cff34$var$shimmerKeyframes}`,
        animationTimingFunction: 'linear',
        backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
    }
});
/**
 * __Skeleton shimmer__
 *
 * A skeleton shimmer is the animation shown on loading skeletons for
 * perceived performance and user satisfaction.
 *
 * This component provides a `className` through render props. This value will
 * have type:
 * + `string`, when `isShimmering={true}`.
 * + `undefined`, when `isShimmering={false}`.
 *
 * @internal
 */ const $04660292477cff34$var$SkeletonShimmer = ({ children: children, isShimmering: isShimmering = false })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css })=>children({
            className: isShimmering ? css($04660292477cff34$var$shimmerStyles) : undefined
        }));
};
var $04660292477cff34$export$2e2bcd8739ae039 = $04660292477cff34$var$SkeletonShimmer;

});


parcelRegister("5Fk4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $00a6b48fc5d47e1d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $LnCko = parcelRequire("LnCko");

var $imZsD = parcelRequire("imZsD");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $00a6b48fc5d47e1d$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $imZsD.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $LnCko.default), {
                name: name,
                hasNodeResolver: !(0, $VSDnB.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
var $00a6b48fc5d47e1d$export$2e2bcd8739ae039 = $00a6b48fc5d47e1d$var$SpotlightTarget;

});
parcelRegister("LnCko", function(module, exports) {

$parcel$export(module.exports, "default", () => $76b01a6bc446afce$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dI393 = parcelRequire("dI393");
const $76b01a6bc446afce$var$spanStyles = null;
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $76b01a6bc446afce$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: divRef,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
var $76b01a6bc446afce$export$2e2bcd8739ae039 = $76b01a6bc446afce$var$NodeResolverSpotlightTarget;

});


parcelRegister("5Trwl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0f6dceac3b1541133f5e1afe0b271c5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44a76fdaaa74fdfa$var$_react = $44a76fdaaa74fdfa$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $44a76fdaaa74fdfa$var$_baseNew = $44a76fdaaa74fdfa$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $44a76fdaaa74fdfa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for roadmaps plan.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44a76fdaaa74fdfa$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $44a76fdaaa74fdfa$var$_react.default.createElement($44a76fdaaa74fdfa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$44a76fdaaa74fdfa$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $44a76fdaaa74fdfa$var$_default = module.exports.default = $44a76fdaaa74fdfa$var$RoadmapsPlanIcon;

});

parcelRegister("1ZDWg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::552918135e976d59647ada829319b3a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $173a77f26aba4973$var$_react = $173a77f26aba4973$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $173a77f26aba4973$var$_baseNew = $173a77f26aba4973$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $173a77f26aba4973$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $173a77f26aba4973$var$AppsIcon = (props)=>/*#__PURE__*/ $173a77f26aba4973$var$_react.default.createElement($173a77f26aba4973$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm8.25.75V9h1.5v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$173a77f26aba4973$var$AppsIcon.displayName = 'AppsIcon';
var $173a77f26aba4973$var$_default = module.exports.default = $173a77f26aba4973$var$AppsIcon;

});

parcelRegister("ls0mX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ecb88d563448af87338c1287afbb1bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9dc7fd379b4b774$var$_react = $f9dc7fd379b4b774$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f9dc7fd379b4b774$var$_baseNew = $f9dc7fd379b4b774$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f9dc7fd379b4b774$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Assets graph
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f9dc7fd379b4b774$var$AssetsGraphIcon = (props)=>/*#__PURE__*/ $f9dc7fd379b4b774$var$_react.default.createElement($f9dc7fd379b4b774$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.28 2.22a.75.75 0 1 0-1.06 1.06.75.75 0 0 0 1.06-1.06M1.16 1.159A2.25 2.25 0 0 1 4.781 3.72l1.695 1.695a3 3 0 0 1 3.048 0l1.695-1.695a2.251 2.251 0 1 1 1.06 1.06l-1.694 1.696a3 3 0 0 1 0 3.048l1.695 1.695a2.251 2.251 0 1 1-1.06 1.06l-1.696-1.694a3 3 0 0 1-3.048 0L4.78 12.28a2.251 2.251 0 1 1-1.06-1.06l1.694-1.696a3 3 0 0 1 0-3.048L3.72 4.78a2.25 2.25 0 0 1-2.56-3.621m12.621 1.06a.75.75 0 1 0-1.06 1.061.75.75 0 0 0 1.06-1.06M9.06 6.94a1.5 1.5 0 1 0-2.12 2.122A1.5 1.5 0 0 0 9.06 6.94m-5.78 5.78a.75.75 0 1 0-1.06 1.061.75.75 0 0 0 1.06-1.06m10.5 0a.75.75 0 1 0-1.06 1.061.75.75 0 0 0 1.06-1.06" clip-rule="evenodd"/>`
    }, props));
$f9dc7fd379b4b774$var$AssetsGraphIcon.displayName = 'AssetsGraphIcon';
var $f9dc7fd379b4b774$var$_default = module.exports.default = $f9dc7fd379b4b774$var$AssetsGraphIcon;

});

parcelRegister("9x5pH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04422a31fe921661fd3c15a462bdcae0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f0b6523520f8759$var$_react = $6f0b6523520f8759$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6f0b6523520f8759$var$_baseNew = $6f0b6523520f8759$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6f0b6523520f8759$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f0b6523520f8759$var$GlobeIcon = (props)=>/*#__PURE__*/ $6f0b6523520f8759$var$_react.default.createElement($6f0b6523520f8759$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$6f0b6523520f8759$var$GlobeIcon.displayName = 'GlobeIcon';
var $6f0b6523520f8759$var$_default = module.exports.default = $6f0b6523520f8759$var$GlobeIcon;

});

parcelRegister("4iV1e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3225129c19adcd71$var$_react = $3225129c19adcd71$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3225129c19adcd71$var$_baseNew = $3225129c19adcd71$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3225129c19adcd71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3225129c19adcd71$var$GoalIcon = (props)=>/*#__PURE__*/ $3225129c19adcd71$var$_react.default.createElement($3225129c19adcd71$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$3225129c19adcd71$var$GoalIcon.displayName = 'GoalIcon';
var $3225129c19adcd71$var$_default = module.exports.default = $3225129c19adcd71$var$GoalIcon;

});

parcelRegister("ecqyi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ed07350d21c7e2ad94ff4198361d506>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a566c862ec6a0c91$var$_react = $a566c862ec6a0c91$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a566c862ec6a0c91$var$_baseNew = $a566c862ec6a0c91$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a566c862ec6a0c91$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a566c862ec6a0c91$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $a566c862ec6a0c91$var$_react.default.createElement($a566c862ec6a0c91$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$a566c862ec6a0c91$var$MarketplaceIcon.displayName = 'MarketplaceIcon';
var $a566c862ec6a0c91$var$_default = module.exports.default = $a566c862ec6a0c91$var$MarketplaceIcon;

});

parcelRegister("kjHmv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e48f30ce66033de9bc11d4e39ddc845f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eca737cc134da8ca$var$_react = $eca737cc134da8ca$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eca737cc134da8ca$var$_baseNew = $eca737cc134da8ca$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eca737cc134da8ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Headphones".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: music, audio.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eca737cc134da8ca$var$HeadphonesIcon = (props)=>/*#__PURE__*/ $eca737cc134da8ca$var$_react.default.createElement($eca737cc134da8ca$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A5.5 5.5 0 0 0 2.5 7v.208A2.5 2.5 0 0 1 6 9.5v3.72A1.78 1.78 0 0 1 4.22 15 3.22 3.22 0 0 1 1 11.78V7a7 7 0 0 1 14 0v4.78A3.22 3.22 0 0 1 11.78 15 1.78 1.78 0 0 1 10 13.22V9.5a2.5 2.5 0 0 1 3.5-2.292V7A5.5 5.5 0 0 0 8 1.5m5.5 8a1 1 0 1 0-2 0v3.72c0 .155.125.28.28.28.95 0 1.72-.77 1.72-1.72zm-11 0v2.28c0 .95.77 1.72 1.72 1.72a.28.28 0 0 0 .28-.28V9.5a1 1 0 1 0-2 0" clip-rule="evenodd"/>`
    }, props));
$eca737cc134da8ca$var$HeadphonesIcon.displayName = 'HeadphonesIcon';
var $eca737cc134da8ca$var$_default = module.exports.default = $eca737cc134da8ca$var$HeadphonesIcon;

});

parcelRegister("dXQDI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc58ff4eb916aa4715fd29d4da19740a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a99e2d5e8e6c58$var$_react = $a2a99e2d5e8e6c58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a2a99e2d5e8e6c58$var$_baseNew = $a2a99e2d5e8e6c58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a2a99e2d5e8e6c58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2a99e2d5e8e6c58$var$ProjectIcon = (props)=>/*#__PURE__*/ $a2a99e2d5e8e6c58$var$_react.default.createElement($a2a99e2d5e8e6c58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$a2a99e2d5e8e6c58$var$ProjectIcon.displayName = 'ProjectIcon';
var $a2a99e2d5e8e6c58$var$_default = module.exports.default = $a2a99e2d5e8e6c58$var$ProjectIcon;

});

parcelRegister("c781K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d1c5d7d8bf36ee2$var$_react = $8d1c5d7d8bf36ee2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8d1c5d7d8bf36ee2$var$_baseNew = $8d1c5d7d8bf36ee2$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8d1c5d7d8bf36ee2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d1c5d7d8bf36ee2$var$TeamsIcon = (props)=>/*#__PURE__*/ $8d1c5d7d8bf36ee2$var$_react.default.createElement($8d1c5d7d8bf36ee2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$8d1c5d7d8bf36ee2$var$TeamsIcon.displayName = 'TeamsIcon';
var $8d1c5d7d8bf36ee2$var$_default = module.exports.default = $8d1c5d7d8bf36ee2$var$TeamsIcon;

});

parcelRegister("7EZ5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $593ba794a5c6525a$var$_react = $593ba794a5c6525a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $593ba794a5c6525a$var$_baseNew = $593ba794a5c6525a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $593ba794a5c6525a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $593ba794a5c6525a$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $593ba794a5c6525a$var$_react.default.createElement($593ba794a5c6525a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$593ba794a5c6525a$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $593ba794a5c6525a$var$_default = module.exports.default = $593ba794a5c6525a$var$ChartTrendIcon;

});

parcelRegister("fJMTr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30e149500cf1a05a183dbc43511b361c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b750fc24fe2dde9f$var$_react = $b750fc24fe2dde9f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b750fc24fe2dde9f$var$_baseNew = $b750fc24fe2dde9f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b750fc24fe2dde9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b750fc24fe2dde9f$var$OperationsIcon = (props)=>/*#__PURE__*/ $b750fc24fe2dde9f$var$_react.default.createElement($b750fc24fe2dde9f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$b750fc24fe2dde9f$var$OperationsIcon.displayName = 'OperationsIcon';
var $b750fc24fe2dde9f$var$_default = module.exports.default = $b750fc24fe2dde9f$var$OperationsIcon;

});

parcelRegister("llvRa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::052aa506253b4fa39b1a73c5776ea203>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0402a646ff642134$var$_react = $0402a646ff642134$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0402a646ff642134$var$_baseNew = $0402a646ff642134$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0402a646ff642134$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shield".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: classifications in Enterprise Trust, security in Jira (Spork)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0402a646ff642134$var$ShieldIcon = (props)=>/*#__PURE__*/ $0402a646ff642134$var$_react.default.createElement($0402a646ff642134$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.53.22a.75.75 0 0 0-1.06 0C6.172 1.518 4.686 2.41 3.515 2.982a16 16 0 0 1-1.434.615 11 11 0 0 1-.51.174l-.023.007-.005.001A.75.75 0 0 0 1 4.5c0 4.338 1.651 7.176 3.334 8.926.836.87 1.672 1.463 2.304 1.842a9 9 0 0 0 .999.519l.066.027.02.008.006.002.003.001a.76.76 0 0 0 .535 0h.004l.006-.003.02-.008.066-.027q.083-.035.227-.103c.19-.09.456-.226.772-.416a11.3 11.3 0 0 0 2.304-1.842C13.349 11.676 15 8.838 15 4.5a.75.75 0 0 0-.544-.721l-.004-.001-.024-.007-.103-.033a11 11 0 0 1-.406-.141c-.35-.13-.85-.33-1.434-.615C11.314 2.412 9.828 1.518 8.53.22M8 1.783C6.69 2.963 5.286 3.788 4.172 4.33a17 17 0 0 1-1.663.707c.128 3.604 1.532 5.92 2.907 7.35a9.8 9.8 0 0 0 1.993 1.595c.24.144.443.25.591.322.148-.072.35-.178.59-.322a9.8 9.8 0 0 0 1.994-1.596c1.375-1.43 2.779-3.745 2.907-7.349l-.09-.032a17 17 0 0 1-1.573-.675C10.714 3.788 9.31 2.963 8 1.783" clip-rule="evenodd"/>`
    }, props));
$0402a646ff642134$var$ShieldIcon.displayName = 'ShieldIcon';
var $0402a646ff642134$var$_default = module.exports.default = $0402a646ff642134$var$ShieldIcon;

});

parcelRegister("4qH7b", function(module, exports) {

$parcel$export(module.exports, "CommonActions", () => $1b78ea4a7b6673b0$export$deb4c0713194b9f5);
/* common-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $1b78ea4a7b6673b0$var$styles = {
    root: "_zulpu2gc _yyhycs5v _1bsb1osq _4cvr1h6o",
    oldLayoutStyles: "_1e0c1txw _1bahh9n0 _1odf1h6o",
    newLayoutStyles: "_1e0c1txw _1bahh9n0 _181n11p5 _1j8b15b0 _lagd1bp4 _1t4c1ris _12e8h9n0"
};
const $1b78ea4a7b6673b0$export$deb4c0713194b9f5 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $1b78ea4a7b6673b0$var$styles.root,
            (0, $VSDnB.fg)('platform_design_system_nav4_top_nav_columns') ? $1b78ea4a7b6673b0$var$styles.newLayoutStyles : $1b78ea4a7b6673b0$var$styles.oldLayoutStyles
        ]),
        children: children
    });

});

parcelRegister("gKrz2", function(module, exports) {

$parcel$export(module.exports, "HomeActions", () => $29c38db79bd750a6$export$ae2177c1f0d2b72c);
/* home-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $c4wuJ = parcelRequire("c4wuJ");
const $29c38db79bd750a6$var$styles = {
    root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw",
    logoPaddingStyles: "_pwyo12x7",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi"
};
const $29c38db79bd750a6$export$ae2177c1f0d2b72c = ({ children: children, testId: testId })=>{
    const ref = (0, $5uXOq.useContext)((0, $c4wuJ.HomeActionsAttachRef));
    const elementRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_fix_component_state_update_for_suspense')) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: (0, $VSDnB.fg)('platform_fix_component_state_update_for_suspense') ? elementRef : ref,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $29c38db79bd750a6$var$styles.root,
            (0, $VSDnB.fg)('platform_design_system_nav4_top_nav_min_widths') ? $29c38db79bd750a6$var$styles.contentMinWidthStyles : // Removing the extra logo padding when applying the content min width
            $29c38db79bd750a6$var$styles.logoPaddingStyles
        ]),
        children: children
    });
};

});
parcelRegister("c4wuJ", function(module, exports) {

$parcel$export(module.exports, "HomeActionsElement", () => $e31dc6e30458fc76$export$4128169e0878a41d);
$parcel$export(module.exports, "HomeActionsAttachRef", () => $e31dc6e30458fc76$export$762fcfeaa67873eb);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $e31dc6e30458fc76$export$4128169e0878a41d = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $e31dc6e30458fc76$export$762fcfeaa67873eb = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $eGmKJ.default));

});


parcelRegister("6yyGB", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButton", () => $9eca7b4695c48c00$export$8bd77667631fec25);
/* toggle-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $c1bvp = parcelRequire("c1bvp");

var $7DmSu = parcelRequire("7DmSu");

var $VSDnB = parcelRequire("VSDnB");

var $Ee6JC = parcelRequire("Ee6JC");

var $eZOeM = parcelRequire("eZOeM");

var $ecbZX = parcelRequire("ecbZX");

var $6qnkT = parcelRequire("6qnkT");
const $9eca7b4695c48c00$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
// For duplicate "mouseenter" issue when changing icons (see below)
const $9eca7b4695c48c00$var$silentIconStyles = null;
const $9eca7b4695c48c00$export$8bd77667631fec25 = ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $ecbZX.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $5uXOq.useState)(!defaultCollapsed);
    const ref = (0, $5uXOq.useContext)((0, $eZOeM.SideNavToggleButtonAttachRef));
    const elementRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_fix_component_state_update_for_suspense')) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $6qnkT.useToggleSideNav)();
    const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
    }, [
        onClick,
        toggleVisibility,
        isSideNavExpanded
    ]);
    /**
   * ## Behaviour
   * It is intentional that collapse icon will be used while the flyout is open.
   * The icon is tied to the expanded / collapse state, and not the flyout state.
   *
   * ## Why a function?
   * Unfortunately, changing the icon inside an <IconButton> when the user is over
   * the button will cause the svg element to be replaced, which can trigger a
   * "mouseenter" event. This is problematic when the user is already over the button,
   * as it can result in a "mouseenter" event after the user manually entered the button.
   *
   * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
   * memoize it, or pull it out into a new function
   */ const icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $bwpsq.default)([
                "_1e0c1bgi _lcxvglyw"
            ]),
            children: isSideNavExpanded ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c1bvp))), {
                ...props
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7DmSu))), {
                ...props
            })
        });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Ee6JC.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: (0, $VSDnB.fg)('platform_fix_component_state_update_for_suspense') ? elementRef : ref,
        tooltip: $9eca7b4695c48c00$var$toggleButtonTooltipOptions
    });
};

});
parcelRegister("c1bvp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::abc8b5d03c24733db4f330a1621745d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bfe80c8ab4914b4$var$_react = $8bfe80c8ab4914b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bfe80c8ab4914b4$var$_baseNew = $8bfe80c8ab4914b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8bfe80c8ab4914b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bfe80c8ab4914b4$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $8bfe80c8ab4914b4$var$_react.default.createElement($8bfe80c8ab4914b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$8bfe80c8ab4914b4$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $8bfe80c8ab4914b4$var$_default = module.exports.default = $8bfe80c8ab4914b4$var$SidebarCollapseIcon;

});

parcelRegister("7DmSu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f4e0f9a7acbecae432a6a2607234087>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58edebfca3737fe1$var$_react = $58edebfca3737fe1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $58edebfca3737fe1$var$_baseNew = $58edebfca3737fe1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $58edebfca3737fe1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $58edebfca3737fe1$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $58edebfca3737fe1$var$_react.default.createElement($58edebfca3737fe1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$58edebfca3737fe1$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $58edebfca3737fe1$var$_default = module.exports.default = $58edebfca3737fe1$var$SidebarExpandIcon;

});

parcelRegister("Ee6JC", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $57458b64a0b37d0d$export$c25acd513dcc8062);
$parcel$export(module.exports, "Button", () => $57458b64a0b37d0d$export$353f5b6fc5456de1);
$parcel$export(module.exports, "LinkButton", () => $57458b64a0b37d0d$export$29d11c0fe2fc51d8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $65VCl = parcelRequire("65VCl");

var $7K1Hj = parcelRequire("7K1Hj");
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $57458b64a0b37d0d$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $7K1Hj.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $65VCl.ThemedIconButton) : (0, $42CjB.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $57458b64a0b37d0d$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $7K1Hj.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $65VCl.ThemedLinkIconButton) : (0, $krXdA.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $57458b64a0b37d0d$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $7K1Hj.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $65VCl.ThemedButton) : (0, $eCeGD.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $57458b64a0b37d0d$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $7K1Hj.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $65VCl.ThemedLinkButton) : (0, $1GGwS.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("krXdA", function(module, exports) {

$parcel$export(module.exports, "default", () => $96efa4c9353641ec$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $5JjdN = parcelRequire("5JjdN");

var $SliG5 = parcelRequire("SliG5");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");

var $3bDjY = parcelRequire("3bDjY");

var $jldZL = parcelRequire("jldZL");

var $4vsgW = parcelRequire("4vsgW");

var $ijDdv = parcelRequire("ijDdv");
const $96efa4c9353641ec$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r81 _1hmsagmp _ajmmvv82 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko14q2"
};
const $96efa4c9353641ec$var$defaultStyles = {
    root: "_bfhkiw92 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $96efa4c9353641ec$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $96efa4c9353641ec$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $96efa4c9353641ec$var$subtleStyles = {
    root: "_bfhk1w7a _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
const $96efa4c9353641ec$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
const $96efa4c9353641ec$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $5uXOq.useRef)(null);
    (0, $SliG5.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                // Shared between tooltip and native props
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                // Shared between tooltip and base props
                onClick: (event, analyticsEvent)=>{
                    onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (0, $5JjdN.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                // Base props only
                xcss: (0, $3JT92.cx)($96efa4c9353641ec$var$styles.base, appearance === 'default' && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $96efa4c9353641ec$var$defaultStyles.rootRefreshed : $96efa4c9353641ec$var$defaultStyles.root), appearance === 'primary' && $96efa4c9353641ec$var$primaryStyles.root, appearance === 'discovery' && $96efa4c9353641ec$var$discoveryStyles.root, appearance === 'subtle' && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $96efa4c9353641ec$var$subtleStyles.rootRefreshed : $96efa4c9353641ec$var$subtleStyles.root), $96efa4c9353641ec$var$styles.linkDecorationUnset, isSelected && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $96efa4c9353641ec$var$selectedStyles.rootRefreshed : $96efa4c9353641ec$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
                isSelected && appearance === 'discovery' && $96efa4c9353641ec$var$selectedStyles.discovery, isDisabled && $96efa4c9353641ec$var$styles.disabled, spacing === 'compact' && $96efa4c9353641ec$var$styles.spacingCompact, $96efa4c9353641ec$var$styles.iconButton, shape === 'circle' && $96efa4c9353641ec$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4vsgW.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ijDdv.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        ref: (0, $5JjdN.default)([
            localRef,
            ref
        ]),
        xcss: (0, $3JT92.cx)($96efa4c9353641ec$var$styles.base, appearance === 'default' && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $96efa4c9353641ec$var$defaultStyles.rootRefreshed : $96efa4c9353641ec$var$defaultStyles.root), appearance === 'primary' && $96efa4c9353641ec$var$primaryStyles.root, appearance === 'discovery' && $96efa4c9353641ec$var$discoveryStyles.root, appearance === 'subtle' && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $96efa4c9353641ec$var$subtleStyles.rootRefreshed : $96efa4c9353641ec$var$subtleStyles.root), $96efa4c9353641ec$var$styles.linkDecorationUnset, isSelected && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $96efa4c9353641ec$var$selectedStyles.rootRefreshed : $96efa4c9353641ec$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $96efa4c9353641ec$var$selectedStyles.discovery, isDisabled && $96efa4c9353641ec$var$styles.disabled, $96efa4c9353641ec$var$styles.iconButton, spacing === 'compact' && $96efa4c9353641ec$var$styles.spacingCompact, shape === 'circle' && $96efa4c9353641ec$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4vsgW.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ijDdv.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                    children: label
                })
            ]
        })
    });
};
// Workarounds to support generic types with forwardRef + memo
const $96efa4c9353641ec$var$WithRef = /*#__PURE__*/ (0, $5uXOq.forwardRef)($96efa4c9353641ec$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $96efa4c9353641ec$var$LinkIconButton = /*#__PURE__*/ (0, $5uXOq.memo)($96efa4c9353641ec$var$WithRef);
var $96efa4c9353641ec$export$2e2bcd8739ae039 = $96efa4c9353641ec$var$LinkIconButton;

});

parcelRegister("65VCl", function(module, exports) {

$parcel$export(module.exports, "themedButtonBackground", () => $402ff993fb2a3bca$export$b93b81aa41a8061a);
$parcel$export(module.exports, "themedButtonBackgroundHovered", () => $402ff993fb2a3bca$export$96a2312c81489aa1);
$parcel$export(module.exports, "themedButtonBackgroundPressed", () => $402ff993fb2a3bca$export$9db7a918ddfed23e);
$parcel$export(module.exports, "themedButtonBorder", () => $402ff993fb2a3bca$export$2b00bded80635cbb);
$parcel$export(module.exports, "themedButtonPrimaryText", () => $402ff993fb2a3bca$export$eca746d7c1a9cd6e);
$parcel$export(module.exports, "themedButtonPrimaryBackground", () => $402ff993fb2a3bca$export$2c2bc298cddb8aca);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", () => $402ff993fb2a3bca$export$6b28e650669cd3c7);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", () => $402ff993fb2a3bca$export$1656be06aad539b9);
$parcel$export(module.exports, "themedButtonSelectedText", () => $402ff993fb2a3bca$export$c26a897d419ef487);
$parcel$export(module.exports, "themedButtonSelectedBackground", () => $402ff993fb2a3bca$export$4e50e625ccffdb13);
$parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", () => $402ff993fb2a3bca$export$55c84c90f36bda4d);
$parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", () => $402ff993fb2a3bca$export$c5c0213472126c08);
$parcel$export(module.exports, "themedButtonSelectedBorder", () => $402ff993fb2a3bca$export$22928007ff541429);
$parcel$export(module.exports, "themedButtonDisabledText", () => $402ff993fb2a3bca$export$787ad93d0f2276af);
$parcel$export(module.exports, "themedButtonDisabledBackground", () => $402ff993fb2a3bca$export$5e774f44b77335d6);
$parcel$export(module.exports, "ThemedButton", () => $402ff993fb2a3bca$export$f67fb575035cc7d0);
$parcel$export(module.exports, "ThemedLinkButton", () => $402ff993fb2a3bca$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedIconButton", () => $402ff993fb2a3bca$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $402ff993fb2a3bca$export$a1ab08e79d264ec8);
/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $5JjdN = parcelRequire("5JjdN");

var $5McnS = parcelRequire("5McnS");
var $3Lty3 = parcelRequire("3Lty3");

var $3bDjY = parcelRequire("3bDjY");

var $jldZL = parcelRequire("jldZL");

var $ivhXk = parcelRequire("ivhXk");
/**
 * Returns the spread props to pass through to underlying primitive components.
 *
 * It removes the props which apply styles.
 */ function $402ff993fb2a3bca$var$getPrimitiveSpreadProps({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
const $402ff993fb2a3bca$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
const $402ff993fb2a3bca$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
const $402ff993fb2a3bca$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
const $402ff993fb2a3bca$export$2b00bded80635cbb = '--ds-top-bar-button-border';
const $402ff993fb2a3bca$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
const $402ff993fb2a3bca$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
const $402ff993fb2a3bca$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
const $402ff993fb2a3bca$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
const $402ff993fb2a3bca$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
const $402ff993fb2a3bca$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
const $402ff993fb2a3bca$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
const $402ff993fb2a3bca$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
const $402ff993fb2a3bca$export$22928007ff541429 = '--ds-top-bar-button-selected-border';
const $402ff993fb2a3bca$export$787ad93d0f2276af = '--ds-top-bar-button-disabled-text';
const $402ff993fb2a3bca$export$5e774f44b77335d6 = '--ds-top-bar-button-disabled-background';
const $402ff993fb2a3bca$var$styles = {
    root: "_zulp12x7 _11c82smr _2rkosqtm _v5649dqc _4bfu18uv _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m3acm _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $402ff993fb2a3bca$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $402ff993fb2a3bca$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
};
/**
 * Intentionally an almost-duplicate of `ThemedAnchor` - make sure to update both.
 *
 * See `ThemedAnchor` for more context.
 */ const $402ff993fb2a3bca$var$ThemedPressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        ...$402ff993fb2a3bca$var$getPrimitiveSpreadProps(props),
        ref: ref,
        type: "button",
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $DEWI6.cx)($402ff993fb2a3bca$var$styles.root, $402ff993fb2a3bca$var$shapeStyles[shape], hasBorder && $402ff993fb2a3bca$var$styles.border, $402ff993fb2a3bca$var$appearanceStyles[appearance], isSelected && $402ff993fb2a3bca$var$styles.selected, isDisabled && $402ff993fb2a3bca$var$styles.disabled),
        isDisabled: isDisabled
    });
});
/**
 * Intentionally an almost-duplicate of `ThemedPressable` - make sure to update both.
 *
 * More 'clever' solutions were tried but I couldn't get them working in an acceptable state.
 *
 * Polymorphism had many typing issues and required sacrificing type safety.
 *
 * Render props had problems passing down styles through `xcss` to the `children` function.
 */ const $402ff993fb2a3bca$var$ThemedAnchor = (0, $ivhXk.forwardRefWithGeneric)(function ThemedAnchor({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
        ...$402ff993fb2a3bca$var$getPrimitiveSpreadProps(props),
        ref: ref,
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $DEWI6.cx)($402ff993fb2a3bca$var$styles.root, $402ff993fb2a3bca$var$shapeStyles[shape], hasBorder && $402ff993fb2a3bca$var$styles.border, $402ff993fb2a3bca$var$appearanceStyles[appearance], isSelected && $402ff993fb2a3bca$var$styles.selected, isDisabled && $402ff993fb2a3bca$var$styles.disabled)
    });
});
const $402ff993fb2a3bca$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
const $402ff993fb2a3bca$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($402ff993fb2a3bca$var$ThemedPressable, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $402ff993fb2a3bca$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $402ff993fb2a3bca$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
const $402ff993fb2a3bca$export$b0b5aeed52623827 = (0, $ivhXk.forwardRefWithGeneric)(function ThemedLinkButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($402ff993fb2a3bca$var$ThemedAnchor, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $402ff993fb2a3bca$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $402ff993fb2a3bca$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
const $402ff993fb2a3bca$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $2OMIu.jsxs)($402ff993fb2a3bca$var$ThemedPressable, {
                ...props,
                shape: "square",
                ref: (0, $5JjdN.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                        children: label
                    })
                ]
            })
    });
});
const $402ff993fb2a3bca$export$a1ab08e79d264ec8 = (0, $ivhXk.forwardRefWithGeneric)(function ThemedLinkIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $2OMIu.jsxs)($402ff993fb2a3bca$var$ThemedAnchor, {
                ...props,
                shape: "square",
                ref: (0, $5JjdN.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                        children: label
                    })
                ]
            })
    });
});

});
parcelRegister("ivhXk", function(module, exports) {

$parcel$export(module.exports, "forwardRefWithGeneric", () => $08f35fc120f4e9ee$export$8ab756e06c5d9001);

var $5uXOq = parcelRequire("5uXOq");
const $08f35fc120f4e9ee$export$8ab756e06c5d9001 = (0, $5uXOq.forwardRef);

});


parcelRegister("7K1Hj", function(module, exports) {

$parcel$export(module.exports, "HasCustomThemeContext", () => $661b09480c788004$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $661b09480c788004$export$abfcaeeca4ae7a55);

var $5uXOq = parcelRequire("5uXOq");
const $661b09480c788004$export$d158fa15757a1890 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $661b09480c788004$export$abfcaeeca4ae7a55() {
    return (0, $5uXOq.useContext)($661b09480c788004$export$d158fa15757a1890);
}

});


parcelRegister("eZOeM", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonElement", () => $42ecc156c1fc66f0$export$9c1768094bef896);
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $42ecc156c1fc66f0$export$fb8fa9a80240785e);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $42ecc156c1fc66f0$export$9c1768094bef896 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $42ecc156c1fc66f0$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $eGmKJ.default));

});

parcelRegister("ecbZX", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibility", () => $251628ab22f05abd$export$4a602ad7e09bdb2c);

var $5uXOq = parcelRequire("5uXOq");

var $b0CFU = parcelRequire("b0CFU");
const $251628ab22f05abd$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};

});
parcelRegister("b0CFU", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityState", () => $4ad787a6949993a9$export$eb04201bb6dd1e4e);
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $4ad787a6949993a9$export$f6b496b07d1ea493);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $4ad787a6949993a9$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $4ad787a6949993a9$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $eGmKJ.default));

});


parcelRegister("6qnkT", function(module, exports) {

$parcel$export(module.exports, "useToggleSideNav", () => $0e2ff6e3f286dc0d$export$477ee35601a0a8ce);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $b0CFU = parcelRequire("b0CFU");
function $0e2ff6e3f286dc0d$export$477ee35601a0a8ce() {
    const setSideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SetSideNavVisibilityState));
    const toggleSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return toggleSideNav;
}

});


parcelRegister("k8rs3", function(module, exports) {

$parcel$export(module.exports, "UserActions", () => $39d34583f1671e23$export$2fb70d5e506c6bc2);
/* user-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $7yA6J = parcelRequire("7yA6J");

var $8U6zd = parcelRequire("8U6zd");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $4ErVz = parcelRequire("4ErVz");

var $hEtBs = parcelRequire("hEtBs");

var $7K1Hj = parcelRequire("7K1Hj");

var $Ee6JC = parcelRequire("Ee6JC");
const $39d34583f1671e23$var$containerStyles = {
    root: "_yyhy11wp _1e0c1txw _1bahh9n0 _1ul9zwfg",
    newLayoutStyles: "_1d2y1ris",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi _ndwch9n0"
};
const $39d34583f1671e23$var$listStyles = {
    root: "_zulp1b66 _4cvr1h6o _1e0c1txw",
    hideOnSmallViewport: "_1e0cglyw _181n1txw",
    popupContainer: "_1yt4u2gc"
};
const $39d34583f1671e23$export$2fb70d5e506c6bc2 = ({ children: children, label: label = 'Actions', showMoreButtonLabel: showMoreButtonLabel = 'Show more' })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    const [isMobile, setIsMobile] = (0, $5uXOq.useState)(false);
    // Note: `query` is a stable value between renders
    const query = (0, $4ErVz.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $7yA6J.useLayoutEffect)(()=>{
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile(query?.matches ?? false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $39d34583f1671e23$var$containerStyles.root,
            (0, $VSDnB.fg)('platform_design_system_nav4_top_nav_columns') && $39d34583f1671e23$var$containerStyles.newLayoutStyles,
            (0, $VSDnB.fg)('platform_design_system_nav4_top_nav_min_widths') && $39d34583f1671e23$var$containerStyles.contentMinWidthStyles
        ]),
        children: isMobile ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-start",
            shouldRenderToParent: true,
            content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K1Hj.HasCustomThemeContext).Provider, {
                    value: false,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEtBs.List), {
                        xcss: (0, $DEWI6.cx)($39d34583f1671e23$var$listStyles.root, $39d34583f1671e23$var$listStyles.popupContainer),
                        children: children
                    })
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $Ee6JC.IconButton), {
                    ...triggerProps,
                    label: showMoreButtonLabel,
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
                    isTooltipDisabled: false
                })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEtBs.List), {
            xcss: (0, $DEWI6.cx)($39d34583f1671e23$var$listStyles.root, $39d34583f1671e23$var$listStyles.hideOnSmallViewport),
            children: children
        })
    });
};

});
parcelRegister("7yA6J", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $c4a0ca5d002df00b$export$e5c5a5f917a5871c);

var $5uXOq = parcelRequire("5uXOq");
const $c4a0ca5d002df00b$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);

});

parcelRegister("hEtBs", function(module, exports) {

$parcel$export(module.exports, "List", () => $fce0d2453e66ead9$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $fce0d2453e66ead9$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $fce0d2453e66ead9$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($fce0d2453e66ead9$var$_List);

});


parcelRegister("fXGYu", function(module, exports) {

$parcel$export(module.exports, "CustomTitle", () => $ddb8ab5bd44c7119$export$9ccddf7ee2a0e24e);
/* custom-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $7K1Hj = parcelRequire("7K1Hj");
const $ddb8ab5bd44c7119$var$styles = {
    root: "_1reo15vq _18m915vq _11c82smr _o5721q9c _p12fuuw1 _1bto1l2s _bozg1b66 _1e0cglyw _10y41txw",
    subtleText: "_syaz1gjq",
    paddingInlineEnd: "_y4tiu2gc"
};
const $ddb8ab5bd44c7119$export$9ccddf7ee2a0e24e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function CustomTitle({ children: children, testId: testId }, ref) {
    const hasCustomTheme = (0, $7K1Hj.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $ddb8ab5bd44c7119$var$styles.root,
            !hasCustomTheme && $ddb8ab5bd44c7119$var$styles.subtleText,
            (0, $VSDnB.fg)('platform_design_system_nav4_top_nav_min_widths') && $ddb8ab5bd44c7119$var$styles.paddingInlineEnd
        ]),
        children: children
    });
});

});

parcelRegister("8Pko5", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $845b77966dafc84c$export$5120f2d0b8d4cab8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7Onh2 = parcelRequire("7Onh2");
const $845b77966dafc84c$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Onh2.IconButton), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});
var // This exists only to extract props.
// eslint-disable-next-line import/no-anonymous-default-export
$845b77966dafc84c$export$2e2bcd8739ae039 = (props)=>{};

});
parcelRegister("7Onh2", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $0f6c597d56619c44$export$c25acd513dcc8062);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $3bDjY = parcelRequire("3bDjY");

var $gKAEK = parcelRequire("gKAEK");

var $2MeWs = parcelRequire("2MeWs");
const $0f6c597d56619c44$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $gKAEK.useTheme)();
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9yOBd.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $2MeWs.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled,
        children: button
    });
    return button;
});

});
parcelRegister("gKAEK", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $c0c8fd8c606cf4da$export$93d4e7f90805808f);

var $5uXOq = parcelRequire("5uXOq");

var $hBZh1 = parcelRequire("hBZh1");
const $c0c8fd8c606cf4da$export$93d4e7f90805808f = ()=>(0, $5uXOq.useContext)((0, $hBZh1.ThemeContext));

});
parcelRegister("hBZh1", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", () => $7322cc82d03b9ede$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeProvider", () => $7322cc82d03b9ede$export$d8964aec282183a3);

var $5uXOq = parcelRequire("5uXOq");

var $k2eCO = parcelRequire("k2eCO");
const $7322cc82d03b9ede$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $k2eCO.defaultTheme));
const $7322cc82d03b9ede$export$d8964aec282183a3 = $7322cc82d03b9ede$export$2c657da244d00bd6.Provider;

});
parcelRegister("k2eCO", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $150e98c6d1394c9a$export$164de7ab8df77ef0);


var $eQhNM = parcelRequire("eQhNM");

var $4sCvx = parcelRequire("4sCvx");
const $150e98c6d1394c9a$export$eeee8619e1b91cb0 = (0, $4sCvx.generateTheme)({
    name: (0, $eQhNM.DEFAULT_THEME_NAME),
    backgroundColor: (0, $829f609a65d26a98$export$29a4f05edc054374),
    highlightColor: (0, $829f609a65d26a98$export$b3de0ae08da2ce64)
});
const $150e98c6d1394c9a$export$164de7ab8df77ef0 = $150e98c6d1394c9a$export$eeee8619e1b91cb0;

});
parcelRegister("eQhNM", function(module, exports) {

$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $7e5624dfecdc168c$export$77823bc9863eaa03);
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $7e5624dfecdc168c$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $7e5624dfecdc168c$export$2e2bcd8739ae039);


var $g16iD = parcelRequire("g16iD");
const $7e5624dfecdc168c$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$b3de0ae08da2ce64), 0.8)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$b3de0ae08da2ce64), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
        },
        productHome: {
            backgroundColor: `var(--ds-text-brand, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
            borderRight: `1px solid ${`var(--ds-border, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$f563ee71e9ee74cd), 0.3)})`}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: `var(--ds-text, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
        },
        primaryButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.7)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.7)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $g16iD.hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.6)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
            }
        },
        search: {
            default: {
                backgroundColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
                borderColor: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
            },
            focus: {
                borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
            },
            hover: {
                backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
            }
        },
        skeleton: {
            backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $7e5624dfecdc168c$var$defaultThemeCopy = JSON.parse(JSON.stringify($7e5624dfecdc168c$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$7e5624dfecdc168c$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$7e5624dfecdc168c$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $7e5624dfecdc168c$export$77823bc9863eaa03 = $7e5624dfecdc168c$var$defaultThemeCopy;
const $7e5624dfecdc168c$export$2491e13b198e597d = 'atlassian';
var $7e5624dfecdc168c$export$2e2bcd8739ae039 = $7e5624dfecdc168c$var$defaultTheme;

});
parcelRegister("g16iD", function(module, exports) {

$parcel$export(module.exports, "hexToRGBA", () => $e44f5a74bfef19bf$export$7229be6d7219ee6a);
$parcel$export(module.exports, "getBoxShadow", () => $e44f5a74bfef19bf$export$bba5a971afe05444);
$parcel$export(module.exports, "generateTextColor", () => $e44f5a74bfef19bf$export$10a10e7cd1193377);
$parcel$export(module.exports, "getContrastColor", () => $e44f5a74bfef19bf$export$77a1051494882576);

var $dBl98 = parcelRequire("dBl98");
const $e44f5a74bfef19bf$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $dBl98.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $e44f5a74bfef19bf$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $e44f5a74bfef19bf$var$hex = '[a-z0-9]';
const $e44f5a74bfef19bf$var$shortHandHexColorPattern = new RegExp(`#(${$e44f5a74bfef19bf$var$hex})(${$e44f5a74bfef19bf$var$hex})(${$e44f5a74bfef19bf$var$hex})`, 'i');
const $e44f5a74bfef19bf$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $e44f5a74bfef19bf$var$isShortHexColor = (color)=>color && color.length === 4;
const $e44f5a74bfef19bf$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$e44f5a74bfef19bf$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $e44f5a74bfef19bf$var$completeTriplet = (colors)=>`#${$e44f5a74bfef19bf$var$repeat(colors[1], 6)}`;
const $e44f5a74bfef19bf$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $e44f5a74bfef19bf$export$db8d2130677f868c = (color)=>{
    if ($e44f5a74bfef19bf$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($e44f5a74bfef19bf$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($e44f5a74bfef19bf$var$isTriplet(colors)) return $e44f5a74bfef19bf$var$completeTriplet(colors);
            else return $e44f5a74bfef19bf$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $e44f5a74bfef19bf$export$10a10e7cd1193377 = (color)=>{
    const converted = $e44f5a74bfef19bf$export$db8d2130677f868c(color);
    return (0, $dBl98.default).contrastRatio(converted).hex;
};
const $e44f5a74bfef19bf$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$e44f5a74bfef19bf$export$7229be6d7219ee6a((0, $dBl98.default).contrast(contrastValue, color).hex, opacityValue);

});


parcelRegister("4sCvx", function(module, exports) {

$parcel$export(module.exports, "generateTheme", () => $2e1eacd2d53fa96f$export$2e4ecffaca289a18);

var $VSDnB = parcelRequire("VSDnB");

var $eQhNM = parcelRequire("eQhNM");

var $g16iD = parcelRequire("g16iD");
const $2e1eacd2d53fa96f$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $2e1eacd2d53fa96f$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $2e1eacd2d53fa96f$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $g16iD.hexToRGBA)(backgroundColor, 0.65) : (0, $g16iD.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $g16iD.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $g16iD.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $g16iD.hexToRGBA)(backgroundColor, 0.8) : (0, $g16iD.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $g16iD.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $g16iD.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $g16iD.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $g16iD.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $g16iD.getBoxShadow)('transparent')
        }
    };
};
const $2e1eacd2d53fa96f$var$generateCreateButtonColors = (themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $g16iD.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $2e1eacd2d53fa96f$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $g16iD.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $eQhNM.DEFAULT_THEME_NAME)) return (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? (0, $eQhNM.defaultThemeBrandRefresh) : (0, $eQhNM.default);
    return {
        mode: {
            create: $2e1eacd2d53fa96f$var$generateButtonCSSStates($2e1eacd2d53fa96f$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $2e1eacd2d53fa96f$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $2e1eacd2d53fa96f$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? color : undefined,
                textColor: (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? color : undefined,
                backgroundColor: highlightColor,
                borderRight: `1px solid ${(0, $g16iD.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $g16iD.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $g16iD.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $g16iD.getBoxShadow)((0, $g16iD.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $g16iD.getContrastColor)(0.1, $2e1eacd2d53fa96f$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});




parcelRegister("2MeWs", function(module, exports) {

$parcel$export(module.exports, "getIconButtonTheme", () => $067a1b7a48c81cf7$export$f32bddcb857301f3);
const $067a1b7a48c81cf7$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-border-radius-circle, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("7FST0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87e7af881897ed302561350d986556a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5966eff7ccf8ae58$var$_react = $5966eff7ccf8ae58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5966eff7ccf8ae58$var$_personAvatar = $5966eff7ccf8ae58$var$_interopRequireDefault((parcelRequire("bdVbi")));

var $5966eff7ccf8ae58$var$_userAvatarCircle = $5966eff7ccf8ae58$var$_interopRequireDefault((parcelRequire("iZZ4y")));
function $5966eff7ccf8ae58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAvatarIcon.
 * This component is PersonAvatarIcon, with `UNSAFE_fallbackIcon` set to "UserAvatarCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5966eff7ccf8ae58$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $5966eff7ccf8ae58$var$_react.default.createElement($5966eff7ccf8ae58$var$_personAvatar.default, Object.assign({
        LEGACY_fallbackIcon: $5966eff7ccf8ae58$var$_userAvatarCircle.default
    }, props));
$5966eff7ccf8ae58$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
var $5966eff7ccf8ae58$var$_default = module.exports.default = $5966eff7ccf8ae58$var$PersonAvatarIcon;

});

parcelRegister("6q3np", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b0ad8e82692fcbf05d6af098ca724db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ac7ca4c7140a0af$var$_react = $4ac7ca4c7140a0af$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4ac7ca4c7140a0af$var$_baseNew = $4ac7ca4c7140a0af$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $4ac7ca4c7140a0af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4ac7ca4c7140a0af$var$LogOutIcon = (props)=>/*#__PURE__*/ $4ac7ca4c7140a0af$var$_react.default.createElement($4ac7ca4c7140a0af$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$4ac7ca4c7140a0af$var$LogOutIcon.displayName = 'LogOutIcon';
var $4ac7ca4c7140a0af$var$_default = module.exports.default = $4ac7ca4c7140a0af$var$LogOutIcon;

});

parcelRegister("k2tiP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95792f9115c7157853016297128836bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e96ab9793163191d$var$_react = $e96ab9793163191d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e96ab9793163191d$var$_settings = $e96ab9793163191d$var$_interopRequireDefault((parcelRequire("epOG5")));

var $e96ab9793163191d$var$_settings2 = $e96ab9793163191d$var$_interopRequireDefault((parcelRequire("lzUP9")));
function $e96ab9793163191d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SettingsIcon.
 * This component is SettingsIcon, with `UNSAFE_fallbackIcon` set to "SettingsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e96ab9793163191d$var$SettingsIcon = (props)=>/*#__PURE__*/ $e96ab9793163191d$var$_react.default.createElement($e96ab9793163191d$var$_settings.default, Object.assign({
        LEGACY_fallbackIcon: $e96ab9793163191d$var$_settings2.default
    }, props));
$e96ab9793163191d$var$SettingsIcon.Name = 'SettingsIconMigration';
var $e96ab9793163191d$var$_default = module.exports.default = $e96ab9793163191d$var$SettingsIcon;

});

parcelRegister("bxqXD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95afbc1e679aeb6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $e95afbc1e679aeb6$var$PeopleIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: "currentColor",
            d: "M10.523 11.3a4.5 4.5 0 0 1 4.5 4.5v2.5a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2.5a4.5 4.5 0 0 1 4.5-4.5h3Zm6 0 .212.005a4.5 4.5 0 0 1 4.283 4.277l.005.218v2.5l-.005.15a2 2 0 0 1-1.838 1.844l-.157.006h-2l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h2v-2.5l-.005-.165a2.5 2.5 0 0 0-2.33-2.33l-.165-.005h-.5l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h.5Zm-6 2h-3a2.5 2.5 0 0 0-2.5 2.5v2.5h8v-2.5a2.5 2.5 0 0 0-2.5-2.5Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm4.61.294a3.5 3.5 0 1 1 0 6.412 1 1 0 0 1 .694-1.872l.24.09a1.5 1.5 0 1 0 .012-2.852l-.252.094a1 1 0 0 1-.693-1.872ZM9.024 5.3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        })
    });
/**
 * __PeopleIcon__
 */ const $e95afbc1e679aeb6$var$PeopleIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $e95afbc1e679aeb6$var$PeopleIconGlyph
    });
var $e95afbc1e679aeb6$export$2e2bcd8739ae039 = $e95afbc1e679aeb6$var$PeopleIcon;

});

parcelRegister("dNE6G", function(module, exports) {

$parcel$export(module.exports, "default", () => $207169627fdfed4e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $207169627fdfed4e$var$PersonIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: "currentColor",
            d: "M13.523 11.3a4.504 4.504 0 0 1 4.478 4.063l.017.218.005.219v2.5c0 .964-.685 1.78-1.66 1.966l-.165.025-.175.009h-8c-.964 0-1.78-.686-1.966-1.66l-.025-.166-.009-.174v-2.5a4.504 4.504 0 0 1 4.064-4.478l.217-.017.22-.005h3Zm0 2H10.55l-.165.003a2.5 2.5 0 0 0-2.356 2.332l-.006.165-.001 2.442.001.058 7.943.002.057-.002v-2.473l-.003-.165a2.5 2.5 0 0 0-2.332-2.357l-.165-.005Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        })
    });
/**
 * __PersonIcon__
 */ const $207169627fdfed4e$var$PersonIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $207169627fdfed4e$var$PersonIconGlyph
    });
var $207169627fdfed4e$export$2e2bcd8739ae039 = $207169627fdfed4e$var$PersonIcon;

});

parcelRegister("d9wnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b0fe4e7c205728d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $3b0fe4e7c205728d$var$SignOutIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: "currentColor",
            d: "m6.023 4.3-.149.005A2 2 0 0 0 4.024 6.3v12l.005.15a2 2 0 0 0 1.994 1.85h5l.117-.007a1 1 0 0 0-.117-1.993h-5v-12h5l.117-.007a1 1 0 0 0-.117-1.993h-5Zm9.293 4.293a1 1 0 0 0-.083 1.32l.084.094 1.292 1.292H9.023a1 1 0 0 0-.125 1.993l.125.008 7.586-.001-1.293 1.294a1 1 0 0 0-.083 1.32l.084.094a1 1 0 0 0 1.32.083l.094-.083 2.974-2.975c.096-.09.175-.198.23-.32l.011-.028a.757.757 0 0 0 .031-.083l.008-.027a.767.767 0 0 0 .02-.08l.007-.042a.767.767 0 0 0 .011-.133v-.039c0-.024-.002-.05-.004-.074l.004.094a1 1 0 0 0-.022-.215l-.008-.031a.807.807 0 0 0-.021-.074l-.018-.046a.64.64 0 0 0-.025-.062l-.019-.035a.64.64 0 0 0-.049-.083.667.667 0 0 0-.047-.07l-.084-.093-3-2.998a1 1 0 0 0-1.414 0Z"
        })
    });
/**
 * __SignOutIcon__
 */ const $3b0fe4e7c205728d$var$SignOutIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $3b0fe4e7c205728d$var$SignOutIconGlyph
    });
var $3b0fe4e7c205728d$export$2e2bcd8739ae039 = $3b0fe4e7c205728d$var$SignOutIcon;

});

parcelRegister("a5n5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f2ae0874fee50c1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $j7LBE = parcelRequire("j7LBE");

var $kJpBP = parcelRequire("kJpBP");

var $VSDnB = parcelRequire("VSDnB");

var $28ffy = parcelRequire("28ffy");

var $gbxMX = parcelRequire("gbxMX");

var $l7Q0F = parcelRequire("l7Q0F");

var $6ERoD = parcelRequire("6ERoD");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $2f2ae0874fee50c1$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $eGmKJ.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $6cAn5;
    const [selected, setSelected] = (0, $gbxMX.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $l7Q0F.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $28ffy.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: (0, $6ERoD.default)() ? 'radio' : 'menuitemradio',
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            // Thanks to spread props, this attribute are passed to ButtonItem, even though
            // it's not in the component's prop types.
            // @ts-expect-error
            title: title,
            ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest,
            children: children
        })
    });
};
var $2f2ae0874fee50c1$export$2e2bcd8739ae039 = $2f2ae0874fee50c1$var$DropdownItemRadio;

});
parcelRegister("28ffy", function(module, exports) {

$parcel$export(module.exports, "default", () => $076dbb2cdd3c6ce4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");

/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ const $076dbb2cdd3c6ce4$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : 'transparent',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
            fillRule: "evenodd",
            children: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "7.5",
                        fill: "currentColor",
                        stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                        strokeWidth: "1"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "3",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        fill: "currentColor",
                        cx: "12",
                        cy: "12",
                        r: "6",
                        stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        fill: "inherit",
                        cx: "12",
                        cy: "12",
                        r: "2"
                    })
                ]
            })
        })
    });
};
var $076dbb2cdd3c6ce4$export$2e2bcd8739ae039 = $076dbb2cdd3c6ce4$var$RadioIcon;

});

parcelRegister("gbxMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5135edb54d9cd4f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b2TJP = parcelRequire("b2TJP");

var $iY6id = parcelRequire("iY6id");

var $1xPgO = parcelRequire("1xPgO");
function $5135edb54d9cd4f5$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $5uXOq.useContext)((0, $iY6id.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $5uXOq.useContext)((0, $b2TJP.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
	 * - radio state changes any time a radio child is changed
	 * - when it changes we want all radio buttons to update their local state
	 * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
	 */ (0, $5uXOq.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        setGroupState(group, {
            ...(0, $1xPgO.default)(existing || {}),
            [id]: defaultSelected || false
        });
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $5135edb54d9cd4f5$export$2e2bcd8739ae039 = $5135edb54d9cd4f5$var$useRadioState;

});
parcelRegister("b2TJP", function(module, exports) {

$parcel$export(module.exports, "RadioGroupContext", () => $414fcc0c0db30c2f$export$a79eda4ff50e30b6);
$parcel$export(module.exports, "default", () => $414fcc0c0db30c2f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $9UCCQ = parcelRequire("9UCCQ");

var $k20lf = parcelRequire("k20lf");

var $iY6id = parcelRequire("iY6id");

var $1xPgO = parcelRequire("1xPgO");
const $414fcc0c0db30c2f$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $eGmKJ.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ const $414fcc0c0db30c2f$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $5uXOq.useContext)((0, $iY6id.SelectionStoreContext));
    const uid = (0, $9KnKW.useId)();
    const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
    /**
	 *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
	 *  - we flush a render by updating this local radio group state
	 */ const [radioGroupState, setRadioGroupState] = (0, $5uXOq.useState)(()=>getGroupState(id));
    const selectRadioItem = (childId, value)=>{
        const newValue = {
            ...(0, $1xPgO.default)(getGroupState(id)),
            [childId]: value
        };
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($414fcc0c0db30c2f$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k20lf.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $414fcc0c0db30c2f$export$2e2bcd8739ae039 = $414fcc0c0db30c2f$var$DropdownItemRadioGroup;

});
parcelRegister("1xPgO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bae1dbc1eac2ebc$export$2e2bcd8739ae039);
const $2bae1dbc1eac2ebc$var$resetOptionsInGroup = (group)=>{
    return Object.keys(group || {}).reduce((accumulator, current)=>({
            ...accumulator,
            [current]: typeof group[current] === 'undefined' ? undefined : false
        }), {});
};
var $2bae1dbc1eac2ebc$export$2e2bcd8739ae039 = $2bae1dbc1eac2ebc$var$resetOptionsInGroup;

});



parcelRegister("6ERoD", function(module, exports) {

$parcel$export(module.exports, "default", () => $343be4cd326415bb$export$2e2bcd8739ae039);
const $343be4cd326415bb$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ const $343be4cd326415bb$var$isVoiceOverSupported = ()=>/Mac OS X/.test($343be4cd326415bb$var$canUseDOM() ? navigator.userAgent : '');
var $343be4cd326415bb$export$2e2bcd8739ae039 = $343be4cd326415bb$var$isVoiceOverSupported;

});


parcelRegister("826f6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e16f3e8522976fe7001db436c90d9bf8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d935a46a5831652$var$_react = $5d935a46a5831652$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5d935a46a5831652$var$_baseNew = $5d935a46a5831652$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5d935a46a5831652$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d935a46a5831652$var$ThemeIcon = (props)=>/*#__PURE__*/ $5d935a46a5831652$var$_react.default.createElement($5d935a46a5831652$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$5d935a46a5831652$var$ThemeIcon.displayName = 'ThemeIcon';
var $5d935a46a5831652$var$_default = module.exports.default = $5d935a46a5831652$var$ThemeIcon;

});

parcelRegister("hWZau", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::202475837f81ea9047d0b06aafdb41ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1174d32c3ea0a52$var$_react = $d1174d32c3ea0a52$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1174d32c3ea0a52$var$_chevronRight = $d1174d32c3ea0a52$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $d1174d32c3ea0a52$var$_chevronRight2 = $d1174d32c3ea0a52$var$_interopRequireDefault((parcelRequire("ebd3R")));
function $d1174d32c3ea0a52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1174d32c3ea0a52$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $d1174d32c3ea0a52$var$_react.default.createElement($d1174d32c3ea0a52$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $d1174d32c3ea0a52$var$_chevronRight2.default
    }, props));
$d1174d32c3ea0a52$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $d1174d32c3ea0a52$var$_default = module.exports.default = $d1174d32c3ea0a52$var$ChevronRightIcon;

});
parcelRegister("3dGN0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281ba53efaa7c88b789646091262f5f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2583c710897a95e5$var$_react = $2583c710897a95e5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2583c710897a95e5$var$_baseNew = $2583c710897a95e5$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2583c710897a95e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2583c710897a95e5$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $2583c710897a95e5$var$_react.default.createElement($2583c710897a95e5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.94 6 3.97 2.03 5.03.97l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$2583c710897a95e5$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $2583c710897a95e5$var$_default = module.exports.default = $2583c710897a95e5$var$ChevronRightIcon;

});


parcelRegister("ex8Nz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a15b1d3d61d052b6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $a15b1d3d61d052b6$var$ThemeIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 20V4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
            fill: "currentColor"
        })
    });
/**
 * __ThemeIcon__
 */ const $a15b1d3d61d052b6$var$ThemeIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $a15b1d3d61d052b6$var$ThemeIconGlyph
    });
var $a15b1d3d61d052b6$export$2e2bcd8739ae039 = $a15b1d3d61d052b6$var$ThemeIcon;

});

parcelRegister("QasRB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8757186054f9d759a1f776986ffd32d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09ccf97ba5b2cc01$var$_react = $09ccf97ba5b2cc01$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $09ccf97ba5b2cc01$var$_backlog = $09ccf97ba5b2cc01$var$_interopRequireDefault((parcelRequire("bRTCF")));

var $09ccf97ba5b2cc01$var$_backlog2 = $09ccf97ba5b2cc01$var$_interopRequireDefault((parcelRequire("adDD5")));
function $09ccf97ba5b2cc01$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BacklogIcon.
 * This component is BacklogIcon, with `UNSAFE_fallbackIcon` set to "BacklogIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09ccf97ba5b2cc01$var$BacklogIcon = (props)=>/*#__PURE__*/ $09ccf97ba5b2cc01$var$_react.default.createElement($09ccf97ba5b2cc01$var$_backlog.default, Object.assign({
        LEGACY_fallbackIcon: $09ccf97ba5b2cc01$var$_backlog2.default
    }, props));
$09ccf97ba5b2cc01$var$BacklogIcon.Name = 'BacklogIconMigration';
var $09ccf97ba5b2cc01$var$_default = module.exports.default = $09ccf97ba5b2cc01$var$BacklogIcon;

});

parcelRegister("dME4E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6de69f6e8d23d80c647d0a6d3ecd7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a08ed7e863649bfd$var$_react = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a08ed7e863649bfd$var$_board = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("8EsNC")));

var $a08ed7e863649bfd$var$_board2 = $a08ed7e863649bfd$var$_interopRequireDefault((parcelRequire("v8Zna")));
function $a08ed7e863649bfd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BoardIcon.
 * This component is BoardIcon, with `UNSAFE_fallbackIcon` set to "BoardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a08ed7e863649bfd$var$BoardIcon = (props)=>/*#__PURE__*/ $a08ed7e863649bfd$var$_react.default.createElement($a08ed7e863649bfd$var$_board.default, Object.assign({
        LEGACY_fallbackIcon: $a08ed7e863649bfd$var$_board2.default
    }, props));
$a08ed7e863649bfd$var$BoardIcon.Name = 'BoardIconMigration';
var $a08ed7e863649bfd$var$_default = module.exports.default = $a08ed7e863649bfd$var$BoardIcon;

});

parcelRegister("aZ5rg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e406a416cb0a4f8d2c2370983b384961>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ff3d1eb1c83e4c4$var$_react = $7ff3d1eb1c83e4c4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7ff3d1eb1c83e4c4$var$_listBulleted = $7ff3d1eb1c83e4c4$var$_interopRequireDefault((parcelRequire("bEjt9")));

var $7ff3d1eb1c83e4c4$var$_bulletList = $7ff3d1eb1c83e4c4$var$_interopRequireDefault((parcelRequire("90gd1")));
function $7ff3d1eb1c83e4c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListBulletedIcon.
 * This component is ListBulletedIcon, with `UNSAFE_fallbackIcon` set to "BulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ff3d1eb1c83e4c4$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $7ff3d1eb1c83e4c4$var$_react.default.createElement($7ff3d1eb1c83e4c4$var$_listBulleted.default, Object.assign({
        LEGACY_fallbackIcon: $7ff3d1eb1c83e4c4$var$_bulletList.default
    }, props));
$7ff3d1eb1c83e4c4$var$ListBulletedIcon.Name = 'ListBulletedIconMigration';
var $7ff3d1eb1c83e4c4$var$_default = module.exports.default = $7ff3d1eb1c83e4c4$var$ListBulletedIcon;

});

parcelRegister("lJosW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::540b588acaf0422e358accf8cfb04725>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd20c75a63e82b8e$var$_react = $fd20c75a63e82b8e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fd20c75a63e82b8e$var$_issues = $fd20c75a63e82b8e$var$_interopRequireDefault((parcelRequire("gmyWi")));

var $fd20c75a63e82b8e$var$_issues2 = $fd20c75a63e82b8e$var$_interopRequireDefault((parcelRequire("8sgpE")));
function $fd20c75a63e82b8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for IssuesIcon.
 * This component is IssuesIcon, with `UNSAFE_fallbackIcon` set to "IssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd20c75a63e82b8e$var$IssuesIcon = (props)=>/*#__PURE__*/ $fd20c75a63e82b8e$var$_react.default.createElement($fd20c75a63e82b8e$var$_issues.default, Object.assign({
        LEGACY_fallbackIcon: $fd20c75a63e82b8e$var$_issues2.default
    }, props));
$fd20c75a63e82b8e$var$IssuesIcon.Name = 'IssuesIconMigration';
var $fd20c75a63e82b8e$var$_default = module.exports.default = $fd20c75a63e82b8e$var$IssuesIcon;

});

parcelRegister("k2Gga", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::478474977414af6f20354d0841ac3249>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e974c67850595917$var$_react = $e974c67850595917$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e974c67850595917$var$_roadmap = $e974c67850595917$var$_interopRequireDefault((parcelRequire("ifnb0")));

var $e974c67850595917$var$_roadmap2 = $e974c67850595917$var$_interopRequireDefault((parcelRequire("i3vuN")));
function $e974c67850595917$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RoadmapIcon.
 * This component is RoadmapIcon, with `UNSAFE_fallbackIcon` set to "RoadmapIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e974c67850595917$var$RoadmapIcon = (props)=>/*#__PURE__*/ $e974c67850595917$var$_react.default.createElement($e974c67850595917$var$_roadmap.default, Object.assign({
        LEGACY_fallbackIcon: $e974c67850595917$var$_roadmap2.default
    }, props));
$e974c67850595917$var$RoadmapIcon.Name = 'RoadmapIconMigration';
var $e974c67850595917$var$_default = module.exports.default = $e974c67850595917$var$RoadmapIcon;

});

parcelRegister("5ILhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6fcaf6f7b2aea1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $6wxJn = parcelRequire("6wxJn");

var $55sHU = parcelRequire("55sHU");

var $8CUq3 = parcelRequire("8CUq3");
function $c6fcaf6f7b2aea1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $c6fcaf6f7b2aea1e$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $55sHU.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $55sHU.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $55sHU.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $c6fcaf6f7b2aea1e$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $c6fcaf6f7b2aea1e$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $c6fcaf6f7b2aea1e$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $c6fcaf6f7b2aea1e$var$Pressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $eGmKJ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $c6fcaf6f7b2aea1e$var$baseStyles,
            $c6fcaf6f7b2aea1e$var$focusRingStyles,
            isDisabled ? $c6fcaf6f7b2aea1e$var$disabledStyles : $c6fcaf6f7b2aea1e$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $55sHU.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $55sHU.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $55sHU.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $55sHU.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $55sHU.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $55sHU.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $55sHU.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $55sHU.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
var $c6fcaf6f7b2aea1e$export$2e2bcd8739ae039 = $c6fcaf6f7b2aea1e$var$Pressable;

});

parcelRegister("gJlZe", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $f3c667de71b5760d$export$b2ad68b9bc407b80);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWz2c = parcelRequire("jWz2c");
const $f3c667de71b5760d$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jWz2c.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $f3c667de71b5760d$export$2e2bcd8739ae039 = $f3c667de71b5760d$export$b2ad68b9bc407b80;

});
parcelRegister("jWz2c", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $76470ef26276f9f4$export$ff983d2a2b6112ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1LwQL = parcelRequire("1LwQL");
const $76470ef26276f9f4$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1LwQL.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1LwQL", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $1dfb7d23cdbb03d0$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $1dfb7d23cdbb03d0$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("h9kUS", function(module, exports) {

$parcel$export(module.exports, "media", () => $e6a0601943d9b8d2$export$987d49ffe1b0900f);
$parcel$export(module.exports, "UNSAFE_media", () => $e6a0601943d9b8d2$export$c881183ca713c214);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $e6a0601943d9b8d2$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
const $e6a0601943d9b8d2$export$c881183ca713c214 = $e6a0601943d9b8d2$export$987d49ffe1b0900f;

});

parcelRegister("9sGJX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a6526ba72ad9bbb4f9b91ad0dbd2f69>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e37e1e25d776240$var$_react = $6e37e1e25d776240$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6e37e1e25d776240$var$_appSwitcher = $6e37e1e25d776240$var$_interopRequireDefault((parcelRequire("3fDjf")));

var $6e37e1e25d776240$var$_appSwitcher2 = $6e37e1e25d776240$var$_interopRequireDefault((parcelRequire("4PKNr")));
function $6e37e1e25d776240$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppSwitcherIcon.
 * This component is AppSwitcherIcon, with `UNSAFE_fallbackIcon` set to "AppSwitcherIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e37e1e25d776240$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $6e37e1e25d776240$var$_react.default.createElement($6e37e1e25d776240$var$_appSwitcher.default, Object.assign({
        LEGACY_fallbackIcon: $6e37e1e25d776240$var$_appSwitcher2.default
    }, props));
$6e37e1e25d776240$var$AppSwitcherIcon.Name = 'AppSwitcherIconMigration';
var $6e37e1e25d776240$var$_default = module.exports.default = $6e37e1e25d776240$var$AppSwitcherIcon;

});

parcelRegister("34gGM", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $2494f88679192657$export$21bfbeb62fdcce8d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $2494f88679192657$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const $2494f88679192657$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $2494f88679192657$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("epnSS", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", () => $46071877c5367215$export$3c6158790f5e01c4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $46071877c5367215$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const $46071877c5367215$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $46071877c5367215$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4ZIaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $046aa419aa6d0212$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $046aa419aa6d0212$var$bannerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $565cb8192fc4e070$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$238d30785c4bca84)
});
const $046aa419aa6d0212$var$bannerFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $565cb8192fc4e070$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $565cb8192fc4e070$export$f963aecf2d4465bd)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $046aa419aa6d0212$var$Banner = (props)=>{
    const { children: children, height: height = (0, $565cb8192fc4e070$export$be83e7118304b28e), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$bcd94a6a792e7f96), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$bcd94a6a792e7f96)]: bannerHeight
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$bcd94a6a792e7f96)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $046aa419aa6d0212$var$bannerStyles,
                isFixed && $046aa419aa6d0212$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$bcd94a6a792e7f96),
            value: bannerHeight
        }), children));
};
var $046aa419aa6d0212$export$2e2bcd8739ae039 = $046aa419aa6d0212$var$Banner;

});
// dimension vars
const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
const $565cb8192fc4e070$export$be83e7118304b28e = 56;
const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
const $565cb8192fc4e070$export$539e68c09584883a = 240;
const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;

parcelRegister("8XpIo", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $45f0612699d6a600$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $45f0612699d6a600$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $45f0612699d6a600$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $45f0612699d6a600$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $45f0612699d6a600$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $45f0612699d6a600$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $45f0612699d6a600$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $45f0612699d6a600$export$218ece2c32b7db0e);


var $1Dapo = parcelRequire("1Dapo");
const $45f0612699d6a600$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $1Dapo.default)().setItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $45f0612699d6a600$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    return storageValue[key];
};
const $45f0612699d6a600$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $1Dapo.default)().getItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $1Dapo.default)().setItem((0, $565cb8192fc4e070$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $45f0612699d6a600$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $45f0612699d6a600$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $45f0612699d6a600$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`), 10) || 0;
};
const $45f0612699d6a600$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $565cb8192fc4e070$export$539e68c09584883a)) / (maxWidth - (0, $565cb8192fc4e070$export$539e68c09584883a));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $45f0612699d6a600$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $565cb8192fc4e070$export$5253dd9707b8c3ba)]: slotName
    });
const $45f0612699d6a600$export$218ece2c32b7db0e = (slotName)=>`[${0, $565cb8192fc4e070$export$5253dd9707b8c3ba}='${slotName}']`;

});
parcelRegister("1Dapo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8542dfb7c79e1b98$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $8542dfb7c79e1b98$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $8542dfb7c79e1b98$var$safeLocalStorage = ()=>{
    if ($8542dfb7c79e1b98$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $8542dfb7c79e1b98$export$2e2bcd8739ae039 = $8542dfb7c79e1b98$var$safeLocalStorage;

});


parcelRegister("2Pb5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $69aa5d485af555af$export$2e2bcd8739ae039);

var $8XpIo = parcelRequire("8XpIo");
const $69aa5d485af555af$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $8XpIo.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $8XpIo.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $69aa5d485af555af$export$2e2bcd8739ae039 = $69aa5d485af555af$var$publishGridState;

});

parcelRegister("amcy7", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $9d139aaa63675775$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $9d139aaa63675775$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $9d139aaa63675775$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $9d139aaa63675775$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $eGmKJ.default),
    unregisterSkipLink: (0, $eGmKJ.default)
});
const $9d139aaa63675775$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($9d139aaa63675775$export$4c5cc3b14c7678a);
const $9d139aaa63675775$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $9d139aaa63675775$export$c9d9cb2ee9590f87();
    (0, $5uXOq.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("fZqMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $be1b215f3de827c6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $be1b215f3de827c6$var$focusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $be1b215f3de827c6$var$sidebarFocusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $be1b215f3de827c6$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($be1b215f3de827c6$var$sidebarFocusStyles) : css($be1b215f3de827c6$var$focusStyles)
        }));
};
var $be1b215f3de827c6$export$2e2bcd8739ae039 = $be1b215f3de827c6$var$SlotFocusRing;

});

parcelRegister("jUxG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bb67776ddc8896$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $h9kUS = parcelRequire("h9kUS");
/**
 * Hoists slot dimension styles to the root element.
 */ const $16bb67776ddc8896$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $h9kUS.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};
var $16bb67776ddc8896$export$2e2bcd8739ae039 = $16bb67776ddc8896$var$SlotDimensions;

});


parcelRegister("c8E4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a355cc90b3ba1759$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $a355cc90b3ba1759$var$contentStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $a355cc90b3ba1759$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: $a355cc90b3ba1759$var$contentStyles
    }, children);
};
var $a355cc90b3ba1759$export$2e2bcd8739ae039 = $a355cc90b3ba1759$var$Content;

});

parcelRegister("eX4XX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0feeff252d3697c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $0feeff252d3697c9$var$leftPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$344062f7cfc9528e)
});
const $0feeff252d3697c9$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$f963aecf2d4465bd),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $0feeff252d3697c9$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $565cb8192fc4e070$export$c4d6152f86ea28f6), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$cbfb0f5b2869b17b), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$cbfb0f5b2869b17b)]: leftPanelWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$cbfb0f5b2869b17b)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $0feeff252d3697c9$var$leftPanelStyles,
                isFixed && $0feeff252d3697c9$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$cbfb0f5b2869b17b),
            value: leftPanelWidth
        }), children));
};
var $0feeff252d3697c9$export$2e2bcd8739ae039 = $0feeff252d3697c9$var$LeftPanel;

});

parcelRegister("aKz2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d471261e665f40$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $71YXv = parcelRequire("71YXv");


var $oGXFy = parcelRequire("oGXFy");



var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $j3yGs = parcelRequire("j3yGs");
var $amcy7 = parcelRequire("amcy7");

var $b8DIB = parcelRequire("b8DIB");

var $2QObc = parcelRequire("2QObc");

var $aY3ai = parcelRequire("aY3ai");

var $1hxaZ = parcelRequire("1hxaZ");

var $jUxG6 = parcelRequire("jUxG6");
const $24d471261e665f40$var$openBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $829f609a65d26a98$export$486ab785e4bac3c6)})`,
    opacity: 1
});
const $24d471261e665f40$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $24d471261e665f40$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $5uXOq.useRef)();
    const mouseOverEventRef = (0, $5uXOq.useRef)();
    const leftSideBarRef = (0, $5uXOq.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, hasInit: hasInit } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $5uXOq.useRef)(isLocked);
    const mouseXRef = (0, $5uXOq.useRef)(0);
    const handlerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $565cb8192fc4e070$export$539e68c09584883a));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$b6744d31294864fd), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $565cb8192fc4e070$export$46acf8758e9e2636);
    else leftSidebarWidthOnMount = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$a30f2e00489a8957), _width, !width || !collapsedStateOverrideOpen && (0, $8XpIo.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $5uXOq.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $8XpIo.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $8XpIo.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd], (0, $565cb8192fc4e070$export$539e68c09584883a)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $565cb8192fc4e070$export$b6744d31294864fd], (0, $565cb8192fc4e070$export$539e68c09584883a)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $565cb8192fc4e070$export$46acf8758e9e2636);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed,
            hasInit: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $565cb8192fc4e070$export$b6744d31294864fd)]: lastLeftSidebarWidth
            });
            (0, $8XpIo.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $565cb8192fc4e070$export$1074d925b0b82be5));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $565cb8192fc4e070$export$1074d925b0b82be5));
    };
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$539e68c09584883a)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $71YXv.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    /**
   * We use both the state and our effect-based ref to protect animation until initialized fully
   */ const isReady = hasInit && notFirstRun.current;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $24d471261e665f40$var$hiddenBackdropStyles,
            isFlyoutOpen && $24d471261e665f40$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aY3ai.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
        variableName: (0, $565cb8192fc4e070$export$a30f2e00489a8957),
        value: isReady ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $565cb8192fc4e070$export$70740f5ad8360a78)
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2QObc.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1hxaZ.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !isReady && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b8DIB.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $24d471261e665f40$export$2e2bcd8739ae039 = $24d471261e665f40$var$LeftSidebar;

});
parcelRegister("oGXFy", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $76ca3f4294719aa5$export$49e55ae2c03d6045);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7yA6J = parcelRequire("7yA6J");

var $h9kUS = parcelRequire("h9kUS");
const $76ca3f4294719aa5$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $h9kUS.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $76ca3f4294719aa5$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $76ca3f4294719aa5$var$queries[queryString];
    (0, $7yA6J.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cBeZP.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("j3yGs", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $423fcd7a7dc715d5$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $423fcd7a7dc715d5$export$94561f6055639ef7);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $423fcd7a7dc715d5$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $423fcd7a7dc715d5$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $eGmKJ.default),
    collapseLeftSidebar: (0, $eGmKJ.default),
    leftSidebarState: $423fcd7a7dc715d5$var$leftSidebarState,
    setLeftSidebarState: (0, $eGmKJ.default),
    toggleLeftSidebar: (0, $eGmKJ.default)
});
const $423fcd7a7dc715d5$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
    return context;
};
const $423fcd7a7dc715d5$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
    (0, $5uXOq.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("b8DIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $035100f87b948476$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $oGXFy = parcelRequire("oGXFy");


var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");

var $gYx5U = parcelRequire("gYx5U");

var $7nOWs = parcelRequire("7nOWs");

var $3bMab = parcelRequire("3bMab");
function $035100f87b948476$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $035100f87b948476$var$cssSelector = {
    [(0, $565cb8192fc4e070$export$9ecd22db14e6c70e)]: true
};
const $035100f87b948476$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $035100f87b948476$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $035100f87b948476$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $035100f87b948476$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $5uXOq.useRef)(leftSidebarState[0, $565cb8192fc4e070$export$a30f2e00489a8957]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $5uXOq.useRef)(0);
    const keyboardEventTimeout = (0, $5uXOq.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $5uXOq.useState)(false);
    const unbindEvents = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $5uXOq.useRef)(leftSidebarState);
    (0, $5uXOq.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $5uXOq.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $565cb8192fc4e070$export$a30f2e00489a8957] - (0, $8XpIo.getLeftPanelWidth)();
        unbindEvents.current = (0, $cBeZP.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$46acf8758e9e2636));
                        document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $5uXOq.useState)(()=>(0, $7nRxN.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $8XpIo.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $565cb8192fc4e070$export$46acf8758e9e2636) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $565cb8192fc4e070$export$46acf8758e9e2636));
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $565cb8192fc4e070$export$6949d4f32b161684)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$46acf8758e9e2636)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $565cb8192fc4e070$export$6949d4f32b161684) && sidebarWidth.current < (0, $565cb8192fc4e070$export$539e68c09584883a)) {
            document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$539e68c09584883a)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: (0, $565cb8192fc4e070$export$539e68c09584883a),
                lastLeftSidebarWidth: (0, $565cb8192fc4e070$export$539e68c09584883a)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $8XpIo.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $565cb8192fc4e070$export$539e68c09584883a)) {
                width = (0, $565cb8192fc4e070$export$539e68c09584883a);
                document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${(0, $565cb8192fc4e070$export$539e68c09584883a) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $565cb8192fc4e070$export$539e68c09584883a);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $565cb8192fc4e070$export$a30f2e00489a8957)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $5uXOq.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $8XpIo.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $8XpIo.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$035100f87b948476$var$cssSelector,
        css: [
            $035100f87b948476$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $035100f87b948476$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bMab.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gYx5U.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $7nOWs.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.Global), {
        styles: $035100f87b948476$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$035100f87b948476$export$2e2bcd8739ae039 = $035100f87b948476$var$ResizeControl;

});
parcelRegister("gYx5U", function(module, exports) {

$parcel$export(module.exports, "default", () => $859a4bb5bdb6af39$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");


function $859a4bb5bdb6af39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $859a4bb5bdb6af39$var$varLineColor = '--ds-line';
const $859a4bb5bdb6af39$var$grabAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$859a4bb5bdb6af39$var$varLineColor]: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
    }
});
const $859a4bb5bdb6af39$var$grabAreaCollapsedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $859a4bb5bdb6af39$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $859a4bb5bdb6af39$var$grabAreaLineSelector = {
    [(0, $565cb8192fc4e070$export$70c702a8c5895f03)]: true
};
const $859a4bb5bdb6af39$var$grabAreaSelector = {
    [(0, $565cb8192fc4e070$export$48a43f91e4becf4e)]: true
};
const $859a4bb5bdb6af39$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$859a4bb5bdb6af39$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $859a4bb5bdb6af39$var$grabAreaStyles,
            isLeftSidebarCollapsed && $859a4bb5bdb6af39$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $859a4bb5bdb6af39$var$lineStyles,
        ...$859a4bb5bdb6af39$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$859a4bb5bdb6af39$export$2e2bcd8739ae039 = $859a4bb5bdb6af39$var$GrabArea;

});

parcelRegister("7nOWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee2fadf0239ec76$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
                                                                                                                                                 * @jsxRuntime classic
                                                                                                                                                 * @jsx jsx
                                                                                                                                                 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $hWZau = parcelRequire("hWZau");


var $lObw7 = parcelRequire("lObw7");

var $h9kUS = parcelRequire("h9kUS");


function $8ee2fadf0239ec76$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ee2fadf0239ec76$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $8ee2fadf0239ec76$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $8ee2fadf0239ec76$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    boxShadow: `0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}`,
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $lObw7.durations).small}ms linear,
    color ${(0, $lObw7.durations).small}ms linear,
    opacity ${(0, $lObw7.durations).medium}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        opacity: 1
    }
});
const $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $8ee2fadf0239ec76$var$preventDefault = (event)=>event.preventDefault();
const $8ee2fadf0239ec76$var$cssSelector = {
    [(0, $565cb8192fc4e070$export$dac2fb31a9f6844d)]: true
};
const $8ee2fadf0239ec76$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$8ee2fadf0239ec76$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $8ee2fadf0239ec76$var$resizeIconButtonStyles,
            $8ee2fadf0239ec76$var$mobileStyles,
            !isLeftSidebarCollapsed && $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $8ee2fadf0239ec76$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $8ee2fadf0239ec76$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8ee2fadf0239ec76$export$2e2bcd8739ae039 = $8ee2fadf0239ec76$var$ResizeButton;

});

parcelRegister("3bMab", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b1337ced2d81f3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $dwLzP = parcelRequire("dwLzP");
const $31b1337ced2d81f3$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $31b1337ced2d81f3$var$direction = 'to left';
const $31b1337ced2d81f3$var$transitionDuration = '0.22s';
const $31b1337ced2d81f3$var$shadowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $31b1337ced2d81f3$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $eba99f58997c09b3$export$57636bb43b1ccbb0)
});
const $31b1337ced2d81f3$var$draggingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $31b1337ced2d81f3$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $dwLzP.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: [
            $31b1337ced2d81f3$var$shadowStyles,
            isDragging && $31b1337ced2d81f3$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$31b1337ced2d81f3$export$2e2bcd8739ae039 = $31b1337ced2d81f3$var$Shadow;

});
parcelRegister("dwLzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6bed85a32a6108$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $fe6bed85a32a6108$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $565cb8192fc4e070$export$802bb2c050f3db5c)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $fe6bed85a32a6108$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)($fe6bed85a32a6108$var$getIsDragging);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($fe6bed85a32a6108$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $565cb8192fc4e070$export$802bb2c050f3db5c)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $fe6bed85a32a6108$export$2e2bcd8739ae039 = $fe6bed85a32a6108$var$useIsSidebarDragging;

});



parcelRegister("2QObc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd36b127ab52f290$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");

var $h9kUS = parcelRequire("h9kUS");


var $dwLzP = parcelRequire("dwLzP");
function $fd36b127ab52f290$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $fd36b127ab52f290$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $fd36b127ab52f290$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $565cb8192fc4e070$export$70740f5ad8360a78)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    }
});
const $fd36b127ab52f290$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $565cb8192fc4e070$export$d6e7e8af042815bb)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $565cb8192fc4e070$export$d6e7e8af042815bb),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $fd36b127ab52f290$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
const $fd36b127ab52f290$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$d2fa14f05b61e66)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $fd36b127ab52f290$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $fd36b127ab52f290$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $fd36b127ab52f290$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $dwLzP.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // mobile viewport styles
            $fd36b127ab52f290$var$mobileStyles,
            isFlyoutOpen && $fd36b127ab52f290$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $fd36b127ab52f290$var$staticInnerStyles,
            isFixed && $fd36b127ab52f290$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $fd36b127ab52f290$var$fixedInnerFlyoutStyles,
            isDragging && $fd36b127ab52f290$var$draggingStyles,
            $fd36b127ab52f290$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd36b127ab52f290$export$2e2bcd8739ae039 = $fd36b127ab52f290$var$LeftSidebarInner;

});

parcelRegister("aY3ai", function(module, exports) {

$parcel$export(module.exports, "default", () => $579ca93715ca9047$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");

var $h9kUS = parcelRequire("h9kUS");


var $dwLzP = parcelRequire("dwLzP");

var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");

var $fZqMW = parcelRequire("fZqMW");
function $579ca93715ca9047$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $579ca93715ca9047$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $579ca93715ca9047$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $565cb8192fc4e070$export$70740f5ad8360a78),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $565cb8192fc4e070$export$d6e7e8af042815bb),
            content: "''"
        }
    }
});
const $579ca93715ca9047$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $579ca93715ca9047$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$f897e1ed9f8ed251),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $579ca93715ca9047$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $579ca93715ca9047$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $565cb8192fc4e070$export$f897e1ed9f8ed251)}`,
        content: "''"
    }
});
const $579ca93715ca9047$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$d2fa14f05b61e66)
});
const $579ca93715ca9047$var$flyoutFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$46acf8758e9e2636)
});
const $579ca93715ca9047$var$selector = (0, $8XpIo.getPageLayoutSlotSelector)('left-sidebar');
const $579ca93715ca9047$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $dwLzP.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                // mobile viewport styles
                $579ca93715ca9047$var$mobileStyles,
                isFlyoutOpen && $579ca93715ca9047$var$mobileFlyoutStyles,
                // generic styles
                $579ca93715ca9047$var$outerStyles,
                isFixed && $579ca93715ca9047$var$fixedStyles,
                isFlyoutOpen && $579ca93715ca9047$var$flyoutStyles,
                isFlyoutOpen && isFixed && $579ca93715ca9047$var$flyoutFixedStyles,
                isDragging && $579ca93715ca9047$var$draggingStyles,
                $579ca93715ca9047$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$579ca93715ca9047$var$selector
        }, children));
};
const $579ca93715ca9047$var$LeftSidebarOuter = /*#__PURE__*/ (0, $5uXOq.forwardRef)($579ca93715ca9047$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$579ca93715ca9047$export$2e2bcd8739ae039 = $579ca93715ca9047$var$LeftSidebarOuter;

});

parcelRegister("1hxaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2beb7a521c0e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");


var $2qAWW = parcelRequire("2qAWW");
function $b2beb7a521c0e059$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $b2beb7a521c0e059$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    transition: 'opacity 0ms linear, visibility 0ms linear',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $565cb8192fc4e070$export$3749e1104328fde4) - 100}ms`,
    visibility: 'hidden'
});
const $b2beb7a521c0e059$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $b2beb7a521c0e059$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $b2beb7a521c0e059$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $2qAWW.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $b2beb7a521c0e059$var$resizableChildrenWrapperStyles,
            isHidden && $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles,
            $b2beb7a521c0e059$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId,
        tabIndex: isHidden ? -1 : 0
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $b2beb7a521c0e059$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b2beb7a521c0e059$export$2e2bcd8739ae039 = $b2beb7a521c0e059$var$ResizableChildrenWrapper;

});
parcelRegister("2qAWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed1c7c9bc9db6ce1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $ed1c7c9bc9db6ce1$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f)) === 'true';
};
const $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $5uXOq.useState)($ed1c7c9bc9db6ce1$var$getIsCollapsing);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($ed1c7c9bc9db6ce1$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $ed1c7c9bc9db6ce1$export$2e2bcd8739ae039 = $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing;

});



parcelRegister("aj7M6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26851ff0e51eadd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $2QObc = parcelRequire("2QObc");

var $aY3ai = parcelRequire("aY3ai");

var $jUxG6 = parcelRequire("jUxG6");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $c26851ff0e51eadd$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$a30f2e00489a8957), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: leftSidebarWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$a30f2e00489a8957)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aY3ai.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
        variableName: (0, $565cb8192fc4e070$export$a30f2e00489a8957),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2QObc.default), {
        isFixed: isFixed
    }, children));
};
var $c26851ff0e51eadd$export$2e2bcd8739ae039 = $c26851ff0e51eadd$var$LeftSidebarWithoutResize;

});

parcelRegister("kUAkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8aae2c1ff30f289$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dWt6p = parcelRequire("dWt6p");



var $dwLzP = parcelRequire("dwLzP");

var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");
function $e8aae2c1ff30f289$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e8aae2c1ff30f289$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $e8aae2c1ff30f289$var$mainStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $565cb8192fc4e070$export$3749e1104328fde4)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
});
const $e8aae2c1ff30f289$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $e8aae2c1ff30f289$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $565cb8192fc4e070$export$b6744d31294864fd)}, ${(0, $565cb8192fc4e070$export$991d5285ad765a3d)}px) + ${(0, $565cb8192fc4e070$export$46acf8758e9e2636)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $e8aae2c1ff30f289$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $dwLzP.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $5uXOq.useContext)((0, $j3yGs.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("main", {
            "data-testid": testId,
            css: [
                $e8aae2c1ff30f289$var$mainStyles,
                isDragging && $e8aae2c1ff30f289$var$draggingStyles,
                isFlyoutOpen && !isFixed && $e8aae2c1ff30f289$var$flyoutStyles,
                $e8aae2c1ff30f289$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('main')
        }, children));
};
var $e8aae2c1ff30f289$export$2e2bcd8739ae039 = $e8aae2c1ff30f289$var$Main;

});

parcelRegister("3WK4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a3c4908a9e1b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $h9kUS = parcelRequire("h9kUS");


var $hhjNo = parcelRequire("hhjNo");
var $ln2Pp = parcelRequire("ln2Pp");

var $crY4K = parcelRequire("crY4K");
const $864a3c4908a9e1b7$var$pageLayoutSelector = {
    [(0, $565cb8192fc4e070$export$659ee746b31b360d)]: true
};
const $864a3c4908a9e1b7$var$gridTemplateAreasMobile = `
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$238d30785c4bca84)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$bec6dca2e63de4ae)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$d1213e82613ff4df)}"
 `;
const $864a3c4908a9e1b7$var$gridTemplateAreas = `
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$238d30785c4bca84)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
  ${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$bec6dca2e63de4ae)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
${''}
  "${(0, $565cb8192fc4e070$export$344062f7cfc9528e)} ${(0, $565cb8192fc4e070$export$d1213e82613ff4df)} ${(0, $565cb8192fc4e070$export$c7139cc2d6110b5f)}"
 `;
const $864a3c4908a9e1b7$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} minmax(0, 1fr) ${(0, $565cb8192fc4e070$export$750459958906793)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} ${(0, $565cb8192fc4e070$export$aeff86a16f13529)} auto`,
    outline: 'none'
});
const $864a3c4908a9e1b7$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $h9kUS.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $565cb8192fc4e070$export$f963aecf2d4465bd)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $864a3c4908a9e1b7$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $565cb8192fc4e070$export$206a08f7f8beb554), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ln2Pp.SkipLinksController), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $crY4K.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$864a3c4908a9e1b7$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $864a3c4908a9e1b7$var$gridStyles,
            $864a3c4908a9e1b7$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hhjNo.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $864a3c4908a9e1b7$export$2e2bcd8739ae039 = $864a3c4908a9e1b7$var$PageLayout;

});
parcelRegister("hhjNo", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $592e749dad0a6cf7$export$850bd1bba41f1448);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eGmKJ = parcelRequire("eGmKJ");

var $dWt6p = parcelRequire("dWt6p");

var $oGXFy = parcelRequire("oGXFy");


var $8XpIo = parcelRequire("8XpIo");

var $j3yGs = parcelRequire("j3yGs");
const $592e749dad0a6cf7$var$handleDataAttributesAndCb = (callback = (0, $eGmKJ.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f));
    callback(leftSidebarState);
};
const $592e749dad0a6cf7$var$leftSidebarSelector = (0, $8XpIo.getPageLayoutSlotCSSSelector)('left-sidebar');
const $592e749dad0a6cf7$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $5uXOq.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $5uXOq.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $5uXOq.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $oGXFy.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $565cb8192fc4e070$export$539e68c09584883a));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $dWt6p.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $565cb8192fc4e070$export$5e5e1875c3fd8f4f), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $565cb8192fc4e070$export$46acf8758e9e2636),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $dWt6p.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $5uXOq.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j3yGs.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("ln2Pp", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $66b4ac88f2caca0d$export$da7be99d6a868f3d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $amcy7 = parcelRequire("amcy7");
const $66b4ac88f2caca0d$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $565cb8192fc4e070$export$5253dd9707b8c3ba)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $66b4ac88f2caca0d$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($66b4ac88f2caca0d$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $5uXOq.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $amcy7.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("crY4K", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $c39a22bbdce5fcea$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $e4yMr = parcelRequire("e4yMr");

var $dWt6p = parcelRequire("dWt6p");



var $amcy7 = parcelRequire("amcy7");
function $c39a22bbdce5fcea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c39a22bbdce5fcea$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $dWt6p.prefersReducedMotion)());
const $c39a22bbdce5fcea$var$skipLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 10px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $c39a22bbdce5fcea$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $c39a22bbdce5fcea$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $c39a22bbdce5fcea$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $c39a22bbdce5fcea$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $c39a22bbdce5fcea$var$assignIndex(num + 1, arr);
};
const $c39a22bbdce5fcea$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $amcy7.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $c39a22bbdce5fcea$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $565cb8192fc4e070$export$659ee746b31b360d)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $565cb8192fc4e070$export$206a08f7f8beb554);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $c39a22bbdce5fcea$var$skipLinkStyles,
            $c39a22bbdce5fcea$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $f8Sb3.jsx)("p", {
        css: $c39a22bbdce5fcea$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("ol", {
        css: $c39a22bbdce5fcea$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($c39a22bbdce5fcea$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle)))));
};
const $c39a22bbdce5fcea$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
};
const $c39a22bbdce5fcea$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $c39a22bbdce5fcea$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
        css: $c39a22bbdce5fcea$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e4yMr.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $c39a22bbdce5fcea$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("4CWca", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9295d31affd013c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $d9295d31affd013c$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$c7139cc2d6110b5f)
});
const $d9295d31affd013c$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$750459958906793),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $d9295d31affd013c$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $565cb8192fc4e070$export$c3e41153b9288bcf), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$fa34f417972d6341), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$fa34f417972d6341)]: rightPanelWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$fa34f417972d6341)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $d9295d31affd013c$var$baseStyles,
                isFixed && $d9295d31affd013c$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$fa34f417972d6341),
            value: rightPanelWidth
        }), children));
};
var $d9295d31affd013c$export$2e2bcd8739ae039 = $d9295d31affd013c$var$RightPanel;

});

parcelRegister("9xmqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07a1808f1030823$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
function $a07a1808f1030823$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $a07a1808f1030823$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $565cb8192fc4e070$export$b44ab66843c05a69),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $565cb8192fc4e070$export$ed7cc0d417ee89e)} + ${(0, $565cb8192fc4e070$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $565cb8192fc4e070$export$750459958906793)})`
});
const $a07a1808f1030823$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $a07a1808f1030823$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: (0, $565cb8192fc4e070$export$b44ab66843c05a69)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $a07a1808f1030823$var$fixedOuterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $565cb8192fc4e070$export$b44ab66843c05a69),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $a07a1808f1030823$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $565cb8192fc4e070$export$b92df8810d2fcd01), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$c103b605cd368aed), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$c103b605cd368aed)]: rightSidebarWidth
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$c103b605cd368aed)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": testId,
            css: [
                $a07a1808f1030823$var$outerStyles,
                isFixed && $a07a1808f1030823$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$c103b605cd368aed),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                isFixed && $a07a1808f1030823$var$fixedInnerStyles,
                !isFixed && $a07a1808f1030823$var$staticInnerStyles
            ]
        }, children)));
};
var $a07a1808f1030823$export$2e2bcd8739ae039 = $a07a1808f1030823$var$RightSidebar;

});

parcelRegister("31ERv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf5fc6d75e2417f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $8XpIo = parcelRequire("8XpIo");

var $2Pb5D = parcelRequire("2Pb5D");
var $amcy7 = parcelRequire("amcy7");

var $fZqMW = parcelRequire("fZqMW");

var $jUxG6 = parcelRequire("jUxG6");
const $7bf5fc6d75e2417f$var$topNavigationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $565cb8192fc4e070$export$aeff86a16f13529),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $565cb8192fc4e070$export$bec6dca2e63de4ae)
});
const $7bf5fc6d75e2417f$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $565cb8192fc4e070$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $565cb8192fc4e070$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $565cb8192fc4e070$export$f963aecf2d4465bd)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $7bf5fc6d75e2417f$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $565cb8192fc4e070$export$4a98ee0bd1ae362), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $8XpIo.resolveDimension)((0, $565cb8192fc4e070$export$3a6a779d9181047c), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Pb5D.default)({
            [(0, $565cb8192fc4e070$export$3a6a779d9181047c)]: topNavigationHeight
        });
        return ()=>{
            (0, $2Pb5D.default)({
                [(0, $565cb8192fc4e070$export$3a6a779d9181047c)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $amcy7.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fZqMW.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $7bf5fc6d75e2417f$var$topNavigationStyles,
                isFixed && $7bf5fc6d75e2417f$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $8XpIo.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUxG6.default), {
            variableName: (0, $565cb8192fc4e070$export$3a6a779d9181047c),
            value: topNavigationHeight
        }), children));
};
var $7bf5fc6d75e2417f$export$2e2bcd8739ae039 = $7bf5fc6d75e2417f$var$TopNavigation;

});

parcelRegister("cIcFn", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $a8132564ed4ca271$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $amcy7 = parcelRequire("amcy7");
const $a8132564ed4ca271$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $amcy7.useSkipLinks)();
    (0, $5uXOq.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("2MLVq", function(module, exports) {

$parcel$export(module.exports, "Aside", () => $77d6f7adcd563578$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lp9re = parcelRequire("lp9re");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $2HiMp = parcelRequire("2HiMp");
const $77d6f7adcd563578$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $77d6f7adcd563578$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $77d6f7adcd563578$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $77d6f7adcd563578$var$getResizeBounds() {
    return $77d6f7adcd563578$var$asideWidthResizeBounds;
}
const $77d6f7adcd563578$var$styles = {
    root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
    fixedContentArea: "_1reo1wug _18m91wug _152t1l7u _165t1run _13wn1if8",
    fullHeight: "_4t3i1osq"
};
function $77d6f7adcd563578$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330, label: label = 'Aside', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $lp9re.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $5uXOq.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$77d6f7adcd563578$var$asideWidthSlotBounds.min}, ${width}px, ${$77d6f7adcd563578$var$asideWidthSlotBounds.max})`;
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        panelId: (0, $ilnvx.asidePanelSplitterId),
        cssVar: $77d6f7adcd563578$var$panelSplitterResizingVar
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("aside", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $77d6f7adcd563578$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $ilnvx.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_asideLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$77d6f7adcd563578$var$panelSplitterResizingVar}, ${asideVariableWidth})` : asideVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.asidePanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $77d6f7adcd563578$var$getResizeBounds,
                resizingCssVar: $77d6f7adcd563578$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $77d6f7adcd563578$var$styles.fullHeight,
                        isFixed && $77d6f7adcd563578$var$styles.fixedContentArea
                    ]),
                    children: children
                })
            })
        ]
    });
}

});
parcelRegister("585q9", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $ac664e290f9d7ee4$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinkInternal", () => $ac664e290f9d7ee4$export$707b94c26b8b75aa);
$parcel$export(module.exports, "useSkipLink", () => $ac664e290f9d7ee4$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");
const $ac664e290f9d7ee4$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerSkipLink: (0, $eGmKJ.default),
    unregisterSkipLink: (0, $eGmKJ.default)
});
const $ac664e290f9d7ee4$var$useSkipLinks = ()=>(0, $5uXOq.useContext)($ac664e290f9d7ee4$export$4c5cc3b14c7678a);
const $ac664e290f9d7ee4$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $ac664e290f9d7ee4$var$useSkipLinks();
    (0, $5uXOq.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
const $ac664e290f9d7ee4$export$89d9323301efc7d6 = (/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex)=>{
    $ac664e290f9d7ee4$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("ilnvx", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", () => $7e0cfbaebce245b0$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $7e0cfbaebce245b0$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $7e0cfbaebce245b0$export$db0c2e1d744fb281);
$parcel$export(module.exports, "bannerMountedVar", () => $7e0cfbaebce245b0$export$515a0b1baafe906c);
$parcel$export(module.exports, "topBarMountedVar", () => $7e0cfbaebce245b0$export$a96e934b2a1eeee);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $7e0cfbaebce245b0$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $7e0cfbaebce245b0$export$5db28b16b6e686bc);
$parcel$export(module.exports, "asidePanelSplitterId", () => $7e0cfbaebce245b0$export$de580d653bac8ad9);
$parcel$export(module.exports, "panelPanelSplitterId", () => $7e0cfbaebce245b0$export$3452dcb65711af44);
$parcel$export(module.exports, "UNSAFE_topBarVar", () => $7e0cfbaebce245b0$export$f4afb213f937404c);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $7e0cfbaebce245b0$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $7e0cfbaebce245b0$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $7e0cfbaebce245b0$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $7e0cfbaebce245b0$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $7e0cfbaebce245b0$export$166d8fd766c3eb92);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $7e0cfbaebce245b0$export$951bf5156e86d974 = '--n_sNvw';
const $7e0cfbaebce245b0$export$594e6a30db7c057e = '--n_asDw';
const $7e0cfbaebce245b0$export$db0c2e1d744fb281 = '--n_pnlW';
const $7e0cfbaebce245b0$export$515a0b1baafe906c = '--n_bnrM';
const $7e0cfbaebce245b0$export$a96e934b2a1eeee = '--n_tbrM';
const $7e0cfbaebce245b0$export$1216dacffd1e9e65 = '--n_sNvlw';
const $7e0cfbaebce245b0$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $7e0cfbaebce245b0$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $7e0cfbaebce245b0$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $7e0cfbaebce245b0$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
const $7e0cfbaebce245b0$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
const $7e0cfbaebce245b0$export$f4afb213f937404c = '--topNavigationHeight';
const $7e0cfbaebce245b0$export$26354f9814213292 = '--bannerHeight';
const $7e0cfbaebce245b0$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $7e0cfbaebce245b0$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $7e0cfbaebce245b0$export$753bf7651b25db91 = '--rightPanelWidth';
const $7e0cfbaebce245b0$export$6460bd6a2446260 = `calc(var(${$7e0cfbaebce245b0$export$26354f9814213292}, 0px) + var(${$7e0cfbaebce245b0$export$f4afb213f937404c}, 0px))`;
const $7e0cfbaebce245b0$export$3055529fab2b4edf = `var(${$7e0cfbaebce245b0$export$6bfc931a04ec5741}, 0px)`;
const $7e0cfbaebce245b0$export$166d8fd766c3eb92 = `calc(var(${$7e0cfbaebce245b0$export$bbbace2ff0c7ae1b}, 0px) + var(${$7e0cfbaebce245b0$export$753bf7651b25db91}, 0px))`;
const $7e0cfbaebce245b0$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    topBarBorder: 3,
    sideNav: 2,
    contentBlockBorder: 2,
    contentInlineBorder: 1,
    panelSmallViewports: 1
};

});

parcelRegister("8oF23", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $1ee0f763875d3fec$export$66e2c1a0115af861);

var $5uXOq = parcelRequire("5uXOq");
const $1ee0f763875d3fec$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});

parcelRegister("2WR37", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $cbb560d7ba4917d9$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $cbb560d7ba4917d9$export$9f45a1325e3cdfb8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1EWMr = parcelRequire("1EWMr");
const $cbb560d7ba4917d9$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: `#${(0, $1EWMr.gridRootId)} { ${variableName}: ${value}px }`
    });
const $cbb560d7ba4917d9$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $cbb560d7ba4917d9$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};

});
parcelRegister("1EWMr", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $f4db93acd3b1ab5b$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $f4db93acd3b1ab5b$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dlnxJ = parcelRequire("dlnxJ");

var $VSDnB = parcelRequire("VSDnB");

var $iuUiD = parcelRequire("iuUiD");

var $df6Ex = parcelRequire("df6Ex");

var $ivVtd = parcelRequire("ivVtd");

var $8oF23 = parcelRequire("8oF23");

var $5rLY7 = parcelRequire("5rLY7");

var $jDR0c = parcelRequire("jDR0c");

var $UTmRP = parcelRequire("UTmRP");
const $f4db93acd3b1ab5b$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $f4db93acd3b1ab5b$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $f4db93acd3b1ab5b$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        var child;
    }, []);
    // OpenLayerObserver is only added when the feature flag is enabled. When disabled, it is only around `SideNav`.
    const OpenLayerObserverIfEnabled = (0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers') ? (0, $dlnxJ.OpenLayerObserver) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $UTmRP.SideNavVisibilityProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jDR0c.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5rLY7.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $df6Ex.HomeActionsProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(OpenLayerObserverIfEnabled, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8oF23.DangerouslyHoistSlotSizes).Provider, {
                            value: UNSAFE_dangerouslyHoistSlotSizes,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ivVtd.SkipLinksProvider), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iuUiD.SkipLinksContainer), {
                                        label: skipLinksLabel,
                                        testId: testId
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                        ref: ref,
                                        className: (0, $bwpsq.default)([
                                            $f4db93acd3b1ab5b$var$styles.root,
                                            xcss
                                        ]),
                                        id: $f4db93acd3b1ab5b$export$a6d827031bcb31d1,
                                        "data-testid": testId,
                                        children: children
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("dlnxJ", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", () => $db6ff2d140327fd6$export$97afddda23bcd287);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $VSDnB = parcelRequire("VSDnB");

var $kEhTY = parcelRequire("kEhTY");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $db6ff2d140327fd6$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $db6ff2d140327fd6$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $db6ff2d140327fd6$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $db6ff2d140327fd6$var$createInternalAPI() {
    /**
	 * The previous data structures are still used if fg('platform_dst_open_layer_observer_close_layers')
	 * is disabled.
	 */ let openLayerCountLegacy = 0;
    const changeListenerRegistryLegacy = new Set();
    /**
	 * These are the new data structures that will be used if fg('platform_dst_open_layer_observer_close_layers')
	 * is enabled.
	 */ /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The `onClose` listeners for each namespace.
	 * Each layer provides an `onClose` callback. **When the layer is open**, its `onClose`
	 * callback is registered in this set.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerCloseListenerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($db6ff2d140327fd6$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $db6ff2d140327fd6$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * If a namespace is provided, the count for that namespace is returned.
	 * Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace } = {}) {
        if (!(0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers')) return openLayerCountLegacy;
        if (namespace) return namespaceToLayerCloseListenerRegistry.get(namespace)?.size ?? 0;
        // A specific namespace was not requested, so we return the sum across all namespaces.
        return $db6ff2d140327fd6$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        if (!(0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers')) {
            changeListenerRegistryLegacy.add(wrapped);
            return function unsubscribe() {
                changeListenerRegistryLegacy.delete(wrapped);
            };
        }
        const namespace = providedNamespace ?? $db6ff2d140327fd6$var$noNamespaceSymbol;
        const listenersForNamespace = $db6ff2d140327fd6$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * This function will be removed with fg('platform_dst_open_layer_observer_close_layers')
	 */ function increment() {
        if (!(0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers')) {
            openLayerCountLegacy += 1;
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(changeListenerRegistryLegacy).forEach((listener)=>listener({
                    count: openLayerCountLegacy
                }));
            return;
        }
    }
    /**
	 * This function will be removed with fg('platform_dst_open_layer_observer_close_layers')
	 */ function decrement() {
        if (!(0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers')) {
            openLayerCountLegacy -= 1;
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(changeListenerRegistryLegacy).forEach((listener)=>listener({
                    count: openLayerCountLegacy
                }));
            return;
        }
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace }) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onClose` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onClose`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped() {
            listener();
        }
        const namespace = providedNamespace ?? $db6ff2d140327fd6$var$noNamespaceSymbol;
        const listenersForNamespace = $db6ff2d140327fd6$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerCloseListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerCloseListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerCloseListenerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach((listener)=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        increment: increment,
        decrement: decrement,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $db6ff2d140327fd6$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $5uXOq.useState)(()=>$db6ff2d140327fd6$var$createInternalAPI());
    const parentContext = (0, $5uXOq.useContext)((0, $kEhTY.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $3joPi.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kEhTY.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

});

parcelRegister("iuUiD", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", () => $8a6fecf6d9ada26f$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $4SKIy = parcelRequire("4SKIy");

var $hgvjm = parcelRequire("hgvjm");
const $8a6fecf6d9ada26f$var$styles = {
    root: "_2rkoglpi _1rjcu2gc _18zr12x7 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    rootToAdd: "_zulp1b66 _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4",
    skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozgze3t",
    skipLinkListToAdd: "_zulp1b66 _1e0c1txw _2lx21bp4 _1pfhze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ const $8a6fecf6d9ada26f$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $8a6fecf6d9ada26f$var$isOnlyWhitespaceRegex = /^\s*$/;
const $8a6fecf6d9ada26f$export$fce25a0c32fbc1e1 = ({ label: label, testId: testId })=>{
    const sortedSkipLinks = (0, $4SKIy.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    const isEmptyLabel = $8a6fecf6d9ada26f$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        onKeyDown: $8a6fecf6d9ada26f$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $bwpsq.default)([
            $8a6fecf6d9ada26f$var$styles.root,
            (0, $VSDnB.fg)('platform_design_system_nav4_skip_link_styling') && $8a6fecf6d9ada26f$var$styles.rootToAdd
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
                weight: (0, $VSDnB.fg)('platform_design_system_nav4_skip_link_styling') ? 'bold' : 'medium',
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
                className: (0, $bwpsq.default)([
                    $8a6fecf6d9ada26f$var$styles.skipLinkList,
                    (0, $VSDnB.fg)('platform_design_system_nav4_skip_link_styling') && $8a6fecf6d9ada26f$var$styles.skipLinkListToAdd
                ]),
                children: sortedSkipLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hgvjm.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
};

});
parcelRegister("4SKIy", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", () => $a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $a6322a25f6b08ecb$export$b0b0d4fc1b356759);

var $5uXOq = parcelRequire("5uXOq");
const $a6322a25f6b08ecb$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $5uXOq.createContext)([]);
const $a6322a25f6b08ecb$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $a6322a25f6b08ecb$var$assignIndex(num + 1, arr);
};
const $a6322a25f6b08ecb$var$sortSkipLinks = (arr)=>{
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
        const listIndex = $a6322a25f6b08ecb$var$assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIdx
    ].sort((a, b)=>a.listIndex - b.listIndex);
};
const $a6322a25f6b08ecb$export$b0b0d4fc1b356759 = ()=>{
    const skipLinksData = (0, $5uXOq.useContext)($a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
    return (0, $5uXOq.useMemo)(()=>{
        return $a6322a25f6b08ecb$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("hgvjm", function(module, exports) {

$parcel$export(module.exports, "SkipLink", () => $ca929d4ef6b95820$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $jhmo0 = parcelRequire("jhmo0");
const $ca929d4ef6b95820$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $ca929d4ef6b95820$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   *
   * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
   *
   * - mess with click events
   * - potentially cause a focus ring to be always visible
   */ (0, $cBeZP.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
const $ca929d4ef6b95820$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate })=>{
    const href = `#${id}`;
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        const target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate?.();
        $ca929d4ef6b95820$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            $ca929d4ef6b95820$var$styles.skipLinkListItem
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jhmo0.default), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: onClick,
            children: children
        })
    });
};

});
parcelRegister("jhmo0", function(module, exports) {

$parcel$export(module.exports, "default", () => $10692011b199b6c5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3joPi = parcelRequire("3joPi");

var $6QvkM = parcelRequire("6QvkM");

var $7a0yc = parcelRequire("7a0yc");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $6wxJn = parcelRequire("6wxJn");

var $jldZL = parcelRequire("jldZL");

var $55sHU = parcelRequire("55sHU");

var $8CUq3 = parcelRequire("8CUq3");
function $10692011b199b6c5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $10692011b199b6c5$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $55sHU.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $55sHU.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $55sHU.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $10692011b199b6c5$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $10692011b199b6c5$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $10692011b199b6c5$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $10692011b199b6c5$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $10692011b199b6c5$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $eGmKJ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $9KnKW.useId)();
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    const RouterLink = (0, $7a0yc.default)();
    const isExternal = typeof href === 'string' && $10692011b199b6c5$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $10692011b199b6c5$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $3joPi.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $10692011b199b6c5$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $10692011b199b6c5$var$baseStyles,
            $10692011b199b6c5$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $55sHU.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $55sHU.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $55sHU.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $55sHU.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $55sHU.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $55sHU.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $55sHU.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $55sHU.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $10692011b199b6c5$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $10692011b199b6c5$var$Anchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)($10692011b199b6c5$var$AnchorNoRef);
var $10692011b199b6c5$export$2e2bcd8739ae039 = $10692011b199b6c5$var$Anchor;

});



parcelRegister("df6Ex", function(module, exports) {

$parcel$export(module.exports, "HomeActionsProvider", () => $311e667ddca00164$export$8b9089606266983e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $c4wuJ = parcelRequire("c4wuJ");
const $311e667ddca00164$export$8b9089606266983e = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c4wuJ.HomeActionsElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c4wuJ.HomeActionsAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("ivVtd", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", () => $04aeed0b84d4da87$export$fe514f9f7b03d46f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $585q9 = parcelRequire("585q9");

var $4SKIy = parcelRequire("4SKIy");
const $04aeed0b84d4da87$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $04aeed0b84d4da87$export$fe514f9f7b03d46f = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($04aeed0b84d4da87$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $5uXOq.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $585q9.SkipLinksContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4SKIy.SkipLinksDataContext).Provider, {
            value: links,
            children: children
        })
    });
};

});

parcelRegister("5rLY7", function(module, exports) {

$parcel$export(module.exports, "SideNavElementProvider", () => $60c376fb0d7017f3$export$85c1ff84bbf6e6dc);
$parcel$export(module.exports, "useSideNavRef", () => $60c376fb0d7017f3$export$fa4d0cff03b1ea4f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $60c376fb0d7017f3$var$SideNavRefContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    current: null
});
function $60c376fb0d7017f3$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($60c376fb0d7017f3$var$SideNavRefContext.Provider, {
        value: sideNavRef,
        children: children
    });
}
function $60c376fb0d7017f3$export$fa4d0cff03b1ea4f() {
    return (0, $5uXOq.useContext)($60c376fb0d7017f3$var$SideNavRefContext);
}

});

parcelRegister("jDR0c", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $e430d141e8d30234$export$ceb8e60e9790fc0f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eZOeM = parcelRequire("eZOeM");
const $e430d141e8d30234$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZOeM.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZOeM.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("UTmRP", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", () => $2510be1036df6cd8$export$aac8e996360f6ad9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b0CFU = parcelRequire("b0CFU");
const $2510be1036df6cd8$export$aac8e996360f6ad9 = ({ children: children })=>{
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0CFU.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0CFU.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};

});



parcelRegister("8mXqE", function(module, exports) {

$parcel$export(module.exports, "useSkipLinkId", () => $57190c324e1ec006$export$fa3cfac0c8e29c5c);
$parcel$export(module.exports, "useLayoutId", () => $57190c324e1ec006$export$110c3550c7c1c9aa);

var $9KnKW = parcelRequire("9KnKW");
function $57190c324e1ec006$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $9KnKW.useId)();
    return uniqueId;
}
function $57190c324e1ec006$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = $57190c324e1ec006$export$fa3cfac0c8e29c5c();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});

parcelRegister("fVO1C", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $0739b5288fba2b3a$export$f662bfb764348932);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9NI3h = parcelRequire("9NI3h");
const $0739b5288fba2b3a$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
    const portalRef = (0, $5uXOq.useRef)(null);
    const context = (0, $5uXOq.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9NI3h.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};

});
parcelRegister("9NI3h", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", () => $ec571489384d3ca6$export$7a4054f2c546f2cd);

var $5uXOq = parcelRequire("5uXOq");
const $ec571489384d3ca6$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("2HiMp", function(module, exports) {

$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $ef753172dcf77156$export$d4931ecf0fbcc8fc);

var $5uXOq = parcelRequire("5uXOq");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");

var $3AWiS = parcelRequire("3AWiS");
function $ef753172dcf77156$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $4hDdm.combine)((0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $3AWiS.isPanelSplitterDragData)(source.data)) return;
                /**
					 * Copies the resizing width value to the `<html>` element.
					 *
					 * Required to reflect the live width of the side navigation.
					 *
					 * Used by:
					 *   - Legacy `--leftSidebarWidth` variable
					 *   - Panel slot max-width constraint
					 *
					 * When the legacy `--leftSidebarWidth` variable is no longer needed,
					 * we could consider writing to the `Panel` element instead.
					 */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        /**
		 * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
		 * if the component unmounts during a drag.
		 */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("3AWiS", function(module, exports) {

$parcel$export(module.exports, "isPanelSplitterDragData", () => $f535d623adcb2c41$export$e239b3966b677000);
$parcel$export(module.exports, "PanelSplitter", () => $f535d623adcb2c41$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $3joPi = parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $98OXW = parcelRequire("98OXW");

var $e4cTf = parcelRequire("e4cTf");

var $VSDnB = parcelRequire("VSDnB");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");

var $4dYas = parcelRequire("4dYas");

var $hjhoK = parcelRequire("hjhoK");

var $fmZmH = parcelRequire("fmZmH");

var $jldZL = parcelRequire("jldZL");

var $9NI3h = parcelRequire("9NI3h");

var $gRo7J = parcelRequire("gRo7J");

var $lVIfq = parcelRequire("lVIfq");

var $fAx1P = parcelRequire("fAx1P");

var $ay5e1 = parcelRequire("ay5e1");

var $1ICwz = parcelRequire("1ICwz");
const $f535d623adcb2c41$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $f535d623adcb2c41$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _d0aluf7j _1gavfnf5 _vp7gaqb7 _30l3aqb7 _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h16c2"
};
const $f535d623adcb2c41$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $f535d623adcb2c41$var$panelSplitterDragDataSymbol = Symbol('panel-splitter-drag-data');
function $f535d623adcb2c41$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [$f535d623adcb2c41$var$panelSplitterDragDataSymbol]: true
    };
}
function $f535d623adcb2c41$export$e239b3966b677000(data) {
    return data[$f535d623adcb2c41$var$panelSplitterDragDataSymbol] === true;
}
const $f535d623adcb2c41$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>{
    const splitterRef = (0, $5uXOq.useRef)(null);
    const panelSplitterContext = (0, $5uXOq.useContext)((0, $9NI3h.PanelSplitterContext));
    (0, $3joPi.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
    (0, $3joPi.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $1ICwz.useTextDirection)(portalRef.current);
    const labelId = (0, $9KnKW.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $5uXOq.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $5uXOq.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $e4cTf.useOpenLayerObserverBehindFG)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const splitter = splitterRef.current;
        (0, $3joPi.default)(splitter, 'Splitter ref must be set');
        return (0, $4hDdm.combine)((0, $4dYas.blockDraggingToIFrames)({
            element: splitter
        }), (0, $7gWdR.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $hjhoK.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $fmZmH.preventUnhandled).start();
            },
            getInitialData () {
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                const initialWidth = (0, $fAx1P.getPixelWidth)(panelRef.current);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $f535d623adcb2c41$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds()
                });
            },
            onDragStart ({ source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                });
                // Close any open layers when the user starts resizing
                if ((0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers')) openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds } = source.data;
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ const targetWidth = (0, $fAx1P.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panelRef.current?.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source }) {
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                (0, $fmZmH.preventUnhandled).stop();
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                (0, $3joPi.default)($f535d623adcb2c41$export$e239b3966b677000(source.data));
                const finalWidth = (0, $fAx1P.getPixelWidth)(panelRef.current);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panelRef.current.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panelRef,
        resizingCssVar,
        panelWidth,
        direction,
        position,
        isEnabled,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $98OXW.default)(onResizeStart);
    const onResizeEndStableRef = (0, $98OXW.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $5uXOq.useState)(()=>(0, $ay5e1.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                if ((0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers')) openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $5uXOq.useCallback)((event)=>{
        const value = parseInt(event.target.value);
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $5uXOq.useRef)(null);
    const handleSliderFocus = (0, $5uXOq.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $gRo7J.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $5uXOq.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $5uXOq.useMemo)(()=>`${(0, $lVIfq.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $bwpsq.default)([
            $f535d623adcb2c41$var$containerStyles.root,
            position === 'start' && $f535d623adcb2c41$var$containerStyles.positionStart,
            position === 'end' && $f535d623adcb2c41$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ref: splitterRef,
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                $f535d623adcb2c41$var$grabAreaStyles.root
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                            type: "range",
                            value: rangeInputValue,
                            step: 20,
                            min: rangeInputBounds.min,
                            max: rangeInputBounds.max,
                            "aria-valuetext": ariaValueText,
                            "aria-labelledby": labelId,
                            onChange: handleSliderInputChange,
                            onFocus: handleSliderFocus,
                            onBlur: handleSliderBlur
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            id: labelId,
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        $f535d623adcb2c41$var$lineStyles.root
                    ])
                })
            ]
        })
    }), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $f535d623adcb2c41$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: hasMounted ? children : null
    });
};
const $f535d623adcb2c41$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)($f535d623adcb2c41$var$ClientOnly, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($f535d623adcb2c41$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId
        })
    });

});
parcelRegister("e4cTf", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", () => $ea3ab92c791f0d5d$export$750f5b0d6c51617e);
$parcel$export(module.exports, "useOpenLayerObserverBehindFG", () => $ea3ab92c791f0d5d$export$e9cbca62806a89c8);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $VSDnB = parcelRequire("VSDnB");

var $kEhTY = parcelRequire("kEhTY");
function $ea3ab92c791f0d5d$export$750f5b0d6c51617e() {
    const context = (0, $5uXOq.useContext)((0, $kEhTY.OpenLayerObserverContext));
    (0, $3joPi.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    const publicAPI = (0, $5uXOq.useMemo)(()=>({
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        }), [
        context.getCount,
        context.onChange,
        context.closeLayers
    ]);
    return publicAPI;
}
function $ea3ab92c791f0d5d$export$e9cbca62806a89c8() {
    const context = (0, $5uXOq.useContext)((0, $kEhTY.OpenLayerObserverContext));
    const publicAPI = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers')) return null;
        if (!context) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
}

});

parcelRegister("gRo7J", function(module, exports) {

$parcel$export(module.exports, "convertResizeBoundToPixels", () => $4ac469c14ce45896$export$3d412b3011b66f82);
function $4ac469c14ce45896$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("lVIfq", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $eb54cea8a4880815$export$b5423678cdf09f5);
function $eb54cea8a4880815$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("fAx1P", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $e9a4e6873a340be1$export$e360234971cb95b8);
$parcel$export(module.exports, "getPixelWidth", () => $e9a4e6873a340be1$export$d942790ad00c41f9);
const $e9a4e6873a340be1$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
const $e9a4e6873a340be1$export$d942790ad00c41f9 = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});

parcelRegister("ay5e1", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $c3821cbf3d3af233$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $c3821cbf3d3af233$var$resizeCallbackDebounceTimeMs = 500;
function $c3821cbf3d3af233$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $c3821cbf3d3af233$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("1ICwz", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $19142174bc5bbe23$export$cf24a79f32f45545);

var $5uXOq = parcelRequire("5uXOq");
const $19142174bc5bbe23$export$cf24a79f32f45545 = (element)=>(0, $5uXOq.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});




parcelRegister("jjRN8", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $365358079a8d32db$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");
const $365358079a8d32db$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat"
};
function $365358079a8d32db$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 height.
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: UNSAFE_height === 0
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $bwpsq.default)([
            $365358079a8d32db$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.HoistCssVarToLocalGrid), {
                variableName: (0, $ilnvx.bannerMountedVar),
                value: UNSAFE_height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_bannerVar),
                value: UNSAFE_height
            }),
            children
        ]
    });
}

});

parcelRegister("hOWCC", function(module, exports) {

$parcel$export(module.exports, "Main", () => $325f1d6156df91d8$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $585q9 = parcelRequire("585q9");

var $8mXqE = parcelRequire("8mXqE");

var $2GcIE = parcelRequire("2GcIE");
const $325f1d6156df91d8$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152t1l7u _165t1run _13wn1if8"
};
function $325f1d6156df91d8$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss, skipLinkLabel: skipLinkLabel = 'Main Content', testId: testId, id: providedId }) {
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    (0, $585q9.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: id,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $325f1d6156df91d8$var$mainElementStyles.root,
                isFixed && $325f1d6156df91d8$var$mainElementStyles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2GcIE.MainStickyContext).Provider, {
                value: Boolean(isFixed),
                children: children
            })
        })
    });
}

});
parcelRegister("2GcIE", function(module, exports) {

$parcel$export(module.exports, "MainStickyContext", () => $7ccaf10616775f74$export$3b369e2c6c1ec840);

var $5uXOq = parcelRequire("5uXOq");
const $7ccaf10616775f74$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});


parcelRegister("ZlCus", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $05534568732462ab$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $5rLY7 = parcelRequire("5rLY7");

var $2HiMp = parcelRequire("2HiMp");
const $05534568732462ab$var$panelSplitterResizingVar = '--n_pnlRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $05534568732462ab$var$oldPanelWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $05534568732462ab$var$oldPanelWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $05534568732462ab$var$getOldResizeBounds() {
    return $05534568732462ab$var$oldPanelWidthResizeBounds;
}
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ const $05534568732462ab$var$fallbackResizeMinWidth = 400;
const $05534568732462ab$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3i1run _kqsw1if8 _152t1l7u _1bsb1adv _14b54rrg _1dhy1c6w _9sns1wug",
    backgroundColor: "_bfhk1bhr _4ap3vuon",
    border: "_191woyrj _16qs1cd0 _z8dmmuej _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw"
};
function $05534568732462ab$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = (0, $VSDnB.fg)('platform_design_system_nav4_panel_default_border') }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $5uXOq.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $5rLY7.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ const minWidth = Math.min(defaultWidth, $05534568732462ab$var$fallbackResizeMinWidth);
    const getNewResizeBounds = (0, $5uXOq.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
        /**
     * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     */ const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${0, $ilnvx.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
    } : $05534568732462ab$var$oldPanelWidthSlotBounds;
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes && (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars'),
        cssVar: $05534568732462ab$var$panelSplitterResizingVar,
        panelId: (0, $ilnvx.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $05534568732462ab$var$styles.root,
            defaultWidth === 0 && $05534568732462ab$var$styles.hidden,
            hasBorder && $05534568732462ab$var$styles.border,
            (0, $VSDnB.fg)('platform_design_system_nav4_panel_default_bg_color') && $05534568732462ab$var$styles.backgroundColor,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $ilnvx.panelVar)]: panelVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.lg,
                responsiveValue: (0, $VSDnB.fg)('platform_design_system_nav4_live_resizing_css_vars') ? `var(${$05534568732462ab$var$panelSplitterResizingVar}, ${panelVariableWidth})` : panelVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? getNewResizeBounds : $05534568732462ab$var$getOldResizeBounds,
                resizingCssVar: $05534568732462ab$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $05534568732462ab$var$styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}

});

parcelRegister("kTus1", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $be4966f89908f895$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $5JjdN = parcelRequire("5JjdN");

var $dlnxJ = parcelRequire("dlnxJ");
var $lJmpK = parcelRequire("lJmpK");
var $e4cTf = parcelRequire("e4cTf");

var $VSDnB = parcelRequire("VSDnB");

var $7gWdR = parcelRequire("7gWdR");

var $h9kUS = parcelRequire("h9kUS");

var $c4wuJ = parcelRequire("c4wuJ");

var $585q9 = parcelRequire("585q9");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");

var $fVO1C = parcelRequire("fVO1C");

var $2HiMp = parcelRequire("2HiMp");

var $5rLY7 = parcelRequire("5rLY7");


var $eZOeM = parcelRequire("eZOeM");

var $fD6iO = parcelRequire("fD6iO");

var $ecbZX = parcelRequire("ecbZX");

var $27t8Q = parcelRequire("27t8Q");

var $6qnkT = parcelRequire("6qnkT");

var $b0CFU = parcelRequire("b0CFU");
const $be4966f89908f895$var$panelSplitterResizingVar = '--n_snvRsz';
const $be4966f89908f895$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $be4966f89908f895$var$getResizeBounds() {
    return $be4966f89908f895$var$widthResizeBounds;
}
const $be4966f89908f895$var$openLayerObserverSideNavNamespace = 'side-nav';
const $be4966f89908f895$var$styles = {
    root: "_nd5l1b6c _bfhk1bhr _16qs1cd0 _vchhusvi _4t3i1run _152t1l7u _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    oldBorder: "_t51zzgxb",
    newBorder: "_t51zoyrj _z8dmmuej",
    newBorderFlyoutOpen: "_z8dm3acm",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $be4966f89908f895$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, id: providedId }) {
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    const expandSideNav = (0, $fD6iO.useExpandSideNav)();
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ const synchronouslyExpandSideNav = (0, $5uXOq.useCallback)(()=>{
        (0, $7nsd3.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $585q9.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    const sideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SideNavVisibilityState));
    const setSideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $ecbZX.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $5uXOq.useState)(defaultCollapsed);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    const clampedWidth = `clamp(${$be4966f89908f895$var$widthResizeBounds.min}, ${width}px, ${$be4966f89908f895$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const navRef = (0, $5uXOq.useRef)(null);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ const sharedRef = (0, $5rLY7.useSideNavRef)();
    const mergedRef = (0, $5JjdN.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $5uXOq.useContext)((0, $eZOeM.SideNavToggleButtonElement));
    const homeActionsElement = (0, $5uXOq.useContext)((0, $c4wuJ.HomeActionsElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $e4cTf.useOpenLayerObserver)();
    const flyoutStateRef = (0, $5uXOq.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const updateFlyoutState = (0, $5uXOq.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'open'
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $94307ebc0fda0ded$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount({
                    namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibility = (0, $6qnkT.useToggleSideNav)();
    (0, $5uXOq.useEffect)(()=>{
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed'
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    const handleExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onExpand?.({
            screen: screen
        });
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState
    ]);
    const handleCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onCollapse?.({
            screen: screen
        });
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $27t8Q.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $5uXOq.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $5uXOq.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        if (!(0, $VSDnB.fg)('platform_design_system_side_nav_click_out_to_close')) // Checking the gate quite early for the best safety + perf measurements
        return;
        return (0, $cBeZP.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                toggleVisibility();
            }
        });
    }, [
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibility
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!homeActionsElement || !toggleButtonElement) return;
        return (0, $cBeZP.bind)(homeActionsElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === homeActionsElement) {
                    // The mouse is directly over the home actions container, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the home actions container that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        homeActionsElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!homeActionsElement) return;
        return (0, $cBeZP.bind)(homeActionsElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the home actions container, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        homeActionsElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, top bar home actions element)
        return openLayerObserver.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $2HiMp.useResizingWidthCssVarOnRootElement)({
        isEnabled: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support'),
        cssVar: $be4966f89908f895$var$panelSplitterResizingVar,
        panelId: (0, $ilnvx.sideNavPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $ilnvx.sideNavVar)]: clampedWidth
        },
        ref: (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? mergedRef : navRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $be4966f89908f895$var$styles.root,
            (0, $VSDnB.fg)('platform_design_system_nav4_sidenav_border') ? $be4966f89908f895$var$styles.newBorder : $be4966f89908f895$var$styles.oldBorder,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $be4966f89908f895$var$styles.hiddenMobileAndDesktop,
            sideNavState?.flyout === 'open' && $be4966f89908f895$var$styles.flyoutOpen,
            sideNavState?.flyout === 'open' && (0, $VSDnB.fg)('platform_design_system_nav4_sidenav_border') && $be4966f89908f895$var$styles.newBorderFlyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && $be4966f89908f895$var$styles.flyoutAnimateClosed
        ]),
        children: [
            (0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') && // This CSS var is used by the `Panel` slot to enforce its maximum width constraint.
            // When we remove the UNSAFE legacy usage, we can change this to `HoistCssVarToLocalGrid`
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.sideNavLiveWidthVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: isExpandedOnDesktop ? `var(${$be4966f89908f895$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
            }),
            dangerouslyHoistSlotSizes && ((0, $VSDnB.fg)('platform_design_system_nav4_preview_panel_support') ? // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_sideNavLayoutVar),
                value: `var(${(0, $ilnvx.sideNavLiveWidthVar)})`
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $ilnvx.UNSAFE_sideNavLayoutVar),
                value: "0px",
                mediaQuery: (0, $h9kUS.media).above.md,
                responsiveValue: isExpandedOnDesktop ? clampedWidth : 0
            })),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVO1C.PanelSplitterProvider), {
                panelId: (0, $ilnvx.sideNavPanelSplitterId),
                panelRef: navRef,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $be4966f89908f895$var$getResizeBounds,
                resizingCssVar: $be4966f89908f895$var$panelSplitterResizingVar,
                isEnabled: isExpandedOnDesktop && !isFlyoutVisible,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $be4966f89908f895$var$styles.flexContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}
function $be4966f89908f895$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, id: id }) {
    // OpenLayerObserver is moving to `Root` when the feature flag is enabled.
    const Wrapper = (0, $VSDnB.fg)('platform_dst_open_layer_observer_close_layers') ? (0, $5uXOq.Fragment) : (0, $dlnxJ.OpenLayerObserver);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJmpK.OpenLayerObserverNamespaceProvider), {
            namespace: $be4966f89908f895$var$openLayerObserverSideNavNamespace,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($be4966f89908f895$var$SideNavInternal, {
                defaultCollapsed: defaultCollapsed,
                defaultWidth: defaultWidth,
                testId: testId,
                label: label,
                skipLinkLabel: skipLinkLabel,
                onExpand: onExpand,
                onCollapse: onCollapse,
                id: id,
                children: children
            })
        })
    });
}

});
parcelRegister("lJmpK", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $68ced8fafd297685$export$327d0d2a7ae6f7cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $6uI1O = parcelRequire("6uI1O");

var $7e96v = parcelRequire("7e96v");
function $68ced8fafd297685$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $7e96v.useOpenLayerObserverNamespace)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $3joPi.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6uI1O.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}

});

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $94307ebc0fda0ded$export$a7801e29f563faad = 400;

parcelRegister("fD6iO", function(module, exports) {

$parcel$export(module.exports, "useExpandSideNav", () => $d44c9e93ca4d5bd6$export$e44b4744d8ff971a);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $b0CFU = parcelRequire("b0CFU");
function $d44c9e93ca4d5bd6$export$e44b4744d8ff971a() {
    const setSideNavState = (0, $5uXOq.useContext)((0, $b0CFU.SetSideNavVisibilityState));
    const expandSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}

});

parcelRegister("27t8Q", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $cb86acb1b056338b$export$1904b8f2577aba9a);

var $5uXOq = parcelRequire("5uXOq");

var $lp9re = parcelRequire("lp9re");
function $cb86acb1b056338b$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $5uXOq.useRef)(onExpand);
    const onCollapseRef = (0, $5uXOq.useRef)(onCollapse);
    (0, $5uXOq.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $lp9re.default)(isExpandedOnDesktop);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop'
        });
        else onCollapseRef.current?.({
            screen: 'desktop'
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    const previousIsExpandedOnMobile = (0, $lp9re.default)(isExpandedOnMobile);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile'
        });
        else onCollapseRef.current?.({
            screen: 'mobile'
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}

});


parcelRegister("fod7Z", function(module, exports) {

$parcel$export(module.exports, "TopBar", () => $474d185125d63dcd$export$c4e96258f3b6511);
/* top-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $585q9 = parcelRequire("585q9");

var $7K1Hj = parcelRequire("7K1Hj");

var $C93Ef = parcelRequire("C93Ef");

var $ilnvx = parcelRequire("ilnvx");

var $8oF23 = parcelRequire("8oF23");

var $2WR37 = parcelRequire("2WR37");

var $8mXqE = parcelRequire("8mXqE");
const $474d185125d63dcd$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
    oldLayoutStyles: "_1rqtc57g",
    newLayoutStyles: "_1j8b18ax"
};
function $474d185125d63dcd$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 48, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, UNSAFE_theme: UNSAFE_theme }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $8oF23.DangerouslyHoistSlotSizes));
    const id = (0, $8mXqE.useLayoutId)({
        providedId: providedId
    });
    (0, $585q9.useSkipLink)(id, skipLinkLabel);
    const customTheme = (0, $C93Ef.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K1Hj.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("header", {
            id: id,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $474d185125d63dcd$var$styles.root,
                (0, $VSDnB.fg)('platform_design_system_nav4_top_nav_columns') ? $474d185125d63dcd$var$styles.newLayoutStyles : $474d185125d63dcd$var$styles.oldLayoutStyles,
                xcss
            ]),
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.HoistCssVarToLocalGrid), {
                    variableName: (0, $ilnvx.topBarMountedVar),
                    value: UNSAFE_height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WR37.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $ilnvx.UNSAFE_topBarVar),
                    value: UNSAFE_height
                }),
                children
            ]
        })
    });
}

});
parcelRegister("C93Ef", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $7d674db87d8ae404$export$c0c5f5b297b77726);

var $5uXOq = parcelRequire("5uXOq");

var $408XH = parcelRequire("408XH");
function $7d674db87d8ae404$export$c0c5f5b297b77726(theme) {
    const value = (0, $5uXOq.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $408XH.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("408XH", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", () => $0ea127ed833ce03d$export$3986d75fe2da3239);

var $g8Ctp = parcelRequire("g8Ctp");

var $65VCl = parcelRequire("65VCl");

var $6QDVn = parcelRequire("6QDVn");

var $3jLRy = parcelRequire("3jLRy");

var $3ysBv = parcelRequire("3ysBv");

var $al2bB = parcelRequire("al2bB");
function $0ea127ed833ce03d$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $0ea127ed833ce03d$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $0ea127ed833ce03d$var$buttonStyles = {
    light: {
        [(0, $65VCl.themedButtonBackground)]: 'transparent',
        [(0, $65VCl.themedButtonBackgroundHovered)]: (0, $3ysBv.palette).Neutral200A,
        [(0, $65VCl.themedButtonBackgroundPressed)]: (0, $3ysBv.palette).Neutral300A,
        [(0, $65VCl.themedButtonBorder)]: (0, $3ysBv.palette).Neutral300A,
        [(0, $65VCl.themedButtonSelectedBackground)]: (0, $3ysBv.palette).Neutral300A,
        [(0, $65VCl.themedButtonSelectedBackgroundHovered)]: (0, $3ysBv.palette).Neutral400A,
        [(0, $65VCl.themedButtonSelectedBackgroundPressed)]: (0, $3ysBv.palette).Neutral500A,
        [(0, $65VCl.themedButtonDisabledText)]: (0, $3ysBv.palette).Neutral400A,
        [(0, $65VCl.themedButtonDisabledBackground)]: (0, $3ysBv.palette).Neutral100A
    },
    dark: {
        [(0, $65VCl.themedButtonBackground)]: 'transparent',
        [(0, $65VCl.themedButtonBackgroundHovered)]: (0, $3ysBv.palette).DarkNeutral200A,
        [(0, $65VCl.themedButtonBackgroundPressed)]: (0, $3ysBv.palette).DarkNeutral300A,
        [(0, $65VCl.themedButtonBorder)]: (0, $3ysBv.palette).DarkNeutral300A,
        [(0, $65VCl.themedButtonSelectedBackground)]: (0, $3ysBv.palette).DarkNeutral300A,
        [(0, $65VCl.themedButtonSelectedBackgroundHovered)]: (0, $3ysBv.palette).DarkNeutral400A,
        [(0, $65VCl.themedButtonSelectedBackgroundPressed)]: (0, $3ysBv.palette).DarkNeutral500A,
        [(0, $65VCl.themedButtonDisabledText)]: (0, $3ysBv.palette).DarkNeutral400A,
        [(0, $65VCl.themedButtonDisabledBackground)]: (0, $3ysBv.palette).DarkNeutral100A
    }
};
const $0ea127ed833ce03d$var$logoStyles = {
    light: {
        [(0, $g8Ctp.themedLogoIcon)]: (0, $3ysBv.palette).DarkNeutral0,
        [(0, $g8Ctp.themedLogoText)]: (0, $3ysBv.palette).DarkNeutral0
    },
    dark: {
        [(0, $g8Ctp.themedLogoIcon)]: (0, $3ysBv.palette).Neutral0,
        [(0, $g8Ctp.themedLogoText)]: (0, $3ysBv.palette).Neutral0
    }
};
function $0ea127ed833ce03d$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $3jLRy.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $3jLRy.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $6QDVn.getTextColor)(backgroundRgb);
    const colorMode = (0, $6QDVn.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $6QDVn.getTextColor)(highlightRgb);
    return {
        backgroundColor: $0ea127ed833ce03d$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$0ea127ed833ce03d$var$buttonStyles[colorMode],
        ...$0ea127ed833ce03d$var$logoStyles[colorMode],
        ...$0ea127ed833ce03d$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $al2bB.themedSearchBorder)]: $0ea127ed833ce03d$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $al2bB.themedSearchBorderFocused)]: $0ea127ed833ce03d$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ [(0, $65VCl.themedButtonPrimaryBackground)]: $0ea127ed833ce03d$var$toRGBString(highlightRgb),
        [(0, $65VCl.themedButtonPrimaryBackgroundHovered)]: $0ea127ed833ce03d$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        [(0, $65VCl.themedButtonPrimaryBackgroundPressed)]: $0ea127ed833ce03d$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        [(0, $65VCl.themedButtonPrimaryText)]: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $0ea127ed833ce03d$var$selectedBackgroundRGBA = {
    light: (0, $3ysBv.paletteRgba).Neutral300A,
    dark: (0, $3ysBv.paletteRgba).DarkNeutral300A
};
function $0ea127ed833ce03d$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $0ea127ed833ce03d$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $6QDVn.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        [(0, $65VCl.themedButtonSelectedText)]: (0, $6QDVn.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        [(0, $65VCl.themedButtonSelectedBorder)]: (0, $6QDVn.isLight)(blendedBackground) ? (0, $3ysBv.palette).Neutral1100 : (0, $3ysBv.palette).DarkNeutral1100
    };
}

});
parcelRegister("g8Ctp", function(module, exports) {

$parcel$export(module.exports, "themedLogoIcon", () => $293136d9291fb1c4$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $293136d9291fb1c4$export$91b0830f8f4ab279);
$parcel$export(module.exports, "NavLogo", () => $293136d9291fb1c4$export$b6394419753329e);
/* nav-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $VSDnB = parcelRequire("VSDnB");

var $jhmo0 = parcelRequire("jhmo0");

var $7K1Hj = parcelRequire("7K1Hj");
const $293136d9291fb1c4$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $293136d9291fb1c4$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
const $293136d9291fb1c4$var$anchorStyles = {
    root: "_2rkoiti9 _1e0c1txw _4cvr1h6o _4t3izwfg",
    newBorderRadius: "_2rkoftgi",
    newMargin: "_ahbq1b66",
    newInteractionStates: "_irr3166n _1di61dty",
    newInteractionStatesCustomTheming: "_irr31rps _1di6qtgh"
};
const $293136d9291fb1c4$var$sharedIconOrLogoContainerStyles = {
    root: "_1reo15vq _18m915vq _bna71tcg _rtys1kw7 _1jpx1f51",
    appIconTilePaddingFlagged: "_18zr1b66"
};
const $293136d9291fb1c4$var$iconContainerStyles = {
    root: "_18zr1b66 _1e0c1txw _p12f1tcg _vchh18uv _10y4glyw"
};
const $293136d9291fb1c4$var$logoContainerStyles = {
    root: "_18zru2gc _1e0cglyw _p12fnklw _vchh18uv _10y41txw"
};
const $293136d9291fb1c4$export$b6394419753329e = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        return;
    }, []);
    const hasCustomTheme = (0, $7K1Hj.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jhmo0.default), {
        ref: ref,
        "aria-label": label,
        href: href,
        // @ts-expect-error - non-standard values for `borderRadius` and the custom theming interaction states
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $DEWI6.cx)($293136d9291fb1c4$var$anchorStyles.root, (0, $VSDnB.fg)('platform_design_system_nav_logo_interaction_states') && $293136d9291fb1c4$var$anchorStyles.newMargin, (0, $VSDnB.fg)('platform_design_system_nav_logo_interaction_states') && $293136d9291fb1c4$var$anchorStyles.newBorderRadius, (0, $VSDnB.fg)('platform_design_system_nav_logo_interaction_states') && (hasCustomTheme ? $293136d9291fb1c4$var$anchorStyles.newInteractionStatesCustomTheming : $293136d9291fb1c4$var$anchorStyles.newInteractionStates)),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $293136d9291fb1c4$var$sharedIconOrLogoContainerStyles.root,
                    $293136d9291fb1c4$var$iconContainerStyles.root,
                    (0, $VSDnB.fg)('platform-team25-app-icon-tiles') && $293136d9291fb1c4$var$sharedIconOrLogoContainerStyles.appIconTilePaddingFlagged
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($293136d9291fb1c4$var$NavLogoRenderer, {
                    logoOrIcon: icon
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $293136d9291fb1c4$var$sharedIconOrLogoContainerStyles.root,
                    $293136d9291fb1c4$var$logoContainerStyles.root,
                    (0, $VSDnB.fg)('platform-team25-app-icon-tiles') && $293136d9291fb1c4$var$sharedIconOrLogoContainerStyles.appIconTilePaddingFlagged
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($293136d9291fb1c4$var$NavLogoRenderer, {
                    logoOrIcon: logo
                })
            })
        ]
    });
};
function $293136d9291fb1c4$var$NavLogoRenderer({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $7K1Hj.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, $2OMIu.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        iconColor: `var(${$293136d9291fb1c4$export$24328117f1132113})`,
        textColor: `var(${$293136d9291fb1c4$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}

});

parcelRegister("6QDVn", function(module, exports) {

$parcel$export(module.exports, "isLight", () => $967caca0dee09c9d$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $967caca0dee09c9d$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $967caca0dee09c9d$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $967caca0dee09c9d$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $967caca0dee09c9d$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $967caca0dee09c9d$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $967caca0dee09c9d$var$linearizeRGBChannel(normal.r),
        g: $967caca0dee09c9d$var$linearizeRGBChannel(normal.g),
        b: $967caca0dee09c9d$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $967caca0dee09c9d$var$flipLuminance = 0.179129;
function $967caca0dee09c9d$export$44af652f4cca9039(color) {
    return $967caca0dee09c9d$var$relativeLuminanceW3C(color) >= $967caca0dee09c9d$var$flipLuminance;
}
function $967caca0dee09c9d$export$5573a5bab3e074b5(backgroundColor) {
    if ($967caca0dee09c9d$var$relativeLuminanceW3C(backgroundColor) >= $967caca0dee09c9d$var$flipLuminance) return 'light';
    return 'dark';
}
const $967caca0dee09c9d$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $967caca0dee09c9d$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $967caca0dee09c9d$export$5573a5bab3e074b5(backgroundColor);
    return $967caca0dee09c9d$var$textColor[colorMode];
}
function $967caca0dee09c9d$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("3jLRy", function(module, exports) {

$parcel$export(module.exports, "parseHex", () => $e39fb962789861e2$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $e39fb962789861e2$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $e39fb962789861e2$export$103711ef09c6edec(color) {
    if (!$e39fb962789861e2$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("3ysBv", function(module, exports) {

$parcel$export(module.exports, "palette", () => $7460df5260aa7edf$export$eaad8caa32d2521d);
$parcel$export(module.exports, "paletteRgba", () => $7460df5260aa7edf$export$c9b84419dae66a82);
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ const $7460df5260aa7edf$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
const $7460df5260aa7edf$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("al2bB", function(module, exports) {

$parcel$export(module.exports, "themedSearchBorder", () => $02c56316137b9683$export$ae6fbf5ba3a7a784);
$parcel$export(module.exports, "themedSearchBorderFocused", () => $02c56316137b9683$export$ee42b8430f4c19bd);
$parcel$export(module.exports, "useLegacySearchTheme", () => $02c56316137b9683$export$18a29b1ed2212823);

var $65VCl = parcelRequire("65VCl");

var $7K1Hj = parcelRequire("7K1Hj");
const $02c56316137b9683$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
const $02c56316137b9683$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ const $02c56316137b9683$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: `var(${$02c56316137b9683$export$ae6fbf5ba3a7a784})`
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #172B4D)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: `var(${$02c56316137b9683$export$ee42b8430f4c19bd})`,
        boxShadow: `inset 0px 0px 0px 1px var(${$02c56316137b9683$export$ee42b8430f4c19bd})`
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: `var(${(0, $65VCl.themedButtonBackgroundHovered)})`
    }
};
function $02c56316137b9683$export$18a29b1ed2212823() {
    const hasCustomTheme = (0, $7K1Hj.useHasCustomTheme)();
    if (hasCustomTheme) return $02c56316137b9683$var$legacySearchTheme;
    return undefined;
}

});




parcelRegister("6tRzQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a5529c459ee2c2df402232a3b7b74525>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b7f02ca64f03771$var$_react = $4b7f02ca64f03771$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b7f02ca64f03771$var$_information = $4b7f02ca64f03771$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $4b7f02ca64f03771$var$_panel = $4b7f02ca64f03771$var$_interopRequireDefault((parcelRequire("kkuz9")));
function $4b7f02ca64f03771$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b7f02ca64f03771$var$InformationIcon = (props)=>/*#__PURE__*/ $4b7f02ca64f03771$var$_react.default.createElement($4b7f02ca64f03771$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $4b7f02ca64f03771$var$_panel.default
    }, props));
$4b7f02ca64f03771$var$InformationIcon.Name = 'InformationIconMigration';
var $4b7f02ca64f03771$var$_default = module.exports.default = $4b7f02ca64f03771$var$InformationIcon;

});

parcelRegister("dg0Fl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b4f7ab8b5658b8ac17876b86421aa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a6d49390b09b82e$var$_react = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9a6d49390b09b82e$var$_questionCircle = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("8nk07")));

var $9a6d49390b09b82e$var$_questionCircle2 = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("eJS47")));
function $9a6d49390b09b82e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a6d49390b09b82e$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $9a6d49390b09b82e$var$_react.default.createElement($9a6d49390b09b82e$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $9a6d49390b09b82e$var$_questionCircle2.default
    }, props));
$9a6d49390b09b82e$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
var $9a6d49390b09b82e$var$_default = module.exports.default = $9a6d49390b09b82e$var$QuestionCircleIcon;

});

parcelRegister("16T6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7856b71523badd$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $cgL5K = parcelRequire("cgL5K");

var $ehtcU = parcelRequire("ehtcU");
const $fe7856b71523badd$var$boxStyles = {
    root: "_2rkopd34 _18zr12x7 _1e0c116y _1o9zidpf _1kz6184x",
    added: "_bfhk1bay",
    default: "_bfhklecj",
    important: "_bfhk1v7l",
    primary: "_bfhkomb0",
    primaryInverted: "_bfhkvuon",
    removed: "_bfhktaeo"
};
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
const $fe7856b71523badd$var$red300 = '#FD9891';
const $fe7856b71523badd$var$blue300 = '#8FB8F6';
const $fe7856b71523badd$var$neutral1000 = '#292A2E';
const $fe7856b71523badd$var$styles = {
    root: "_2rkogqwt _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhkmv6i _syaz1fxt",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1e6v",
    removed: "_bfhk1gly _syaz1fxt"
};
const $fe7856b71523badd$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    // Use this flag for allowing negative values(numbers) in badge component when custom number field is used
    if ((0, $VSDnB.fg)('platform_ken_2029_negative_numbers_badge')) return typeof children === 'number' && typeof max === 'number' ? (0, $ehtcU.formatValueWithNegativeSupport)(children, max) : children;
    return typeof children === 'number' && max ? (0, $ehtcU.formatValue)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $fe7856b71523badd$var$Badge = /*#__PURE__*/ (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $bwpsq.default)([
            $fe7856b71523badd$var$styles.root,
            $fe7856b71523badd$var$styles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $fe7856b71523badd$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            backgroundColor: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $bwpsq.default)([
            $fe7856b71523badd$var$boxStyles.root,
            $fe7856b71523badd$var$boxStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cgL5K.default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance],
            children: $fe7856b71523badd$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
$fe7856b71523badd$var$Badge.displayName = 'Badge';
var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
const $fe7856b71523badd$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("ehtcU", function(module, exports) {

$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $24d41a560822020b$export$4b844743568d5983);
$parcel$export(module.exports, "formatValue", () => $24d41a560822020b$export$7c4d25c0c3217d8c);
function $24d41a560822020b$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $24d41a560822020b$export$4b844743568d5983(value, max) {
    const safeValue = $24d41a560822020b$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $24d41a560822020b$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $24d41a560822020b$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $24d41a560822020b$var$getSafeValue(value);
    const safeMax = $24d41a560822020b$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("j9VTE", function(module, exports) {

$parcel$export(module.exports, "NestedContext", () => $1d9622231f6b7781$export$46b2c2071c8c725a);
$parcel$export(module.exports, "useNestedContext", () => $1d9622231f6b7781$export$f24166abe9ed712b);
$parcel$export(module.exports, "useShouldNestedElementRender", () => $1d9622231f6b7781$export$37e8646a1abfc3e6);

var $5uXOq = parcelRequire("5uXOq");
const $1d9622231f6b7781$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $1d9622231f6b7781$export$f24166abe9ed712b = ()=>{
    const context = (0, $5uXOq.useContext)($1d9622231f6b7781$export$46b2c2071c8c725a);
    if (!context) {
        let error = '';
        throw new Error(error);
    }
    return context;
};
const $1d9622231f6b7781$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $5uXOq.useContext)($1d9622231f6b7781$export$46b2c2071c8c725a);
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});

parcelRegister("8GsOl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ddb2a0e6c8a33d7611a427658d95f19>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65289839d421bbf4$var$_react = $65289839d421bbf4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $65289839d421bbf4$var$_lightbulb = $65289839d421bbf4$var$_interopRequireDefault((parcelRequire("e78BF")));

var $65289839d421bbf4$var$_lightbulbFilled = $65289839d421bbf4$var$_interopRequireDefault((parcelRequire("iUyym")));
function $65289839d421bbf4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LightbulbIcon.
 * This component is LightbulbIcon, with `UNSAFE_fallbackIcon` set to "LightbulbFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65289839d421bbf4$var$LightbulbIcon = (props)=>/*#__PURE__*/ $65289839d421bbf4$var$_react.default.createElement($65289839d421bbf4$var$_lightbulb.default, Object.assign({
        LEGACY_fallbackIcon: $65289839d421bbf4$var$_lightbulbFilled.default
    }, props));
$65289839d421bbf4$var$LightbulbIcon.Name = 'LightbulbIconMigration';
var $65289839d421bbf4$var$_default = module.exports.default = $65289839d421bbf4$var$LightbulbIcon;

});

parcelRegister("kxFlx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8dbd8d9850b83e4eb37f60fa877444d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef46f6416da27377$var$_react = $ef46f6416da27377$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef46f6416da27377$var$_crossCircle = $ef46f6416da27377$var$_interopRequireDefault((parcelRequire("hI6SY")));

var $ef46f6416da27377$var$_crossCircle2 = $ef46f6416da27377$var$_interopRequireDefault((parcelRequire("d5Zn3")));
function $ef46f6416da27377$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "CrossCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef46f6416da27377$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $ef46f6416da27377$var$_react.default.createElement($ef46f6416da27377$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $ef46f6416da27377$var$_crossCircle2.default
    }, props));
$ef46f6416da27377$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $ef46f6416da27377$var$_default = module.exports.default = $ef46f6416da27377$var$CrossCircleIcon;

});

parcelRegister("2bzBV", function(module, exports) {

$parcel$export(module.exports, "OverflowProvider", () => $a09db1d7916aff70$export$a3a2def3937905a0);
$parcel$export(module.exports, "useOverflowStatus", () => $a09db1d7916aff70$export$3fcfc71fab3314f2);
$parcel$export(module.exports, "useOverflowController", () => $a09db1d7916aff70$export$705aa66a39c35bf7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $eGmKJ = parcelRequire("eGmKJ");
// Prevent width detector from triggering too many re-renders
const $a09db1d7916aff70$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
const $a09db1d7916aff70$var$ITEM_APPROX_MINWIDTH = 70;
const $a09db1d7916aff70$var$calculateHash = (w, n)=>w + '#' + n;
const $a09db1d7916aff70$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $a09db1d7916aff70$var$OverflowContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $eGmKJ.default),
    closeOverflowMenu: (0, $eGmKJ.default)
});
const $a09db1d7916aff70$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const { Provider: Provider } = $a09db1d7916aff70$var$OverflowContext;
    const value = (0, $5uXOq.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Provider, {
        value: value,
        children: children
    });
};
const $a09db1d7916aff70$export$3fcfc71fab3314f2 = ()=>(0, $5uXOq.useContext)($a09db1d7916aff70$var$OverflowContext);
const $a09db1d7916aff70$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(nodes);
    const [width, setWidth] = (0, $5uXOq.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $5uXOq.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $5uXOq.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $5uXOq.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $5uXOq.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, $a09db1d7916aff70$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $a09db1d7916aff70$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $a09db1d7916aff70$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $a09db1d7916aff70$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $a09db1d7916aff70$var$ITEM_APPROX_MINWIDTH * 2), $a09db1d7916aff70$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $a09db1d7916aff70$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $a09db1d7916aff70$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $a09db1d7916aff70$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
		 * This is not necessarily equal to `lastItemWidth` because the
		 * ```js
		 * if (wasJustLimited) {}
		 * ```
		 * branch above modifies `itemsWidths`.
		 *
		 * Using `lastItemWidth` here can cause collapsing behavior to fail,
		 * such as the issue reported in DSP-7329.
		 */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $a09db1d7916aff70$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $a09db1d7916aff70$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $a09db1d7916aff70$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line import/no-anonymous-default-export
$a09db1d7916aff70$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("gSZmd", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $dfe52a3a6f12c8c9$export$d4c4e98c5044dc8);

var $hEtBs = parcelRequire("hEtBs");
const $dfe52a3a6f12c8c9$export$d4c4e98c5044dc8 = (0, $hEtBs.List);

});

parcelRegister("1qQhw", function(module, exports) {

$parcel$export(module.exports, "MenuListItem", () => $352eeaf5cfbddcbe$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUDGK = parcelRequire("eUDGK");
const $352eeaf5cfbddcbe$export$6c2f3257abc4825b = (0, $eUDGK.ListItem);

});
parcelRegister("eUDGK", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $afd3e9c9301967e3$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $afd3e9c9301967e3$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId,
        children: children
    });
}
const $afd3e9c9301967e3$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($afd3e9c9301967e3$var$_ListItem);

});


parcelRegister("ijIzb", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", () => $3445978e5e6e1849$export$17d3acb0b4379d02);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $3445978e5e6e1849$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const $3445978e5e6e1849$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3445978e5e6e1849$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kxZMz", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", () => $fa32ebd87a25ffa6$export$dabef2be6cd28c20);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $fa32ebd87a25ffa6$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $fa32ebd87a25ffa6$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $fa32ebd87a25ffa6$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bOVbW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cc8d44dd44920ffd526686a9e2bd3636>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89b0ba45464c36f9$var$_react = $89b0ba45464c36f9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $89b0ba45464c36f9$var$_baseNew = $89b0ba45464c36f9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $89b0ba45464c36f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features and functionality. Editions may replace the current premium sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89b0ba45464c36f9$var$EditionsIcon = (props)=>/*#__PURE__*/ $89b0ba45464c36f9$var$_react.default.createElement($89b0ba45464c36f9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.614 1.353A.75.75 0 0 1 3.25 1h9.5a.75.75 0 0 1 .636.353l2.5 4a.75.75 0 0 1-.065.884l-7.25 8.5a.75.75 0 0 1-1.142 0l-7.25-8.5a.75.75 0 0 1-.065-.885zM3.666 2.5 2.103 5H4.7l.78-2.5zm3.385 0L6.271 5H9.73l-.781-2.5zm3.47 0L11.3 5h2.596l-1.563-2.5zm3.103 4h-2.328l-1.424 4.399zM8 11.813 9.72 6.5H6.28zM4.704 6.5l1.424 4.399L2.375 6.5z" clip-rule="evenodd"/>`
    }, props));
$89b0ba45464c36f9$var$EditionsIcon.displayName = 'EditionsIcon';
var $89b0ba45464c36f9$var$_default = module.exports.default = $89b0ba45464c36f9$var$EditionsIcon;

});

parcelRegister("i7S2n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e4382cd4db66693d3c799807338c8cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d322cc20711ec758$var$_react = $d322cc20711ec758$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d322cc20711ec758$var$_creditCard = $d322cc20711ec758$var$_interopRequireDefault((parcelRequire("yJt0Y")));

var $d322cc20711ec758$var$_creditcardFilled = $d322cc20711ec758$var$_interopRequireDefault((parcelRequire("kbAiU")));
function $d322cc20711ec758$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CreditCardIcon.
 * This component is CreditCardIcon, with `UNSAFE_fallbackIcon` set to "CreditcardFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d322cc20711ec758$var$CreditCardIcon = (props)=>/*#__PURE__*/ $d322cc20711ec758$var$_react.default.createElement($d322cc20711ec758$var$_creditCard.default, Object.assign({
        LEGACY_fallbackIcon: $d322cc20711ec758$var$_creditcardFilled.default
    }, props));
$d322cc20711ec758$var$CreditCardIcon.Name = 'CreditCardIconMigration';
var $d322cc20711ec758$var$_default = module.exports.default = $d322cc20711ec758$var$CreditCardIcon;

});

parcelRegister("bZC6Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::49812071d6f0a774fd1a4306f3d0718e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bb2f3f40a6108ea$var$_react = $8bb2f3f40a6108ea$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bb2f3f40a6108ea$var$_baseNew = $8bb2f3f40a6108ea$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8bb2f3f40a6108ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bb2f3f40a6108ea$var$WarningIcon = (props)=>/*#__PURE__*/ $8bb2f3f40a6108ea$var$_react.default.createElement($8bb2f3f40a6108ea$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.702 9.137A1.25 1.25 0 0 1 10.612 11H1.388a1.25 1.25 0 0 1-1.09-1.863l4.614-8.2a1.25 1.25 0 0 1 2.178 0zM6.75 2.75V6.5h-1.5V2.75zm-.75 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$8bb2f3f40a6108ea$var$WarningIcon.displayName = 'WarningIcon';
var $8bb2f3f40a6108ea$var$_default = module.exports.default = $8bb2f3f40a6108ea$var$WarningIcon;

});

parcelRegister("fxNl3", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $b429ec418bceed55$export$c49a2b642fe9eef4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $b429ec418bceed55$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $b429ec418bceed55$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $b429ec418bceed55$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("vNVcd", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $a1d820a02703cd98$export$9923361bd43fa030);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3fDjf = parcelRequire("3fDjf");

var $9sGJX = parcelRequire("9sGJX");

var $7Onh2 = parcelRequire("7Onh2");
const $a1d820a02703cd98$export$9923361bd43fa030 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Onh2.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9sGJX))), {
            color: "currentColor",
            spacing: "spacious",
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
const $a1d820a02703cd98$export$28833e0dfbd2ac80 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Onh2.IconButton), {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fDjf))), {
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps',
            color: "var(--ds-icon, #44546F)"
        }),
        component: component,
        href: href,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
var // exists only to extract props
// eslint-disable-next-line import/no-anonymous-default-export
$a1d820a02703cd98$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("7paD5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc9ca86dc3d7916919414cea3f7ddc7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56431cfb6cb87beb$var$_react = $56431cfb6cb87beb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $56431cfb6cb87beb$var$_linkExternal = $56431cfb6cb87beb$var$_interopRequireDefault((parcelRequire("ggICg")));

var $56431cfb6cb87beb$var$_shortcut = $56431cfb6cb87beb$var$_interopRequireDefault((parcelRequire("17Ngn")));
function $56431cfb6cb87beb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkExternalIcon.
 * This component is LinkExternalIcon, with `UNSAFE_fallbackIcon` set to "ShortcutIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56431cfb6cb87beb$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $56431cfb6cb87beb$var$_react.default.createElement($56431cfb6cb87beb$var$_linkExternal.default, Object.assign({
        LEGACY_fallbackIcon: $56431cfb6cb87beb$var$_shortcut.default
    }, props));
$56431cfb6cb87beb$var$LinkExternalIcon.Name = 'LinkExternalIconMigration';
var $56431cfb6cb87beb$var$_default = module.exports.default = $56431cfb6cb87beb$var$LinkExternalIcon;

});

parcelRegister("fL0AO", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $15d1a88fcd7214c3$export$9923361bd43fa030);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3fDjf = parcelRequire("3fDjf");

var $Ee6JC = parcelRequire("Ee6JC");
const $15d1a88fcd7214c3$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $15d1a88fcd7214c3$export$9923361bd43fa030 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $Ee6JC.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3fDjf))),
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $15d1a88fcd7214c3$var$toggleButtonTooltipOptions,
        isSelected: isSelected
    }));

});

parcelRegister("kTHGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $77295807efde9889$export$2e2bcd8739ae039);



var $hAKJr = parcelRequire("hAKJr");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $77295807efde9889$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $hAKJr.default)[tokenId];
    let tokenValue = fallback;
    typeof $6cAn5;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $77295807efde9889$export$2e2bcd8739ae039 = $77295807efde9889$var$getTokenValue;

});

parcelRegister("eCCin", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $58c8bcec2d2f91c7$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $1PVpv = parcelRequire("1PVpv");



var $k2eCO = parcelRequire("k2eCO");
var $hBZh1 = parcelRequire("hBZh1");

var $fSH9K = parcelRequire("fSH9K");
function $58c8bcec2d2f91c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $58c8bcec2d2f91c7$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $8acc83d90e579622$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $58c8bcec2d2f91c7$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $58c8bcec2d2f91c7$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $58c8bcec2d2f91c7$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $58c8bcec2d2f91c7$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $58c8bcec2d2f91c7$export$f66ccb39f60980e5 = (props)=>{
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $k2eCO.defaultTheme), testId: testId, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hBZh1.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PVpv.NavigationAnalyticsContext), {
        data: $58c8bcec2d2f91c7$var$analyticsData
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $58c8bcec2d2f91c7$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner",
        "data-vc": `atlassian-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'atlassian-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
        css: $58c8bcec2d2f91c7$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $f8Sb3.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $f8Sb3.jsx)(ProductHome, null), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fSH9K.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $58c8bcec2d2f91c7$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $f8Sb3.jsx)(Search, null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "list",
        css: [
            $58c8bcec2d2f91c7$var$rightStyles,
            $58c8bcec2d2f91c7$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && /*#__PURE__*/ (0, $f8Sb3.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $f8Sb3.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $f8Sb3.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $f8Sb3.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $f8Sb3.jsx)(Profile, null))))));
};

});
const $8acc83d90e579622$export$30fa7cc5f2690a43 = 56;
const $8acc83d90e579622$export$4033a111ca79977d = 1280;
const $8acc83d90e579622$export$24ec62cee78b7042 = 1130;
const $8acc83d90e579622$export$d8bde68ac946124f = '--ds--ans--fbc';
const $8acc83d90e579622$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $8acc83d90e579622$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $8acc83d90e579622$export$d81606c1fc5119bc = '--ds--ans--c';
const $8acc83d90e579622$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("fSH9K", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $6fdfdcc72d14d5cb$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1I7E8 = parcelRequire("1I7E8");


var $gJlZe = parcelRequire("gJlZe");

var $2bzBV = parcelRequire("2bzBV");

var $7ownK = parcelRequire("7ownK");
function $6fdfdcc72d14d5cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6fdfdcc72d14d5cb$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $6fdfdcc72d14d5cb$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $6fdfdcc72d14d5cb$var$overflowItemsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
});
const $6fdfdcc72d14d5cb$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $5uXOq.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $2bzBV.useOverflowController)(items);
    const onMoreClick = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7ownK.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2bzBV.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $6fdfdcc72d14d5cb$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6fdfdcc72d14d5cb$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2bzBV.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1I7E8.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $f8Sb3.jsx)(Create, null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $6fdfdcc72d14d5cb$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gJlZe.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("7ownK", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $07ec44e10e1bbcf4$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $c8Oei = parcelRequire("c8Oei");

var $711X2 = parcelRequire("711X2");
const $07ec44e10e1bbcf4$export$bb3af89fb196520d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $711X2.PrimaryButton), {
        component: component,
        iconAfter: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            LEGACY_margin: `0 ${"var(--ds-space-negative-050, -4px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
            color: "currentColor",
            label: ""
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        ...rest
    });
});

});
parcelRegister("711X2", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $52863ca42b4251a4$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9yOBd = parcelRequire("9yOBd");

var $3bDjY = parcelRequire("3bDjY");

var $gKAEK = parcelRequire("gKAEK");

var $d8hYi = parcelRequire("d8hYi");
function $52863ca42b4251a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $52863ca42b4251a4$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $52863ca42b4251a4$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $52863ca42b4251a4$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $52863ca42b4251a4$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$52863ca42b4251a4$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$52863ca42b4251a4$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $52863ca42b4251a4$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const themeFromContext = (0, $gKAEK.useTheme)();
    const button = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            [$52863ca42b4251a4$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$52863ca42b4251a4$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $52863ca42b4251a4$var$buttonBaseStyles,
            isHighlighted && $52863ca42b4251a4$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9yOBd.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $d8hYi.getPrimaryButtonTheme)(themeFromContext),
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});

});
parcelRegister("d8hYi", function(module, exports) {

$parcel$export(module.exports, "getPrimaryButtonTheme", () => $655194713e502995$export$14dd6915caf431fe);
const $655194713e502995$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});





parcelRegister("3qye2", function(module, exports) {

$parcel$export(module.exports, "SkeletonSwitcherButton", () => $cbbf4d27993dbc7a$export$41b1bb24b7702cc2);
$parcel$export(module.exports, "Nav4SkeletonSwitcherButton", () => $cbbf4d27993dbc7a$export$68afc1d9d20a7bd8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $3fDjf = parcelRequire("3fDjf");

var $9sGJX = parcelRequire("9sGJX");

var $3XuTW = parcelRequire("3XuTW");

var $gKAEK = parcelRequire("gKAEK");
const $cbbf4d27993dbc7a$var$skeletonSwitcherButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 100%)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:only-of-type': {
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        marginRight: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'normal'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        width: 24,
        height: 24,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        verticalAlign: 'middle'
    }
});
const $cbbf4d27993dbc7a$export$41b1bb24b7702cc2 = ({ label: label = '', testId: testId })=>{
    const theme = (0, $gKAEK.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.iconButton.default,
        "data-testid": testId,
        css: $cbbf4d27993dbc7a$var$skeletonSwitcherButtonStyles,
        type: "button"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9sGJX))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    }));
};
const $cbbf4d27993dbc7a$export$68afc1d9d20a7bd8 = ({ label: label = '', testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3XuTW.SkeletonIconButton), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3fDjf))), {
        label: label,
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }));

});
parcelRegister("3XuTW", function(module, exports) {

$parcel$export(module.exports, "SkeletonIconButton", () => $666894f166710a66$export$7b398af37f6177e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gKAEK = parcelRequire("gKAEK");
function $666894f166710a66$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $666894f166710a66$var$skeletonIconButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: 0,
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 100%)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'normal'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        width: 24,
        height: 24,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        verticalAlign: 'middle'
    }
});
const $666894f166710a66$var$buttonWrapperStyles = {
    name: "khzvr",
    styles: "margin-inline-end:var(--ds-space-050, 4px);&:only-of-type{margin-inline-end:0;}"
};
const $666894f166710a66$export$7b398af37f6177e = ({ children: children, testId: testId })=>{
    const theme = (0, $gKAEK.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "listitem",
        css: $666894f166710a66$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.iconButton.default,
        "data-testid": testId,
        css: $666894f166710a66$var$skeletonIconButtonStyles,
        type: "button"
    }, children));
};

});


parcelRegister("g6jiF", function(module, exports) {

$parcel$export(module.exports, "Create", () => $f43287fd6bbef582$export$8ade6fcbf3a7de5d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9yOBd = parcelRequire("9yOBd");

var $faod6 = parcelRequire("faod6");

var $3bDjY = parcelRequire("3bDjY");


var $gKAEK = parcelRequire("gKAEK");

var $7Onh2 = parcelRequire("7Onh2");

var $kN8y7 = parcelRequire("kN8y7");
const $f43287fd6bbef582$var$wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-smallscreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${(0, $8acc83d90e579622$export$24ec62cee78b7042) - 1}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-largescreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (min-width: ${0, $8acc83d90e579622$export$24ec62cee78b7042}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $f43287fd6bbef582$var$TooltipSwitch = ({ buttonTooltip: buttonTooltip, children: children })=>buttonTooltip ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: buttonTooltip,
        hideTooltipOnClick: true
    }, children) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
const $f43287fd6bbef582$export$8ade6fcbf3a7de5d = ({ onClick: onClick, href: href, text: text, buttonTooltip: buttonTooltip, iconButtonTooltip: iconButtonTooltip, testId: testId, label: label })=>{
    const theme = (0, $gKAEK.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f43287fd6bbef582$var$wrapperStyles,
        role: "listitem",
        "data-testid": "create-button-wrapper"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($f43287fd6bbef582$var$TooltipSwitch, {
        buttonTooltip: buttonTooltip
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9yOBd.default), {
        id: "createGlobalItem",
        "aria-label": label,
        onClick: onClick,
        href: href,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: (0, $kN8y7.getCreateButtonTheme)(theme),
        testId: testId && `${testId}-button`,
        "data-hide-on-smallscreens": true
    }, text)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7Onh2.IconButton), {
        id: "createGlobalItemIconButton",
        testId: testId && `${testId}-icon-button`,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
            color: "currentColor",
            spacing: "spacious",
            label: text
        }),
        onClick: onClick,
        href: href,
        tooltip: iconButtonTooltip,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $kN8y7.getCreateButtonTheme)(theme),
        "aria-label": text,
        "data-hide-on-largescreens": true
    }));
};

});
parcelRegister("faod6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbaf72704b8a24398cb5b76f6fe1dbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0aa91dd45a22c5b$var$_react = $b0aa91dd45a22c5b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b0aa91dd45a22c5b$var$_add = $b0aa91dd45a22c5b$var$_interopRequireDefault((parcelRequire("dZbEw")));

var $b0aa91dd45a22c5b$var$_add2 = $b0aa91dd45a22c5b$var$_interopRequireDefault((parcelRequire("9lMrf")));
function $b0aa91dd45a22c5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "EditorAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0aa91dd45a22c5b$var$AddIcon = (props)=>/*#__PURE__*/ $b0aa91dd45a22c5b$var$_react.default.createElement($b0aa91dd45a22c5b$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $b0aa91dd45a22c5b$var$_add2.default
    }, props));
$b0aa91dd45a22c5b$var$AddIcon.Name = 'AddIconMigration';
var $b0aa91dd45a22c5b$var$_default = module.exports.default = $b0aa91dd45a22c5b$var$AddIcon;

});

parcelRegister("kN8y7", function(module, exports) {

$parcel$export(module.exports, "getCreateButtonTheme", () => $adc5cd243919440f$export$256eebed8e934f30);
const $adc5cd243919440f$export$256eebed8e934f30 = ({ mode: { create: create } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...create.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': create.hover,
                ':focus': create.focus,
                // :active doesn't work in FF, becasue we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && create.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("83yN3", function(module, exports) {

$parcel$export(module.exports, "SkeletonCreateButton", () => $a4ea4ac62a17ab73$export$e321b2260435e302);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gKAEK = parcelRequire("gKAEK");
function $a4ea4ac62a17ab73$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a4ea4ac62a17ab73$var$skeletonCreateButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: 32,
    padding: `0 ${"var(--ds-space-150, 12px)"}`,
    alignSelf: 'center',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $a4ea4ac62a17ab73$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $a4ea4ac62a17ab73$export$e321b2260435e302 = ({ text: text, testId: testId })=>{
    const theme = (0, $gKAEK.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "listitem",
        css: $a4ea4ac62a17ab73$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.create.default,
        css: $a4ea4ac62a17ab73$var$skeletonCreateButtonStyles,
        "data-testid": testId,
        type: "button"
    }, text));
};

});

parcelRegister("2tvF5", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $f2c2ffda8d778b24$export$6d3c345ce7c38fd9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dZbEw = parcelRequire("dZbEw");

var $Ee6JC = parcelRequire("Ee6JC");
const $f2c2ffda8d778b24$export$6d3c345ce7c38fd9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onClick: onClick, testId: testId, interactionName: interactionName }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $Ee6JC.Button), {
        ref: ref,
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))),
        onClick: onClick,
        testId: testId,
        interactionName: interactionName,
        children: children
    }));

});

parcelRegister("4YvKq", function(module, exports) {

$parcel$export(module.exports, "Help", () => $8f34ba1016bafdbb$export$1be7516c0280bee8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dg0Fl = parcelRequire("dg0Fl");

var $gKAEK = parcelRequire("gKAEK");

var $2WekC = parcelRequire("2WekC");

var $7Onh2 = parcelRequire("7Onh2");
const $8f34ba1016bafdbb$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $8f34ba1016bafdbb$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { badge: badge, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    const { mode: { navigation: navigation } } = (0, $gKAEK.useTheme)();
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Onh2.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
            label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
            color: "currentColor",
            spacing: "spacious",
            LEGACY_secondaryColor: navigation.backgroundColor
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    });
    return badge ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WekC.BadgeContainer), {
        id: $8f34ba1016bafdbb$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: button
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        children: button
    });
});

});
parcelRegister("2WekC", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $b5ac5d6c4dfbdac2$export$f710265eb5a003da);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $b5ac5d6c4dfbdac2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b5ac5d6c4dfbdac2$var$badgeContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    insetBlockStart: `${"var(--ds-space-negative-050, -4px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none'
});
const $b5ac5d6c4dfbdac2$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $b5ac5d6c4dfbdac2$export$f710265eb5a003da = (props)=>{
    const { id: badgeId, badge: Badge, children: children, role: role } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $b5ac5d6c4dfbdac2$var$containerStyles,
        role: role
    }, children, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $b5ac5d6c4dfbdac2$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Badge, null)));
};

});


parcelRegister("9kXvc", function(module, exports) {

$parcel$export(module.exports, "SkeletonHelpButton", () => $70aba88b02ff347a$export$9ee5d6e291d4e456);
$parcel$export(module.exports, "Nav4SkeletonHelpButton", () => $70aba88b02ff347a$export$c25bc9ca782b25f4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dg0Fl = parcelRequire("dg0Fl");

var $8nk07 = parcelRequire("8nk07");

var $3XuTW = parcelRequire("3XuTW");

var $gKAEK = parcelRequire("gKAEK");
const $70aba88b02ff347a$export$9ee5d6e291d4e456 = ({ label: label = '' })=>{
    const { mode: { navigation: navigation } } = (0, $gKAEK.useTheme)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3XuTW.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
            label: label,
            color: "currentColor",
            LEGACY_secondaryColor: navigation.backgroundColor
        })
    });
};
const $70aba88b02ff347a$export$c25bc9ca782b25f4 = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3XuTW.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8nk07))), {
            label: label,
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("ey2zZ", function(module, exports) {

$parcel$export(module.exports, "Help", () => $2fecf07e9130a44a$export$1be7516c0280bee8);
/**
 * @jsxRuntime classic
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8nk07 = parcelRequire("8nk07");

var $9MMay = parcelRequire("9MMay");

var $6Dtpf = parcelRequire("6Dtpf");
const $2fecf07e9130a44a$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $2fecf07e9130a44a$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Help({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, isListItem: isListItem, badge: badge }, ref) {
    const sharedProps = {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8nk07))),
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        ref: ref
    };
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Dtpf.UserAction), {
        ...sharedProps,
        isListItem: isListItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MMay.BadgeContainer), {
        id: $2fecf07e9130a44a$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Dtpf.UserAction), {
        ...sharedProps,
        // We explicitly set the UserAction to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false
    }));
});

});
parcelRegister("9MMay", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $e73d1b1ea40e5fd9$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $e73d1b1ea40e5fd9$var$styles = {
    root: "_kqswh2mm _1e0c1txw",
    badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
};
const $e73d1b1ea40e5fd9$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $bwpsq.default)([
            $e73d1b1ea40e5fd9$var$styles.root
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                id: badgeId,
                "aria-hidden": true,
                className: (0, $bwpsq.default)([
                    $e73d1b1ea40e5fd9$var$styles.badgeContainer
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Badge, {})
            })
        ]
    });

});

parcelRegister("6Dtpf", function(module, exports) {

$parcel$export(module.exports, "UserAction", () => $594fea2a6857b8ff$export$d344b04822cd68e8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eUDGK = parcelRequire("eUDGK");

var $Ee6JC = parcelRequire("Ee6JC");
const $594fea2a6857b8ff$export$d344b04822cd68e8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $eUDGK.ListItem) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Ee6JC.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup
        })
    });
});

});


parcelRegister("68lE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3cfbb7a61c4e64$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");



var $gKAEK = parcelRequire("gKAEK");

var $fgkqi = parcelRequire("fgkqi");
function $3a3cfbb7a61c4e64$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $3a3cfbb7a61c4e64$var$productLogoStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $3a3cfbb7a61c4e64$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $3a3cfbb7a61c4e64$var$productIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $3a3cfbb7a61c4e64$var$productHomeButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $3a3cfbb7a61c4e64$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
/**
 * __Custom product home__
 *
 * Use `CustomProductHome` to provide a custom logo and icon with URLs.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#custom-product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $3a3cfbb7a61c4e64$var$CustomProductHome = (props)=>{
    const { href: href, iconAlt: iconAlt, iconUrl: iconUrl, logoAlt: logoAlt, logoMaxWidth: logoMaxWidth = 260, logoUrl: logoUrl, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest } = props;
    const theme = (0, $gKAEK.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const Tag = (0, $fgkqi.getTag)(onClick, href);
    const preventFocusRing = (event)=>{
        event.preventDefault();
        onMouseDown && onMouseDown(event);
    };
    const productHomeButtonDynamicStyles = {
        [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)(Tag, {
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $3a3cfbb7a61c4e64$var$productHomeButtonStyles,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        ...rest
    }, logoUrl && /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $3a3cfbb7a61c4e64$var$customMaxHeightStyles,
            $3a3cfbb7a61c4e64$var$productLogoStyles
        ],
        src: logoUrl,
        alt: logoAlt,
        "data-testid": testId && `${testId}-logo`,
        "data-vc": "custom-product-home-logo"
    }), iconUrl && /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $3a3cfbb7a61c4e64$var$customMaxHeightStyles,
            $3a3cfbb7a61c4e64$var$productIconStyles
        ],
        src: iconUrl,
        alt: iconAlt,
        "data-testid": testId && `${testId}-icon`,
        "data-vc": "custom-product-home-icon"
    })), siteTitle && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $3a3cfbb7a61c4e64$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $3a3cfbb7a61c4e64$export$2e2bcd8739ae039 = $3a3cfbb7a61c4e64$var$CustomProductHome;

});
parcelRegister("fgkqi", function(module, exports) {

$parcel$export(module.exports, "getTag", () => $eb9d291932721df9$export$dad497fe1f6e27c0);
const $eb9d291932721df9$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("esSwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $538bd94a54e78f12$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");



var $gKAEK = parcelRequire("gKAEK");

var $3mMDm = parcelRequire("3mMDm");

var $fgkqi = parcelRequire("fgkqi");
function $538bd94a54e78f12$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $538bd94a54e78f12$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $538bd94a54e78f12$var$productHomeButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${"var(--ds-border-focused, #4C9AFF)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $538bd94a54e78f12$var$productLogoStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$538bd94a54e78f12$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: `var(${$538bd94a54e78f12$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $538bd94a54e78f12$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $538bd94a54e78f12$var$productIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $538bd94a54e78f12$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $538bd94a54e78f12$var$ProductHome = ({ 'aria-label': ariaLabel, href: href, icon: Icon, logo: Logo, logoMaxWidth: logoMaxWidth = 260, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest })=>{
    const theme = (0, $gKAEK.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    // After the brand refresh, iconColor and textColor should be set to 'undefined' to allow the original
    // multi-color logo tile colors to be visible, rather than a hardcoded blue.
    let { iconColor: iconColor = (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? undefined : 'inherit', textColor: textColor = (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? undefined : theme.mode.productHome.color } = theme.mode.productHome;
    // The default theme is set at module scope and immediately used in context.
    // To allow the feature flag to switch the logo color at runtime, we also detect the original hardcoded
    // values and override them to undefined.
    if (iconColor === '#357DE8' && textColor === `var(--ds-text, ${0, $829f609a65d26a98$export$ad0bacf983b7ddaa})` && (0, $VSDnB.fg)('platform-team25-app-icon-tiles')) {
        iconColor = undefined;
        textColor = undefined;
    }
    const Tag = (0, $fgkqi.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $3mMDm.stripEmptyProperties)({
        [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$538bd94a54e78f12$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $538bd94a54e78f12$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        "aria-label": ariaLabel,
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $538bd94a54e78f12$var$customMaxHeightStyles,
            $538bd94a54e78f12$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? 'brand' : undefined
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $538bd94a54e78f12$var$customMaxHeightStyles,
            $538bd94a54e78f12$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, {
        iconColor: iconColor,
        size: (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? 'small' : undefined,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: (0, $VSDnB.fg)('platform-team25-app-icon-tiles') ? 'brand' : undefined
    }))), siteTitle && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $538bd94a54e78f12$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $538bd94a54e78f12$export$2e2bcd8739ae039 = $538bd94a54e78f12$var$ProductHome;

});
parcelRegister("3mMDm", function(module, exports) {

$parcel$export(module.exports, "stripEmptyProperties", () => $59fdda837c8257e3$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $59fdda837c8257e3$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});


parcelRegister("k2QUc", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogo", () => $a693453326af5315$export$765cacec8b0843f3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $a693453326af5315$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal product logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 32" focusable="false" aria-hidden="true" height="32" fill="none">
      <path fill=${colors.iconColor} d="M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"/>
      <path fill=${colors.atlassianLogoTextColor} d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354"/>
    </svg>`;
};
const $a693453326af5315$export$765cacec8b0843f3 = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $a693453326af5315$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8vDvO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f847d1cd9da5a4c2f8db9579d329d66>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $631fde4578bc8518$var$_react = $631fde4578bc8518$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $631fde4578bc8518$var$_app = $631fde4578bc8518$var$_interopRequireDefault((parcelRequire("hRf4g")));

var $631fde4578bc8518$var$_addon = $631fde4578bc8518$var$_interopRequireDefault((parcelRequire("apKqz")));
function $631fde4578bc8518$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppIcon.
 * This component is AppIcon, with `UNSAFE_fallbackIcon` set to "AddonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $631fde4578bc8518$var$AppIcon = (props)=>/*#__PURE__*/ $631fde4578bc8518$var$_react.default.createElement($631fde4578bc8518$var$_app.default, Object.assign({
        LEGACY_fallbackIcon: $631fde4578bc8518$var$_addon.default
    }, props));
$631fde4578bc8518$var$AppIcon.Name = 'AppIconMigration';
var $631fde4578bc8518$var$_default = module.exports.default = $631fde4578bc8518$var$AppIcon;

});

parcelRegister("8TWpC", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $a8d50d5b33301a3d$export$c72f6eaae7b9adff);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $epOG5 = parcelRequire("epOG5");

var $6Dtpf = parcelRequire("6Dtpf");
const $a8d50d5b33301a3d$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Dtpf.UserAction), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($epOG5)))
    }));

});

parcelRegister("3rGy0", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $78f794893daa6da1$export$c72f6eaae7b9adff);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $k2tiP = parcelRequire("k2tiP");

var $7Onh2 = parcelRequire("7Onh2");
const $78f794893daa6da1$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Onh2.IconButton), {
            component: component,
            href: href,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
                color: "currentColor",
                spacing: "spacious",
                label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});

parcelRegister("cmbsU", function(module, exports) {

$parcel$export(module.exports, "SkeletonSettingsButton", () => $87125a345dc924c4$export$914093d4d181ff4d);
$parcel$export(module.exports, "Nav4SkeletonSettingsButton", () => $87125a345dc924c4$export$beac98f336d7b14f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $k2tiP = parcelRequire("k2tiP");

var $epOG5 = parcelRequire("epOG5");

var $3XuTW = parcelRequire("3XuTW");
const $87125a345dc924c4$export$914093d4d181ff4d = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3XuTW.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
            color: "currentColor",
            spacing: "spacious",
            label: label
        })
    });
const $87125a345dc924c4$export$beac98f336d7b14f = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3XuTW.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("eaGfl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e8a00667b2b14b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $cYuZM = parcelRequire("cYuZM");

var $eGmKJ = parcelRequire("eGmKJ");


var $baKwq = parcelRequire("baKwq");
function $5e8a00667b2b14b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5e8a00667b2b14b7$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'block',
        width: '30%',
        height: "var(--ds-space-100, 8px)",
        backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`,
        borderRadius: 100,
        content: '""'
    }
});
const $5e8a00667b2b14b7$var$defaultWidthStyles = {
    name: "me8tg7",
    styles: "::after{width:30%;}"
};
const $5e8a00667b2b14b7$var$customWidthStyles = {
    name: "ms0ivw",
    styles: "::after{width:var(--width);}"
};
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $5e8a00667b2b14b7$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $eGmKJ.default) })=>{
    (0, $cYuZM.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $eGmKJ.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $f8Sb3.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $baKwq.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            style: {
                '--width': width
            },
            css: [
                $5e8a00667b2b14b7$var$skeletonStyles,
                width ? $5e8a00667b2b14b7$var$customWidthStyles : $5e8a00667b2b14b7$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-ds--menu--skeleton-heading-item": true,
            "data-testid": testId
        }));
};
var $5e8a00667b2b14b7$export$2e2bcd8739ae039 = $5e8a00667b2b14b7$var$SkeletonHeadingItem;

});

parcelRegister("jAy2o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c4ae6cbf448d83dbeec4b01140533b0d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e42bc844c50d30a9$var$_react = $e42bc844c50d30a9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e42bc844c50d30a9$var$_baseNew = $e42bc844c50d30a9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e42bc844c50d30a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e42bc844c50d30a9$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $e42bc844c50d30a9$var$_react.default.createElement($e42bc844c50d30a9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.302.641 1.146.968-3.167 3.75a.75.75 0 0 1-1.146 0L3.552 7.484l1.146-.968 1.01 1.197z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M16 7v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75V7z" clip-rule="evenodd"/>`
    }, props));
$e42bc844c50d30a9$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $e42bc844c50d30a9$var$_default = module.exports.default = $e42bc844c50d30a9$var$WorkItemsIcon;

});

parcelRegister("1Wiru", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa2c753ece5041b181498943e0fe8bd9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1699837b07cb7a4a$var$_react = $1699837b07cb7a4a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1699837b07cb7a4a$var$_dashboard = $1699837b07cb7a4a$var$_interopRequireDefault((parcelRequire("gsyzJ")));

var $1699837b07cb7a4a$var$_activity = $1699837b07cb7a4a$var$_interopRequireDefault((parcelRequire("hPSf5")));
function $1699837b07cb7a4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DashboardIcon.
 * This component is DashboardIcon, with `UNSAFE_fallbackIcon` set to "ActivityIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1699837b07cb7a4a$var$DashboardIcon = (props)=>/*#__PURE__*/ $1699837b07cb7a4a$var$_react.default.createElement($1699837b07cb7a4a$var$_dashboard.default, Object.assign({
        LEGACY_fallbackIcon: $1699837b07cb7a4a$var$_activity.default
    }, props));
$1699837b07cb7a4a$var$DashboardIcon.Name = 'DashboardIconMigration';
var $1699837b07cb7a4a$var$_default = module.exports.default = $1699837b07cb7a4a$var$DashboardIcon;

});

parcelRegister("fwpGE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2f90a428e27c19a23210f4827b99818>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02ea8b6fb3b8469b$var$_react = $02ea8b6fb3b8469b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $02ea8b6fb3b8469b$var$_folderClosed = $02ea8b6fb3b8469b$var$_interopRequireDefault((parcelRequire("9xuGL")));

var $02ea8b6fb3b8469b$var$_folder = $02ea8b6fb3b8469b$var$_interopRequireDefault((parcelRequire("bP37O")));
function $02ea8b6fb3b8469b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FolderClosedIcon.
 * This component is FolderClosedIcon, with `UNSAFE_fallbackIcon` set to "FolderIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02ea8b6fb3b8469b$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $02ea8b6fb3b8469b$var$_react.default.createElement($02ea8b6fb3b8469b$var$_folderClosed.default, Object.assign({
        LEGACY_fallbackIcon: $02ea8b6fb3b8469b$var$_folder.default
    }, props));
$02ea8b6fb3b8469b$var$FolderClosedIcon.Name = 'FolderClosedIconMigration';
var $02ea8b6fb3b8469b$var$_default = module.exports.default = $02ea8b6fb3b8469b$var$FolderClosedIcon;

});

parcelRegister("dZ2wS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d92ee8885a3bd0486e697aace29ae839>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2e2ef1e344a537a$var$_react = $a2e2ef1e344a537a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a2e2ef1e344a537a$var$_screen = $a2e2ef1e344a537a$var$_interopRequireDefault((parcelRequire("9fIhE")));

var $a2e2ef1e344a537a$var$_screen2 = $a2e2ef1e344a537a$var$_interopRequireDefault((parcelRequire("3Jz4b")));
function $a2e2ef1e344a537a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ScreenIcon.
 * This component is ScreenIcon, with `UNSAFE_fallbackIcon` set to "ScreenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2e2ef1e344a537a$var$ScreenIcon = (props)=>/*#__PURE__*/ $a2e2ef1e344a537a$var$_react.default.createElement($a2e2ef1e344a537a$var$_screen.default, Object.assign({
        LEGACY_fallbackIcon: $a2e2ef1e344a537a$var$_screen2.default
    }, props));
$a2e2ef1e344a537a$var$ScreenIcon.Name = 'ScreenIconMigration';
var $a2e2ef1e344a537a$var$_default = module.exports.default = $a2e2ef1e344a537a$var$ScreenIcon;

});

parcelRegister("6Lc8h", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c11af61bf1d5e1e60e3ad123179be896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ec08b271318e97e$var$_react = $4ec08b271318e97e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4ec08b271318e97e$var$_personAvatar = $4ec08b271318e97e$var$_interopRequireDefault((parcelRequire("bdVbi")));

var $4ec08b271318e97e$var$_personCircle = $4ec08b271318e97e$var$_interopRequireDefault((parcelRequire("3B33y")));
function $4ec08b271318e97e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAvatarIcon.
 * This component is PersonAvatarIcon, with `UNSAFE_fallbackIcon` set to "PersonCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4ec08b271318e97e$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $4ec08b271318e97e$var$_react.default.createElement($4ec08b271318e97e$var$_personAvatar.default, Object.assign({
        LEGACY_fallbackIcon: $4ec08b271318e97e$var$_personCircle.default
    }, props));
$4ec08b271318e97e$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
var $4ec08b271318e97e$var$_default = module.exports.default = $4ec08b271318e97e$var$PersonAvatarIcon;

});

parcelRegister("6R0Et", function(module, exports) {

$parcel$export(module.exports, "SkeletonPrimaryButton", () => $9c211af0799e6e88$export$4a3049f952d3f130);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gKAEK = parcelRequire("gKAEK");

var $3mMDm = parcelRequire("3mMDm");
function $9c211af0799e6e88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR = '--primary-button-before-highlighted-background-color';
const $9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR = '--primary-button-after-dropdown-border-color';
const $9c211af0799e6e88$var$primaryButtonSkeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `0 ${"var(--ds-space-075, 6px)"}`,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    position: 'relative',
    appearance: 'none',
    border: 0,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::-moz-focus-inner': {
        border: 0
    }
});
const $9c211af0799e6e88$var$isHighlightedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $9c211af0799e6e88$var$isHighlightedAndDropdownButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        insetInlineEnd: -10
    }
});
const $9c211af0799e6e88$var$isHighlightedNotDropdownButtonStyles = {
    name: "1sue5tp",
    styles: "&:before{inset-inline-end:var(--ds-space-025, 2px);}"
};
const $9c211af0799e6e88$var$isDropdownButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginInlineEnd: 18,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        display: 'inline-block',
        width: 4,
        height: 4,
        position: 'absolute',
        borderBlockEnd: '2px solid',
        borderColor: `var(${$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR})`,
        borderInlineEnd: '2px solid',
        borderRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockStart: 'calc(50% - 4px)',
        insetInlineStart: 'calc(100% - 3px)',
        marginInlineStart: "var(--ds-space-050, 4px)",
        transform: 'rotate(45deg) scale(1.05)',
        verticalAlign: 'middle'
    }
});
const $9c211af0799e6e88$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $9c211af0799e6e88$export$4a3049f952d3f130 = ({ isDropdownButton: isDropdownButton = false, isHighlighted: isHighlighted = false, text: text, children: children, testId: testId })=>{
    const theme = (0, $gKAEK.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const dynamicStyles = (0, $3mMDm.stripEmptyProperties)({
        ...primaryButton.default,
        ...isHighlighted && {
            color: primaryButton.selected.color
        },
        [$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR]: primaryButton.selected.borderColor,
        [$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR]: isHighlighted ? primaryButton.default.borderColor : primaryButton.default.color
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "listitem",
        css: $9c211af0799e6e88$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: [
            $9c211af0799e6e88$var$primaryButtonSkeletonStyles,
            isHighlighted && $9c211af0799e6e88$var$isHighlightedStyles,
            isDropdownButton && $9c211af0799e6e88$var$isDropdownButtonStyles,
            isHighlighted && (isDropdownButton ? $9c211af0799e6e88$var$isHighlightedAndDropdownButtonStyles : $9c211af0799e6e88$var$isHighlightedNotDropdownButtonStyles)
        ],
        "data-testid": testId
    }, text || children));
};

});

parcelRegister("7FtaJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14f14ae2593cbb89c3cab1b7918f4611>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5952fdbb28afd899$var$_react = $5952fdbb28afd899$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5952fdbb28afd899$var$_baseNew = $5952fdbb28afd899$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5952fdbb28afd899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starred or favourited objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5952fdbb28afd899$var$StarStarredIcon = (props)=>/*#__PURE__*/ $5952fdbb28afd899$var$_react.default.createElement($5952fdbb28afd899$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 0a.75.75 0 0 1 .7.48l1.288 3.35 3.32.256a.75.75 0 0 1 .422 1.324L9.182 7.533l.945 3.523a.75.75 0 0 1-1.148.813L6 9.825l-2.979 2.042a.75.75 0 0 1-1.148-.812l.945-3.523L.27 5.41a.75.75 0 0 1 .422-1.324l3.32-.256L5.3.48A.75.75 0 0 1 6 0m0 2.84-.928 2.413-2.423.186 1.866 1.556-.667 2.488L6 8.007l2.152 1.476-.667-2.488L9.35 5.439l-2.423-.186z" clip-rule="evenodd"/><path fill="currentcolor" d="M5.072 5.253 6 2.84l.928 2.414 2.423.186-1.866 1.556.667 2.488L6 8.007 3.848 9.483l.667-2.488L2.65 5.439z"/>`,
        type: 'utility'
    }, props));
$5952fdbb28afd899$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $5952fdbb28afd899$var$_default = module.exports.default = $5952fdbb28afd899$var$StarStarredIcon;

});

parcelRegister("9Xmvg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2acc08ab6395d499b2798249d78c49fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73fb14674561f421$var$_react = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $73fb14674561f421$var$_arrowUpRight = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("3sGLB")));

var $73fb14674561f421$var$_open = $73fb14674561f421$var$_interopRequireDefault((parcelRequire("1FouZ")));
function $73fb14674561f421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpRightIcon.
 * This component is ArrowUpRightIcon, with `UNSAFE_fallbackIcon` set to "OpenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73fb14674561f421$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $73fb14674561f421$var$_react.default.createElement($73fb14674561f421$var$_arrowUpRight.default, Object.assign({
        LEGACY_fallbackIcon: $73fb14674561f421$var$_open.default
    }, props));
$73fb14674561f421$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
var $73fb14674561f421$var$_default = module.exports.default = $73fb14674561f421$var$ArrowUpRightIcon;

});

parcelRegister("3ZC89", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b007f69ad81895a86b02f3ac63c0846>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e84a5872037db9e$var$_react = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2e84a5872037db9e$var$_premium = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("41hx5")));

var $2e84a5872037db9e$var$_premium2 = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("8EYBJ")));
function $2e84a5872037db9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PremiumIcon.
 * This component is PremiumIcon, with `UNSAFE_fallbackIcon` set to "PremiumIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e84a5872037db9e$var$PremiumIcon = (props)=>/*#__PURE__*/ $2e84a5872037db9e$var$_react.default.createElement($2e84a5872037db9e$var$_premium.default, Object.assign({
        LEGACY_fallbackIcon: $2e84a5872037db9e$var$_premium2.default
    }, props));
$2e84a5872037db9e$var$PremiumIcon.Name = 'PremiumIconMigration';
var $2e84a5872037db9e$var$_default = module.exports.default = $2e84a5872037db9e$var$PremiumIcon;

});

parcelRegister("2o8gl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289d4f542a1ed26db6d28b87ad2efcf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1bd43b75b5db29b6$var$_react = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1bd43b75b5db29b6$var$_filter = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("jX361")));

var $1bd43b75b5db29b6$var$_filter2 = $1bd43b75b5db29b6$var$_interopRequireDefault((parcelRequire("bTqXB")));
function $1bd43b75b5db29b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FilterIcon.
 * This component is FilterIcon, with `UNSAFE_fallbackIcon` set to "FilterIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1bd43b75b5db29b6$var$FilterIcon = (props)=>/*#__PURE__*/ $1bd43b75b5db29b6$var$_react.default.createElement($1bd43b75b5db29b6$var$_filter.default, Object.assign({
        LEGACY_fallbackIcon: $1bd43b75b5db29b6$var$_filter2.default
    }, props));
$1bd43b75b5db29b6$var$FilterIcon.Name = 'FilterIconMigration';
var $1bd43b75b5db29b6$var$_default = module.exports.default = $1bd43b75b5db29b6$var$FilterIcon;

});

parcelRegister("50Bjx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7183201509c40b5c08006bcaf851f797>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a59e5a58dbd64b5$var$_react = $3a59e5a58dbd64b5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3a59e5a58dbd64b5$var$_dashboard = $3a59e5a58dbd64b5$var$_interopRequireDefault((parcelRequire("gsyzJ")));

var $3a59e5a58dbd64b5$var$_dashboard2 = $3a59e5a58dbd64b5$var$_interopRequireDefault((parcelRequire("hSLU7")));
function $3a59e5a58dbd64b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DashboardIcon.
 * This component is DashboardIcon, with `UNSAFE_fallbackIcon` set to "DashboardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a59e5a58dbd64b5$var$DashboardIcon = (props)=>/*#__PURE__*/ $3a59e5a58dbd64b5$var$_react.default.createElement($3a59e5a58dbd64b5$var$_dashboard.default, Object.assign({
        LEGACY_fallbackIcon: $3a59e5a58dbd64b5$var$_dashboard2.default
    }, props));
$3a59e5a58dbd64b5$var$DashboardIcon.Name = 'DashboardIconMigration';
var $3a59e5a58dbd64b5$var$_default = module.exports.default = $3a59e5a58dbd64b5$var$DashboardIcon;

});

parcelRegister("26g7Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa501adbace966b726e3581e51103297>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1878a6eab82c2b68$var$_react = $1878a6eab82c2b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1878a6eab82c2b68$var$_search = $1878a6eab82c2b68$var$_interopRequireDefault((parcelRequire("hyOJh")));

var $1878a6eab82c2b68$var$_search2 = $1878a6eab82c2b68$var$_interopRequireDefault((parcelRequire("tvuR8")));
function $1878a6eab82c2b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "SearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1878a6eab82c2b68$var$SearchIcon = (props)=>/*#__PURE__*/ $1878a6eab82c2b68$var$_react.default.createElement($1878a6eab82c2b68$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $1878a6eab82c2b68$var$_search2.default
    }, props));
$1878a6eab82c2b68$var$SearchIcon.Name = 'SearchIconMigration';
var $1878a6eab82c2b68$var$_default = module.exports.default = $1878a6eab82c2b68$var$SearchIcon;

});

parcelRegister("cqOtB", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $97a5809923f255bf$export$36ba2f559d49a8f6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $a1X0L = parcelRequire("a1X0L");

var $2WekC = parcelRequire("2WekC");

var $7Onh2 = parcelRequire("7Onh2");
const $97a5809923f255bf$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $97a5809923f255bf$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { badge: badge, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2WekC.BadgeContainer), {
        id: $97a5809923f255bf$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Onh2.IconButton), {
            "aria-describedby": $97a5809923f255bf$var$NOTIFICATIONS_BADGE_ID,
            component: component,
            href: href,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1X0L))), {
                spacing: "spacious",
                color: "currentColor",
                label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});
parcelRegister("a1X0L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01602fb49c3451f8884e2ed4b4e67e9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74d7c5cb5b7ac75c$var$_react = $74d7c5cb5b7ac75c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $74d7c5cb5b7ac75c$var$_notification = $74d7c5cb5b7ac75c$var$_interopRequireDefault((parcelRequire("jDorM")));

var $74d7c5cb5b7ac75c$var$_notification2 = $74d7c5cb5b7ac75c$var$_interopRequireDefault((parcelRequire("825vU")));
function $74d7c5cb5b7ac75c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for NotificationIcon.
 * This component is NotificationIcon, with `UNSAFE_fallbackIcon` set to "NotificationIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74d7c5cb5b7ac75c$var$NotificationIcon = (props)=>/*#__PURE__*/ $74d7c5cb5b7ac75c$var$_react.default.createElement($74d7c5cb5b7ac75c$var$_notification.default, Object.assign({
        LEGACY_fallbackIcon: $74d7c5cb5b7ac75c$var$_notification2.default
    }, props));
$74d7c5cb5b7ac75c$var$NotificationIcon.Name = 'NotificationIconMigration';
var $74d7c5cb5b7ac75c$var$_default = module.exports.default = $74d7c5cb5b7ac75c$var$NotificationIcon;

});


parcelRegister("9Ugep", function(module, exports) {

$parcel$export(module.exports, "SkeletonNotificationButton", () => $ae19a5528a9df359$export$a14f01df37978534);
$parcel$export(module.exports, "Nav4SkeletonNotificationButton", () => $ae19a5528a9df359$export$6df5583c56de301f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $a1X0L = parcelRequire("a1X0L");

var $jDorM = parcelRequire("jDorM");

var $3XuTW = parcelRequire("3XuTW");
const $ae19a5528a9df359$export$a14f01df37978534 = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3XuTW.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1X0L))), {
            color: "currentColor",
            spacing: "spacious",
            label: label
        })
    });
const $ae19a5528a9df359$export$6df5583c56de301f = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3XuTW.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jDorM))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("2j6pM", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $3ffd5a1d23c84e5b$export$36ba2f559d49a8f6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jDorM = parcelRequire("jDorM");

var $9MMay = parcelRequire("9MMay");

var $6Dtpf = parcelRequire("6Dtpf");
const $3ffd5a1d23c84e5b$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $3ffd5a1d23c84e5b$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MMay.BadgeContainer), {
        id: $3ffd5a1d23c84e5b$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Dtpf.UserAction), {
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            isSelected: isSelected,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jDorM))),
            // We explicitly set the UserAction to not be a list item,
            // because the BadgeContainer already has a list item role (if `isListItem` is true)
            isListItem: false
        })
    });
});

});

parcelRegister("oZ7y4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27adf6ccfa0da2e986d1468bec1512ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04b1a750273d38f2$var$_react = $04b1a750273d38f2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $04b1a750273d38f2$var$_notification = $04b1a750273d38f2$var$_interopRequireDefault((parcelRequire("jDorM")));

var $04b1a750273d38f2$var$_notificationDirect = $04b1a750273d38f2$var$_interopRequireDefault((parcelRequire("6Njc0")));
function $04b1a750273d38f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for NotificationIcon.
 * This component is NotificationIcon, with `UNSAFE_fallbackIcon` set to "NotificationDirectIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04b1a750273d38f2$var$NotificationIcon = (props)=>/*#__PURE__*/ $04b1a750273d38f2$var$_react.default.createElement($04b1a750273d38f2$var$_notification.default, Object.assign({
        LEGACY_fallbackIcon: $04b1a750273d38f2$var$_notificationDirect.default
    }, props));
$04b1a750273d38f2$var$NotificationIcon.Name = 'NotificationIconMigration';
var $04b1a750273d38f2$var$_default = module.exports.default = $04b1a750273d38f2$var$NotificationIcon;

});

const $af03419a6de12610$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $af03419a6de12610$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $af03419a6de12610$export$13f57c02915787b3 = 'atlaskit-portal';

const $edbbaf000cbe1dd7$export$ed5835cc67e87f72 = 'akPortalMount';
const $edbbaf000cbe1dd7$export$80816bd900e5bd00 = 'akPortalUnmount';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $ff8b18549b2c06bf$export$d6830277b06edd6 = 'normal';


$parcel$global.rlb("kvRbA")
//# sourceMappingURL=shared~atlassian-navigation~atlaskit~ar.e69698a8.js.map
